/* tslint:disable */
/* eslint-disable */
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A calendar date without a time component, serialized as yyyy-mm-dd */
  Date: string;
  DateTime: any;
  /** Represents untyped JSON */
  JSON: any;
  Json: string;
  Phone: any;
  Upload: any;
};

export type AccountDeletionRequest = {
  __typename?: 'AccountDeletionRequest';
  approvedAt?: Maybe<Scalars['DateTime']>;
  approvedBy?: Maybe<User>;
  createdAt: Scalars['DateTime'];
  createdBy: User;
  customer?: Maybe<Customer>;
  id: Scalars['Int'];
  reason?: Maybe<Scalars['String']>;
  rejectedAt?: Maybe<Scalars['DateTime']>;
  rejectedBy?: Maybe<User>;
  rejectionReason?: Maybe<Scalars['String']>;
  restaurant?: Maybe<Restaurant>;
  status: AccountDeletionRequestStatus;
  statusHuman: Scalars['String'];
};

/** Autogenerated return type of AccountDeletionRequestApprove. */
export type AccountDeletionRequestApprovePayload = {
  __typename?: 'AccountDeletionRequestApprovePayload';
  accountDeletionRequest?: Maybe<AccountDeletionRequest>;
  errors?: Maybe<Array<UserError>>;
};

export type AccountDeletionRequestCollection = Collection & {
  __typename?: 'AccountDeletionRequestCollection';
  /** Limit */
  limit?: Maybe<Scalars['Int']>;
  /** Offset */
  offset?: Maybe<Scalars['Int']>;
  /** List of records */
  records: Array<AccountDeletionRequest>;
  /** Total */
  total: Scalars['Int'];
};


export type AccountDeletionRequestCollectionTotalArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};

/** Autogenerated return type of AccountDeletionRequestReject. */
export type AccountDeletionRequestRejectPayload = {
  __typename?: 'AccountDeletionRequestRejectPayload';
  accountDeletionRequest?: Maybe<AccountDeletionRequest>;
  errors?: Maybe<Array<UserError>>;
};

export enum AccountDeletionRequestStatus {
  Approved = 'approved',
  Pending = 'pending',
  Rejected = 'rejected'
}

export type AddressDistanceFilterInput = {
  /** Miles */
  distance: Scalars['Float'];
  fullAddress: Scalars['String'];
};

export type Admin = {
  __typename?: 'Admin';
  authToken?: Maybe<Scalars['String']>;
  availableFacebookPages?: Maybe<Array<FacebookRemotePage>>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  lastName?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of AdminForgotPassword. */
export type AdminForgotPasswordPayload = {
  __typename?: 'AdminForgotPasswordPayload';
  errors?: Maybe<Array<UserError>>;
};

/** Autogenerated return type of AdminLogin. */
export type AdminLoginPayload = {
  __typename?: 'AdminLoginPayload';
  admin?: Maybe<Admin>;
  errors?: Maybe<Array<UserError>>;
};

/** Autogenerated return type of AdminResetPassword. */
export type AdminResetPasswordPayload = {
  __typename?: 'AdminResetPasswordPayload';
  admin?: Maybe<Admin>;
  errors?: Maybe<Array<UserError>>;
};

export type AgentChat = {
  __typename?: 'AgentChat';
  agentChatMessages: Array<AgentChatMessage>;
  agentChatMessagesCount: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  firstMessagePreview?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  lastMessageAt?: Maybe<Scalars['DateTime']>;
  status: AgentChatStatus;
};

export type AgentChatCollection = Collection & {
  __typename?: 'AgentChatCollection';
  /** Limit */
  limit?: Maybe<Scalars['Int']>;
  /** Offset */
  offset?: Maybe<Scalars['Int']>;
  /** List of records */
  records: Array<AgentChat>;
  /** Total */
  total: Scalars['Int'];
};


export type AgentChatCollectionTotalArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};

/** Autogenerated return type of AgentChatCreate. */
export type AgentChatCreatePayload = {
  __typename?: 'AgentChatCreatePayload';
  agentChat?: Maybe<AgentChat>;
  errors?: Maybe<Array<UserError>>;
};

/** Autogenerated return type of AgentChatDelete. */
export type AgentChatDeletePayload = {
  __typename?: 'AgentChatDeletePayload';
  agentChat?: Maybe<AgentChat>;
  errors?: Maybe<Array<UserError>>;
};

export type AgentChatMessage = {
  __typename?: 'AgentChatMessage';
  createdAt: Scalars['DateTime'];
  error: Scalars['Boolean'];
  id: Scalars['Int'];
  intents: Scalars['JSON'];
  metadata?: Maybe<Scalars['JSON']>;
  parts: Array<AgentChatPart>;
  preview?: Maybe<Scalars['String']>;
  role: AgentChatMessageRole;
};

/** Autogenerated return type of AgentChatMessageCreate. */
export type AgentChatMessageCreatePayload = {
  __typename?: 'AgentChatMessageCreatePayload';
  agentChat?: Maybe<AgentChat>;
  errors?: Maybe<Array<UserError>>;
};

export enum AgentChatMessageRole {
  Assistant = 'assistant',
  System = 'system',
  User = 'user'
}

export type AgentChatPart = {
  __typename?: 'AgentChatPart';
  filename?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  mediaType?: Maybe<Scalars['String']>;
  raw: Scalars['JSON'];
  text?: Maybe<Scalars['String']>;
  toolName?: Maybe<Scalars['String']>;
  type: AgentChatPartType;
  url?: Maybe<Scalars['String']>;
};

export enum AgentChatPartType {
  File = 'file',
  Other = 'other',
  Reasoning = 'reasoning',
  Text = 'text',
  Tool = 'tool',
  ToolApprovalSummary = 'tool_approval_summary'
}

export enum AgentChatStatus {
  Finished = 'finished',
  Processing = 'processing'
}

/** Autogenerated return type of AgentChatToolApproval. */
export type AgentChatToolApprovalPayload = {
  __typename?: 'AgentChatToolApprovalPayload';
  agentChat?: Maybe<AgentChat>;
  errors?: Maybe<Array<UserError>>;
};

export type AgentChatsFilterInput = {
  /** Include soft-deleted chats */
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
  /** Include chats with no messages */
  includeEmpty?: InputMaybe<Scalars['Boolean']>;
};

export type ApparelPartnershipRequest = {
  __typename?: 'ApparelPartnershipRequest';
  accepted: Scalars['Boolean'];
  id: Scalars['Int'];
  image?: Maybe<ImageAttachment>;
};

export type AutoCoverNotification = {
  __typename?: 'AutoCoverNotification';
  autoCoverRun: AutoCoverRun;
  createdAt: Scalars['DateTime'];
  emailNotificationStatus?: Maybe<AutoCoverNotificationStatus>;
  id: Scalars['Int'];
  order: Scalars['Int'];
  pushNotificationStatus?: Maybe<AutoCoverNotificationStatus>;
  runAt: Scalars['DateTime'];
  smsNotificationStatus?: Maybe<AutoCoverNotificationStatus>;
  status: Scalars['String'];
  truck: Truck;
};

export enum AutoCoverNotificationStatus {
  Delivered = 'delivered',
  Opened = 'opened',
  Sent = 'sent'
}

/** Autogenerated return type of AutoCoverRequest. */
export type AutoCoverRequestPayload = {
  __typename?: 'AutoCoverRequestPayload';
  errors?: Maybe<Array<UserError>>;
  event?: Maybe<Event>;
};

export type AutoCoverRun = {
  __typename?: 'AutoCoverRun';
  createdAt: Scalars['DateTime'];
  event: Event;
  finishedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  notifications?: Maybe<Array<AutoCoverNotification>>;
  runAt: Scalars['DateTime'];
  status: Scalars['String'];
  trigger: Scalars['String'];
};

export enum AvailabilityRule {
  AlreadyBooked = 'already_booked',
  Blacklist = 'blacklist',
  BookableTime = 'bookable_time',
  BookingDelay = 'booking_delay',
  FoodRestrictions = 'food_restrictions',
  FullyBooked = 'fully_booked',
  MaxBookingsPerSequence = 'max_bookings_per_sequence',
  RejectedByOrganizer = 'rejected_by_organizer',
  SameTruckBooking = 'same_truck_booking',
  Whitelist = 'whitelist'
}

export type AvailableOrders = {
  __typename?: 'AvailableOrders';
  ordersLeft?: Maybe<Scalars['Int']>;
  time: Scalars['DateTime'];
};

export type BftContactInfo = {
  __typename?: 'BftContactInfo';
  email: Scalars['String'];
  hireATruck: Scalars['String'];
  phone: Scalars['String'];
};

export type BlogPost = {
  __typename?: 'BlogPost';
  contentSections: Array<ContentSection>;
  customerPath: Scalars['String'];
  customerUrl: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  metaDescription: Scalars['String'];
  published: Scalars['Boolean'];
  publishedAt: Scalars['DateTime'];
  seoName: Scalars['String'];
  slug: Scalars['String'];
  title: Scalars['String'];
};


export type BlogPostContentSectionsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};

/** Autogenerated return type of BlogPostCreate. */
export type BlogPostCreatePayload = {
  __typename?: 'BlogPostCreatePayload';
  blogPost?: Maybe<BlogPost>;
  errors?: Maybe<Array<UserError>>;
};

/** Autogenerated return type of BlogPostUpdate. */
export type BlogPostUpdatePayload = {
  __typename?: 'BlogPostUpdatePayload';
  blogPost?: Maybe<BlogPost>;
  errors?: Maybe<Array<UserError>>;
};

export enum BookingMode {
  Approve = 'approve',
  Instant = 'instant'
}

export type CalendarIntegration = {
  __typename?: 'CalendarIntegration';
  active: Scalars['Boolean'];
  calendarName: Scalars['String'];
  enableExport: Scalars['Boolean'];
  enableImport: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  truck: Truck;
};

/** Autogenerated return type of CalendarIntegrationCreate. */
export type CalendarIntegrationCreatePayload = {
  __typename?: 'CalendarIntegrationCreatePayload';
  calendarIntegration?: Maybe<CalendarIntegration>;
  employee?: Maybe<Employee>;
  errors?: Maybe<Array<UserError>>;
};

/** Autogenerated return type of CalendarIntegrationRemove. */
export type CalendarIntegrationRemovePayload = {
  __typename?: 'CalendarIntegrationRemovePayload';
  employee?: Maybe<Employee>;
  errors?: Maybe<Array<UserError>>;
};

/** Autogenerated return type of CalendarIntegrationUpdate. */
export type CalendarIntegrationUpdatePayload = {
  __typename?: 'CalendarIntegrationUpdatePayload';
  calendarIntegration?: Maybe<CalendarIntegration>;
  employee?: Maybe<Employee>;
  errors?: Maybe<Array<UserError>>;
};

export type CalendarOption = {
  __typename?: 'CalendarOption';
  id: Scalars['String'];
  name: Scalars['String'];
  primary?: Maybe<Scalars['Boolean']>;
};

export type Cart = {
  __typename?: 'Cart';
  amountCustomTip?: Maybe<Money>;
  appleCreditsNotice?: Maybe<Scalars['String']>;
  canAuthorizeCard: Scalars['Boolean'];
  coupon?: Maybe<CartCoupon>;
  customerNotes: Scalars['String'];
  delayedPickupAt?: Maybe<Scalars['DateTime']>;
  eligibleForAppleCredits: Scalars['Boolean'];
  id?: Maybe<Scalars['Int']>;
  itemRecommendations: Array<LocationItem>;
  items: Array<CartItem>;
  location?: Maybe<Location>;
  order?: Maybe<Order>;
  pickupTimeSelected: Scalars['Boolean'];
  price: CartPrice;
  status: CartStatus;
  tipPercentage?: Maybe<Scalars['Int']>;
  uuid?: Maybe<Scalars['String']>;
};


export type CartItemRecommendationsArgs = {
  count: Scalars['Int'];
};

/** Autogenerated return type of CartAddItem. */
export type CartAddItemPayload = {
  __typename?: 'CartAddItemPayload';
  cart?: Maybe<Cart>;
  errors?: Maybe<Array<UserError>>;
};

/** Autogenerated return type of CartApplyCoupon. */
export type CartApplyCouponPayload = {
  __typename?: 'CartApplyCouponPayload';
  cart?: Maybe<Cart>;
  errors?: Maybe<Array<UserError>>;
};

/** Autogenerated return type of CartCheckForPayment. */
export type CartCheckForPaymentPayload = {
  __typename?: 'CartCheckForPaymentPayload';
  cart?: Maybe<Cart>;
  errors?: Maybe<Array<UserError>>;
};

/** Autogenerated return type of CartCheckoutSession. */
export type CartCheckoutSessionPayload = {
  __typename?: 'CartCheckoutSessionPayload';
  cart?: Maybe<Cart>;
  errors?: Maybe<Array<UserError>>;
  order?: Maybe<Order>;
  stripeCheckoutUrl?: Maybe<Scalars['String']>;
  stripeSessionId?: Maybe<Scalars['String']>;
};

export type CartCoupon = {
  __typename?: 'CartCoupon';
  active: Scalars['Boolean'];
  code: Scalars['String'];
  id: Scalars['Int'];
  name: Scalars['String'];
};

/** Autogenerated return type of CartCreatePaymentIntent. */
export type CartCreatePaymentIntentPayload = {
  __typename?: 'CartCreatePaymentIntentPayload';
  cart?: Maybe<Cart>;
  customerStripeId?: Maybe<Scalars['String']>;
  ephemeralKey?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<UserError>>;
  paymentIntentClientSecret?: Maybe<Scalars['String']>;
  stripePaymentIntent?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of CartCreateSetupIntent. */
export type CartCreateSetupIntentPayload = {
  __typename?: 'CartCreateSetupIntentPayload';
  cart?: Maybe<Cart>;
  customerStripeId?: Maybe<Scalars['String']>;
  ephemeralKey?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<UserError>>;
  setupIntentClientSecret?: Maybe<Scalars['String']>;
  stripeSetupIntent?: Maybe<Scalars['String']>;
};

export type CartItem = {
  __typename?: 'CartItem';
  id: Scalars['String'];
  locationItem: LocationItem;
  quantity: Scalars['Int'];
  questions: Array<CartItemQuestion>;
  specialInstructions: Scalars['String'];
  upsell: Scalars['Boolean'];
};

export type CartItemInput = {
  locationItemId: Scalars['Int'];
  quantity: Scalars['Int'];
  questions: Array<CartItemQuestionInput>;
  source?: InputMaybe<Scalars['String']>;
  specialInstructions: Scalars['String'];
  upsell?: InputMaybe<Scalars['Boolean']>;
};

export type CartItemPrice = {
  __typename?: 'CartItemPrice';
  locationItem: LocationItem;
  name: Scalars['String'];
  quantity: Scalars['Int'];
  taxIncluded: Scalars['Boolean'];
  total: Money;
};

export type CartItemQuestion = {
  __typename?: 'CartItemQuestion';
  answers: Array<LocationItemAnswer>;
  locationItemQuestion: LocationItemQuestion;
};

export type CartItemQuestionInput = {
  answerIds: Array<Scalars['Int']>;
  id: Scalars['Int'];
};

/** Autogenerated return type of CartPlaceFreeOrder. */
export type CartPlaceFreeOrderPayload = {
  __typename?: 'CartPlaceFreeOrderPayload';
  cart?: Maybe<Cart>;
  errors?: Maybe<Array<UserError>>;
  order?: Maybe<Order>;
};

export type CartPrice = {
  __typename?: 'CartPrice';
  items: Array<CartItemPrice>;
  lines: Array<PriceLine>;
  subtotal: Money;
  total: Money;
};

/** Autogenerated return type of CartRemoveCoupon. */
export type CartRemoveCouponPayload = {
  __typename?: 'CartRemoveCouponPayload';
  cart?: Maybe<Cart>;
  errors?: Maybe<Array<UserError>>;
};

/** Autogenerated return type of CartRemoveItem. */
export type CartRemoveItemPayload = {
  __typename?: 'CartRemoveItemPayload';
  cart?: Maybe<Cart>;
  errors?: Maybe<Array<UserError>>;
};

/** Autogenerated return type of CartRemovePickupTime. */
export type CartRemovePickupTimePayload = {
  __typename?: 'CartRemovePickupTimePayload';
  cart?: Maybe<Cart>;
  errors?: Maybe<Array<UserError>>;
};

export enum CartStatus {
  Finished = 'finished',
  NewCart = 'new_cart',
  Paid = 'paid'
}

/** Autogenerated return type of CartUpdateCustomerNotes. */
export type CartUpdateCustomerNotesPayload = {
  __typename?: 'CartUpdateCustomerNotesPayload';
  cart?: Maybe<Cart>;
  errors?: Maybe<Array<UserError>>;
};

/** Autogenerated return type of CartUpdateItem. */
export type CartUpdateItemPayload = {
  __typename?: 'CartUpdateItemPayload';
  cart?: Maybe<Cart>;
  errors?: Maybe<Array<UserError>>;
};

/** Autogenerated return type of CartUpdateLotNotes. */
export type CartUpdateLotNotesPayload = {
  __typename?: 'CartUpdateLotNotesPayload';
  cart?: Maybe<Cart>;
  errors?: Maybe<Array<UserError>>;
};

/** Autogenerated return type of CartUpdatePickupTime. */
export type CartUpdatePickupTimePayload = {
  __typename?: 'CartUpdatePickupTimePayload';
  cart?: Maybe<Cart>;
  errors?: Maybe<Array<UserError>>;
};

/** Autogenerated return type of CartUpdateTip. */
export type CartUpdateTipPayload = {
  __typename?: 'CartUpdateTipPayload';
  cart?: Maybe<Cart>;
  errors?: Maybe<Array<UserError>>;
};

/** Autogenerated return type of CartUseExistingCard. */
export type CartUseExistingCardPayload = {
  __typename?: 'CartUseExistingCardPayload';
  cart?: Maybe<Cart>;
  errors?: Maybe<Array<UserError>>;
  setupIntentClientSecret?: Maybe<Scalars['String']>;
  stripeSetupIntent?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of CartVerifyItemsAvailability. */
export type CartVerifyItemsAvailabilityPayload = {
  __typename?: 'CartVerifyItemsAvailabilityPayload';
  cart?: Maybe<Cart>;
  errors?: Maybe<Array<UserError>>;
  removedItemNames?: Maybe<Array<Scalars['String']>>;
};

/** Autogenerated return type of CateringAlcoholRequestCreate. */
export type CateringAlcoholRequestCreatePayload = {
  __typename?: 'CateringAlcoholRequestCreatePayload';
  cateringRequestCode?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<UserError>>;
};

export type CateringCategory = {
  __typename?: 'CateringCategory';
  active: Scalars['Boolean'];
  aiGenerated: Scalars['Boolean'];
  childCategories: Array<CateringCategory>;
  contentSections: Array<ContentSection>;
  customerPath: Scalars['String'];
  customerUrl: Scalars['String'];
  enableFaq: Scalars['Boolean'];
  faqSections: Array<FaqSection>;
  id: Scalars['Int'];
  image?: Maybe<ImageAttachment>;
  mainPage: Scalars['Boolean'];
  market?: Maybe<Market>;
  metaDescription: Scalars['String'];
  minBudget: Money;
  name: Scalars['String'];
  parentCategory?: Maybe<CateringCategory>;
  publicFaqSections: Array<FaqSection>;
  seoName: Scalars['String'];
  slug: Scalars['String'];
  subtitle: Scalars['String'];
  title: Scalars['String'];
};


export type CateringCategoryChildCategoriesArgs = {
  marketId?: InputMaybe<Scalars['Int']>;
  marketSeoName?: InputMaybe<Scalars['String']>;
};


export type CateringCategoryCustomerPathArgs = {
  marketSeoName?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of CateringCategoryMarketClone. */
export type CateringCategoryMarketClonePayload = {
  __typename?: 'CateringCategoryMarketClonePayload';
  cateringCategory?: Maybe<CateringCategory>;
  errors?: Maybe<Array<UserError>>;
};

/** Autogenerated return type of CateringCategoryUpdate. */
export type CateringCategoryUpdatePayload = {
  __typename?: 'CateringCategoryUpdatePayload';
  cateringCategory?: Maybe<CateringCategory>;
  errors?: Maybe<Array<UserError>>;
};

/** Autogenerated return type of CateringConvertToDebitPayment. */
export type CateringConvertToDebitPaymentPayload = {
  __typename?: 'CateringConvertToDebitPaymentPayload';
  cateringRequest?: Maybe<CateringRequest>;
  errors?: Maybe<Array<UserError>>;
};

/** Autogenerated return type of CateringConvertToFullPayment. */
export type CateringConvertToFullPaymentPayload = {
  __typename?: 'CateringConvertToFullPaymentPayload';
  cateringRequest?: Maybe<CateringRequest>;
  errors?: Maybe<Array<UserError>>;
};

export type CateringCustomRequest = {
  __typename?: 'CateringCustomRequest';
  code: Scalars['String'];
  createdAt: Scalars['DateTime'];
  customer?: Maybe<User>;
  customerName?: Maybe<Scalars['String']>;
  emailThreads: Array<EmailThread>;
  fields: Array<CateringCustomRequestField>;
  fullAddress?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  logsKlass: Scalars['String'];
  noteKlass: CommentableEntity;
  recordId: Scalars['Int'];
  requestType: CateringCustomRequestType;
  requestTypeHuman: Scalars['String'];
  status: CateringCustomRequestStatus;
  statusHuman: Scalars['String'];
  tags: Array<Scalars['String']>;
  textConversation?: Maybe<TextConversation>;
  user?: Maybe<User>;
};

export type CateringCustomRequestCollection = {
  __typename?: 'CateringCustomRequestCollection';
  /** Limit */
  limit?: Maybe<Scalars['Int']>;
  /** Offset */
  offset?: Maybe<Scalars['Int']>;
  /** List of records */
  records: Array<CateringCustomRequest>;
  /** Total */
  total: Scalars['Int'];
};

export type CateringCustomRequestField = {
  __typename?: 'CateringCustomRequestField';
  fieldType: Scalars['String'];
  name: Scalars['String'];
  value?: Maybe<Scalars['String']>;
};

export enum CateringCustomRequestStatus {
  Cancelled = 'cancelled',
  ClientContacted = 'client_contacted',
  Finished = 'finished',
  InProgress = 'in_progress',
  Pending = 'pending'
}

export enum CateringCustomRequestType {
  Alcohol = 'alcohol',
  GoogleForm = 'google_form',
  Other = 'other',
  Recurring = 'recurring'
}

/** Autogenerated return type of CateringCustomRequestUpdateStatus. */
export type CateringCustomRequestUpdateStatusPayload = {
  __typename?: 'CateringCustomRequestUpdateStatusPayload';
  cateringCustomRequest?: Maybe<CateringCustomRequest>;
  errors?: Maybe<Array<UserError>>;
};

/** Autogenerated return type of CateringCustomRequestUpdateTags. */
export type CateringCustomRequestUpdateTagsPayload = {
  __typename?: 'CateringCustomRequestUpdateTagsPayload';
  cateringCustomRequest?: Maybe<CateringCustomRequest>;
  errors?: Maybe<Array<UserError>>;
};

export type CateringCustomRequestsFilterInput = {
  requestType?: InputMaybe<CateringCustomRequestType>;
  search?: InputMaybe<Scalars['String']>;
  statuses?: InputMaybe<Array<CateringCustomRequestStatus>>;
  tags?: InputMaybe<Array<Scalars['String']>>;
};

export enum CateringInstantBookStatus {
  Finished = 'finished',
  InProgress = 'in_progress',
  Initial = 'initial'
}

export type CateringInvoice = {
  __typename?: 'CateringInvoice';
  amountCustomer: Money;
  amountCustomerBase: Money;
  calculateAchAmount: Money;
  calculateCardAmount: Money;
  createdAt: Scalars['DateTime'];
  deposit: Scalars['Boolean'];
  dueAt: Scalars['DateTime'];
  id: Scalars['Int'];
  paymentType: CateringInvoicePayment;
  paymentTypeHuman: Scalars['String'];
  status: CateringInvoiceStatus;
  statusHuman: Scalars['String'];
  stripeInvoicePdfUrl?: Maybe<Scalars['String']>;
  stripeNumber?: Maybe<Scalars['String']>;
  stripePaymentUrl?: Maybe<Scalars['String']>;
  stripeReferences?: Maybe<Array<StripeReference>>;
};

/** Autogenerated return type of CateringInvoicePay. */
export type CateringInvoicePayPayload = {
  __typename?: 'CateringInvoicePayPayload';
  cateringRequest?: Maybe<CateringRequest>;
  errors?: Maybe<Array<UserError>>;
  invoice?: Maybe<CateringInvoice>;
};

export enum CateringInvoicePayment {
  Ach = 'ach',
  Card = 'card'
}

export enum CateringInvoiceStatus {
  AwaitingPayment = 'awaiting_payment',
  Paid = 'paid',
  Pending = 'pending',
  Refunded = 'refunded',
  Voided = 'voided'
}

/** Autogenerated return type of CateringIssueInvoice. */
export type CateringIssueInvoicePayload = {
  __typename?: 'CateringIssueInvoicePayload';
  cateringRequest?: Maybe<CateringRequest>;
  errors?: Maybe<Array<UserError>>;
};

export type CateringManualTruckDebit = {
  __typename?: 'CateringManualTruckDebit';
  amount: Money;
  createdAt: Scalars['DateTime'];
  createdBy: User;
  id: Scalars['Int'];
  note: Scalars['String'];
  truck: Truck;
};

/** Autogenerated return type of CateringManualTruckDebitCreate. */
export type CateringManualTruckDebitCreatePayload = {
  __typename?: 'CateringManualTruckDebitCreatePayload';
  cateringRequest?: Maybe<CateringRequest>;
  errors?: Maybe<Array<UserError>>;
  manualTruckDebit?: Maybe<CateringManualTruckDebit>;
};

/** Autogenerated return type of CateringManualTruckDebitDelete. */
export type CateringManualTruckDebitDeletePayload = {
  __typename?: 'CateringManualTruckDebitDeletePayload';
  cateringRequest?: Maybe<CateringRequest>;
  errors?: Maybe<Array<UserError>>;
};

export type CateringMealPart = {
  __typename?: 'CateringMealPart';
  count: Scalars['Int'];
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type CateringNotificationCounts = {
  __typename?: 'CateringNotificationCounts';
  groupId: Scalars['Int'];
  notifiedCount: Scalars['Int'];
  pendingCount: Scalars['Int'];
};

export type CateringOrder = {
  __typename?: 'CateringOrder';
  cateringOrderItems: Array<CateringOrderItem>;
  createdAt: Scalars['DateTime'];
  customer?: Maybe<Customer>;
  customerEmail?: Maybe<Scalars['String']>;
  customerName: Scalars['String'];
  customerPhone?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  truck: Truck;
};

export type CateringOrderAnswer = {
  __typename?: 'CateringOrderAnswer';
  id: Scalars['Int'];
  itemAnswer: ItemAnswer;
  text: Scalars['String'];
};

export type CateringOrderAnswerInput = {
  answerId: Scalars['Int'];
};

/** Autogenerated return type of CateringOrderCancel. */
export type CateringOrderCancelPayload = {
  __typename?: 'CateringOrderCancelPayload';
  errors?: Maybe<Array<UserError>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type CateringOrderCollection = Collection & {
  __typename?: 'CateringOrderCollection';
  /** Limit */
  limit?: Maybe<Scalars['Int']>;
  /** Offset */
  offset?: Maybe<Scalars['Int']>;
  /** List of records */
  records: Array<CateringOrder>;
  /** Total */
  total: Scalars['Int'];
};


export type CateringOrderCollectionTotalArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};

/** Autogenerated return type of CateringOrderCreate. */
export type CateringOrderCreatePayload = {
  __typename?: 'CateringOrderCreatePayload';
  cateringOrder?: Maybe<CateringOrder>;
  cateringRequestPreview?: Maybe<CateringRequestPreview>;
  errors?: Maybe<Array<UserError>>;
};

export type CateringOrderInput = {
  items: Array<CateringOrderItemInput>;
};

export type CateringOrderItem = {
  __typename?: 'CateringOrderItem';
  cateringOrderQuestions: Array<CateringOrderQuestion>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  item: Item;
  name: Scalars['String'];
  quantity: Scalars['Int'];
  specialInstructions?: Maybe<Scalars['String']>;
};

export type CateringOrderItemInput = {
  itemId: Scalars['Int'];
  quantity: Scalars['Int'];
  questions: Array<CateringOrderQuestionInput>;
  specialInstructions: Scalars['String'];
};

export type CateringOrderQuestion = {
  __typename?: 'CateringOrderQuestion';
  cateringOrderAnswers: Array<CateringOrderAnswer>;
  id: Scalars['Int'];
  itemQuestion: ItemQuestion;
  text: Scalars['String'];
};

export type CateringOrderQuestionInput = {
  answers: Array<CateringOrderAnswerInput>;
  questionId: Scalars['Int'];
};

export type CateringOrdersFilterInput = {
  cateringRequestId?: InputMaybe<Scalars['Int']>;
  orderGroupUuid?: InputMaybe<Scalars['String']>;
};

export enum CateringOrdersLimitMode {
  PerGroup = 'per_group',
  PerTruck = 'per_truck'
}

export enum CateringOrdersMode {
  OrderFromAllTrucks = 'order_from_all_trucks',
  OrderFromSingleTruck = 'order_from_single_truck'
}

export type CateringOrdersSortInput = {
  /** ASC / DESC */
  direction: SortDirection;
  /** Field to sort by */
  field: CateringOrdersSortInputFields;
};

export enum CateringOrdersSortInputFields {
  CreatedAt = 'created_at'
}

export type CateringOrganizerDebit = {
  __typename?: 'CateringOrganizerDebit';
  amountBase: Money;
  amountBft: Money;
  amountOrganizer: Money;
  id: Scalars['Int'];
  status: CateringOrganizerDebitStatus;
  statusHuman: Scalars['String'];
  stripeReferences?: Maybe<Array<StripeReference>>;
};

export enum CateringOrganizerDebitStatus {
  Paid = 'paid',
  Pending = 'pending',
  Reversed = 'reversed'
}

/** Autogenerated return type of CateringOtherCreate. */
export type CateringOtherCreatePayload = {
  __typename?: 'CateringOtherCreatePayload';
  errors?: Maybe<Array<UserError>>;
  id?: Maybe<Scalars['Int']>;
};

export type CateringOverageRequest = {
  __typename?: 'CateringOverageRequest';
  amountCustomer: Money;
  amountTruck: Money;
  approvedBy?: Maybe<User>;
  createdBy: User;
  id: Scalars['Int'];
  mealCount: Scalars['Int'];
  overageAmountPerMeal: Money;
  rejectedBy?: Maybe<User>;
  rejectionReason?: Maybe<Scalars['String']>;
  status: CateringOverageRequestStatus;
  statusHuman: Scalars['String'];
  truck: Truck;
};

/** Autogenerated return type of CateringOverageRequestApprove. */
export type CateringOverageRequestApprovePayload = {
  __typename?: 'CateringOverageRequestApprovePayload';
  cateringRequest?: Maybe<CateringRequest>;
  errors?: Maybe<Array<UserError>>;
  overageRequest?: Maybe<CateringOverageRequest>;
};

/** Autogenerated return type of CateringOverageRequestCreate. */
export type CateringOverageRequestCreatePayload = {
  __typename?: 'CateringOverageRequestCreatePayload';
  cateringRequest?: Maybe<CateringRequest>;
  errors?: Maybe<Array<UserError>>;
  overageRequest?: Maybe<CateringOverageRequest>;
};

/** Autogenerated return type of CateringOverageRequestReject. */
export type CateringOverageRequestRejectPayload = {
  __typename?: 'CateringOverageRequestRejectPayload';
  cateringRequest?: Maybe<CateringRequest>;
  errors?: Maybe<Array<UserError>>;
  overageRequest?: Maybe<CateringOverageRequest>;
};

/** Autogenerated return type of CateringOverageRequestRevert. */
export type CateringOverageRequestRevertPayload = {
  __typename?: 'CateringOverageRequestRevertPayload';
  cateringRequest?: Maybe<CateringRequest>;
  errors?: Maybe<Array<UserError>>;
  overageRequest?: Maybe<CateringOverageRequest>;
};

export enum CateringOverageRequestStatus {
  Approved = 'approved',
  Pending = 'pending',
  Rejected = 'rejected'
}

/** Autogenerated return type of CateringOverageRequestUpdateBudget. */
export type CateringOverageRequestUpdateBudgetPayload = {
  __typename?: 'CateringOverageRequestUpdateBudgetPayload';
  cateringRequest?: Maybe<CateringRequest>;
  errors?: Maybe<Array<UserError>>;
  overageRequest?: Maybe<CateringOverageRequest>;
};

/** Autogenerated return type of CateringPayOrganizer. */
export type CateringPayOrganizerPayload = {
  __typename?: 'CateringPayOrganizerPayload';
  cateringRequest?: Maybe<CateringRequest>;
  errors?: Maybe<Array<UserError>>;
};

export enum CateringPreferredContactMethod {
  ContactByEmail = 'contact_by_email',
  ContactByPhone = 'contact_by_phone',
  ContactByPhoneOrEmail = 'contact_by_phone_or_email',
  ContactByText = 'contact_by_text'
}

/** Autogenerated return type of CateringProposalAcknowledge. */
export type CateringProposalAcknowledgePayload = {
  __typename?: 'CateringProposalAcknowledgePayload';
  cateringRequest?: Maybe<CateringRequest>;
  errors?: Maybe<Array<UserError>>;
  requestProposal?: Maybe<CateringRequestProposal>;
};

/** Autogenerated return type of CateringProposalChoose. */
export type CateringProposalChoosePayload = {
  __typename?: 'CateringProposalChoosePayload';
  cateringRequest?: Maybe<CateringRequest>;
  errors?: Maybe<Array<UserError>>;
};

export type CateringProposalHistory = {
  __typename?: 'CateringProposalHistory';
  id: Scalars['Int'];
  monthProposalCount: Scalars['Int'];
  threeYearProposalCount: Scalars['Int'];
  yearProposalCount: Scalars['Int'];
};

export type CateringProposalSelection = {
  proposalVariantIds: Array<Scalars['Int']>;
  truckGroupId: Scalars['Int'];
};

export enum CateringProposalStatus {
  Approved = 'approved',
  Pending = 'pending',
  Rejected = 'rejected'
}

/** Autogenerated return type of CateringProposalUpdateComments. */
export type CateringProposalUpdateCommentsPayload = {
  __typename?: 'CateringProposalUpdateCommentsPayload';
  cateringRequest?: Maybe<CateringRequest>;
  cateringTruckRequest?: Maybe<CateringTruckRequest>;
  errors?: Maybe<Array<UserError>>;
  requestProposal?: Maybe<CateringRequestProposal>;
};

/** Autogenerated return type of CateringProposalUpdateStatus. */
export type CateringProposalUpdateStatusPayload = {
  __typename?: 'CateringProposalUpdateStatusPayload';
  cateringRequest?: Maybe<CateringRequest>;
  cateringTruckRequest?: Maybe<CateringTruckRequest>;
  errors?: Maybe<Array<UserError>>;
  requestProposal?: Maybe<CateringRequestProposal>;
};

/** Autogenerated return type of CateringProposalUpdateVariantComments. */
export type CateringProposalUpdateVariantCommentsPayload = {
  __typename?: 'CateringProposalUpdateVariantCommentsPayload';
  cateringRequest?: Maybe<CateringRequest>;
  cateringTruckRequest?: Maybe<CateringTruckRequest>;
  errors?: Maybe<Array<UserError>>;
  proposalVariant?: Maybe<CateringRequestProposalVariant>;
  requestProposal?: Maybe<CateringRequestProposal>;
};

export type CateringQueueTruck = {
  __typename?: 'CateringQueueTruck';
  createdAt: Scalars['DateTime'];
  id: Scalars['Int'];
  notificationBatchIndex?: Maybe<Scalars['Int']>;
  notifiedAt?: Maybe<Scalars['DateTime']>;
  position: Scalars['Int'];
  truck: Truck;
};

/** Autogenerated return type of CateringRecurringCreate. */
export type CateringRecurringCreatePayload = {
  __typename?: 'CateringRecurringCreatePayload';
  errors?: Maybe<Array<UserError>>;
  id?: Maybe<Scalars['Int']>;
};

export type CateringRequest = {
  __typename?: 'CateringRequest';
  acceptingOrders: Scalars['Boolean'];
  additionalInstructions?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  anonymousTrucks: Scalars['Boolean'];
  attendees: Scalars['Int'];
  bathroomAvailability?: Maybe<Scalars['String']>;
  bftFeePercentage?: Maybe<Scalars['Float']>;
  canBeCancelled: Scalars['Boolean'];
  canBeFinished: Scalars['Boolean'];
  canBeReverted: Scalars['Boolean'];
  canBeUncancelled: Scalars['Boolean'];
  canConvertToDepositPayment: Scalars['Boolean'];
  canConvertToFullPayment: Scalars['Boolean'];
  canPayByAch: Scalars['Boolean'];
  cateringOrders: CateringOrderCollection;
  cateringType: Scalars['String'];
  code: Scalars['String'];
  conciergeFeeAmount: Money;
  conciergeFeeRefundable: Scalars['Boolean'];
  conciergeFeeStatus: ConciergeFeeStatus;
  conciergeFeeStatusHuman: Scalars['String'];
  contactName?: Maybe<Scalars['String']>;
  contactPhone?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  creationNote?: Maybe<Scalars['String']>;
  customer?: Maybe<Customer>;
  customerBudgetModifier: Money;
  customerBudgetPerPerson: Money;
  customerCanNotifyQueue: Scalars['Boolean'];
  customerOwsAmount: Money;
  customerPaidAmount: Money;
  customerPath: Scalars['String'];
  customerTotalBudget: Money;
  customerUrl: Scalars['String'];
  dropOff?: Maybe<Scalars['Boolean']>;
  emailThreads: Array<EmailThread>;
  emailThreadsSummary: ConversationSummary;
  enableAlcoholCatering: Scalars['Boolean'];
  enabledEmails: Array<Scalars['String']>;
  endAt: Scalars['DateTime'];
  extraParkingSpace?: Maybe<Scalars['String']>;
  fixedLocation: Scalars['Boolean'];
  foodPreferences?: Maybe<Scalars['String']>;
  foodTrucksEstimate?: Maybe<FoodTrucksEstimate>;
  forceAllowAch?: Maybe<Scalars['Boolean']>;
  fullAddress: Scalars['String'];
  fundsAvailableToPayTrucks: Money;
  id: Scalars['Int'];
  instantBookStatus: CateringInstantBookStatus;
  instantBookingNotAcknowledged: Scalars['Int'];
  invoices: Array<CateringInvoice>;
  leftToPayByCustomer: Money;
  manualTruckDebits: Array<CateringManualTruckDebit>;
  market: Market;
  markupMultiplier: Scalars['Float'];
  mealParts: Array<CateringMealPart>;
  myTruckRequests: Array<CateringTruckRequest>;
  newProposalCount: Scalars['Int'];
  notesForTruck?: Maybe<Scalars['String']>;
  notificationCounts: Array<CateringNotificationCounts>;
  optimisticLockingToken: Scalars['String'];
  ordersEnabled: Scalars['Boolean'];
  ordersLimitMode: CateringOrdersLimitMode;
  ordersMode: CateringOrdersMode;
  ordersPublicUrl?: Maybe<Scalars['String']>;
  organization?: Maybe<Organization>;
  organizerDebits: Array<CateringOrganizerDebit>;
  overageRequests: Array<CateringOverageRequest>;
  parkingInstructions?: Maybe<Scalars['String']>;
  paymentStatus: CateringRequestPaymentStatus;
  paymentStatusHuman: Scalars['String'];
  preferredContactMethod: CateringPreferredContactMethod;
  preferredContactMethodHuman: Scalars['String'];
  preferredTruck?: Maybe<Truck>;
  queueBatchSize: Scalars['Int'];
  queueCustomerCheckInAt?: Maybe<Scalars['DateTime']>;
  queueNotificationAt?: Maybe<Scalars['DateTime']>;
  quoteConverted?: Maybe<Scalars['Boolean']>;
  quoteOnly?: Maybe<Scalars['Boolean']>;
  requestProposal: CateringRequestProposal;
  requestProposalStatuses: Array<KeyValue>;
  requestProposals: Array<CateringRequestProposal>;
  requestTruckGroups: Array<CateringRequestTruckGroup>;
  requiredDocuments: Array<TruckDocumentCategory>;
  requiredDocumentsNotes?: Maybe<Scalars['String']>;
  scheduleConflicts: Array<TruckScheduleConflict>;
  shortAddress: Scalars['String'];
  startAt: Scalars['DateTime'];
  status: CateringRequestStatus;
  statusCustomerHuman: Scalars['String'];
  statusHuman: Scalars['String'];
  stepsCustomer: Array<CateringRequestStep>;
  stripeReferences?: Maybe<Array<StripeReference>>;
  tags: Array<Scalars['String']>;
  textConversation?: Maybe<TextConversation>;
  textMessagesSummary?: Maybe<ConversationSummary>;
  totalTruckSpots: Scalars['Int'];
  travelBudget: Money;
  truckArrivalTime?: Maybe<Scalars['String']>;
  truckAssignments: Array<CateringTruckAssignment>;
  truckDebits: Array<CateringTruckDebit>;
  truckRequests: Array<CateringTruckRequest>;
};


export type CateringRequestCateringOrdersArgs = {
  filter?: InputMaybe<CateringOrdersFilterInput>;
  page?: InputMaybe<CollectionInput>;
  sort?: InputMaybe<Array<CateringOrdersSortInput>>;
};


export type CateringRequestRequestProposalArgs = {
  id: Scalars['Int'];
};


export type CateringRequestScheduleConflictsArgs = {
  truckId: Scalars['Int'];
};


export type CateringRequestTextConversationArgs = {
  createIfNotExists?: InputMaybe<Scalars['Boolean']>;
};

/** Autogenerated return type of CateringRequestAddTrucks. */
export type CateringRequestAddTrucksPayload = {
  __typename?: 'CateringRequestAddTrucksPayload';
  cateringRequest?: Maybe<CateringRequest>;
  errors?: Maybe<Array<UserError>>;
  truckRequirementsNotMet?: Maybe<Array<Truck>>;
};

/** Autogenerated return type of CateringRequestAssignOrganizer. */
export type CateringRequestAssignOrganizerPayload = {
  __typename?: 'CateringRequestAssignOrganizerPayload';
  cateringRequest?: Maybe<CateringRequest>;
  errors?: Maybe<Array<UserError>>;
};

export type CateringRequestBudget = {
  __typename?: 'CateringRequestBudget';
  amount?: Maybe<Money>;
  error?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of CateringRequestCancel. */
export type CateringRequestCancelPayload = {
  __typename?: 'CateringRequestCancelPayload';
  cateringRequest?: Maybe<CateringRequest>;
  errors?: Maybe<Array<UserError>>;
};

export type CateringRequestCollection = Collection & {
  __typename?: 'CateringRequestCollection';
  /** Limit */
  limit?: Maybe<Scalars['Int']>;
  /** Offset */
  offset?: Maybe<Scalars['Int']>;
  /** List of records */
  records: Array<CateringRequest>;
  /** Total */
  total: Scalars['Int'];
};


export type CateringRequestCollectionTotalArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};

/** Autogenerated return type of CateringRequestConfirmConciergeFee. */
export type CateringRequestConfirmConciergeFeePayload = {
  __typename?: 'CateringRequestConfirmConciergeFeePayload';
  cateringRequest?: Maybe<CateringRequest>;
  errors?: Maybe<Array<UserError>>;
};

/** Autogenerated return type of CateringRequestCreateConciergeFeePaymentIntent. */
export type CateringRequestCreateConciergeFeePaymentIntentPayload = {
  __typename?: 'CateringRequestCreateConciergeFeePaymentIntentPayload';
  clientSecret?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<UserError>>;
  paymentIntentId?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of CateringRequestCreate. */
export type CateringRequestCreatePayload = {
  __typename?: 'CateringRequestCreatePayload';
  cateringRequest?: Maybe<CateringRequest>;
  draft?: Maybe<Scalars['Boolean']>;
  errors?: Maybe<Array<UserError>>;
};

/** Autogenerated return type of CateringRequestDeleteTrucks. */
export type CateringRequestDeleteTrucksPayload = {
  __typename?: 'CateringRequestDeleteTrucksPayload';
  cateringRequest?: Maybe<CateringRequest>;
  errors?: Maybe<Array<UserError>>;
};

/** Autogenerated return type of CateringRequestFinished. */
export type CateringRequestFinishedPayload = {
  __typename?: 'CateringRequestFinishedPayload';
  cateringRequest?: Maybe<CateringRequest>;
  errors?: Maybe<Array<UserError>>;
};

/** Autogenerated return type of CateringRequestMakeTruckQueue. */
export type CateringRequestMakeTruckQueuePayload = {
  __typename?: 'CateringRequestMakeTruckQueuePayload';
  cateringRequest?: Maybe<CateringRequest>;
  errors?: Maybe<Array<UserError>>;
};

/** Autogenerated return type of CateringRequestNotifyQueue. */
export type CateringRequestNotifyQueuePayload = {
  __typename?: 'CateringRequestNotifyQueuePayload';
  cateringRequest?: Maybe<CateringRequest>;
  errors?: Maybe<Array<UserError>>;
};

/** Autogenerated return type of CateringRequestNotifyQueueTrucks. */
export type CateringRequestNotifyQueueTrucksPayload = {
  __typename?: 'CateringRequestNotifyQueueTrucksPayload';
  cateringRequest?: Maybe<CateringRequest>;
  errors?: Maybe<Array<UserError>>;
};

export enum CateringRequestPaymentStatus {
  AwaitingPayment = 'awaiting_payment',
  Paid = 'paid'
}

export type CateringRequestPreview = {
  __typename?: 'CateringRequestPreview';
  acceptingOrders: Scalars['Boolean'];
  anonymousTrucks: Scalars['Boolean'];
  code: Scalars['String'];
  conciergeFeeAmount: Money;
  conciergeFeeRefundable: Scalars['Boolean'];
  conciergeFeeStatus: ConciergeFeeStatus;
  customerPath: Scalars['String'];
  customerUrl: Scalars['String'];
  dropOff: Scalars['Boolean'];
  foodTrucksEstimate?: Maybe<FoodTrucksEstimate>;
  id: Scalars['Int'];
  ordersEnabled: Scalars['Boolean'];
  ordersLimitMode: CateringOrdersLimitMode;
  ordersMode: CateringOrdersMode;
  requestProposal?: Maybe<CateringRequestProposalPreview>;
  requestProposals: Array<CateringRequestProposalPreview>;
  requestTruckGroups: Array<CateringRequestTruckGroupPreview>;
  status: CateringRequestStatus;
  statusCustomerHuman: Scalars['String'];
  statusHuman: Scalars['String'];
  truckAssignments: Array<CateringTruckAssignmentPreview>;
};


export type CateringRequestPreviewRequestProposalArgs = {
  id: Scalars['Int'];
};

export type CateringRequestProposal = {
  __typename?: 'CateringRequestProposal';
  autoReview?: Maybe<Scalars['Boolean']>;
  cancellationPolicy: Array<Scalars['String']>;
  cancellationPolicyFullDays: Scalars['Int'];
  cancellationPolicyHalfDays: Scalars['Int'];
  combinedComments?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  customerBudget: Money;
  customerBudgetModifier: Money;
  customerMenuUrl: Scalars['String'];
  endAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  instantBook: Scalars['Boolean'];
  instantBookAcknowledged: Scalars['Boolean'];
  items: Array<Item>;
  menu: Menu;
  menuComments?: Maybe<Scalars['String']>;
  otherComments?: Maybe<Scalars['String']>;
  overageAmountPerMeal?: Maybe<Money>;
  proposalVariants: Array<CateringRequestProposalVariant>;
  requestTruckGroup: CateringRequestTruckGroup;
  reviewedOtherComments?: Maybe<Scalars['String']>;
  scheduleConflicts: Array<TruckScheduleConflict>;
  startAt?: Maybe<Scalars['DateTime']>;
  status: CateringProposalStatus;
  truck: Truck;
  truckBudget: Money;
  truckBudgetModifier: Money;
  truckBudgetPerPerson: Money;
  truckChat?: Maybe<TruckChat>;
  truckEmailThreads: Array<EmailThread>;
  truckName: Scalars['String'];
  truckRequest: CateringTruckRequest;
  truckTags: Array<Scalars['String']>;
  warnings: Array<Scalars['String']>;
};


export type CateringRequestProposalCancellationPolicyArgs = {
  showFee?: InputMaybe<Scalars['Boolean']>;
};


export type CateringRequestProposalCustomerMenuUrlArgs = {
  includeToken?: InputMaybe<Scalars['Boolean']>;
};

export type CateringRequestProposalPreview = {
  __typename?: 'CateringRequestProposalPreview';
  combinedComments?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  customerMenuUrl: Scalars['String'];
  id: Scalars['Int'];
  instantBook: Scalars['Boolean'];
  items: Array<Item>;
  proposalVariants: Array<CateringRequestProposalVariantPreview>;
  requestTruckGroup: CateringRequestTruckGroupPreview;
  reviewedOtherComments?: Maybe<Scalars['String']>;
  scheduleConflicts: Array<TruckScheduleConflict>;
  status: CateringProposalStatus;
  truck: Truck;
  truckName: Scalars['String'];
  truckTags: Array<Scalars['String']>;
};

export type CateringRequestProposalSuggestion = {
  __typename?: 'CateringRequestProposalSuggestion';
  cancellationPolicyFullDays: Scalars['Int'];
  cancellationPolicyHalfDays: Scalars['Int'];
  id: Scalars['Int'];
  menuId?: Maybe<Scalars['Int']>;
  otherComments: Scalars['String'];
  variants: Array<CateringRequestProposalSuggestionVariant>;
};

export type CateringRequestProposalSuggestionVariant = {
  __typename?: 'CateringRequestProposalSuggestionVariant';
  id: Scalars['Int'];
  itemIds: Array<Scalars['Int']>;
  menuComments: Scalars['String'];
  overageAmountPerMeal?: Maybe<Money>;
};

export type CateringRequestProposalVariant = {
  __typename?: 'CateringRequestProposalVariant';
  customerBudget: Money;
  customerBudgetModifier: Money;
  customerOverageAmountPerMeal?: Maybe<Money>;
  id: Scalars['Int'];
  items: Array<Item>;
  menuComments?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  overageAmountPerMeal?: Maybe<Money>;
  position: Scalars['Int'];
  reviewedMenuComments?: Maybe<Scalars['String']>;
  selected: Scalars['Boolean'];
  truckBudget: Money;
  truckBudgetModifier: Money;
  truckBudgetPerPerson: Money;
};

export type CateringRequestProposalVariantInput = {
  itemIds: Array<Scalars['Int']>;
  menuComments?: InputMaybe<Scalars['String']>;
  modifierCents?: InputMaybe<Scalars['Int']>;
};

export type CateringRequestProposalVariantPreview = {
  __typename?: 'CateringRequestProposalVariantPreview';
  id: Scalars['Int'];
  items: Array<Item>;
  name: Scalars['String'];
  position: Scalars['Int'];
  reviewedMenuComments?: Maybe<Scalars['String']>;
  selected: Scalars['Boolean'];
};

/** Autogenerated return type of CateringRequestQueueRemove. */
export type CateringRequestQueueRemovePayload = {
  __typename?: 'CateringRequestQueueRemovePayload';
  cateringRequest?: Maybe<CateringRequest>;
  errors?: Maybe<Array<UserError>>;
};

/** Autogenerated return type of CateringRequestQueueReorder. */
export type CateringRequestQueueReorderPayload = {
  __typename?: 'CateringRequestQueueReorderPayload';
  cateringRequest?: Maybe<CateringRequest>;
  errors?: Maybe<Array<UserError>>;
};

/** Autogenerated return type of CateringRequestReadyForSelection. */
export type CateringRequestReadyForSelectionPayload = {
  __typename?: 'CateringRequestReadyForSelectionPayload';
  cateringRequest?: Maybe<CateringRequest>;
  errors?: Maybe<Array<UserError>>;
};

/** Autogenerated return type of CateringRequestRefundConciergeFee. */
export type CateringRequestRefundConciergeFeePayload = {
  __typename?: 'CateringRequestRefundConciergeFeePayload';
  cateringRequest?: Maybe<CateringRequest>;
  errors?: Maybe<Array<UserError>>;
};

/** Autogenerated return type of CateringRequestRevert. */
export type CateringRequestRevertPayload = {
  __typename?: 'CateringRequestRevertPayload';
  cateringRequest?: Maybe<CateringRequest>;
  errors?: Maybe<Array<UserError>>;
};

export enum CateringRequestStatus {
  Cancelled = 'cancelled',
  Confirmed = 'confirmed',
  Finished = 'finished',
  OrganizerAssigned = 'organizer_assigned',
  OrganizerConfirmed = 'organizer_confirmed',
  Pending = 'pending',
  TruckSelection = 'truck_selection',
  TrucksNotified = 'trucks_notified'
}

export type CateringRequestStep = {
  __typename?: 'CateringRequestStep';
  id: Scalars['String'];
  key: Scalars['String'];
  name: Scalars['String'];
  status: CateringRequestStepStatus;
};

export enum CateringRequestStepStatus {
  Completed = 'completed',
  Failed = 'failed',
  InProgress = 'in_progress',
  Pending = 'pending'
}

export type CateringRequestTruckGroup = {
  __typename?: 'CateringRequestTruckGroup';
  attendees: Scalars['Int'];
  endAt: Scalars['DateTime'];
  foodPreferences?: Maybe<Scalars['String']>;
  foodTypes: Array<FoodType>;
  id: Scalars['Int'];
  mealParts: Array<CateringMealPart>;
  name: Scalars['String'];
  queueTrucks: Array<CateringQueueTruck>;
  requestProposals: Array<CateringRequestProposal>;
  spots: Scalars['Int'];
  startAt: Scalars['DateTime'];
  truckBudget: Money;
  truckBudgetPerPerson?: Maybe<Money>;
  truckFeePercentage: Scalars['Float'];
  truckRequests: Array<CateringTruckRequest>;
};

export type CateringRequestTruckGroupInput = {
  attendees: Scalars['Int'];
  endAt?: InputMaybe<Scalars['DateTime']>;
  foodPreferences?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  mealParts: Array<MealPartsInput>;
  name: Scalars['String'];
  spots: Scalars['Int'];
  startAt?: InputMaybe<Scalars['DateTime']>;
  truckBudgetCents: Scalars['Int'];
  truckFeePercentage: Scalars['Float'];
};

export type CateringRequestTruckGroupPreview = {
  __typename?: 'CateringRequestTruckGroupPreview';
  attendees?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  mealParts: Array<CateringMealPart>;
  name: Scalars['String'];
  requestProposals: Array<CateringRequestProposalPreview>;
  spots: Scalars['Int'];
};

/** Autogenerated return type of CateringRequestTruckGroupsUpdate. */
export type CateringRequestTruckGroupsUpdatePayload = {
  __typename?: 'CateringRequestTruckGroupsUpdatePayload';
  cateringRequest?: Maybe<CateringRequest>;
  errors?: Maybe<Array<UserError>>;
};

/** Autogenerated return type of CateringRequestUncancel. */
export type CateringRequestUncancelPayload = {
  __typename?: 'CateringRequestUncancelPayload';
  cateringRequest?: Maybe<CateringRequest>;
  errors?: Maybe<Array<UserError>>;
};

export type CateringRequestUpdateInput = {
  additionalInstructions?: InputMaybe<Scalars['String']>;
  anonymousTrucks?: InputMaybe<Scalars['Boolean']>;
  attendees?: InputMaybe<Scalars['Int']>;
  bathroomAvailability?: InputMaybe<Scalars['String']>;
  bftFeePercentage?: InputMaybe<Scalars['Float']>;
  cateringType?: InputMaybe<Scalars['String']>;
  contactName?: InputMaybe<Scalars['String']>;
  contactPhone?: InputMaybe<Scalars['String']>;
  customerTotalBudgetCents?: InputMaybe<Scalars['Int']>;
  enabledEmails?: InputMaybe<Array<Scalars['String']>>;
  endAt?: InputMaybe<Scalars['DateTime']>;
  extraParkingSpace?: InputMaybe<Scalars['String']>;
  forceAllowAch?: InputMaybe<Scalars['Boolean']>;
  fullAddress?: InputMaybe<Scalars['String']>;
  marketId?: InputMaybe<Scalars['Int']>;
  markupMultiplier?: InputMaybe<Scalars['Float']>;
  mealParts?: InputMaybe<Array<MealPartsInput>>;
  notesForTruck?: InputMaybe<Scalars['String']>;
  ordersEnabled?: InputMaybe<Scalars['Boolean']>;
  ordersLimitMode?: InputMaybe<CateringOrdersLimitMode>;
  ordersMode?: InputMaybe<CateringOrdersMode>;
  parkingInstructions?: InputMaybe<Scalars['String']>;
  quoteOnly?: InputMaybe<Scalars['Boolean']>;
  requiredDocuments?: InputMaybe<Array<TruckDocumentCategoryId>>;
  requiredDocumentsNotes?: InputMaybe<Scalars['String']>;
  startAt?: InputMaybe<Scalars['DateTime']>;
  travelBudgetCents?: InputMaybe<Scalars['Int']>;
  truckArrivalTime?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of CateringRequestUpdate. */
export type CateringRequestUpdatePayload = {
  __typename?: 'CateringRequestUpdatePayload';
  cateringRequest?: Maybe<CateringRequest>;
  errors?: Maybe<Array<UserError>>;
};

/** Autogenerated return type of CateringRequestUpdateQueueBatchSize. */
export type CateringRequestUpdateQueueBatchSizePayload = {
  __typename?: 'CateringRequestUpdateQueueBatchSizePayload';
  cateringRequest?: Maybe<CateringRequest>;
  errors?: Maybe<Array<UserError>>;
};

/** Autogenerated return type of CateringRequestUpdateTags. */
export type CateringRequestUpdateTagsPayload = {
  __typename?: 'CateringRequestUpdateTagsPayload';
  cateringRequest?: Maybe<CateringRequest>;
  errors?: Maybe<Array<UserError>>;
};

export type CateringRequestsFilterInput = {
  conciergeFeeStatuses?: InputMaybe<Array<ConciergeFeeStatus>>;
  /** Requests created after this date */
  createdAtGt?: InputMaybe<Scalars['DateTime']>;
  /** Requests created before this date */
  createdAtLt?: InputMaybe<Scalars['DateTime']>;
  dropOff?: InputMaybe<Scalars['Boolean']>;
  hasNewProposals?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  marketId?: InputMaybe<Scalars['Int']>;
  maxCustomerTotalBudgetCents?: InputMaybe<Scalars['Int']>;
  minCustomerTotalBudgetCents?: InputMaybe<Scalars['Int']>;
  /** Requests with no paid invoice */
  missingDeposit?: InputMaybe<Scalars['Boolean']>;
  myTruckHasProposal?: InputMaybe<Scalars['Boolean']>;
  myTruckRejected?: InputMaybe<Scalars['Boolean']>;
  notAcknowledged?: InputMaybe<Scalars['Boolean']>;
  or?: InputMaybe<Array<CateringRequestsFilterInput>>;
  organizationId?: InputMaybe<Scalars['Int']>;
  paymentStatuses?: InputMaybe<Array<CateringRequestPaymentStatus>>;
  quoteOnly?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  /** Requests with event start after this date */
  startAtGt?: InputMaybe<Scalars['DateTime']>;
  /** Requests with event start before this date */
  startAtLt?: InputMaybe<Scalars['DateTime']>;
  statuses?: InputMaybe<Array<CateringRequestStatus>>;
  tags?: InputMaybe<Array<Scalars['String']>>;
  truckId?: InputMaybe<Scalars['Int']>;
};

export type CateringRequestsSortInput = {
  /** ASC / DESC */
  direction: SortDirection;
  /** Field to sort by */
  field: CateringRequestsSortInputFields;
};

export enum CateringRequestsSortInputFields {
  CreatedAt = 'created_at',
  StartAt = 'start_at'
}

export type CateringTruckAssignment = {
  __typename?: 'CateringTruckAssignment';
  canSubmitOverageRequest: Scalars['Boolean'];
  id: Scalars['Int'];
  leftToPay: Money;
  ordersLeft: Scalars['Int'];
  overageRequests: Array<CateringOverageRequest>;
  requestProposal: CateringRequestProposal;
  requestTruckGroup: CateringRequestTruckGroup;
  truck: Truck;
  truckPaid: Money;
  truckPayTotal: Money;
  truckPayWithFee: Money;
};

export type CateringTruckAssignmentPreview = {
  __typename?: 'CateringTruckAssignmentPreview';
  id: Scalars['Int'];
  ordersLeft: Scalars['Int'];
  requestProposal: CateringRequestProposalPreview;
  requestTruckGroup: CateringRequestTruckGroupPreview;
  truck: Truck;
};

/** Autogenerated return type of CateringTruckBudgetUpdate. */
export type CateringTruckBudgetUpdatePayload = {
  __typename?: 'CateringTruckBudgetUpdatePayload';
  cateringRequest?: Maybe<CateringRequest>;
  errors?: Maybe<Array<UserError>>;
};

export type CateringTruckDebit = {
  __typename?: 'CateringTruckDebit';
  amount: Money;
  id: Scalars['Int'];
  status: CateringTruckDebitStatus;
  statusHuman: Scalars['String'];
  stripeReferences?: Maybe<Array<StripeReference>>;
  truck: Truck;
};

/** Autogenerated return type of CateringTruckDebitCreate. */
export type CateringTruckDebitCreatePayload = {
  __typename?: 'CateringTruckDebitCreatePayload';
  cateringDebit?: Maybe<CateringTruckDebit>;
  cateringRequest?: Maybe<CateringRequest>;
  errors?: Maybe<Array<UserError>>;
};

export enum CateringTruckDebitStatus {
  Paid = 'paid',
  Pending = 'pending',
  Reversed = 'reversed'
}

export type CateringTruckRequest = {
  __typename?: 'CateringTruckRequest';
  acceptedAt?: Maybe<Scalars['DateTime']>;
  cateringRequest: CateringRequest;
  createdAt: Scalars['DateTime'];
  id: Scalars['Int'];
  proposalHistory: CateringProposalHistory;
  rejectReason?: Maybe<Scalars['String']>;
  rejectedAt?: Maybe<Scalars['DateTime']>;
  requestProposal?: Maybe<CateringRequestProposal>;
  requestTruckGroup: CateringRequestTruckGroup;
  status: CateringTruckRequestStatus;
  statusHuman: Scalars['String'];
  statusTruckHuman: Scalars['String'];
  steps: Array<CateringRequestStep>;
  truck: Truck;
  truckProposalSuggestion?: Maybe<CateringRequestProposalSuggestion>;
};

/** Autogenerated return type of CateringTruckRequestPropose. */
export type CateringTruckRequestProposePayload = {
  __typename?: 'CateringTruckRequestProposePayload';
  cateringRequest?: Maybe<CateringRequest>;
  cateringTruckRequest?: Maybe<CateringTruckRequest>;
  errors?: Maybe<Array<UserError>>;
};

/** Autogenerated return type of CateringTruckRequestReject. */
export type CateringTruckRequestRejectPayload = {
  __typename?: 'CateringTruckRequestRejectPayload';
  cateringRequest?: Maybe<CateringRequest>;
  cateringTruckRequest?: Maybe<CateringTruckRequest>;
  errors?: Maybe<Array<UserError>>;
};

export enum CateringTruckRequestStatus {
  Accepted = 'accepted',
  Chosen = 'chosen',
  Outdated = 'outdated',
  Rejected = 'rejected',
  Sent = 'sent'
}

export type ClientCompaniesReport = {
  __typename?: 'ClientCompaniesReport';
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  iframeUrl: Scalars['String'];
  slug: Scalars['String'];
  title: Scalars['String'];
};

export type ClientCompany = {
  __typename?: 'ClientCompany';
  clientCompanyCards?: Maybe<Array<ClientCompanyCard>>;
  clientCompanyDaySummaries?: Maybe<Array<ClientCompanyDaySummary>>;
  clientCompanyDaySummary?: Maybe<ClientCompanyDaySummary>;
  clientCompanyMonthSummaries?: Maybe<Array<ClientCompanyMonthSummary>>;
  corporateUsers?: Maybe<Array<CorporateUser>>;
  couponSignupCode?: Maybe<Scalars['String']>;
  couponSignupEnabled?: Maybe<Scalars['Boolean']>;
  dayDiscounts?: Maybe<Array<DayDiscount>>;
  email: Scalars['String'];
  id: Scalars['Int'];
  invoiceCollectionMethod: ClientCompanyInvoiceCollectionMethod;
  lots?: Maybe<Array<Lot>>;
  maxDiscountPerLocation?: Maybe<Money>;
  maxDiscountPerLocationEnabled?: Maybe<Scalars['Boolean']>;
  members: CustomerCollection;
  name: Scalars['String'];
  onlyAchPayments: Scalars['Boolean'];
  reports: Array<ClientCompaniesReport>;
};


export type ClientCompanyClientCompanyDaySummariesArgs = {
  from?: InputMaybe<Scalars['Date']>;
  to?: InputMaybe<Scalars['Date']>;
};


export type ClientCompanyClientCompanyDaySummaryArgs = {
  date: Scalars['DateTime'];
};


export type ClientCompanyMembersArgs = {
  filter?: InputMaybe<CustomersFilterInput>;
  page?: InputMaybe<CollectionInput>;
  sort?: InputMaybe<Array<CustomersSortInput>>;
};

/** Autogenerated return type of ClientCompanyAddCard. */
export type ClientCompanyAddCardPayload = {
  __typename?: 'ClientCompanyAddCardPayload';
  clientCompanyCard?: Maybe<ClientCompanyCard>;
  errors?: Maybe<Array<UserError>>;
};

/** Autogenerated return type of ClientCompanyAddLot. */
export type ClientCompanyAddLotPayload = {
  __typename?: 'ClientCompanyAddLotPayload';
  clientCompany?: Maybe<ClientCompany>;
  errors?: Maybe<Array<UserError>>;
};

/** Autogenerated return type of ClientCompanyAddMember. */
export type ClientCompanyAddMemberPayload = {
  __typename?: 'ClientCompanyAddMemberPayload';
  errors?: Maybe<Array<UserError>>;
  member?: Maybe<Customer>;
};

/** Autogenerated return type of ClientCompanyAddMembers. */
export type ClientCompanyAddMembersPayload = {
  __typename?: 'ClientCompanyAddMembersPayload';
  errors?: Maybe<Array<UserError>>;
  members?: Maybe<Array<Customer>>;
};

export type ClientCompanyCard = {
  __typename?: 'ClientCompanyCard';
  active?: Maybe<Scalars['Boolean']>;
  brand?: Maybe<Scalars['String']>;
  expMonth?: Maybe<Scalars['String']>;
  expYear?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  last4?: Maybe<Scalars['String']>;
};

export type ClientCompanyCollection = Collection & {
  __typename?: 'ClientCompanyCollection';
  /** Limit */
  limit?: Maybe<Scalars['Int']>;
  /** Offset */
  offset?: Maybe<Scalars['Int']>;
  /** List of records */
  records: Array<ClientCompany>;
  /** Total */
  total: Scalars['Int'];
};


export type ClientCompanyCollectionTotalArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};

/** Autogenerated return type of ClientCompanyCreate. */
export type ClientCompanyCreatePayload = {
  __typename?: 'ClientCompanyCreatePayload';
  clientCompany?: Maybe<ClientCompany>;
  errors?: Maybe<Array<UserError>>;
};

export type ClientCompanyDayDiscountInput = {
  /** Discount in cents */
  discountCents: Scalars['Int'];
  /** Day of week */
  wday: Scalars['Int'];
};

export type ClientCompanyDaySummary = {
  __typename?: 'ClientCompanyDaySummary';
  date: Scalars['Date'];
  id: Scalars['Int'];
  orderCount: Scalars['Int'];
  orders: Array<Order>;
  spentByMembers: Money;
  spentPerMember: Money;
  totalSpent: Money;
};

/** Autogenerated return type of ClientCompanyDiscountUpdate. */
export type ClientCompanyDiscountUpdatePayload = {
  __typename?: 'ClientCompanyDiscountUpdatePayload';
  clientCompany?: Maybe<ClientCompany>;
  errors?: Maybe<Array<UserError>>;
};

export type ClientCompanyInput = {
  /** Notification Email */
  email?: InputMaybe<Scalars['String']>;
  /** How Stripe collects payment for this company's invoices */
  invoiceCollectionMethod?: InputMaybe<ClientCompanyInvoiceCollectionMethod>;
  /** Name */
  name?: InputMaybe<Scalars['String']>;
  /** Offer only ACH payment methods on Stripe invoices */
  onlyAchPayments?: InputMaybe<Scalars['Boolean']>;
};

export type ClientCompanyInvoice = {
  __typename?: 'ClientCompanyInvoice';
  amountClientCompany: Money;
  clientCompanyPaymentStatus: ClientCompanyInvoicePaymentStatus;
  clientCompanyPaymentStatusHuman: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['Int'];
  location?: Maybe<Location>;
  orders: OrderCollection;
  stripeInvoicePdfUrl?: Maybe<Scalars['String']>;
  stripeNumber?: Maybe<Scalars['String']>;
  stripePaymentUrl?: Maybe<Scalars['String']>;
  stripeReferences?: Maybe<Array<StripeReference>>;
};


export type ClientCompanyInvoiceOrdersArgs = {
  filter?: InputMaybe<OrdersFilterInput>;
  page?: InputMaybe<CollectionInput>;
  sort?: InputMaybe<Array<OrdersSortInput>>;
};

export type ClientCompanyInvoiceCollection = Collection & {
  __typename?: 'ClientCompanyInvoiceCollection';
  /** Limit */
  limit?: Maybe<Scalars['Int']>;
  /** Offset */
  offset?: Maybe<Scalars['Int']>;
  /** List of records */
  records: Array<ClientCompanyInvoice>;
  /** Total */
  total: Scalars['Int'];
};


export type ClientCompanyInvoiceCollectionTotalArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};

export enum ClientCompanyInvoiceCollectionMethod {
  ChargeAutomatically = 'charge_automatically',
  SendInvoice = 'send_invoice'
}

export enum ClientCompanyInvoicePaymentStatus {
  ClientCompanyNotPaid = 'client_company_not_paid',
  ClientCompanyPaid = 'client_company_paid',
  ClientCompanyRefunded = 'client_company_refunded'
}

export type ClientCompanyInvoiceSortInput = {
  /** ASC / DESC */
  direction: SortDirection;
  /** Field to sort by */
  field: ClientCompanyInvoiceSortInputFields;
};

export enum ClientCompanyInvoiceSortInputFields {
  CreatedAt = 'created_at'
}

/** Autogenerated return type of ClientCompanyMakeCardCurrent. */
export type ClientCompanyMakeCardCurrentPayload = {
  __typename?: 'ClientCompanyMakeCardCurrentPayload';
  clientCompanyCard?: Maybe<ClientCompanyCard>;
  errors?: Maybe<Array<UserError>>;
};

export type ClientCompanyMemberInput = {
  /** Notification Email */
  email: Scalars['String'];
  /** First Name */
  firstName: Scalars['String'];
  /** Last Name */
  lastName: Scalars['String'];
  /** Phone */
  phone?: InputMaybe<Scalars['String']>;
};

export type ClientCompanyMonthSummary = {
  __typename?: 'ClientCompanyMonthSummary';
  id: Scalars['Int'];
  month: Scalars['Date'];
  orderCount: Scalars['Int'];
};

/** Autogenerated return type of ClientCompanyRemoveCard. */
export type ClientCompanyRemoveCardPayload = {
  __typename?: 'ClientCompanyRemoveCardPayload';
  errors?: Maybe<Array<UserError>>;
};

/** Autogenerated return type of ClientCompanyRemoveLot. */
export type ClientCompanyRemoveLotPayload = {
  __typename?: 'ClientCompanyRemoveLotPayload';
  clientCompany?: Maybe<ClientCompany>;
  errors?: Maybe<Array<UserError>>;
};

/** Autogenerated return type of ClientCompanyRemoveMember. */
export type ClientCompanyRemoveMemberPayload = {
  __typename?: 'ClientCompanyRemoveMemberPayload';
  clientCompany?: Maybe<ClientCompany>;
  errors?: Maybe<Array<UserError>>;
};

/** Autogenerated return type of ClientCompanySignupCouponUpdate. */
export type ClientCompanySignupCouponUpdatePayload = {
  __typename?: 'ClientCompanySignupCouponUpdatePayload';
  clientCompany?: Maybe<ClientCompany>;
  errors?: Maybe<Array<UserError>>;
};

/** Autogenerated return type of ClientCompanyUpdate. */
export type ClientCompanyUpdatePayload = {
  __typename?: 'ClientCompanyUpdatePayload';
  clientCompany?: Maybe<ClientCompany>;
  errors?: Maybe<Array<UserError>>;
};

export type Collection = {
  /** Limit */
  limit?: Maybe<Scalars['Int']>;
  /** Offset */
  offset?: Maybe<Scalars['Int']>;
  /** Total */
  total: Scalars['Int'];
};


export type CollectionTotalArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};

export type CollectionInput = {
  /** Limit */
  limit?: InputMaybe<Scalars['Int']>;
  /** Offset */
  offset?: InputMaybe<Scalars['Int']>;
};

export enum CommentableEntity {
  CateringAlcoholRequest = 'CateringAlcoholRequest',
  CateringOtherSubmission = 'CateringOtherSubmission',
  CateringRecurringSubmission = 'CateringRecurringSubmission',
  CateringRequest = 'CateringRequest',
  Customer = 'Customer',
  EmailConversation = 'EmailConversation',
  Event = 'Event',
  EventsRequest = 'EventsRequest',
  GoogleFormSubmission = 'GoogleFormSubmission',
  Location = 'Location',
  Lot = 'Lot',
  Restaurant = 'Restaurant',
  Truck = 'Truck',
  TruckChat = 'TruckChat',
  User = 'User'
}

export enum ConciergeFeeStatus {
  ConciergeFeePaid = 'concierge_fee_paid',
  ConciergeFeePending = 'concierge_fee_pending',
  ConciergeFeeRefunded = 'concierge_fee_refunded',
  NoConciergeFee = 'no_concierge_fee'
}

export type ContentSection = {
  __typename?: 'ContentSection';
  content: HtmlRecord;
  id: Scalars['Int'];
  image?: Maybe<ImageAttachment>;
  imageAlt?: Maybe<Scalars['String']>;
  position: Scalars['Int'];
};

export type ContentSectionInput = {
  content: HtmlRecordInput;
  id?: InputMaybe<Scalars['Int']>;
  image?: InputMaybe<Scalars['Upload']>;
  imageAlt?: InputMaybe<Scalars['String']>;
};

export type ContractEnvelope = {
  __typename?: 'ContractEnvelope';
  createdAt: Scalars['DateTime'];
  documents: Array<FileAttachment>;
  email: Scalars['String'];
  externalAdminUrl?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  status: ContractEnvelopeStatus;
  statusHuman: Scalars['String'];
  templateName: Scalars['String'];
  title: Scalars['String'];
};

export enum ContractEnvelopeStatus {
  Authoritativecopy = 'authoritativecopy',
  Completed = 'completed',
  Correct = 'correct',
  Created = 'created',
  Declined = 'declined',
  Deleted = 'deleted',
  Delivered = 'delivered',
  Initial = 'initial',
  Sent = 'sent',
  Signed = 'signed',
  Template = 'template',
  Timedout = 'timedout',
  Transfercompleted = 'transfercompleted',
  Voided = 'voided'
}

/** Autogenerated return type of ContractEnvelopeVoid. */
export type ContractEnvelopeVoidPayload = {
  __typename?: 'ContractEnvelopeVoidPayload';
  envelope?: Maybe<ContractEnvelope>;
  errors?: Maybe<Array<UserError>>;
};

export type Conversation = {
  __typename?: 'Conversation';
  id: Scalars['Int'];
  texts?: Maybe<Array<Text>>;
};

export type ConversationSummary = {
  __typename?: 'ConversationSummary';
  id: Scalars['String'];
  messagesTotal: Scalars['Int'];
  unread: Scalars['Boolean'];
};

export type CorporateUser = {
  __typename?: 'CorporateUser';
  active: Scalars['Boolean'];
  authToken?: Maybe<Scalars['String']>;
  clientCompany?: Maybe<ClientCompany>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  lastName?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  spoofUrl?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of CorporateUserCreate. */
export type CorporateUserCreatePayload = {
  __typename?: 'CorporateUserCreatePayload';
  corporateUser?: Maybe<CorporateUser>;
  errors?: Maybe<Array<UserError>>;
};

/** Autogenerated return type of CorporateUserForgotPassword. */
export type CorporateUserForgotPasswordPayload = {
  __typename?: 'CorporateUserForgotPasswordPayload';
  errors?: Maybe<Array<UserError>>;
};

/** Autogenerated return type of CorporateUserLogin. */
export type CorporateUserLoginPayload = {
  __typename?: 'CorporateUserLoginPayload';
  corporateUser?: Maybe<CorporateUser>;
  errors?: Maybe<Array<UserError>>;
};

/** Autogenerated return type of CorporateUserResetPassword. */
export type CorporateUserResetPasswordPayload = {
  __typename?: 'CorporateUserResetPasswordPayload';
  corporateUser?: Maybe<CorporateUser>;
  errors?: Maybe<Array<UserError>>;
};

/** Autogenerated return type of CorporateUserUpdate. */
export type CorporateUserUpdatePayload = {
  __typename?: 'CorporateUserUpdatePayload';
  corporateUser?: Maybe<CorporateUser>;
  errors?: Maybe<Array<UserError>>;
};

export type Coupon = {
  __typename?: 'Coupon';
  active: Scalars['Boolean'];
  activeAfterTime?: Maybe<Scalars['DateTime']>;
  activeBeforeTime?: Maybe<Scalars['DateTime']>;
  code: Scalars['String'];
  discount?: Maybe<Money>;
  discountPaidBy: CouponDiscountPaidBy;
  discountPercentage?: Maybe<Scalars['Int']>;
  discountType: CouponDiscountType;
  enableMoneyLimit: Scalars['Boolean'];
  id: Scalars['Int'];
  lots?: Maybe<LotCollection>;
  maxDiscountAmount: Money;
  minOrderAmount: Money;
  moneyLimit?: Maybe<Money>;
  multiUse: Scalars['Boolean'];
  name: Scalars['String'];
  platforms: Array<Platform>;
  remainingDiscount?: Maybe<Money>;
  restaurant?: Maybe<Restaurant>;
  showInEmail: Scalars['Boolean'];
};

export type CouponCollection = Collection & {
  __typename?: 'CouponCollection';
  /** Limit */
  limit?: Maybe<Scalars['Int']>;
  /** Offset */
  offset?: Maybe<Scalars['Int']>;
  /** List of records */
  records: Array<Coupon>;
  /** Total */
  total: Scalars['Int'];
};


export type CouponCollectionTotalArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};

/** Autogenerated return type of CouponCreate. */
export type CouponCreatePayload = {
  __typename?: 'CouponCreatePayload';
  coupon?: Maybe<Coupon>;
  errors?: Maybe<Array<UserError>>;
};

/** Autogenerated return type of CouponDisable. */
export type CouponDisablePayload = {
  __typename?: 'CouponDisablePayload';
  coupon?: Maybe<Coupon>;
  errors?: Maybe<Array<UserError>>;
};

export enum CouponDiscountPaidBy {
  PaidByBft = 'paid_by_bft',
  PaidByRestaurant = 'paid_by_restaurant'
}

export enum CouponDiscountType {
  FlatDiscount = 'flat_discount',
  PercentageDiscount = 'percentage_discount'
}

/** Autogenerated return type of CouponEnable. */
export type CouponEnablePayload = {
  __typename?: 'CouponEnablePayload';
  coupon?: Maybe<Coupon>;
  errors?: Maybe<Array<UserError>>;
};

export type CouponInput = {
  active: Scalars['Boolean'];
  activeAfterTime?: InputMaybe<Scalars['DateTime']>;
  activeBeforeTime?: InputMaybe<Scalars['DateTime']>;
  code: Scalars['String'];
  discountCents: Scalars['Int'];
  discountPercentage: Scalars['Int'];
  discountType: CouponDiscountType;
  enableMoneyLimit: Scalars['Boolean'];
  lotIds?: InputMaybe<Array<Scalars['Int']>>;
  maxDiscountAmountCents: Scalars['Int'];
  minOrderAmountCents: Scalars['Int'];
  moneyLimitCents: Scalars['Int'];
  multiUse: Scalars['Boolean'];
  name: Scalars['String'];
  platforms: Array<Platform>;
  showInEmail: Scalars['Boolean'];
};

/** Autogenerated return type of CouponUpdate. */
export type CouponUpdatePayload = {
  __typename?: 'CouponUpdatePayload';
  coupon?: Maybe<Coupon>;
  errors?: Maybe<Array<UserError>>;
};

export type CouponsFilterInput = {
  /** Filter by active status */
  active?: InputMaybe<Scalars['Boolean']>;
  /** Filter by who pays for discount */
  discountPaidBy?: InputMaybe<CouponDiscountPaidBy>;
  /** Filter by multi-use */
  multiUse?: InputMaybe<Scalars['Boolean']>;
  /** Filter by name (case-insensitive) */
  nameSearch?: InputMaybe<Scalars['String']>;
  /** Filter by restaurant */
  restaurantId?: InputMaybe<Scalars['Int']>;
};

export type CouponsSortInput = {
  /** ASC / DESC */
  direction: SortDirection;
  /** Field to sort by */
  field: CouponsSortInputFields;
};

export enum CouponsSortInputFields {
  Active = 'active',
  CreatedAt = 'created_at',
  Name = 'name'
}

/** Autogenerated return type of CreditsTriggerConfigUpdate. */
export type CreditsTriggerConfigUpdatePayload = {
  __typename?: 'CreditsTriggerConfigUpdatePayload';
  creditsTriggersConfig?: Maybe<CreditsTriggersConfig>;
  errors?: Maybe<Array<UserError>>;
};

export type CreditsTriggersConfig = {
  __typename?: 'CreditsTriggersConfig';
  triggerConfigs: Array<TriggerConfig>;
};

export type Customer = {
  __typename?: 'Customer';
  amountCredit: Money;
  anonymous: Scalars['Boolean'];
  authenticationToken: Scalars['String'];
  cateringOrders: CateringOrderCollection;
  cateringRequests?: Maybe<Array<CateringRequest>>;
  completeProfile: Scalars['Boolean'];
  customerCards: Array<CustomerCard>;
  email: Scalars['String'];
  eventsRequests?: Maybe<Array<EventsRequest>>;
  firstName?: Maybe<Scalars['String']>;
  fraud: Scalars['Boolean'];
  genericSubscriptions?: Maybe<Array<GenericSubscription>>;
  id: Scalars['Int'];
  lastName?: Maybe<Scalars['String']>;
  lotSubscriptions?: Maybe<Array<LotSubscription>>;
  name?: Maybe<Scalars['String']>;
  orders: OrderCollection;
  phone?: Maybe<Scalars['Phone']>;
  profilePicture: CustomerProfilePicture;
  referralCode: Scalars['String'];
  spoofUrl?: Maybe<Scalars['String']>;
  stripeLink?: Maybe<Scalars['String']>;
  tawkHash?: Maybe<Scalars['String']>;
  trackingOptedOut: Scalars['Boolean'];
};


export type CustomerCateringOrdersArgs = {
  filter?: InputMaybe<CateringOrdersFilterInput>;
  page?: InputMaybe<CollectionInput>;
  sort?: InputMaybe<Array<CateringOrdersSortInput>>;
};


export type CustomerOrdersArgs = {
  filter?: InputMaybe<OrdersFilterInput>;
  page?: InputMaybe<CollectionInput>;
  sort?: InputMaybe<Array<OrdersSortInput>>;
};

/** Autogenerated return type of CustomerBulkCreateByAdmin. */
export type CustomerBulkCreateByAdminPayload = {
  __typename?: 'CustomerBulkCreateByAdminPayload';
  customers?: Maybe<Array<Customer>>;
  errors?: Maybe<Array<UserError>>;
  rowErrors?: Maybe<Array<Scalars['String']>>;
};

export type CustomerCard = {
  __typename?: 'CustomerCard';
  brand: Scalars['String'];
  currentPaymentMethod: Scalars['Boolean'];
  id: Scalars['Int'];
  last4: Scalars['String'];
  stripeId: Scalars['String'];
};

/** Autogenerated return type of CustomerCardRemove. */
export type CustomerCardRemovePayload = {
  __typename?: 'CustomerCardRemovePayload';
  customer?: Maybe<Customer>;
  customerCard?: Maybe<CustomerCard>;
  errors?: Maybe<Array<UserError>>;
};

export type CustomerCollection = Collection & {
  __typename?: 'CustomerCollection';
  /** Limit */
  limit?: Maybe<Scalars['Int']>;
  /** Offset */
  offset?: Maybe<Scalars['Int']>;
  /** List of records */
  records: Array<Customer>;
  /** Total */
  total: Scalars['Int'];
};


export type CustomerCollectionTotalArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};

/** Autogenerated return type of CustomerCreateByAdmin. */
export type CustomerCreateByAdminPayload = {
  __typename?: 'CustomerCreateByAdminPayload';
  customer?: Maybe<Customer>;
  errors?: Maybe<Array<UserError>>;
};

/** Autogenerated return type of CustomerCreateByOrganizer. */
export type CustomerCreateByOrganizerPayload = {
  __typename?: 'CustomerCreateByOrganizerPayload';
  customer?: Maybe<Customer>;
  errors?: Maybe<Array<UserError>>;
};

/** Autogenerated return type of CustomerCreditCreate. */
export type CustomerCreditCreatePayload = {
  __typename?: 'CustomerCreditCreatePayload';
  customer?: Maybe<Customer>;
  errors?: Maybe<Array<UserError>>;
};

/** Autogenerated return type of CustomerDeviceRegister. */
export type CustomerDeviceRegisterPayload = {
  __typename?: 'CustomerDeviceRegisterPayload';
  errors?: Maybe<Array<UserError>>;
  success?: Maybe<Scalars['Boolean']>;
};

/** Autogenerated return type of CustomerEmailCodeLogin. */
export type CustomerEmailCodeLoginPayload = {
  __typename?: 'CustomerEmailCodeLoginPayload';
  customer?: Maybe<Customer>;
  errors?: Maybe<Array<UserError>>;
  redirectTo?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of CustomerEmailCodeSignup. */
export type CustomerEmailCodeSignupPayload = {
  __typename?: 'CustomerEmailCodeSignupPayload';
  customer?: Maybe<Customer>;
  errors?: Maybe<Array<UserError>>;
  redirectTo?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of CustomerGenericSubscriptionsCreate. */
export type CustomerGenericSubscriptionsCreatePayload = {
  __typename?: 'CustomerGenericSubscriptionsCreatePayload';
  customer?: Maybe<Customer>;
  errors?: Maybe<Array<UserError>>;
};

/** Autogenerated return type of CustomerLogin. */
export type CustomerLoginPayload = {
  __typename?: 'CustomerLoginPayload';
  customer?: Maybe<Customer>;
  errors?: Maybe<Array<UserError>>;
  redirectTo?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of CustomerPartnerAuth. */
export type CustomerPartnerAuthPayload = {
  __typename?: 'CustomerPartnerAuthPayload';
  customer?: Maybe<Customer>;
  errors?: Maybe<Array<UserError>>;
};

export type CustomerPaths = {
  __typename?: 'CustomerPaths';
  blogPostsPaths: Array<Scalars['String']>;
  cateringCategoryPaths: Array<Scalars['String']>;
  cateringFoodTypesPaths: Array<Scalars['String']>;
  lotPaths: Array<Scalars['String']>;
  marketPaths: Array<Scalars['String']>;
  marketTopTrucksPaths: Array<Scalars['String']>;
  marketTrucksListPaths: Array<Scalars['String']>;
  truckPaths: Array<Scalars['String']>;
  trucksMapPaths: Array<Scalars['String']>;
};

/** Autogenerated return type of CustomerPhoneLogin. */
export type CustomerPhoneLoginPayload = {
  __typename?: 'CustomerPhoneLoginPayload';
  customer?: Maybe<Customer>;
  errors?: Maybe<Array<UserError>>;
  redirectTo?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of CustomerPhoneSignup. */
export type CustomerPhoneSignupPayload = {
  __typename?: 'CustomerPhoneSignupPayload';
  customer?: Maybe<Customer>;
  errors?: Maybe<Array<UserError>>;
  redirectTo?: Maybe<Scalars['String']>;
};

export type CustomerProfilePicture = {
  __typename?: 'CustomerProfilePicture';
  original?: Maybe<Scalars['String']>;
  present: Scalars['Boolean'];
  small: Scalars['String'];
};

/** Autogenerated return type of CustomerRemove. */
export type CustomerRemovePayload = {
  __typename?: 'CustomerRemovePayload';
  errors?: Maybe<Array<UserError>>;
};

/** Autogenerated return type of CustomerUnmarkAsFraud. */
export type CustomerUnmarkAsFraudPayload = {
  __typename?: 'CustomerUnmarkAsFraudPayload';
  customer?: Maybe<Customer>;
  errors?: Maybe<Array<UserError>>;
};

/** Autogenerated return type of CustomerUpdateEmail. */
export type CustomerUpdateEmailPayload = {
  __typename?: 'CustomerUpdateEmailPayload';
  customer?: Maybe<Customer>;
  errors?: Maybe<Array<UserError>>;
};

/** Autogenerated return type of CustomerUpdateName. */
export type CustomerUpdateNamePayload = {
  __typename?: 'CustomerUpdateNamePayload';
  customer?: Maybe<Customer>;
  errors?: Maybe<Array<UserError>>;
};

/** Autogenerated return type of CustomerUpdate. */
export type CustomerUpdatePayload = {
  __typename?: 'CustomerUpdatePayload';
  customer?: Maybe<Customer>;
  errors?: Maybe<Array<UserError>>;
};

/** Autogenerated return type of CustomerUpdatePhone. */
export type CustomerUpdatePhonePayload = {
  __typename?: 'CustomerUpdatePhonePayload';
  customer?: Maybe<Customer>;
  errors?: Maybe<Array<UserError>>;
};

export type CustomersFilterInput = {
  /** Only customers who have an event request on this lot (organizer must manage the lot) */
  managesLotId?: InputMaybe<Scalars['Int']>;
  /** Filter */
  search?: InputMaybe<Scalars['String']>;
};

export type CustomersSortInput = {
  /** ASC / DESC */
  direction: SortDirection;
  /** Field to sort by */
  field: CustomersSortInputFields;
};

export enum CustomersSortInputFields {
  FirstName = 'first_name',
  LastName = 'last_name'
}

export type DashEntitySubscription = {
  __typename?: 'DashEntitySubscription';
  id: Scalars['String'];
  subscribed: Scalars['Boolean'];
};

export type DashNotification = {
  __typename?: 'DashNotification';
  body: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['Int'];
  read: Scalars['Boolean'];
  title: Scalars['String'];
  url?: Maybe<Scalars['String']>;
};

export type DashNotificationCollection = Collection & {
  __typename?: 'DashNotificationCollection';
  /** Limit */
  limit?: Maybe<Scalars['Int']>;
  /** Offset */
  offset?: Maybe<Scalars['Int']>;
  /** List of records */
  records: Array<DashNotification>;
  /** Total */
  total: Scalars['Int'];
};


export type DashNotificationCollectionTotalArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};

export type DashNotificationsFilterInput = {
  unread?: InputMaybe<Scalars['Boolean']>;
};

/** Autogenerated return type of DashNotificationsMarkRead. */
export type DashNotificationsMarkReadPayload = {
  __typename?: 'DashNotificationsMarkReadPayload';
  dashNotifications?: Maybe<Array<DashNotification>>;
  errors?: Maybe<Array<UserError>>;
};

/** Autogenerated return type of DashSubscribeToEntity. */
export type DashSubscribeToEntityPayload = {
  __typename?: 'DashSubscribeToEntityPayload';
  entitySubscription?: Maybe<DashEntitySubscription>;
  errors?: Maybe<Array<UserError>>;
};

export type DashSubscriptionChannel = {
  __typename?: 'DashSubscriptionChannel';
  description: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
  subscribed: Scalars['Boolean'];
  value: Scalars['String'];
};

/** Autogenerated return type of DashSubscriptionChannelsUpdate. */
export type DashSubscriptionChannelsUpdatePayload = {
  __typename?: 'DashSubscriptionChannelsUpdatePayload';
  dashSubscriptionChannels?: Maybe<Array<DashSubscriptionChannel>>;
  errors?: Maybe<Array<UserError>>;
};

export type DashWatcher = {
  __typename?: 'DashWatcher';
  entityId: Scalars['Int'];
  entityType: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
  userId: Scalars['Int'];
};

export type DayDiscount = {
  __typename?: 'DayDiscount';
  discount: Money;
  wday: Scalars['Int'];
  wdayName: Scalars['String'];
};

export type DefaultEventSetting = {
  __typename?: 'DefaultEventSetting';
  allowTrucksToSpecifyTime: Scalars['Boolean'];
  bookingCancellationFee: Money;
  lotFoodRestrictions: Array<LotFoodRestriction>;
  numberedSpots: Scalars['Boolean'];
  paidCancellationIntervalSeconds: Scalars['Int'];
  refundIntervalSeconds: Scalars['Int'];
  spotDescriptions: Array<SpotDescription>;
  spots: Scalars['Int'];
  truckGroupRules: Array<TruckGroupRule>;
};

export type DefaultLotSetting = {
  __typename?: 'DefaultLotSetting';
  bookingCancellationFee: Money;
  email?: Maybe<Scalars['String']>;
  facebook?: Maybe<Scalars['String']>;
  instagram?: Maybe<Scalars['String']>;
  market?: Maybe<Market>;
  paidCancellationIntervalSeconds: Scalars['Int'];
  phone?: Maybe<Scalars['String']>;
  refundIntervalSeconds: Scalars['Int'];
  sameTruckBookingSeconds: Scalars['Int'];
  snapchat?: Maybe<Scalars['String']>;
  truckGroupRules: Array<TruckGroupRule>;
  twitter?: Maybe<Scalars['String']>;
  website?: Maybe<Scalars['String']>;
  yelp?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of DefaultLotSettingsUpdate. */
export type DefaultLotSettingsUpdatePayload = {
  __typename?: 'DefaultLotSettingsUpdatePayload';
  defaultLotSetting?: Maybe<DefaultLotSetting>;
  errors?: Maybe<Array<UserError>>;
};

/** Autogenerated return type of DeleteAccountRequest. */
export type DeleteAccountRequestPayload = {
  __typename?: 'DeleteAccountRequestPayload';
  errors?: Maybe<Array<UserError>>;
  success?: Maybe<Scalars['Boolean']>;
};

export enum DepositStatus {
  DepositPaid = 'deposit_paid',
  DepositPending = 'deposit_pending',
  DepositRefunded = 'deposit_refunded',
  NoDeposit = 'no_deposit'
}

export enum DevicePlatform {
  Android = 'android',
  Ios = 'ios'
}

export type DistanceFilterInput = {
  /** Miles */
  distance: Scalars['Float'];
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
};

export type EmailConversation = {
  __typename?: 'EmailConversation';
  email: Scalars['String'];
  emailMessages: EmailMessageCollection;
  emailThreads: Array<EmailThread>;
  id: Scalars['Int'];
  read: Scalars['Boolean'];
  subscribed: Scalars['Boolean'];
};


export type EmailConversationEmailMessagesArgs = {
  page?: InputMaybe<CollectionInput>;
  sort?: InputMaybe<Array<EmailMessagesSortInput>>;
};


export type EmailConversationEmailThreadsArgs = {
  filter?: InputMaybe<EmailThreadsFilterInput>;
};

export type EmailMessage = {
  __typename?: 'EmailMessage';
  attachments: Array<EmailMessageAttachment>;
  bccFull: Array<EmailMessageAddress>;
  ccFull: Array<EmailMessageAddress>;
  createdAt: Scalars['DateTime'];
  direction: EmailMessageDirection;
  fromFull: EmailMessageAddress;
  htmlBody?: Maybe<Scalars['String']>;
  htmlBodyPresent: Scalars['Boolean'];
  id: Scalars['Int'];
  name: Scalars['String'];
  preview: Scalars['String'];
  replyToFull: Array<EmailMessageAddress>;
  status: EmailMessageStatus;
  subject: Scalars['String'];
  textBody: Scalars['String'];
  toFull: Array<EmailMessageAddress>;
};

export type EmailMessageAddress = {
  __typename?: 'EmailMessageAddress';
  email: Scalars['String'];
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
};

export type EmailMessageAttachment = {
  __typename?: 'EmailMessageAttachment';
  filename: Scalars['String'];
  id: Scalars['Int'];
  url: Scalars['String'];
};

export type EmailMessageCollection = Collection & {
  __typename?: 'EmailMessageCollection';
  /** Limit */
  limit?: Maybe<Scalars['Int']>;
  /** Offset */
  offset?: Maybe<Scalars['Int']>;
  /** List of records */
  records: Array<EmailMessage>;
  /** Total */
  total: Scalars['Int'];
};


export type EmailMessageCollectionTotalArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};

export enum EmailMessageDirection {
  Inbound = 'inbound',
  Outbound = 'outbound'
}

export enum EmailMessageStatus {
  Failed = 'failed',
  Opened = 'opened',
  Sent = 'sent'
}

export type EmailMessagesSortInput = {
  /** ASC / DESC */
  direction: SortDirection;
  /** Field to sort by */
  field: EmailMessagesSortInputFields;
};

export enum EmailMessagesSortInputFields {
  CreatedAt = 'created_at'
}

export type EmailSuppression = {
  __typename?: 'EmailSuppression';
  email: Scalars['String'];
  reason: Scalars['String'];
};

export type EmailThread = {
  __typename?: 'EmailThread';
  cateringRequest?: Maybe<CateringRequest>;
  channel: EmailThreadChannel;
  customer?: Maybe<Customer>;
  emailConversation: EmailConversation;
  emailMessage: EmailMessage;
  emailMessageOpened: Scalars['Boolean'];
  emailMessages: EmailMessageCollection;
  emailMessagesCount: Scalars['Int'];
  entityId: Scalars['Int'];
  entityLink?: Maybe<Scalars['String']>;
  entityName: Scalars['String'];
  entityType: Scalars['String'];
  eventsRequest?: Maybe<EventsRequest>;
  id: Scalars['Int'];
  lastMessageAt: Scalars['DateTime'];
  organizer?: Maybe<Organizer>;
  read: Scalars['Boolean'];
  restaurant?: Maybe<Restaurant>;
  textConversation?: Maybe<TextConversation>;
  title: Scalars['String'];
  truck?: Maybe<Truck>;
  updatedAt: Scalars['DateTime'];
  userName: Scalars['String'];
};


export type EmailThreadEmailMessageArgs = {
  id: Scalars['Int'];
};


export type EmailThreadEmailMessagesArgs = {
  page?: InputMaybe<CollectionInput>;
  sort?: InputMaybe<Array<EmailMessagesSortInput>>;
};

export enum EmailThreadChannel {
  Ap = 'ap',
  Ar = 'ar',
  Catering = 'catering',
  Review = 'review',
  Sales = 'sales',
  Support = 'support'
}

export type EmailThreadCollection = Collection & {
  __typename?: 'EmailThreadCollection';
  /** Limit */
  limit?: Maybe<Scalars['Int']>;
  /** Offset */
  offset?: Maybe<Scalars['Int']>;
  /** List of records */
  records: Array<EmailThread>;
  /** Total */
  total: Scalars['Int'];
};


export type EmailThreadCollectionTotalArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};

export enum EmailThreadEntity {
  CateringAlcoholRequest = 'CateringAlcoholRequest',
  CateringOtherSubmission = 'CateringOtherSubmission',
  CateringRecurringSubmission = 'CateringRecurringSubmission',
  CateringRequest = 'CateringRequest',
  Event = 'Event',
  EventsRequest = 'EventsRequest',
  GoogleFormSubmission = 'GoogleFormSubmission',
  Lot = 'Lot',
  Truck = 'Truck'
}

/** Autogenerated return type of EmailThreadMarkAsRead. */
export type EmailThreadMarkAsReadPayload = {
  __typename?: 'EmailThreadMarkAsReadPayload';
  emailThread?: Maybe<EmailThread>;
  errors?: Maybe<Array<UserError>>;
};

export type EmailThreadsFilterInput = {
  cateringStatuses?: InputMaybe<Array<CateringRequestStatus>>;
  channel?: InputMaybe<Array<EmailThreadChannel>>;
  entityType?: InputMaybe<Scalars['String']>;
  entityTypes?: InputMaybe<Array<Scalars['String']>>;
  id?: InputMaybe<Scalars['Int']>;
  or?: InputMaybe<Array<EmailThreadsFilterInput>>;
  organizationId?: InputMaybe<Scalars['Int']>;
  read?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  userTypes?: InputMaybe<Array<EmailThreadsFilterUserType>>;
};

export enum EmailThreadsFilterUserType {
  Customer = 'customer',
  Organizer = 'organizer',
  Restaurant = 'restaurant',
  Unknown = 'unknown'
}

export type EmailThreadsSortInput = {
  /** ASC / DESC */
  direction: SortDirection;
  /** Field to sort by */
  field: EmailThreadsSortInputFields;
};

export enum EmailThreadsSortInputFields {
  CreatedAt = 'created_at',
  LastMessageAt = 'last_message_at',
  Read = 'read',
  UpdatedAt = 'updated_at'
}

/** Autogenerated return type of EmailVerificationCodeSend. */
export type EmailVerificationCodeSendPayload = {
  __typename?: 'EmailVerificationCodeSendPayload';
  canUsePasswordAuth?: Maybe<Scalars['Boolean']>;
  errors?: Maybe<Array<UserError>>;
};

/** Autogenerated return type of EmailVerificationCodeVerify. */
export type EmailVerificationCodeVerifyPayload = {
  __typename?: 'EmailVerificationCodeVerifyPayload';
  emailToken?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<UserError>>;
};

export type Employee = {
  __typename?: 'Employee';
  active: Scalars['Boolean'];
  authenticationToken?: Maybe<Scalars['String']>;
  availableFacebookPages?: Maybe<Array<FacebookRemotePage>>;
  availableGoogleCalendars?: Maybe<Array<CalendarOption>>;
  calendarIntegrations?: Maybe<Array<CalendarIntegration>>;
  connectedToFacebook?: Maybe<Scalars['Boolean']>;
  connectedToGoogleCalendar?: Maybe<Scalars['Boolean']>;
  connectedToTwitter?: Maybe<Scalars['Boolean']>;
  email?: Maybe<Scalars['String']>;
  facebookPages?: Maybe<Array<FacebookPage>>;
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  lastName?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  phone?: Maybe<Scalars['Phone']>;
  restaurant: Restaurant;
  roles: Array<EmployeeRole>;
  spoofUrl?: Maybe<Scalars['String']>;
  tawkHash?: Maybe<Scalars['String']>;
  trackingOptedOut: Scalars['Boolean'];
  truck: Truck;
  twitterIntegrations?: Maybe<Array<TwitterIntegration>>;
  userNotifications: UserNotificationCollection;
};


export type EmployeeUserNotificationsArgs = {
  filter?: InputMaybe<UserNotificationsFilterInput>;
  sort?: InputMaybe<Array<UserNotificationsSortInput>>;
};

/** Autogenerated return type of EmployeeChangePassword. */
export type EmployeeChangePasswordPayload = {
  __typename?: 'EmployeeChangePasswordPayload';
  employee?: Maybe<Employee>;
  errors?: Maybe<Array<UserError>>;
};

/** Autogenerated return type of EmployeeChangeTruck. */
export type EmployeeChangeTruckPayload = {
  __typename?: 'EmployeeChangeTruckPayload';
  employee?: Maybe<Employee>;
  errors?: Maybe<Array<UserError>>;
};

/** Autogenerated return type of EmployeeCreate. */
export type EmployeeCreatePayload = {
  __typename?: 'EmployeeCreatePayload';
  employee?: Maybe<Employee>;
  errors?: Maybe<Array<UserError>>;
};

/** Autogenerated return type of EmployeeForgotPassword. */
export type EmployeeForgotPasswordPayload = {
  __typename?: 'EmployeeForgotPasswordPayload';
  errors?: Maybe<Array<UserError>>;
};

/** Autogenerated return type of EmployeeLogin. */
export type EmployeeLoginPayload = {
  __typename?: 'EmployeeLoginPayload';
  employee?: Maybe<Employee>;
  errors?: Maybe<Array<UserError>>;
};

/** Autogenerated return type of EmployeeNotificationsCreate. */
export type EmployeeNotificationsCreatePayload = {
  __typename?: 'EmployeeNotificationsCreatePayload';
  errors?: Maybe<Array<UserError>>;
  userNotificationGroup?: Maybe<UserNotificationGroup>;
};

/** Autogenerated return type of EmployeeResetPassword. */
export type EmployeeResetPasswordPayload = {
  __typename?: 'EmployeeResetPasswordPayload';
  employee?: Maybe<Employee>;
  errors?: Maybe<Array<UserError>>;
};

export enum EmployeeRole {
  Booking = 'booking',
  Full = 'full',
  Menu = 'menu',
  Orders = 'orders',
  Permits = 'permits',
  Reports = 'reports'
}

/** Autogenerated return type of EmployeeUpdateByAdmin. */
export type EmployeeUpdateByAdminPayload = {
  __typename?: 'EmployeeUpdateByAdminPayload';
  employee?: Maybe<Employee>;
  errors?: Maybe<Array<UserError>>;
};

/** Autogenerated return type of EmployeeUpdate. */
export type EmployeeUpdatePayload = {
  __typename?: 'EmployeeUpdatePayload';
  employee?: Maybe<Employee>;
  errors?: Maybe<Array<UserError>>;
};

export type Event = {
  __typename?: 'Event';
  allowTrucksToSpecifyTime: Scalars['Boolean'];
  autoApplyEnabled: Scalars['Boolean'];
  autoCoverRuns?: Maybe<Array<AutoCoverRun>>;
  bookableAt?: Maybe<Scalars['DateTime']>;
  bookingAvailability: EventAvailability;
  bookingCancellationFee: Money;
  bookingMode: BookingMode;
  cancellationPolicyText: Scalars['String'];
  chargeSalesPercentage: Scalars['Float'];
  chargeSalesPercentageEnabled: Scalars['Boolean'];
  code: Scalars['String'];
  currentRestaurantTransactionFeePercentage: Scalars['Float'];
  customerEvent: Scalars['Boolean'];
  eligibleTrucks?: Maybe<Array<Truck>>;
  emailThreads: Array<EmailThread>;
  endAt: Scalars['DateTime'];
  eventSequence?: Maybe<EventSequence>;
  eventsRequest?: Maybe<EventsRequest>;
  eventsRequestPresent?: Maybe<Scalars['Boolean']>;
  fee: Money;
  fixedSalesGuarantee: Scalars['Boolean'];
  futureEventsInSequenceCount?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  instantBookEligibleTrucks: Array<Truck>;
  locations: LocationCollection;
  lot: Lot;
  lotFoodRestrictions: Array<LotFoodRestriction>;
  minOrdersAmount: Money;
  minimumAmountPolicy?: Maybe<Scalars['String']>;
  newProposalCount?: Maybe<Scalars['Int']>;
  numberedSpots: Scalars['Boolean'];
  paidCancellationIntervalSeconds: Scalars['Int'];
  peopleEstimated?: Maybe<Scalars['Int']>;
  refundIntervalSeconds: Scalars['Int'];
  refundPolicyText: Scalars['String'];
  registeredTrucks?: Maybe<Array<Truck>>;
  requiredDocuments: Array<TruckDocumentCategory>;
  requiredDocumentsNotes?: Maybe<Scalars['String']>;
  salesGuaranteeAmount: Money;
  salesPercentageFrom: LocationSalesPercentageFrom;
  salesPercentageIncludesBookingFee: Scalars['Boolean'];
  salesPercentagePolicy?: Maybe<Scalars['String']>;
  salesPrediction?: Maybe<SalesPrediction>;
  scheduleConflicts: Array<TruckScheduleConflict>;
  spotDescriptions: Array<SpotDescription>;
  spots?: Maybe<Scalars['Int']>;
  spotsInformation: Array<LotSpotInfo>;
  spotsLeft?: Maybe<Array<Scalars['Int']>>;
  startAt: Scalars['DateTime'];
  timeToChargeTruck: Scalars['Boolean'];
  timezone: Scalars['String'];
  truckChargeTime: Scalars['DateTime'];
  truckDashboardEventUrl: Scalars['String'];
  truckGroupRules: Array<TruckGroupRule>;
  truckProgressSteps: Array<CateringRequestStep>;
  truckProposals: Array<EventsTruckProposal>;
  truckRequest?: Maybe<TruckRequest>;
  truckRequests: Array<TruckRequest>;
  visible?: Maybe<Scalars['Boolean']>;
  weatherDescription?: Maybe<Scalars['String']>;
};


export type EventBookingAvailabilityArgs = {
  applyCredits?: InputMaybe<Scalars['Boolean']>;
  menuId?: InputMaybe<Scalars['Int']>;
  truckId: Scalars['Int'];
};


export type EventEligibleTrucksArgs = {
  disabledRules?: InputMaybe<Array<AvailabilityRule>>;
};


export type EventLocationsArgs = {
  filter?: InputMaybe<LocationsFilterInput>;
  page?: InputMaybe<CollectionInput>;
  sort?: InputMaybe<Array<LocationsSortInput>>;
};


export type EventSalesPercentagePolicyArgs = {
  truckId?: InputMaybe<Scalars['Int']>;
};


export type EventSalesPredictionArgs = {
  truckId: Scalars['Int'];
};


export type EventScheduleConflictsArgs = {
  truckId: Scalars['Int'];
};


export type EventTruckDashboardEventUrlArgs = {
  authenticated?: InputMaybe<Scalars['Boolean']>;
};


export type EventTruckProgressStepsArgs = {
  truckId: Scalars['Int'];
};


export type EventTruckRequestArgs = {
  truckId: Scalars['Int'];
};

/** Autogenerated return type of EventAddTrucks. */
export type EventAddTrucksPayload = {
  __typename?: 'EventAddTrucksPayload';
  errors?: Maybe<Array<UserError>>;
  event?: Maybe<Event>;
  truckRequests?: Maybe<Array<TruckRequest>>;
};

/** Autogenerated return type of EventAutoApply. */
export type EventAutoApplyPayload = {
  __typename?: 'EventAutoApplyPayload';
  errors?: Maybe<Array<UserError>>;
  event?: Maybe<Event>;
};

export type EventAvailability = {
  __typename?: 'EventAvailability';
  amountTruck: Money;
  availabilityErrors: Array<EventAvailabilityError>;
  available: Scalars['Boolean'];
  id: Scalars['String'];
};

export type EventAvailabilityDate = {
  __typename?: 'EventAvailabilityDate';
  date?: Maybe<Scalars['DateTime']>;
  events?: Maybe<Array<Event>>;
  locations?: Maybe<Array<Location>>;
};

export type EventAvailabilityError = {
  __typename?: 'EventAvailabilityError';
  message: Scalars['String'];
  name: AvailabilityRule;
};

/** Autogenerated return type of EventBook. */
export type EventBookPayload = {
  __typename?: 'EventBookPayload';
  errors?: Maybe<Array<UserError>>;
  event?: Maybe<Event>;
  location?: Maybe<Location>;
};

/** Autogenerated return type of EventChooseTruckProposal. */
export type EventChooseTruckProposalPayload = {
  __typename?: 'EventChooseTruckProposalPayload';
  errors?: Maybe<Array<UserError>>;
  event?: Maybe<Event>;
  location?: Maybe<Location>;
  truckRequest?: Maybe<TruckRequest>;
};

export type EventCollection = Collection & {
  __typename?: 'EventCollection';
  /** Limit */
  limit?: Maybe<Scalars['Int']>;
  /** Offset */
  offset?: Maybe<Scalars['Int']>;
  /** List of records */
  records: Array<Event>;
  /** Total */
  total: Scalars['Int'];
};


export type EventCollectionTotalArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};

/** Autogenerated return type of EventCreate. */
export type EventCreatePayload = {
  __typename?: 'EventCreatePayload';
  errors?: Maybe<Array<UserError>>;
  events?: Maybe<Array<Event>>;
};

/** Autogenerated return type of EventDestroy. */
export type EventDestroyPayload = {
  __typename?: 'EventDestroyPayload';
  errors?: Maybe<Array<UserError>>;
  success?: Maybe<Scalars['Boolean']>;
};

export enum EventOccurrenceType {
  Every = 'every',
  Every_1 = 'every_1',
  Every_2 = 'every_2',
  Every_3 = 'every_3',
  Every_4 = 'every_4',
  EveryOtherWeek = 'every_other_week',
  FirstWeek = 'first_week',
  LastWeek = 'last_week'
}

/** Autogenerated return type of EventProposalApprove. */
export type EventProposalApprovePayload = {
  __typename?: 'EventProposalApprovePayload';
  errors?: Maybe<Array<UserError>>;
  event?: Maybe<Event>;
  truckProposal?: Maybe<EventsTruckProposal>;
};

/** Autogenerated return type of EventProposalReject. */
export type EventProposalRejectPayload = {
  __typename?: 'EventProposalRejectPayload';
  errors?: Maybe<Array<UserError>>;
  event?: Maybe<Event>;
  truckProposal?: Maybe<EventsTruckProposal>;
};

/** Autogenerated return type of EventRegisterTruck. */
export type EventRegisterTruckPayload = {
  __typename?: 'EventRegisterTruckPayload';
  errors?: Maybe<Array<UserError>>;
  event?: Maybe<Event>;
  location?: Maybe<Location>;
};

export type EventSequence = {
  __typename?: 'EventSequence';
  color?: Maybe<Scalars['String']>;
  endAt: Scalars['DateTime'];
  id: Scalars['Int'];
  occurrenceDays: Array<Scalars['Int']>;
  occurrenceLengthSeconds?: Maybe<Scalars['Int']>;
  occurrenceType: EventOccurrenceType;
  startAt: Scalars['DateTime'];
};

/** Autogenerated return type of EventShareWithCustomer. */
export type EventShareWithCustomerPayload = {
  __typename?: 'EventShareWithCustomerPayload';
  errors?: Maybe<Array<UserError>>;
  eventsRequest?: Maybe<EventsRequest>;
};

/** Autogenerated return type of EventTruckPropose. */
export type EventTruckProposePayload = {
  __typename?: 'EventTruckProposePayload';
  errors?: Maybe<Array<UserError>>;
  event?: Maybe<Event>;
  proposal?: Maybe<EventsTruckProposal>;
};

/** Autogenerated return type of EventTruckRequestReject. */
export type EventTruckRequestRejectPayload = {
  __typename?: 'EventTruckRequestRejectPayload';
  errors?: Maybe<Array<UserError>>;
  event?: Maybe<Event>;
  truckRequest?: Maybe<TruckRequest>;
};

/** Autogenerated return type of EventUpdate. */
export type EventUpdatePayload = {
  __typename?: 'EventUpdatePayload';
  errors?: Maybe<Array<UserError>>;
  events?: Maybe<Array<Event>>;
};

/** Autogenerated return type of EventUpdateSalesGuarantee. */
export type EventUpdateSalesGuaranteePayload = {
  __typename?: 'EventUpdateSalesGuaranteePayload';
  errors?: Maybe<Array<UserError>>;
  event?: Maybe<Event>;
};

export type EventsFilterInput = {
  /** Events since date, inclusive */
  fromDatetime?: InputMaybe<Scalars['DateTime']>;
  /** Inactive are excluded by default */
  includeInactive?: InputMaybe<Scalars['Boolean']>;
  /** Filter by lot */
  lotId?: InputMaybe<Scalars['Int']>;
  /** Add events with other conditions */
  or?: InputMaybe<Array<EventsFilterInput>>;
  /** Events until date, inclusive */
  toDatetime?: InputMaybe<Scalars['DateTime']>;
};

export type EventsInstantBookConfig = {
  __typename?: 'EventsInstantBookConfig';
  baseHours?: Maybe<Scalars['Int']>;
  baseMinimumHighSeasonPremiumDays?: Maybe<Money>;
  baseMinimumHighSeasonRegularDays?: Maybe<Money>;
  baseMinimumPremiumDays?: Maybe<Money>;
  baseMinimumRegular?: Maybe<Money>;
  customerEventsEnabled: Scalars['Boolean'];
  extraHourHighSeasonPremiumDays?: Maybe<Money>;
  extraHourHighSeasonRegularDays?: Maybe<Money>;
  extraHourPremiumDays?: Maybe<Money>;
  extraHourRegular?: Maybe<Money>;
  finished: Scalars['Boolean'];
  highSeasonMonths: Array<Scalars['Int']>;
  id: Scalars['Int'];
  managedEventsEnabled: Scalars['Boolean'];
  menu?: Maybe<Menu>;
  noteForCustomer?: Maybe<Scalars['String']>;
  premiumDays: Array<Scalars['Int']>;
  truck: Truck;
};

/** Autogenerated return type of EventsInstantBookConfigCreate. */
export type EventsInstantBookConfigCreatePayload = {
  __typename?: 'EventsInstantBookConfigCreatePayload';
  errors?: Maybe<Array<UserError>>;
  eventsInstantBookConfig?: Maybe<EventsInstantBookConfig>;
};

/** Autogenerated return type of EventsInstantBookFinish. */
export type EventsInstantBookFinishPayload = {
  __typename?: 'EventsInstantBookFinishPayload';
  errors?: Maybe<Array<UserError>>;
  eventsInstantBookConfig?: Maybe<EventsInstantBookConfig>;
};

/** Autogenerated return type of EventsInstantBookUpdateGeneral. */
export type EventsInstantBookUpdateGeneralPayload = {
  __typename?: 'EventsInstantBookUpdateGeneralPayload';
  errors?: Maybe<Array<UserError>>;
  eventsInstantBookConfig?: Maybe<EventsInstantBookConfig>;
};

/** Autogenerated return type of EventsInstantBookUpdateMenu. */
export type EventsInstantBookUpdateMenuPayload = {
  __typename?: 'EventsInstantBookUpdateMenuPayload';
  errors?: Maybe<Array<UserError>>;
  eventsInstantBookConfig?: Maybe<EventsInstantBookConfig>;
};

/** Autogenerated return type of EventsInstantBookUpdatePricing. */
export type EventsInstantBookUpdatePricingPayload = {
  __typename?: 'EventsInstantBookUpdatePricingPayload';
  errors?: Maybe<Array<UserError>>;
  eventsInstantBookConfig?: Maybe<EventsInstantBookConfig>;
};

export type EventsRequest = {
  __typename?: 'EventsRequest';
  browseTrucksUrl: Scalars['String'];
  canAddTrucks: Scalars['Boolean'];
  canBookTrucks: Scalars['Boolean'];
  canCancel: Scalars['Boolean'];
  cancelReason?: Maybe<Scalars['String']>;
  code: Scalars['String'];
  contactEmail?: Maybe<Scalars['String']>;
  contactName?: Maybe<Scalars['String']>;
  contactPhone?: Maybe<Scalars['String']>;
  contractEnvelopes: Array<ContractEnvelope>;
  createdAt: Scalars['DateTime'];
  creationNote?: Maybe<Scalars['String']>;
  customer: Customer;
  customerPath: Scalars['String'];
  customerProgressSteps: Array<CateringRequestStep>;
  customerUrl: Scalars['String'];
  deadlineAt?: Maybe<Scalars['DateTime']>;
  depositAmount: Money;
  depositRefundable: Scalars['Boolean'];
  depositStatus: DepositStatus;
  depositStatusHuman: Scalars['String'];
  emailThreads: Array<EmailThread>;
  endAt: Scalars['DateTime'];
  event: Event;
  foodPreferences?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  instantBookStatus: InstantBookStatus;
  location?: Maybe<Location>;
  lot: Lot;
  managedEvent: Scalars['Boolean'];
  peopleEstimated?: Maybe<Scalars['Int']>;
  problems: Array<Scalars['String']>;
  salesGuaranteeAmount: Money;
  startAt: Scalars['DateTime'];
  status: Status;
  statusCustomerHuman: Scalars['String'];
  statusHuman: Scalars['String'];
  stripeReferences?: Maybe<Array<StripeReference>>;
  tags: Array<Scalars['String']>;
  textConversation?: Maybe<TextConversation>;
  truckAppBookingUrl: Scalars['String'];
  truckRequests: Array<TruckRequest>;
  truckSearchStatus: TruckSearchStatus;
  truckSuggestions: Array<EventsRequestTruckSuggestion>;
  useSalesGuarantee: Scalars['Boolean'];
};


export type EventsRequestTruckSuggestionsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  preferredTruckId?: InputMaybe<Scalars['Int']>;
};

/** Autogenerated return type of EventsRequestAddTrucks. */
export type EventsRequestAddTrucksPayload = {
  __typename?: 'EventsRequestAddTrucksPayload';
  errors?: Maybe<Array<UserError>>;
  eventsRequest?: Maybe<EventsRequest>;
};

/** Autogenerated return type of EventsRequestApprove. */
export type EventsRequestApprovePayload = {
  __typename?: 'EventsRequestApprovePayload';
  errors?: Maybe<Array<UserError>>;
  eventsRequest?: Maybe<EventsRequest>;
};

/** Autogenerated return type of EventsRequestCancel. */
export type EventsRequestCancelPayload = {
  __typename?: 'EventsRequestCancelPayload';
  errors?: Maybe<Array<UserError>>;
  eventsRequest?: Maybe<EventsRequest>;
};

/** Autogenerated return type of EventsRequestChooseTruckProposals. */
export type EventsRequestChooseTruckProposalsPayload = {
  __typename?: 'EventsRequestChooseTruckProposalsPayload';
  errors?: Maybe<Array<UserError>>;
  event?: Maybe<Event>;
  eventsRequest?: Maybe<EventsRequest>;
  locations?: Maybe<Array<Location>>;
  truckRequests?: Maybe<Array<TruckRequest>>;
};

export type EventsRequestCollection = Collection & {
  __typename?: 'EventsRequestCollection';
  /** Limit */
  limit?: Maybe<Scalars['Int']>;
  /** Offset */
  offset?: Maybe<Scalars['Int']>;
  /** List of records */
  records: Array<EventsRequest>;
  /** Total */
  total: Scalars['Int'];
};


export type EventsRequestCollectionTotalArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};

/** Autogenerated return type of EventsRequestConfirmDeposit. */
export type EventsRequestConfirmDepositPayload = {
  __typename?: 'EventsRequestConfirmDepositPayload';
  errors?: Maybe<Array<UserError>>;
  eventsRequest?: Maybe<EventsRequest>;
};

/** Autogenerated return type of EventsRequestCreate. */
export type EventsRequestCreatePayload = {
  __typename?: 'EventsRequestCreatePayload';
  errors?: Maybe<Array<UserError>>;
  eventsRequest?: Maybe<EventsRequest>;
};

/** Autogenerated return type of EventsRequestCreatePaymentIntent. */
export type EventsRequestCreatePaymentIntentPayload = {
  __typename?: 'EventsRequestCreatePaymentIntentPayload';
  clientSecret?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<UserError>>;
  paymentIntentId?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of EventsRequestDelete. */
export type EventsRequestDeletePayload = {
  __typename?: 'EventsRequestDeletePayload';
  errors?: Maybe<Array<UserError>>;
  event?: Maybe<Event>;
};

/** Autogenerated return type of EventsRequestRefundDeposit. */
export type EventsRequestRefundDepositPayload = {
  __typename?: 'EventsRequestRefundDepositPayload';
  errors?: Maybe<Array<UserError>>;
  eventsRequest?: Maybe<EventsRequest>;
};

export type EventsRequestTruckSuggestion = {
  __typename?: 'EventsRequestTruckSuggestion';
  id: Scalars['Int'];
  matchesFoodPreferences: Scalars['Boolean'];
  recommended: Scalars['Boolean'];
  tags: Array<Scalars['String']>;
  truck: Truck;
};

/** Autogenerated return type of EventsRequestUpdateTags. */
export type EventsRequestUpdateTagsPayload = {
  __typename?: 'EventsRequestUpdateTagsPayload';
  errors?: Maybe<Array<UserError>>;
  eventsRequest?: Maybe<EventsRequest>;
};

export type EventsRequestsFilterInput = {
  customerSigned?: InputMaybe<Scalars['Boolean']>;
  depositStatuses?: InputMaybe<Array<DepositStatus>>;
  /** true - shared by an organizer, false - created by a customer */
  managedEvent?: InputMaybe<Scalars['Boolean']>;
  /** Events Request is in one of these statuses */
  statuses?: InputMaybe<Array<Status>>;
  tags?: InputMaybe<Array<Scalars['String']>>;
  useSalesGuarantee?: InputMaybe<Scalars['Boolean']>;
};

export type EventsRequestsSortInput = {
  /** ASC / DESC */
  direction: SortDirection;
  /** Field to sort by */
  field: EventsRequestsSortInputFields;
};

export enum EventsRequestsSortInputFields {
  CreatedAt = 'created_at',
  DeadlineAt = 'deadline_at',
  InProgress = 'in_progress',
  StartAt = 'start_at'
}

export type EventsSortInput = {
  /** ASC / DESC */
  direction: SortDirection;
  /** Field to sort by */
  field: EventsSortInputFields;
};

export enum EventsSortInputFields {
  CreatedAt = 'created_at',
  StartAt = 'start_at'
}

export type EventsTruckProposal = {
  __typename?: 'EventsTruckProposal';
  applyCredits: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  /** Public link to this proposal's menu on the proposal's truck */
  customerMenuUrl: Scalars['String'];
  endAt?: Maybe<Scalars['DateTime']>;
  event: Event;
  id: Scalars['Int'];
  instantBook: Scalars['Boolean'];
  instantBookAcknowledged: Scalars['Boolean'];
  /** Last finished location on this lot (by time) */
  lastLotLocation?: Maybe<Location>;
  menu: Menu;
  notes?: Maybe<Scalars['String']>;
  /** Whether this proposal's truck is the customer's preferred truck */
  preferred: Scalars['Boolean'];
  rejectReason?: Maybe<Scalars['String']>;
  salesGuaranteeAmount: Money;
  /** Sales prediction for this truck at this event, visible to organizers and admins */
  salesPrediction?: Maybe<SalesPrediction>;
  scheduleConflicts: Array<TruckScheduleConflict>;
  spot?: Maybe<Scalars['Int']>;
  spotDescription?: Maybe<Scalars['String']>;
  startAt?: Maybe<Scalars['DateTime']>;
  status: EventsTruckProposalStatus;
  truck: Truck;
  truckRequest: TruckRequest;
};

/** Autogenerated return type of EventsTruckProposalAcknowledge. */
export type EventsTruckProposalAcknowledgePayload = {
  __typename?: 'EventsTruckProposalAcknowledgePayload';
  errors?: Maybe<Array<UserError>>;
  event?: Maybe<Event>;
  truckProposal?: Maybe<EventsTruckProposal>;
};

export enum EventsTruckProposalStatus {
  Approved = 'approved',
  Pending = 'pending',
  Rejected = 'rejected'
}

/** Autogenerated return type of ExperientialMarketingCreateNew. */
export type ExperientialMarketingCreateNewPayload = {
  __typename?: 'ExperientialMarketingCreateNewPayload';
  errors?: Maybe<Array<UserError>>;
  id?: Maybe<Scalars['Int']>;
};

/** Autogenerated return type of ExperientialRequestCreate. */
export type ExperientialRequestCreatePayload = {
  __typename?: 'ExperientialRequestCreatePayload';
  errors?: Maybe<Array<UserError>>;
};

export type FacebookMarketPage = {
  __typename?: 'FacebookMarketPage';
  active: Scalars['Boolean'];
  facebookUrl: Scalars['String'];
  id: Scalars['Int'];
  market: Market;
  name: Scalars['String'];
  user: Admin;
};

/** Autogenerated return type of FacebookMarketPageCreate. */
export type FacebookMarketPageCreatePayload = {
  __typename?: 'FacebookMarketPageCreatePayload';
  errors?: Maybe<Array<UserError>>;
  facebookMarketPage?: Maybe<FacebookMarketPage>;
};

/** Autogenerated return type of FacebookMarketPageDelete. */
export type FacebookMarketPageDeletePayload = {
  __typename?: 'FacebookMarketPageDeletePayload';
  errors?: Maybe<Array<UserError>>;
  success?: Maybe<Scalars['Boolean']>;
};

/** Autogenerated return type of FacebookMarketPageUpdate. */
export type FacebookMarketPageUpdatePayload = {
  __typename?: 'FacebookMarketPageUpdatePayload';
  errors?: Maybe<Array<UserError>>;
  facebookMarketPage?: Maybe<FacebookMarketPage>;
};

export type FacebookPage = {
  __typename?: 'FacebookPage';
  facebookUrl: Scalars['String'];
  id: Scalars['Int'];
  name: Scalars['String'];
  truck: Truck;
};

/** Autogenerated return type of FacebookPagePostingCreate. */
export type FacebookPagePostingCreatePayload = {
  __typename?: 'FacebookPagePostingCreatePayload';
  employee?: Maybe<Employee>;
  errors?: Maybe<Array<UserError>>;
};

/** Autogenerated return type of FacebookPagePostingDelete. */
export type FacebookPagePostingDeletePayload = {
  __typename?: 'FacebookPagePostingDeletePayload';
  employee?: Maybe<Employee>;
  errors?: Maybe<Array<UserError>>;
};

/** Autogenerated return type of FacebookPostingIntegrationDelete. */
export type FacebookPostingIntegrationDeletePayload = {
  __typename?: 'FacebookPostingIntegrationDeletePayload';
  employee?: Maybe<Employee>;
  errors?: Maybe<Array<UserError>>;
};

export type FacebookRemotePage = {
  __typename?: 'FacebookRemotePage';
  facebookUrl: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
};

export type FaqSection = {
  __typename?: 'FaqSection';
  content: HtmlRecord;
  id: Scalars['Int'];
  position: Scalars['Int'];
  title: Scalars['String'];
};

export type FaqSectionInput = {
  content: HtmlRecordInput;
  id?: InputMaybe<Scalars['Int']>;
  title: Scalars['String'];
};

export type FileAttachment = {
  __typename?: 'FileAttachment';
  contentType: Scalars['String'];
  fileName: Scalars['String'];
  id: Scalars['Int'];
  previewUrl?: Maybe<Scalars['String']>;
  url: Scalars['String'];
  variantUrl: Scalars['String'];
};


export type FileAttachmentPreviewUrlArgs = {
  format?: InputMaybe<ImageAttachmentFormat>;
  height: Scalars['Int'];
  width: Scalars['Int'];
};


export type FileAttachmentVariantUrlArgs = {
  format?: InputMaybe<ImageAttachmentFormat>;
  height: Scalars['Int'];
  width: Scalars['Int'];
};

/** Autogenerated return type of FoodItemActivate. */
export type FoodItemActivatePayload = {
  __typename?: 'FoodItemActivatePayload';
  errors?: Maybe<Array<UserError>>;
  item?: Maybe<Item>;
};

/** Autogenerated return type of FoodItemCreate. */
export type FoodItemCreatePayload = {
  __typename?: 'FoodItemCreatePayload';
  errors?: Maybe<Array<UserError>>;
  item?: Maybe<Item>;
};

/** Autogenerated return type of FoodItemRemove. */
export type FoodItemRemovePayload = {
  __typename?: 'FoodItemRemovePayload';
  errors?: Maybe<Array<UserError>>;
  menu?: Maybe<Menu>;
};

/** Autogenerated return type of FoodItemUpdate. */
export type FoodItemUpdatePayload = {
  __typename?: 'FoodItemUpdatePayload';
  errors?: Maybe<Array<UserError>>;
  item?: Maybe<Item>;
};

export type FoodTrucksEstimate = {
  __typename?: 'FoodTrucksEstimate';
  allTrucks: Scalars['Int'];
  instantTrucks: Scalars['Int'];
};

export type FoodType = {
  __typename?: 'FoodType';
  foodTypeCategories: Array<FoodTypeCategory>;
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type FoodTypeCategory = {
  __typename?: 'FoodTypeCategory';
  defaultMaximumSpots: Scalars['Int'];
  foodTypes: Array<FoodType>;
  id: Scalars['Int'];
  name: Scalars['String'];
  position: Scalars['Int'];
};

/** Autogenerated return type of FoodTypeCategoryCreate. */
export type FoodTypeCategoryCreatePayload = {
  __typename?: 'FoodTypeCategoryCreatePayload';
  errors?: Maybe<Array<UserError>>;
  foodTypeCategory?: Maybe<FoodTypeCategory>;
};

/** Autogenerated return type of FoodTypeCategoryUpdate. */
export type FoodTypeCategoryUpdatePayload = {
  __typename?: 'FoodTypeCategoryUpdatePayload';
  errors?: Maybe<Array<UserError>>;
  foodTypeCategory?: Maybe<FoodTypeCategory>;
};

/** Autogenerated return type of FoodTypeCreate. */
export type FoodTypeCreatePayload = {
  __typename?: 'FoodTypeCreatePayload';
  errors?: Maybe<Array<UserError>>;
  foodType?: Maybe<FoodType>;
};

/** Autogenerated return type of FoodTypeDestroy. */
export type FoodTypeDestroyPayload = {
  __typename?: 'FoodTypeDestroyPayload';
  errors?: Maybe<Array<UserError>>;
  success: Scalars['Boolean'];
};

export type FoodTypePage = {
  __typename?: 'FoodTypePage';
  active: Scalars['Boolean'];
  aiGenerated: Scalars['Boolean'];
  contentSections: Array<ContentSection>;
  customerPath: Scalars['String'];
  customerUrl: Scalars['String'];
  featured: Scalars['Boolean'];
  foodTypePageItems: Array<FoodTypePageItem>;
  foodTypes: Array<FoodType>;
  id: Scalars['Int'];
  image?: Maybe<ImageAttachment>;
  market?: Maybe<Market>;
  metaDescription: Scalars['String'];
  name: Scalars['String'];
  publicFaqSections: Array<FaqSection>;
  seoName: Scalars['String'];
  slug: Scalars['String'];
  subtitle: Scalars['String'];
  suggestedFeaturedItems: Array<Item>;
  title: Scalars['String'];
  trucks: Array<Truck>;
};


export type FoodTypePageCustomerPathArgs = {
  marketSeoName?: InputMaybe<Scalars['String']>;
};


export type FoodTypePageFoodTypePageItemsArgs = {
  count?: InputMaybe<Scalars['Int']>;
};


export type FoodTypePageTrucksArgs = {
  count?: InputMaybe<Scalars['Int']>;
};

export type FoodTypePageItem = {
  __typename?: 'FoodTypePageItem';
  id: Scalars['Int'];
  image: ImageAttachment;
  name: Scalars['String'];
  position: Scalars['Int'];
};

export type FoodTypePageItemInput = {
  id?: InputMaybe<Scalars['Int']>;
  image?: InputMaybe<Scalars['Upload']>;
  name: Scalars['String'];
};

/** Autogenerated return type of FoodTypePageMarketClone. */
export type FoodTypePageMarketClonePayload = {
  __typename?: 'FoodTypePageMarketClonePayload';
  errors?: Maybe<Array<UserError>>;
  foodTypePage?: Maybe<FoodTypePage>;
};

/** Autogenerated return type of FoodTypePageUpdate. */
export type FoodTypePageUpdatePayload = {
  __typename?: 'FoodTypePageUpdatePayload';
  errors?: Maybe<Array<UserError>>;
  foodTypePage?: Maybe<FoodTypePage>;
};

/** Autogenerated return type of FoodTypeUpdate. */
export type FoodTypeUpdatePayload = {
  __typename?: 'FoodTypeUpdatePayload';
  errors?: Maybe<Array<UserError>>;
  foodType?: Maybe<FoodType>;
};

export type FoodTypesFilterInput = {
  /** Search */
  search?: InputMaybe<Scalars['String']>;
};

export type GenericSubscription = {
  __typename?: 'GenericSubscription';
  active?: Maybe<Scalars['Boolean']>;
  channel: GenericSubscriptionChannel;
  entityId?: Maybe<Scalars['Int']>;
  entityType?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  userId?: Maybe<Scalars['Int']>;
};

export enum GenericSubscriptionChannel {
  Email = 'email',
  Sms = 'sms'
}

export type GlobalConfig = {
  __typename?: 'GlobalConfig';
  bonusForReferral: Money;
  bookingFee: Money;
  bookingFeePercentage: Scalars['Float'];
  id: Scalars['Int'];
  useBookingFeePercentage: Scalars['Boolean'];
};

/** Autogenerated return type of GlobalConfigUpdate. */
export type GlobalConfigUpdatePayload = {
  __typename?: 'GlobalConfigUpdatePayload';
  errors?: Maybe<Array<UserError>>;
  globalConfig?: Maybe<GlobalConfig>;
};

export type GuessLocation = {
  __typename?: 'GuessLocation';
  lat: Scalars['Float'];
  lng: Scalars['Float'];
  market: Market;
  outsideService: Scalars['Boolean'];
};

export type HealthPermit = {
  __typename?: 'HealthPermit';
  address?: Maybe<Scalars['String']>;
  futureLocations: Scalars['Int'];
  id: Scalars['Int'];
  lastInspectionAt?: Maybe<Scalars['Date']>;
  municipality: Organization;
  number: Scalars['String'];
  score?: Maybe<Scalars['Int']>;
  truck: Truck;
  truckName: Scalars['String'];
};

export type HealthPermitCollection = Collection & {
  __typename?: 'HealthPermitCollection';
  /** Limit */
  limit?: Maybe<Scalars['Int']>;
  /** Offset */
  offset?: Maybe<Scalars['Int']>;
  /** List of records */
  records: Array<HealthPermit>;
  /** Total */
  total: Scalars['Int'];
};


export type HealthPermitCollectionTotalArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};

/** Autogenerated return type of HealthPermitCreate. */
export type HealthPermitCreatePayload = {
  __typename?: 'HealthPermitCreatePayload';
  errors?: Maybe<Array<UserError>>;
  healthPermit?: Maybe<HealthPermit>;
};

/** Autogenerated return type of HealthPermitDelete. */
export type HealthPermitDeletePayload = {
  __typename?: 'HealthPermitDeletePayload';
  errors?: Maybe<Array<UserError>>;
  truck?: Maybe<Truck>;
};

export type HealthPermitFilterInput = {
  /** Search */
  search?: InputMaybe<Scalars['String']>;
  /** Filter by truck */
  truckId?: InputMaybe<Scalars['Int']>;
};

export type HealthPermitSortInput = {
  /** ASC / DESC */
  direction: SortDirection;
  /** Field to sort by */
  field: HealthPermitSortInputFields;
};

export enum HealthPermitSortInputFields {
  LastInspectionAt = 'last_inspection_at',
  TruckName = 'truck_name'
}

/** Autogenerated return type of HealthPermitUpdate. */
export type HealthPermitUpdatePayload = {
  __typename?: 'HealthPermitUpdatePayload';
  errors?: Maybe<Array<UserError>>;
  healthPermit?: Maybe<HealthPermit>;
};

export type HtmlRecord = {
  __typename?: 'HtmlRecord';
  editorState?: Maybe<Scalars['Json']>;
  editorStateV2?: Maybe<Scalars['Json']>;
  html: Scalars['String'];
  present: Scalars['Boolean'];
  textPreview: Scalars['String'];
};


export type HtmlRecordHtmlArgs = {
  wrapTables?: InputMaybe<Scalars['Boolean']>;
};

export type HtmlRecordInput = {
  editorState?: InputMaybe<Scalars['Json']>;
  editorStateV2?: InputMaybe<Scalars['Json']>;
  html: Scalars['String'];
};

export type ImageAttachment = {
  __typename?: 'ImageAttachment';
  id: Scalars['Int'];
  previewUrl: Scalars['String'];
  url: Scalars['String'];
  variantUrl: Scalars['String'];
};


export type ImageAttachmentPreviewUrlArgs = {
  format?: InputMaybe<ImageAttachmentFormat>;
  height: Scalars['Int'];
  width: Scalars['Int'];
};


export type ImageAttachmentVariantUrlArgs = {
  format?: InputMaybe<ImageAttachmentFormat>;
  height: Scalars['Int'];
  width: Scalars['Int'];
};

export enum ImageAttachmentFormat {
  Jpg = 'jpg',
  Png = 'png'
}

export type ImageWithAttribution = {
  __typename?: 'ImageWithAttribution';
  attributionName?: Maybe<Scalars['String']>;
  attributionUrl?: Maybe<Scalars['String']>;
  url: Scalars['String'];
};

export type InstantBookAvailability = {
  __typename?: 'InstantBookAvailability';
  /** 0-23 */
  fromHour: Scalars['Int'];
  /** 0-23 */
  toHour: Scalars['Int'];
  /** 0 is Sunday */
  wday: Scalars['Int'];
};

export type InstantBookConfig = {
  __typename?: 'InstantBookConfig';
  cancellationPolicyFullDays?: Maybe<Scalars['Int']>;
  cancellationPolicyHalfDays?: Maybe<Scalars['Int']>;
  enabled: Scalars['Boolean'];
  finished: Scalars['Boolean'];
  id: Scalars['Int'];
  instantBookTiers: Array<InstantBookTier>;
  otherComments?: Maybe<Scalars['String']>;
  truck: Truck;
};

/** Autogenerated return type of InstantBookConfigCreate. */
export type InstantBookConfigCreatePayload = {
  __typename?: 'InstantBookConfigCreatePayload';
  errors?: Maybe<Array<UserError>>;
  instantBookConfig?: Maybe<InstantBookConfig>;
};

/** Autogenerated return type of InstantBookFinish. */
export type InstantBookFinishPayload = {
  __typename?: 'InstantBookFinishPayload';
  errors?: Maybe<Array<UserError>>;
  instantBookConfig?: Maybe<InstantBookConfig>;
};

export enum InstantBookStatus {
  Finished = 'finished',
  InProgress = 'in_progress',
  Initial = 'initial'
}

export type InstantBookTier = {
  __typename?: 'InstantBookTier';
  id: Scalars['Int'];
  instantBookTierUpsellTypes: Array<InstantBookTierUpsellType>;
  items: Array<Item>;
  menu: Menu;
  menuComments?: Maybe<Scalars['String']>;
};

export type InstantBookTierInput = {
  itemsIds: Array<Scalars['Int']>;
  menuComments?: InputMaybe<Scalars['String']>;
  menuId: Scalars['Int'];
  prices: Array<InstantBookTierPriceInput>;
};

export type InstantBookTierPriceInput = {
  priceCents: Scalars['Int'];
  upsellTypeId: Scalars['Int'];
};

export type InstantBookTierUpsellType = {
  __typename?: 'InstantBookTierUpsellType';
  id: Scalars['Int'];
  price: Money;
  upsellType: UpsellType;
};

/** Autogenerated return type of InstantBookUpdateGeneral. */
export type InstantBookUpdateGeneralPayload = {
  __typename?: 'InstantBookUpdateGeneralPayload';
  errors?: Maybe<Array<UserError>>;
  instantBookConfig?: Maybe<InstantBookConfig>;
};

/** Autogenerated return type of InstantBookUpdatePolicy. */
export type InstantBookUpdatePolicyPayload = {
  __typename?: 'InstantBookUpdatePolicyPayload';
  errors?: Maybe<Array<UserError>>;
  instantBookConfig?: Maybe<InstantBookConfig>;
};

/** Autogenerated return type of InstantBookUpdateTiers. */
export type InstantBookUpdateTiersPayload = {
  __typename?: 'InstantBookUpdateTiersPayload';
  errors?: Maybe<Array<UserError>>;
  instantBookConfig?: Maybe<InstantBookConfig>;
};

export type Item = {
  __typename?: 'Item';
  active: Scalars['Boolean'];
  description?: Maybe<Scalars['String']>;
  featured: Scalars['Boolean'];
  hasSpecialInstructions: Scalars['Boolean'];
  id: Scalars['Int'];
  image: ItemImage;
  itemQuestions: Array<ItemQuestion>;
  manualPosition: Scalars['Int'];
  menu?: Maybe<Menu>;
  name: Scalars['String'];
  price: Money;
  tags: Array<ItemTag>;
  upsellType: UpsellType;
};


export type ItemImageArgs = {
  fallback?: InputMaybe<Scalars['Boolean']>;
};

export type ItemAnswer = {
  __typename?: 'ItemAnswer';
  active?: Maybe<Scalars['Boolean']>;
  adjustment?: Maybe<Money>;
  default: Scalars['Boolean'];
  id: Scalars['Int'];
  text?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of ItemAnswerActivate. */
export type ItemAnswerActivatePayload = {
  __typename?: 'ItemAnswerActivatePayload';
  errors?: Maybe<Array<UserError>>;
  itemAnswer?: Maybe<ItemAnswer>;
};

export type ItemAnswerInput = {
  adjustmentCents: Scalars['Int'];
  default?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  text: Scalars['String'];
};

export type ItemCollection = Collection & {
  __typename?: 'ItemCollection';
  /** Limit */
  limit?: Maybe<Scalars['Int']>;
  /** Offset */
  offset?: Maybe<Scalars['Int']>;
  /** List of records */
  records: Array<Item>;
  /** Total */
  total: Scalars['Int'];
};


export type ItemCollectionTotalArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};

export type ItemImage = {
  __typename?: 'ItemImage';
  high: Scalars['String'];
  medium: Scalars['String'];
  original?: Maybe<Scalars['String']>;
  present: Scalars['Boolean'];
  resizedOriginal: Scalars['String'];
  small: Scalars['String'];
  thumb: Scalars['String'];
};

export type ItemQuestion = {
  __typename?: 'ItemQuestion';
  active?: Maybe<Scalars['Boolean']>;
  id: Scalars['Int'];
  itemAnswers?: Maybe<Array<ItemAnswer>>;
  maxAnswers?: Maybe<Scalars['Int']>;
  position: Scalars['Int'];
  questionType: ItemQuestionType;
  questionTypeHuman?: Maybe<Scalars['String']>;
  questionTypeId: Scalars['Int'];
  required?: Maybe<Scalars['Boolean']>;
  text: Scalars['String'];
};

/** Autogenerated return type of ItemQuestionActivate. */
export type ItemQuestionActivatePayload = {
  __typename?: 'ItemQuestionActivatePayload';
  errors?: Maybe<Array<UserError>>;
  itemQuestion?: Maybe<ItemQuestion>;
};

/** Autogenerated return type of ItemQuestionCreate. */
export type ItemQuestionCreatePayload = {
  __typename?: 'ItemQuestionCreatePayload';
  errors?: Maybe<Array<UserError>>;
  itemQuestion?: Maybe<ItemQuestion>;
};

export type ItemQuestionInput = {
  itemAnswers: Array<ItemAnswerInput>;
  maxAnswers?: InputMaybe<Scalars['Int']>;
  questionType: ItemQuestionType;
  required: Scalars['Boolean'];
  text: Scalars['String'];
};

/** Autogenerated return type of ItemQuestionRemove. */
export type ItemQuestionRemovePayload = {
  __typename?: 'ItemQuestionRemovePayload';
  errors?: Maybe<Array<UserError>>;
  item?: Maybe<Item>;
};

export enum ItemQuestionType {
  Checkbox = 'checkbox',
  Dropdown = 'dropdown'
}

/** Autogenerated return type of ItemQuestionUpdate. */
export type ItemQuestionUpdatePayload = {
  __typename?: 'ItemQuestionUpdatePayload';
  errors?: Maybe<Array<UserError>>;
  itemQuestion?: Maybe<ItemQuestion>;
};

/** Autogenerated return type of ItemQuestionUpdatePositions. */
export type ItemQuestionUpdatePositionsPayload = {
  __typename?: 'ItemQuestionUpdatePositionsPayload';
  errors?: Maybe<Array<UserError>>;
  item?: Maybe<Item>;
};

export type ItemSortInput = {
  /** ASC / DESC */
  direction: SortDirection;
  /** Field to sort by */
  field: ItemSortInputFields;
};

export enum ItemSortInputFields {
  Active = 'active',
  Auto = 'auto',
  Featured = 'featured',
  Name = 'name',
  Popularity = 'popularity'
}

export type ItemTag = {
  __typename?: 'ItemTag';
  color: Scalars['String'];
  highlighted: Scalars['Boolean'];
  id: Scalars['String'];
  image100Url?: Maybe<Scalars['String']>;
  image200Url?: Maybe<Scalars['String']>;
  imageSvgUrl?: Maybe<Scalars['String']>;
  name: Scalars['String'];
};

export type ItemsFilterInput = {
  active?: InputMaybe<Scalars['Boolean']>;
};

export type KeyValue = {
  __typename?: 'KeyValue';
  key: Scalars['String'];
  value: Scalars['String'];
};

export type Location = {
  __typename?: 'Location';
  active?: Maybe<Scalars['Boolean']>;
  actualStartTime?: Maybe<Scalars['DateTime']>;
  address: Scalars['String'];
  allowOrders: Scalars['Boolean'];
  amountBookingCancellationFeeTruck?: Maybe<Money>;
  amountClientCompanyDiscountTotal?: Maybe<Money>;
  amountLeftToOrder: Money;
  amountLeftToOrderPercentage?: Maybe<Scalars['Float']>;
  amountNetSales?: Maybe<Money>;
  amountOnlineNetSales: Money;
  amountRestaurantNet?: Maybe<Money>;
  amountRestaurantOnlineTotal?: Maybe<Money>;
  amountRestaurantTotal?: Maybe<Money>;
  amountTruck?: Maybe<Money>;
  asapOrdersEnabled: Scalars['Boolean'];
  autoConfirmSalesDays: Scalars['Int'];
  availableOrderTimes: Array<Scalars['DateTime']>;
  availableOrdersPerTime: Array<AvailableOrders>;
  bookingCancellationFee?: Maybe<Money>;
  bookingFeeChangeable: Scalars['Boolean'];
  canCancelWithNotEnoughOrders: Scalars['Boolean'];
  canCancelWithRefund: Scalars['Boolean'];
  canCancelWithoutRefund: Scalars['Boolean'];
  canChangeEventTime: Scalars['Boolean'];
  canOrganizerRefund: Scalars['Boolean'];
  canStartInPreOrder?: Maybe<Scalars['Boolean']>;
  canSubmitWalkupSales: Scalars['Boolean'];
  cancelConfirmationButton: Scalars['String'];
  cancelConfirmationText: Scalars['String'];
  cancellationFeeTruckPaymentStatus?: Maybe<LocationCancellationFeeTruckPaymentStatus>;
  cancellationPolicyText: Scalars['String'];
  chargeSalesPercentage: Scalars['Float'];
  chargeSalesPercentageEnabled: Scalars['Boolean'];
  contractEnvelopes: Array<ContractEnvelope>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customerUrl: Scalars['String'];
  deadlineAt?: Maybe<Scalars['DateTime']>;
  delayedPickupEnabled: Scalars['Boolean'];
  employeesOnline?: Maybe<Scalars['Boolean']>;
  endEarlyReason?: Maybe<Scalars['String']>;
  endTime: Scalars['DateTime'];
  event?: Maybe<Event>;
  foodImage: LocationFoodImage;
  id: Scalars['Int'];
  isFree: Scalars['Boolean'];
  items: Array<Item>;
  latitude?: Maybe<Scalars['Float']>;
  locationDescription: Scalars['String'];
  locationItems: Array<LocationItem>;
  longitude?: Maybe<Scalars['Float']>;
  lot: Lot;
  manualFee?: Maybe<Money>;
  manuallyGeocoded?: Maybe<Scalars['Boolean']>;
  menu: Menu;
  minOrdersAmount: Money;
  offlineOrders: OfflineOrderCollection;
  offlineOrdersStepsEnabled: Scalars['Boolean'];
  orderEtaMinutes?: Maybe<Scalars['Int']>;
  orders: OrderCollection;
  ordersAmountPerTimeSlot: Money;
  ordersPerTimeSlot: Scalars['Int'];
  organizerFee?: Maybe<Money>;
  paidCancellationIntervalSeconds?: Maybe<Scalars['Int']>;
  phone?: Maybe<Scalars['Phone']>;
  refundIntervalSeconds?: Maybe<Scalars['Int']>;
  refundPolicyText: Scalars['String'];
  report?: Maybe<LocationReport>;
  reportUrl: Scalars['String'];
  restaurant?: Maybe<Restaurant>;
  salesConfirmationStatus: LocationSalesConfirmationStatus;
  salesConfirmationStatusHuman: Scalars['String'];
  salesGuarantee: Scalars['Boolean'];
  salesGuaranteeAmount: Money;
  salesPercentageAmountBft?: Maybe<Money>;
  salesPercentageAmountOrganizer?: Maybe<Money>;
  salesPercentageAmountTruck?: Maybe<Money>;
  salesPercentageFrom: LocationSalesPercentageFrom;
  salesPercentageFromAmount?: Maybe<Money>;
  salesPercentageFromHuman: Scalars['String'];
  salesPercentageIncludesBookingFee: Scalars['Boolean'];
  salesPercentagePaidAt?: Maybe<Scalars['DateTime']>;
  salesPercentagePolicy?: Maybe<Scalars['String']>;
  salesPercentagePolicyShort?: Maybe<Scalars['String']>;
  salesPercentageStatus: LocationSalesPercentageStatus;
  salesPercentageStatusHuman: Scalars['String'];
  showAmountLeftToOrder: Scalars['Boolean'];
  spotNumber?: Maybe<Scalars['Int']>;
  startTime: Scalars['DateTime'];
  taxRate?: Maybe<Scalars['Float']>;
  tipsEnabled: Scalars['Boolean'];
  truck: Truck;
  truckChat?: Maybe<TruckChat>;
  truckPaymentStatus?: Maybe<LocationTruckPaymentStatus>;
  walkupCustomersQuantity?: Maybe<Scalars['Int']>;
  walkupCustomersQuantityPos?: Maybe<Scalars['Int']>;
  walkupSalesAmount?: Maybe<Money>;
  walkupSalesAmountPos?: Maybe<Money>;
  workStatus: LocationWorkStatus;
  workStatusHuman: Scalars['String'];
};


export type LocationAvailableOrderTimesArgs = {
  cached?: InputMaybe<Scalars['Boolean']>;
};


export type LocationLocationItemsArgs = {
  itemActive?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<LocationItemSortInput>>;
  status?: InputMaybe<LocationItemStatus>;
};


export type LocationOfflineOrdersArgs = {
  filter?: InputMaybe<OfflineOrdersFilterInput>;
  page?: InputMaybe<CollectionInput>;
  sort?: InputMaybe<Array<OfflineOrdersSortInput>>;
};


export type LocationOrdersArgs = {
  filter?: InputMaybe<OrdersFilterInput>;
  page?: InputMaybe<CollectionInput>;
  sort?: InputMaybe<Array<OrdersSortInput>>;
};


export type LocationSalesConfirmationStatusHumanArgs = {
  short?: InputMaybe<Scalars['Boolean']>;
};

/** Autogenerated return type of LocationAddSalesGuaranteeContract. */
export type LocationAddSalesGuaranteeContractPayload = {
  __typename?: 'LocationAddSalesGuaranteeContractPayload';
  contractEnvelope?: Maybe<ContractEnvelope>;
  errors?: Maybe<Array<UserError>>;
  location?: Maybe<Location>;
};

/** Autogenerated return type of LocationCancelBooking. */
export type LocationCancelBookingPayload = {
  __typename?: 'LocationCancelBookingPayload';
  errors?: Maybe<Array<UserError>>;
  location?: Maybe<Location>;
};

export enum LocationCancellationFeeTruckPaymentStatus {
  TruckCancellationFeeNotOwed = 'truck_cancellation_fee_not_owed',
  TruckCancellationFeeOwed = 'truck_cancellation_fee_owed',
  TruckCancellationFeePaid = 'truck_cancellation_fee_paid',
  TruckCancellationFeeRefunded = 'truck_cancellation_fee_refunded'
}

/** Autogenerated return type of LocationChangeSpot. */
export type LocationChangeSpotPayload = {
  __typename?: 'LocationChangeSpotPayload';
  errors?: Maybe<Array<UserError>>;
  location?: Maybe<Location>;
};

/** Autogenerated return type of LocationChangeTime. */
export type LocationChangeTimePayload = {
  __typename?: 'LocationChangeTimePayload';
  errors?: Maybe<Array<UserError>>;
  location?: Maybe<Location>;
};

export type LocationCollection = Collection & {
  __typename?: 'LocationCollection';
  /** Limit */
  limit?: Maybe<Scalars['Int']>;
  /** Offset */
  offset?: Maybe<Scalars['Int']>;
  /** List of records */
  records: Array<Location>;
  /** Total */
  total: Scalars['Int'];
};


export type LocationCollectionTotalArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};

/** Autogenerated return type of LocationConfirmSales. */
export type LocationConfirmSalesPayload = {
  __typename?: 'LocationConfirmSalesPayload';
  errors?: Maybe<Array<UserError>>;
  location?: Maybe<Location>;
};

/** Autogenerated return type of LocationCreateCustom. */
export type LocationCreateCustomPayload = {
  __typename?: 'LocationCreateCustomPayload';
  errors?: Maybe<Array<UserError>>;
  locations?: Maybe<Array<Location>>;
};

/** Autogenerated return type of LocationDeferWalkupSales. */
export type LocationDeferWalkupSalesPayload = {
  __typename?: 'LocationDeferWalkupSalesPayload';
  errors?: Maybe<Array<UserError>>;
  location?: Maybe<Location>;
};

/** Autogenerated return type of LocationEndEarlyReason. */
export type LocationEndEarlyReasonPayload = {
  __typename?: 'LocationEndEarlyReasonPayload';
  errors?: Maybe<Array<UserError>>;
  location?: Maybe<Location>;
};

/** Autogenerated return type of LocationEndWork. */
export type LocationEndWorkPayload = {
  __typename?: 'LocationEndWorkPayload';
  errors?: Maybe<Array<UserError>>;
  location?: Maybe<Location>;
};

export type LocationFoodImage = {
  __typename?: 'LocationFoodImage';
  medium: Scalars['String'];
  original?: Maybe<Scalars['String']>;
  present: Scalars['Boolean'];
};

export type LocationItem = {
  __typename?: 'LocationItem';
  id: Scalars['Int'];
  item: Item;
  location: Location;
  locationItemQuestions: Array<LocationItemQuestion>;
  maxQuantity?: Maybe<Scalars['Int']>;
  orderItemsCount: Scalars['Int'];
  status: LocationItemStatus;
};


export type LocationItemLocationItemQuestionsArgs = {
  status?: InputMaybe<LocationItemStatus>;
};

export type LocationItemAnswer = {
  __typename?: 'LocationItemAnswer';
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  itemAnswer: ItemAnswer;
  locationItemQuestion: LocationItemQuestion;
  status: LocationItemStatus;
  text?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of LocationItemAnswerChangeStatus. */
export type LocationItemAnswerChangeStatusPayload = {
  __typename?: 'LocationItemAnswerChangeStatusPayload';
  errors?: Maybe<Array<UserError>>;
  locationItemAnswer?: Maybe<LocationItemAnswer>;
};

/** Autogenerated return type of LocationItemChangeMaxQuantity. */
export type LocationItemChangeMaxQuantityPayload = {
  __typename?: 'LocationItemChangeMaxQuantityPayload';
  errors?: Maybe<Array<UserError>>;
  locationItem?: Maybe<LocationItem>;
};

/** Autogenerated return type of LocationItemChangeStatus. */
export type LocationItemChangeStatusPayload = {
  __typename?: 'LocationItemChangeStatusPayload';
  errors?: Maybe<Array<UserError>>;
  locationItem?: Maybe<LocationItem>;
};

export type LocationItemQuestion = {
  __typename?: 'LocationItemQuestion';
  id: Scalars['Int'];
  itemQuestion: ItemQuestion;
  locationItem: LocationItem;
  locationItemAnswers?: Maybe<Array<LocationItemAnswer>>;
  status: LocationItemStatus;
  text: Scalars['String'];
};


export type LocationItemQuestionLocationItemAnswersArgs = {
  status?: InputMaybe<LocationItemStatus>;
};

/** Autogenerated return type of LocationItemQuestionChangeStatus. */
export type LocationItemQuestionChangeStatusPayload = {
  __typename?: 'LocationItemQuestionChangeStatusPayload';
  errors?: Maybe<Array<UserError>>;
  locationItemQuestion?: Maybe<LocationItemQuestion>;
};

export enum LocationItemSortField {
  Active = 'active',
  Auto = 'auto',
  Featured = 'featured',
  Popularity = 'popularity'
}

export type LocationItemSortInput = {
  /** ASC / DESC */
  direction: SortDirection;
  /** Field to sort by */
  field: LocationItemSortField;
};

export enum LocationItemStatus {
  Active = 'active',
  Disabled = 'disabled'
}

/** Autogenerated return type of LocationMakeFeeUncollectible. */
export type LocationMakeFeeUncollectiblePayload = {
  __typename?: 'LocationMakeFeeUncollectiblePayload';
  errors?: Maybe<Array<UserError>>;
  location?: Maybe<Location>;
};

/** Autogenerated return type of LocationMenuUpdate. */
export type LocationMenuUpdatePayload = {
  __typename?: 'LocationMenuUpdatePayload';
  errors?: Maybe<Array<UserError>>;
  location?: Maybe<Location>;
};

/** Autogenerated return type of LocationMinimumIsMet. */
export type LocationMinimumIsMetPayload = {
  __typename?: 'LocationMinimumIsMetPayload';
  errors?: Maybe<Array<UserError>>;
  location?: Maybe<Location>;
};

/** Autogenerated return type of LocationMinimumIsNotMet. */
export type LocationMinimumIsNotMetPayload = {
  __typename?: 'LocationMinimumIsNotMetPayload';
  errors?: Maybe<Array<UserError>>;
  location?: Maybe<Location>;
};

/** Autogenerated return type of LocationMove. */
export type LocationMovePayload = {
  __typename?: 'LocationMovePayload';
  errors?: Maybe<Array<UserError>>;
  location?: Maybe<Location>;
};

/** Autogenerated return type of LocationPause. */
export type LocationPausePayload = {
  __typename?: 'LocationPausePayload';
  errors?: Maybe<Array<UserError>>;
  location?: Maybe<Location>;
};

/** Autogenerated return type of LocationPaySalesPercentage. */
export type LocationPaySalesPercentagePayload = {
  __typename?: 'LocationPaySalesPercentagePayload';
  errors?: Maybe<Array<UserError>>;
  location?: Maybe<Location>;
};

/** Autogenerated return type of LocationProlongWork. */
export type LocationProlongWorkPayload = {
  __typename?: 'LocationProlongWorkPayload';
  errors?: Maybe<Array<UserError>>;
  location?: Maybe<Location>;
};

/** Autogenerated return type of LocationRefundBookingFee. */
export type LocationRefundBookingFeePayload = {
  __typename?: 'LocationRefundBookingFeePayload';
  errors?: Maybe<Array<UserError>>;
  location?: Maybe<Location>;
};

/** Autogenerated return type of LocationRefundCancellationFee. */
export type LocationRefundCancellationFeePayload = {
  __typename?: 'LocationRefundCancellationFeePayload';
  errors?: Maybe<Array<UserError>>;
  location?: Maybe<Location>;
};

/** Autogenerated return type of LocationRefundSalesPercentage. */
export type LocationRefundSalesPercentagePayload = {
  __typename?: 'LocationRefundSalesPercentagePayload';
  errors?: Maybe<Array<UserError>>;
  location?: Maybe<Location>;
};

/** Autogenerated return type of LocationRefundTruck. */
export type LocationRefundTruckPayload = {
  __typename?: 'LocationRefundTruckPayload';
  errors?: Maybe<Array<UserError>>;
  location?: Maybe<Location>;
};

/** Autogenerated return type of LocationRemoveTruck. */
export type LocationRemoveTruckPayload = {
  __typename?: 'LocationRemoveTruckPayload';
  errors?: Maybe<Array<UserError>>;
  location?: Maybe<Location>;
};

/** Autogenerated return type of LocationReplaceTruck. */
export type LocationReplaceTruckPayload = {
  __typename?: 'LocationReplaceTruckPayload';
  errors?: Maybe<Array<UserError>>;
  location?: Maybe<Location>;
};

export type LocationReport = {
  __typename?: 'LocationReport';
  amountDiscountCompensation: Money;
  amountFees: Money;
  amountTax: Money;
  amountTip: Money;
  amountTotalGross: Money;
  amountTotalNet: Money;
  categoriesGrouped: Array<LocationReportItem>;
  grossSales: Money;
  id: Scalars['Int'];
  itemsGrouped: Array<LocationReportItem>;
  netSales: Money;
};

export type LocationReportItem = {
  __typename?: 'LocationReportItem';
  amount: Money;
  count: Scalars['Int'];
  id: Scalars['String'];
  name: Scalars['String'];
};

/** Autogenerated return type of LocationResume. */
export type LocationResumePayload = {
  __typename?: 'LocationResumePayload';
  errors?: Maybe<Array<UserError>>;
  location?: Maybe<Location>;
};

export enum LocationSalesConfirmationStatus {
  SalesAwaitingConfirmation = 'sales_awaiting_confirmation',
  SalesConfirmed = 'sales_confirmed',
  SalesNotEntered = 'sales_not_entered'
}

export enum LocationSalesPercentageFrom {
  SalesPercentageFromAll = 'sales_percentage_from_all',
  SalesPercentageFromOnline = 'sales_percentage_from_online'
}

export enum LocationSalesPercentageStatus {
  SalesNotPaid = 'sales_not_paid',
  SalesPaid = 'sales_paid',
  SalesRefunded = 'sales_refunded'
}

export type LocationSchedule = {
  __typename?: 'LocationSchedule';
  date: Scalars['DateTime'];
  dateAlias: Scalars['String'];
  id: Scalars['String'];
  locations: Array<Location>;
};

export enum LocationScope {
  PreOrderAvailable = 'pre_order_available',
  TimeToCharge = 'time_to_charge',
  TodayAndFuture = 'today_and_future',
  TodayAndPast = 'today_and_past'
}

/** Autogenerated return type of LocationSendSalesGuaranteeContract. */
export type LocationSendSalesGuaranteeContractPayload = {
  __typename?: 'LocationSendSalesGuaranteeContractPayload';
  errors?: Maybe<Array<UserError>>;
  location?: Maybe<Location>;
};

/** Autogenerated return type of LocationSetCoordinates. */
export type LocationSetCoordinatesPayload = {
  __typename?: 'LocationSetCoordinatesPayload';
  errors?: Maybe<Array<UserError>>;
  location?: Maybe<Location>;
};

/** Autogenerated return type of LocationStart. */
export type LocationStartPayload = {
  __typename?: 'LocationStartPayload';
  errors?: Maybe<Array<UserError>>;
  location?: Maybe<Location>;
};

/** Autogenerated return type of LocationStartPreOrder. */
export type LocationStartPreOrderPayload = {
  __typename?: 'LocationStartPreOrderPayload';
  errors?: Maybe<Array<UserError>>;
  location?: Maybe<Location>;
};

/** Autogenerated return type of LocationSubmitWalkupSales. */
export type LocationSubmitWalkupSalesPayload = {
  __typename?: 'LocationSubmitWalkupSalesPayload';
  errors?: Maybe<Array<UserError>>;
  location?: Maybe<Location>;
};

/** Autogenerated return type of LocationTaxRateUpdate. */
export type LocationTaxRateUpdatePayload = {
  __typename?: 'LocationTaxRateUpdatePayload';
  errors?: Maybe<Array<UserError>>;
  location?: Maybe<Location>;
};

/** Autogenerated return type of LocationTriggerCharge. */
export type LocationTriggerChargePayload = {
  __typename?: 'LocationTriggerChargePayload';
  errors?: Maybe<Array<UserError>>;
  location?: Maybe<Location>;
};

export enum LocationTruckPaymentStatus {
  TruckNotPaid = 'truck_not_paid',
  TruckPaid = 'truck_paid',
  TruckRefunded = 'truck_refunded'
}

/** Autogenerated return type of LocationUpdateBookingFee. */
export type LocationUpdateBookingFeePayload = {
  __typename?: 'LocationUpdateBookingFeePayload';
  errors?: Maybe<Array<UserError>>;
  location?: Maybe<Location>;
};

/** Autogenerated return type of LocationUpdateCancellationTerms. */
export type LocationUpdateCancellationTermsPayload = {
  __typename?: 'LocationUpdateCancellationTermsPayload';
  errors?: Maybe<Array<UserError>>;
  location?: Maybe<Location>;
};

/** Autogenerated return type of LocationUpdateDelayedPickup. */
export type LocationUpdateDelayedPickupPayload = {
  __typename?: 'LocationUpdateDelayedPickupPayload';
  errors?: Maybe<Array<UserError>>;
  location?: Maybe<Location>;
};

/** Autogenerated return type of LocationUpdateOfflineOrdersSteps. */
export type LocationUpdateOfflineOrdersStepsPayload = {
  __typename?: 'LocationUpdateOfflineOrdersStepsPayload';
  errors?: Maybe<Array<UserError>>;
  location?: Maybe<Location>;
};

/** Autogenerated return type of LocationUpdateOrdersPerTimeSlot. */
export type LocationUpdateOrdersPerTimeSlotPayload = {
  __typename?: 'LocationUpdateOrdersPerTimeSlotPayload';
  errors?: Maybe<Array<UserError>>;
  location?: Maybe<Location>;
};

/** Autogenerated return type of LocationUpdatePhone. */
export type LocationUpdatePhonePayload = {
  __typename?: 'LocationUpdatePhonePayload';
  errors?: Maybe<Array<UserError>>;
  location?: Maybe<Location>;
};

/** Autogenerated return type of LocationUpdatePickupTimeOptions. */
export type LocationUpdatePickupTimeOptionsPayload = {
  __typename?: 'LocationUpdatePickupTimeOptionsPayload';
  errors?: Maybe<Array<UserError>>;
  location?: Maybe<Location>;
};

/** Autogenerated return type of LocationUpdateSalesGuarantee. */
export type LocationUpdateSalesGuaranteePayload = {
  __typename?: 'LocationUpdateSalesGuaranteePayload';
  errors?: Maybe<Array<UserError>>;
  location?: Maybe<Location>;
};

/** Autogenerated return type of LocationUpdateSalesPercentage. */
export type LocationUpdateSalesPercentagePayload = {
  __typename?: 'LocationUpdateSalesPercentagePayload';
  errors?: Maybe<Array<UserError>>;
  location?: Maybe<Location>;
};

/** Autogenerated return type of LocationUpdateVisibility. */
export type LocationUpdateVisibilityPayload = {
  __typename?: 'LocationUpdateVisibilityPayload';
  errors?: Maybe<Array<UserError>>;
  event?: Maybe<Event>;
  location?: Maybe<Location>;
};

export enum LocationWorkStatus {
  PreOrder = 'pre_order',
  WorkEnded = 'work_ended',
  WorkNotStarted = 'work_not_started',
  WorkPaused = 'work_paused',
  WorkStarted = 'work_started'
}

export type LocationsFilterInput = {
  /** Order ahead is allowed */
  allowOrders?: InputMaybe<Scalars['Boolean']>;
  /** Filter by charge sales percentage enable */
  chargeSalesPercentageEnabled?: InputMaybe<Scalars['Boolean']>;
  /** Discoverable events are included by default */
  discoverableOnly?: InputMaybe<Scalars['Boolean']>;
  /** Filter by event */
  eventId?: InputMaybe<Scalars['Int']>;
  /** Locations since date, inclusive */
  fromDatetime?: InputMaybe<Scalars['DateTime']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  /** Inactive are excluded by default */
  includeInactive?: InputMaybe<Scalars['Boolean']>;
  /** Filter by lot */
  lotId?: InputMaybe<Scalars['Int']>;
  /** Filter by the location's lot */
  lotsFilter?: InputMaybe<LotsFilterInput>;
  /** Filter by market */
  marketId?: InputMaybe<Scalars['Int']>;
  near?: InputMaybe<DistanceFilterInput>;
  /** Locations are present on that date */
  onDate?: InputMaybe<Scalars['DateTime']>;
  /** Add locations with other conditions */
  or?: InputMaybe<Array<LocationsFilterInput>>;
  /** Filter by organization */
  organizationId?: InputMaybe<Scalars['Int']>;
  /** Filter by restaurant */
  restaurantId?: InputMaybe<Scalars['Int']>;
  /** Filter by sales confirmation status */
  salesConfirmationStatus?: InputMaybe<LocationSalesConfirmationStatus>;
  /** Filter by sales guarantee */
  salesGuarantee?: InputMaybe<Scalars['Boolean']>;
  /** Filter by sales percentage status */
  salesPercentageStatus?: InputMaybe<LocationSalesPercentageStatus>;
  scopes?: InputMaybe<Array<LocationScope>>;
  /** Location is in one of these statuses */
  statuses?: InputMaybe<Array<LocationWorkStatus>>;
  /** Locations until date, inclusive */
  toDatetime?: InputMaybe<Scalars['DateTime']>;
  /** Filter by truck */
  truckId?: InputMaybe<Scalars['Int']>;
};

export type LocationsSortInput = {
  /** ASC / DESC */
  direction: SortDirection;
  /** Field to sort by */
  field: LocationsSortInputFields;
};

export enum LocationsSortInputFields {
  CreatedAt = 'created_at',
  EventStartAt = 'event_start_at',
  StartTime = 'start_time',
  TruckChargeTime = 'truck_charge_time'
}

export type LogEvent = {
  __typename?: 'LogEvent';
  bftAgent: Scalars['Boolean'];
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  entities?: Maybe<Array<LogEventEntity>>;
  id: Scalars['Int'];
  userName?: Maybe<Scalars['String']>;
};

export type LogEventCollection = Collection & {
  __typename?: 'LogEventCollection';
  hasMore: Scalars['Boolean'];
  /** Limit */
  limit?: Maybe<Scalars['Int']>;
  /** Offset */
  offset?: Maybe<Scalars['Int']>;
  /** List of records */
  records: Array<LogEvent>;
  /** Total */
  total: Scalars['Int'];
};


export type LogEventCollectionTotalArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};

export type LogEventEntity = {
  __typename?: 'LogEventEntity';
  className?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

export type LogEventEntityInput = {
  /** Class Name */
  className: Scalars['String'];
  /** Entity Id */
  id: Scalars['Int'];
};

export enum LogEventHandler {
  AccountDeletionRequestApproved = 'account_deletion_request_approved',
  AccountDeletionRequestRejected = 'account_deletion_request_rejected',
  AutoCoverFinished = 'auto_cover_finished',
  AutoCoverScheduled = 'auto_cover_scheduled',
  AutoCoverStarted = 'auto_cover_started',
  CateringCustomRequestUpdated = 'catering_custom_request_updated',
  CateringCustomTagsUpdated = 'catering_custom_tags_updated',
  CateringInvoiceCreated = 'catering_invoice_created',
  CateringInvoiceCreditNote = 'catering_invoice_credit_note',
  CateringInvoicePaid = 'catering_invoice_paid',
  CateringInvoiceVoided = 'catering_invoice_voided',
  CateringManualTruckDebitCreated = 'catering_manual_truck_debit_created',
  CateringManualTruckDebitDeleted = 'catering_manual_truck_debit_deleted',
  CateringOrganizerAssigned = 'catering_organizer_assigned',
  CateringOverageRequestApproved = 'catering_overage_request_approved',
  CateringOverageRequestCreated = 'catering_overage_request_created',
  CateringOverageRequestRejected = 'catering_overage_request_rejected',
  CateringOverageRequestUpdated = 'catering_overage_request_updated',
  CateringPayOrganizer = 'catering_pay_organizer',
  CateringPayTruck = 'catering_pay_truck',
  CateringProposalChosen = 'catering_proposal_chosen',
  CateringProposalCommentsUpdated = 'catering_proposal_comments_updated',
  CateringProposalStatusUpdated = 'catering_proposal_status_updated',
  CateringProposalVariantCommentsUpdated = 'catering_proposal_variant_comments_updated',
  CateringQueueBatchSizeUpdated = 'catering_queue_batch_size_updated',
  CateringQueueBatchTriggered = 'catering_queue_batch_triggered',
  CateringQueueTrucksNotified = 'catering_queue_trucks_notified',
  CateringQueueTrucksRemoved = 'catering_queue_trucks_removed',
  CateringQuoteStatusChange = 'catering_quote_status_change',
  CateringRequestCreated = 'catering_request_created',
  CateringRequestDraft = 'catering_request_draft',
  CateringRequestUpdated = 'catering_request_updated',
  CateringStatusChange = 'catering_status_change',
  CateringTagsUpdated = 'catering_tags_updated',
  CateringTruckAcknowledgedCatering = 'catering_truck_acknowledged_catering',
  CateringTruckBudgetUpdated = 'catering_truck_budget_updated',
  CateringTruckGroupCreated = 'catering_truck_group_created',
  CateringTruckGroupDeleted = 'catering_truck_group_deleted',
  CateringTruckGroupUpdated = 'catering_truck_group_updated',
  CateringTruckProposal = 'catering_truck_proposal',
  CateringTruckRejectedCatering = 'catering_truck_rejected_catering',
  CateringTruckRequestsDeleted = 'catering_truck_requests_deleted',
  CateringTrucksAdded = 'catering_trucks_added',
  ChargeTruckSalesPercentageError = 'charge_truck_sales_percentage_error',
  ContractEnvelopeStatusChanged = 'contract_envelope_status_changed',
  CustomerSignup = 'customer_signup',
  EmailMessageSent = 'email_message_sent',
  EmployeeSignedIn = 'employee_signed_in',
  EventBooked = 'event_booked',
  EventDeleted = 'event_deleted',
  EventSharedWithCustomer = 'event_shared_with_customer',
  EventUpdated = 'event_updated',
  EventsCreated = 'events_created',
  EventsProposalApproved = 'events_proposal_approved',
  EventsProposalRejected = 'events_proposal_rejected',
  EventsRequestApproved = 'events_request_approved',
  EventsRequestProposalsChosen = 'events_request_proposals_chosen',
  EventsRequestTagsUpdated = 'events_request_tags_updated',
  EventsTruckAcknowledgedEventBooking = 'events_truck_acknowledged_event_booking',
  FoodItemChanged = 'food_item_changed',
  ItemAnswerChanged = 'item_answer_changed',
  ItemQuestionChanged = 'item_question_changed',
  LocationBookingFeeRefunded = 'location_booking_fee_refunded',
  LocationCancellationFeeRefunded = 'location_cancellation_fee_refunded',
  LocationDelayedPickupUpdated = 'location_delayed_pickup_updated',
  LocationEndEarly = 'location_end_early',
  LocationItemAnswerStatusChange = 'location_item_answer_status_change',
  LocationItemChangeMaxQuantity = 'location_item_change_max_quantity',
  LocationItemQuestionStatusChange = 'location_item_question_status_change',
  LocationItemStatusChange = 'location_item_status_change',
  LocationMakeFeeUncollectible = 'location_make_fee_uncollectible',
  LocationManuallyGeocoded = 'location_manually_geocoded',
  LocationMenuUpdated = 'location_menu_updated',
  LocationMoved = 'location_moved',
  LocationNetSalesUpdated = 'location_net_sales_updated',
  LocationOrdersPerTimeSlotUpdated = 'location_orders_per_time_slot_updated',
  LocationPhoneUpdated = 'location_phone_updated',
  LocationPickupTimeOptionsUpdated = 'location_pickup_time_options_updated',
  LocationPoliciesUpdated = 'location_policies_updated',
  LocationSalesConfirmed = 'location_sales_confirmed',
  LocationSalesPercentageRefunded = 'location_sales_percentage_refunded',
  LocationSpotChanged = 'location_spot_changed',
  LotShareStopped = 'lot_share_stopped',
  LotSharedWithCustomer = 'lot_shared_with_customer',
  MarkCustomerAsFraud = 'mark_customer_as_fraud',
  MenuChanged = 'menu_changed',
  NoteAdded = 'note_added',
  OrderAbandoned = 'order_abandoned',
  OrderCancelled = 'order_cancelled',
  OrderComplete = 'order_complete',
  OrderConfirmed = 'order_confirmed',
  OrderCreated = 'order_created',
  OrderCustomerRefunded = 'order_customer_refunded',
  OrderRated = 'order_rated',
  OrderRatingReason = 'order_rating_reason',
  OrderReady = 'order_ready',
  OrderTruckPaymentReversed = 'order_truck_payment_reversed',
  OrganizerNotifiedTrucks = 'organizer_notified_trucks',
  OrganizerReplacedTruck = 'organizer_replaced_truck',
  OtherLog = 'other_log',
  PickupTimeUpdated = 'pickup_time_updated',
  PreOrderStarted = 'pre_order_started',
  RefundApproved = 'refund_approved',
  RefundRejected = 'refund_rejected',
  RefundRequested = 'refund_requested',
  RestaurantCreditAdded = 'restaurant_credit_added',
  RestaurantCreditSpent = 'restaurant_credit_spent',
  SalesPercentagePriceUpdated = 'sales_percentage_price_updated',
  ShiftEmailCustomerNotifications = 'shift_email_customer_notifications',
  ShiftPushCustomerNotifications = 'shift_push_customer_notifications',
  ShiftSmsCustomerNotifications = 'shift_sms_customer_notifications',
  SmsMessageSent = 'sms_message_sent',
  SqlReportRun = 'sql_report_run',
  StripeDispute = 'stripe_dispute',
  TruckAgreedToMinimum = 'truck_agreed_to_minimum',
  TruckCancelledLocation = 'truck_cancelled_location',
  TruckChargedCancellationFee = 'truck_charged_cancellation_fee',
  TruckChatNewMessage = 'truck_chat_new_message',
  TruckProblemDetectionStarted = 'truck_problem_detection_started',
  TruckProblemDismissed = 'truck_problem_dismissed',
  TruckProblemsDetected = 'truck_problems_detected',
  TruckRefunded = 'truck_refunded',
  TruckRegisteredForEvent = 'truck_registered_for_event',
  TruckRemoved = 'truck_removed',
  TruckReviewApproved = 'truck_review_approved',
  TruckReviewRejected = 'truck_review_rejected',
  TruckReviewRequested = 'truck_review_requested',
  TruckSignup = 'truck_signup',
  TruckSuggestionUpdated = 'truck_suggestion_updated',
  UnmarkCustomerAsFraud = 'unmark_customer_as_fraud',
  WalkupSalesDeferred = 'walkup_sales_deferred',
  WalkupSalesSubmitted = 'walkup_sales_submitted',
  WorkEnded = 'work_ended',
  WorkPaused = 'work_paused',
  WorkProlonged = 'work_prolonged',
  WorkResumed = 'work_resumed',
  WorkStarted = 'work_started'
}

export type LogEventInput = {
  /** Entity conditions */
  entities?: InputMaybe<Array<LogEventEntityInput>>;
  /** Log Event Handler Types */
  eventTypes?: InputMaybe<Array<LogEventHandler>>;
  /** User Name Search */
  userName?: InputMaybe<Scalars['String']>;
};

export type LogEventsSortInput = {
  /** ASC / DESC */
  direction: SortDirection;
  /** Field to sort by */
  field: LogEventsSortInputFields;
};

export enum LogEventsSortInputFields {
  CreatedAt = 'created_at'
}

export type Lot = {
  __typename?: 'Lot';
  active: Scalars['Boolean'];
  address?: Maybe<Scalars['String']>;
  allowBooking?: Maybe<Scalars['Boolean']>;
  allowOrders?: Maybe<Scalars['Boolean']>;
  amountConvenienceFee?: Maybe<Money>;
  amountConvenienceFeeCents?: Maybe<Scalars['Int']>;
  appNotice?: Maybe<Scalars['String']>;
  assignedOrganizer?: Maybe<Organizer>;
  autocoverEnabled: Scalars['Boolean'];
  averageOrderCount?: Maybe<Scalars['Int']>;
  averageSalesAmount?: Maybe<Money>;
  bftSalesPercentageCut?: Maybe<Scalars['Float']>;
  bookingFeeCents?: Maybe<Scalars['Int']>;
  bookingFeePercentage?: Maybe<Scalars['Float']>;
  chargeTruckInSeconds?: Maybe<Scalars['Int']>;
  city?: Maybe<Scalars['String']>;
  clientCompanyName?: Maybe<Scalars['String']>;
  clientEmail?: Maybe<Scalars['String']>;
  clientName?: Maybe<Scalars['String']>;
  clientPhone?: Maybe<Scalars['String']>;
  collectRatings?: Maybe<Scalars['Boolean']>;
  creditForSubscriptions?: Maybe<Money>;
  creditForSubscriptionsCents?: Maybe<Scalars['Int']>;
  custom: Scalars['Boolean'];
  dailyMenuEmails?: Maybe<Scalars['Boolean']>;
  defaultEventSetting?: Maybe<DefaultEventSetting>;
  description: HtmlRecord;
  distance?: Maybe<Scalars['Float']>;
  email?: Maybe<Scalars['String']>;
  emailThreads: Array<EmailThread>;
  enableAutocover?: Maybe<Scalars['Boolean']>;
  enableRestaurantTransactionFee?: Maybe<Scalars['Boolean']>;
  events: EventCollection;
  eventsWithTrucksApplied: Array<Event>;
  facebook?: Maybe<Scalars['String']>;
  featured?: Maybe<Scalars['Boolean']>;
  flyerImage?: Maybe<LotFlyerImage>;
  foodImage?: Maybe<LotFoodImage>;
  fullAddress: Scalars['String'];
  id: Scalars['Int'];
  image?: Maybe<LotImage>;
  instagram?: Maybe<Scalars['String']>;
  latitude: Scalars['Float'];
  locationDescription?: Maybe<Scalars['String']>;
  locationSchedule: Array<LocationSchedule>;
  locations: LocationCollection;
  locationsThisDayCount: Scalars['Int'];
  locationsThisWeekCount: Scalars['Int'];
  longitude: Scalars['Float'];
  lotGroupPosition?: Maybe<Scalars['Int']>;
  lotPath: Scalars['String'];
  lotSpotLayoutImage: LotLotSpotLayoutImage;
  lotUrl: Scalars['String'];
  lotUrlWithSignIn: Scalars['String'];
  manuallyGeocoded?: Maybe<Scalars['Boolean']>;
  market: Market;
  name: Scalars['String'];
  nameWithinGroup?: Maybe<Scalars['String']>;
  notice: HtmlRecord;
  notificationEmail?: Maybe<Scalars['String']>;
  organization: Organization;
  organizerLastEvent?: Maybe<Event>;
  organizerNextEvent?: Maybe<Event>;
  organizerNextEventWithSpotsLeft?: Maybe<Event>;
  organizerTrucksForNotifications: TruckCollection;
  overwriteBookingFee?: Maybe<Scalars['Boolean']>;
  partnershipIds?: Maybe<Array<Scalars['Int']>>;
  partnerships: Array<Partnership>;
  performanceHistory: Array<LotPerformanceHistory>;
  permitNumber?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  privateProperty?: Maybe<Scalars['Boolean']>;
  referralEnabled: Scalars['Boolean'];
  restaurantTransactionFeeOnOffline?: Maybe<Scalars['Boolean']>;
  restaurantTransactionFeePercentage?: Maybe<Scalars['Float']>;
  sameTruckBookingSeconds: Scalars['Int'];
  schedulePath: Scalars['String'];
  sendNextWeekSchedule?: Maybe<Scalars['Boolean']>;
  sendOnWeekDay?: Maybe<Scalars['Int']>;
  seoName: Scalars['String'];
  sharedWithCustomer?: Maybe<Customer>;
  shiftNotificationTimeType?: Maybe<ShiftNotificationTime>;
  showFullSchedule?: Maybe<Scalars['Boolean']>;
  showSalesEstimation: Scalars['Boolean'];
  slug: Scalars['String'];
  smsTruckInstructions?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  subscribed: Scalars['Boolean'];
  subscribedCustomersCount?: Maybe<Scalars['Int']>;
  taxRate?: Maybe<Scalars['Float']>;
  textConversation?: Maybe<TextConversation>;
  tiktok?: Maybe<Scalars['String']>;
  tipsEnabled?: Maybe<Scalars['Boolean']>;
  truckChargeDelayEnabled?: Maybe<Scalars['Boolean']>;
  truckInstantBookEnabled: Scalars['Boolean'];
  twitter?: Maybe<Scalars['String']>;
  useBookingFeePercentage?: Maybe<Scalars['Boolean']>;
  vendingInstructions?: Maybe<Scalars['String']>;
  website?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};


export type LotEventsArgs = {
  filter?: InputMaybe<EventsFilterInput>;
  page?: InputMaybe<CollectionInput>;
  sort?: InputMaybe<Array<EventsSortInput>>;
};


export type LotLocationScheduleArgs = {
  days: Scalars['Int'];
  todayPlaceholder?: InputMaybe<Scalars['Boolean']>;
};


export type LotLocationsArgs = {
  filter?: InputMaybe<LocationsFilterInput>;
  page?: InputMaybe<CollectionInput>;
  sort?: InputMaybe<Array<LocationsSortInput>>;
};


export type LotLotGroupPositionArgs = {
  lotGroupId?: InputMaybe<Scalars['Int']>;
};


export type LotLotUrlWithSignInArgs = {
  partnerCode?: InputMaybe<Scalars['String']>;
};


export type LotNameWithinGroupArgs = {
  lotGroupId?: InputMaybe<Scalars['Int']>;
};


export type LotOrganizerTrucksForNotificationsArgs = {
  page?: InputMaybe<CollectionInput>;
};


export type LotTruckInstantBookEnabledArgs = {
  truckId: Scalars['Int'];
};

/** Autogenerated return type of LotAssignOrganizer. */
export type LotAssignOrganizerPayload = {
  __typename?: 'LotAssignOrganizerPayload';
  errors?: Maybe<Array<UserError>>;
  lot?: Maybe<Lot>;
};

/** Autogenerated return type of LotBookCustom. */
export type LotBookCustomPayload = {
  __typename?: 'LotBookCustomPayload';
  errors?: Maybe<Array<UserError>>;
  event?: Maybe<Event>;
  location?: Maybe<Location>;
};

/** Autogenerated return type of LotChangeOrganization. */
export type LotChangeOrganizationPayload = {
  __typename?: 'LotChangeOrganizationPayload';
  errors?: Maybe<Array<UserError>>;
  lot?: Maybe<Lot>;
};

export type LotCollection = Collection & {
  __typename?: 'LotCollection';
  /** Limit */
  limit?: Maybe<Scalars['Int']>;
  /** Offset */
  offset?: Maybe<Scalars['Int']>;
  /** List of records */
  records: Array<Lot>;
  /** Total */
  total: Scalars['Int'];
};


export type LotCollectionTotalArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};

/** Autogenerated return type of LotCopySubscribers. */
export type LotCopySubscribersPayload = {
  __typename?: 'LotCopySubscribersPayload';
  errors?: Maybe<Array<UserError>>;
  fromLot?: Maybe<Lot>;
  toLot?: Maybe<Lot>;
};

/** Autogenerated return type of LotCreateCustom. */
export type LotCreateCustomPayload = {
  __typename?: 'LotCreateCustomPayload';
  errors?: Maybe<Array<UserError>>;
  lot?: Maybe<Lot>;
};

/** Autogenerated return type of LotCreate. */
export type LotCreatePayload = {
  __typename?: 'LotCreatePayload';
  errors?: Maybe<Array<UserError>>;
  lot?: Maybe<Lot>;
};

export type LotFlyerImage = {
  __typename?: 'LotFlyerImage';
  medium: Scalars['String'];
  original?: Maybe<Scalars['String']>;
  present: Scalars['Boolean'];
};

export type LotFoodImage = {
  __typename?: 'LotFoodImage';
  medium: Scalars['String'];
  original?: Maybe<Scalars['String']>;
  present: Scalars['Boolean'];
};

export type LotFoodRestriction = {
  __typename?: 'LotFoodRestriction';
  alternateFee?: Maybe<Money>;
  alternateFeeEnabled: Scalars['Boolean'];
  foodType?: Maybe<FoodType>;
  foodTypeCategory?: Maybe<FoodTypeCategory>;
  id: Scalars['Int'];
  maximumSpots: Scalars['Int'];
  savedSpots: Scalars['Int'];
  spanDays: Scalars['Int'];
};

export type LotFoodRestrictionInput = {
  alternateFeeCents?: InputMaybe<Scalars['Int']>;
  alternateFeeEnabled?: InputMaybe<Scalars['Boolean']>;
  foodTypeCategoryId?: InputMaybe<Scalars['Int']>;
  foodTypeId?: InputMaybe<Scalars['Int']>;
  maximumSpots?: InputMaybe<Scalars['Int']>;
  savedSpots?: InputMaybe<Scalars['Int']>;
  spanDays?: InputMaybe<Scalars['Int']>;
};

export type LotGroup = {
  __typename?: 'LotGroup';
  address?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  flyerImage?: Maybe<ImageAttachment>;
  fullAddress?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  image?: Maybe<LotGroupImage>;
  locationSchedule: Array<LocationSchedule>;
  lotGroupPath: Scalars['String'];
  lotGroupUrl: Scalars['String'];
  lots?: Maybe<Array<Lot>>;
  name?: Maybe<Scalars['String']>;
  notice: HtmlRecord;
  schedulePath: Scalars['String'];
  seoName?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};


export type LotGroupLocationScheduleArgs = {
  days: Scalars['Int'];
  todayPlaceholder?: InputMaybe<Scalars['Boolean']>;
};

export type LotGroupCollection = Collection & {
  __typename?: 'LotGroupCollection';
  /** Limit */
  limit?: Maybe<Scalars['Int']>;
  /** Offset */
  offset?: Maybe<Scalars['Int']>;
  /** List of records */
  records: Array<LotGroup>;
  /** Total */
  total: Scalars['Int'];
};


export type LotGroupCollectionTotalArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};

/** Autogenerated return type of LotGroupCreate. */
export type LotGroupCreatePayload = {
  __typename?: 'LotGroupCreatePayload';
  errors?: Maybe<Array<UserError>>;
  lotGroup?: Maybe<LotGroup>;
};

export type LotGroupImage = {
  __typename?: 'LotGroupImage';
  high: Scalars['String'];
  horizontalStretch: Scalars['String'];
  medium: Scalars['String'];
  original?: Maybe<Scalars['String']>;
  present: Scalars['Boolean'];
  small: Scalars['String'];
  thumb: Scalars['String'];
};

export type LotGroupInput = {
  id: Scalars['Int'];
  nameWithinGroup: Scalars['String'];
  position: Scalars['Int'];
};

/** Autogenerated return type of LotGroupRemove. */
export type LotGroupRemovePayload = {
  __typename?: 'LotGroupRemovePayload';
  errors?: Maybe<Array<UserError>>;
};

/** Autogenerated return type of LotGroupUpdateNotice. */
export type LotGroupUpdateNoticePayload = {
  __typename?: 'LotGroupUpdateNoticePayload';
  errors?: Maybe<Array<UserError>>;
  lotGroup?: Maybe<LotGroup>;
};

/** Autogenerated return type of LotGroupUpdate. */
export type LotGroupUpdatePayload = {
  __typename?: 'LotGroupUpdatePayload';
  errors?: Maybe<Array<UserError>>;
  lotGroup?: Maybe<LotGroup>;
};

export type LotGroupsSortInput = {
  /** ASC / DESC */
  direction: SortDirection;
  /** Field to sort by */
  field: LotGroupsSortInputFields;
};

export enum LotGroupsSortInputFields {
  Id = 'id',
  Name = 'name'
}

export type LotImage = {
  __typename?: 'LotImage';
  high: Scalars['String'];
  horizontalStretch: Scalars['String'];
  medium: Scalars['String'];
  original?: Maybe<Scalars['String']>;
  present: Scalars['Boolean'];
  small: Scalars['String'];
  thumb: Scalars['String'];
};

/** Autogenerated return type of LotInstantBookAdd. */
export type LotInstantBookAddPayload = {
  __typename?: 'LotInstantBookAddPayload';
  errors?: Maybe<Array<UserError>>;
  lot?: Maybe<Lot>;
  truck?: Maybe<Truck>;
};

/** Autogenerated return type of LotInstantBookRemove. */
export type LotInstantBookRemovePayload = {
  __typename?: 'LotInstantBookRemovePayload';
  errors?: Maybe<Array<UserError>>;
  lot?: Maybe<Lot>;
  truck?: Maybe<Truck>;
};

export type LotLotSpotLayoutImage = {
  __typename?: 'LotLotSpotLayoutImage';
  big: Scalars['String'];
  medium: Scalars['String'];
  original?: Maybe<Scalars['String']>;
  present: Scalars['Boolean'];
  small: Scalars['String'];
  thumb: Scalars['String'];
};

export type LotPerformanceHistory = {
  __typename?: 'LotPerformanceHistory';
  date: Scalars['DateTime'];
  foodType: Scalars['String'];
  id: Scalars['Int'];
  orderCount: Scalars['Int'];
  timeOfDay: Scalars['String'];
  weatherDescription?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of LotSendMenuEmail. */
export type LotSendMenuEmailPayload = {
  __typename?: 'LotSendMenuEmailPayload';
  errors?: Maybe<Array<UserError>>;
  lot?: Maybe<Lot>;
};

/** Autogenerated return type of LotShareWithCustomer. */
export type LotShareWithCustomerPayload = {
  __typename?: 'LotShareWithCustomerPayload';
  errors?: Maybe<Array<UserError>>;
  eventsRequests?: Maybe<Array<EventsRequest>>;
  lot?: Maybe<Lot>;
};

export type LotSpotInfo = {
  __typename?: 'LotSpotInfo';
  available: Scalars['Boolean'];
  description: Scalars['String'];
  id: Scalars['Int'];
};

/** Autogenerated return type of LotStopSharingWithCustomer. */
export type LotStopSharingWithCustomerPayload = {
  __typename?: 'LotStopSharingWithCustomerPayload';
  errors?: Maybe<Array<UserError>>;
  lot?: Maybe<Lot>;
};

/** Autogenerated return type of LotSubscribe. */
export type LotSubscribePayload = {
  __typename?: 'LotSubscribePayload';
  errors?: Maybe<Array<UserError>>;
  lot?: Maybe<Lot>;
};

export type LotSubscription = {
  __typename?: 'LotSubscription';
  active: Scalars['Boolean'];
  id: Scalars['Int'];
  lot: Lot;
};

/** Autogenerated return type of LotUnsubscribe. */
export type LotUnsubscribePayload = {
  __typename?: 'LotUnsubscribePayload';
  errors?: Maybe<Array<UserError>>;
  lot?: Maybe<Lot>;
};

/** Autogenerated return type of LotUpdateAdminSettings. */
export type LotUpdateAdminSettingsPayload = {
  __typename?: 'LotUpdateAdminSettingsPayload';
  errors?: Maybe<Array<UserError>>;
  lot?: Maybe<Lot>;
};

/** Autogenerated return type of LotUpdateDescription. */
export type LotUpdateDescriptionPayload = {
  __typename?: 'LotUpdateDescriptionPayload';
  errors?: Maybe<Array<UserError>>;
  lot?: Maybe<Lot>;
};

/** Autogenerated return type of LotUpdateNotice. */
export type LotUpdateNoticePayload = {
  __typename?: 'LotUpdateNoticePayload';
  errors?: Maybe<Array<UserError>>;
  lot?: Maybe<Lot>;
};

/** Autogenerated return type of LotUpdate. */
export type LotUpdatePayload = {
  __typename?: 'LotUpdatePayload';
  errors?: Maybe<Array<UserError>>;
  lot?: Maybe<Lot>;
};

export type LotsFilterInput = {
  /** Filter by active */
  active?: InputMaybe<Scalars['Boolean']>;
  /** Filter by lots assigned to that organizer */
  assignedOrganizerId?: InputMaybe<Scalars['Int']>;
  /** Filter by custom */
  custom?: InputMaybe<Scalars['Boolean']>;
  /** Filter by ids */
  ids?: InputMaybe<Array<Scalars['Int']>>;
  /** Locations are present on that day */
  locationsFilter?: InputMaybe<LocationsFilterInput>;
  /** Locations this week greater than or equal to */
  locationsThisWeekGte?: InputMaybe<Scalars['Int']>;
  /** Filter by market */
  marketId?: InputMaybe<Scalars['Int']>;
  /** Filter by name */
  nameSearch?: InputMaybe<Scalars['String']>;
  near?: InputMaybe<DistanceFilterInput>;
  nearAddress?: InputMaybe<AddressDistanceFilterInput>;
  /** Add lots with other conditions */
  or?: InputMaybe<Array<LotsFilterInput>>;
  privateProperty?: InputMaybe<Scalars['Boolean']>;
  skipThirdPartyLots?: InputMaybe<Scalars['Boolean']>;
  subscribed?: InputMaybe<Scalars['Boolean']>;
};

export type LotsSortInput = {
  /** ASC / DESC */
  direction: SortDirection;
  /** Field to sort by */
  field: LotsSortInputFields;
};

export enum LotsSortInputFields {
  Active = 'active',
  Distance = 'distance',
  LocationsThisWeekCount = 'locations_this_week_count',
  Name = 'name'
}

export type MapLocationGroup = {
  __typename?: 'MapLocationGroup';
  address: Scalars['String'];
  fromTime: Scalars['DateTime'];
  items: Array<MapLocationGroupItem>;
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
  title: Scalars['String'];
  toTime: Scalars['DateTime'];
};

export type MapLocationGroupItem = {
  __typename?: 'MapLocationGroupItem';
  allowOrders: Scalars['Boolean'];
  endTime: Scalars['DateTime'];
  foodImage?: Maybe<MapLocationGroupItemTruckFoodImage>;
  foodTypes: Array<Scalars['String']>;
  fullAddress: Scalars['String'];
  id: Scalars['Int'];
  key: Scalars['String'];
  latitude: Scalars['Float'];
  locationPath?: Maybe<Scalars['String']>;
  longitude: Scalars['Float'];
  lotId?: Maybe<Scalars['Int']>;
  lotName?: Maybe<Scalars['String']>;
  lotPath?: Maybe<Scalars['String']>;
  ratingInfo?: Maybe<TruckRatingInfo>;
  restaurantId: Scalars['Int'];
  restaurantLogo: MapLocationRestaurantLogo;
  startTime: Scalars['DateTime'];
  truckId: Scalars['Int'];
  truckName: Scalars['String'];
  truckScheduleUrl?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

export type MapLocationGroupItemTruckFoodImage = {
  __typename?: 'MapLocationGroupItemTruckFoodImage';
  medium: Scalars['String'];
  original?: Maybe<Scalars['String']>;
  present: Scalars['Boolean'];
};

export type MapLocationRestaurantLogo = {
  __typename?: 'MapLocationRestaurantLogo';
  medium: Scalars['String'];
  original?: Maybe<Scalars['String']>;
  present: Scalars['Boolean'];
  small: Scalars['String'];
  thumb: Scalars['String'];
};

export type Market = {
  __typename?: 'Market';
  active: Scalars['Boolean'];
  alcoholCatering: Scalars['Boolean'];
  appleCredits: Scalars['Boolean'];
  appleCreditsPercentage: Scalars['Boolean'];
  appleCreditsPercentageValue: Scalars['Float'];
  bftFacebook?: Maybe<Scalars['String']>;
  cateringCategoriesEnabled: Scalars['Boolean'];
  cateringDescription1: HtmlRecord;
  cateringDescription2: HtmlRecord;
  cateringDropOffMinBudget: Money;
  cateringMinBudget: Money;
  customerCateringPath: Scalars['String'];
  customerCateringUrl: Scalars['String'];
  customerPath: Scalars['String'];
  customerTopTrucksPath: Scalars['String'];
  customerTopTrucksUrl: Scalars['String'];
  customerTrucksListPath: Scalars['String'];
  customerTrucksListUrl: Scalars['String'];
  customerTrucksMapPath: Scalars['String'];
  customerTrucksMapUrl: Scalars['String'];
  customerUrl: Scalars['String'];
  description?: Maybe<HtmlRecord>;
  distance?: Maybe<Scalars['Float']>;
  eventsMinOrdersAmount: Money;
  eventsRequestRestaurantTransactionFeePercentage: Scalars['Float'];
  eventsReward: Money;
  eventsSalesGuaranteeAmount: Money;
  facebookPage?: Maybe<FacebookMarketPage>;
  foodTypePagesEnabled: Scalars['Boolean'];
  id: Scalars['Int'];
  image: MarketImage;
  imageAuthor?: Maybe<Scalars['String']>;
  imageAuthorUrl?: Maybe<Scalars['String']>;
  imageLicense?: Maybe<Scalars['String']>;
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
  lots: LotCollection;
  marketTopTrucks: Array<MarketTopTruck>;
  name: Scalars['String'];
  popularTrucks: TruckCollection;
  salesGuaranteeRequired: Scalars['Boolean'];
  showMap: Scalars['Boolean'];
  skylineImage: ImageWithAttribution;
  state: Scalars['String'];
  stateFull: Scalars['String'];
  topTrucksDescription: HtmlRecord;
  topTrucksEnabled: Scalars['Boolean'];
  trucks: TruckCollection;
  upsellTypeAdjustments: Array<UpsellTypeMarketAdjustment>;
};


export type MarketLotsArgs = {
  filter?: InputMaybe<LotsFilterInput>;
  page?: InputMaybe<CollectionInput>;
  sort?: InputMaybe<Array<LotsSortInput>>;
};


export type MarketPopularTrucksArgs = {
  page?: InputMaybe<CollectionInput>;
};


export type MarketSkylineImageArgs = {
  width?: InputMaybe<Scalars['Int']>;
};


export type MarketTrucksArgs = {
  filter?: InputMaybe<TrucksFilterInput>;
  page?: InputMaybe<CollectionInput>;
  sort?: InputMaybe<Array<TrucksSortInput>>;
};

export type MarketCollection = Collection & {
  __typename?: 'MarketCollection';
  /** Limit */
  limit?: Maybe<Scalars['Int']>;
  /** Offset */
  offset?: Maybe<Scalars['Int']>;
  /** List of records */
  records: Array<Market>;
  /** Total */
  total: Scalars['Int'];
};


export type MarketCollectionTotalArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};

/** Autogenerated return type of MarketCreate. */
export type MarketCreatePayload = {
  __typename?: 'MarketCreatePayload';
  errors?: Maybe<Array<UserError>>;
  market?: Maybe<Market>;
};

export type MarketImage = {
  __typename?: 'MarketImage';
  medium: Scalars['String'];
  original?: Maybe<Scalars['String']>;
  present: Scalars['Boolean'];
  small: Scalars['String'];
  thumb: Scalars['String'];
};

export type MarketInput = {
  appleCredits?: InputMaybe<Scalars['Boolean']>;
  appleCreditsPercentage?: InputMaybe<Scalars['Boolean']>;
  appleCreditsPercentageValue?: InputMaybe<Scalars['Float']>;
  bftFacebook?: InputMaybe<Scalars['String']>;
  cateringCategoriesEnabled: Scalars['Boolean'];
  /** Catering Description 1 */
  cateringDescription1?: InputMaybe<HtmlRecordInput>;
  /** Catering Description 2 */
  cateringDescription2?: InputMaybe<HtmlRecordInput>;
  cateringDropOffMinBudgetCents: Scalars['Int'];
  cateringMinBudgetCents: Scalars['Int'];
  /** Description */
  description?: InputMaybe<HtmlRecordInput>;
  eventsMinOrdersAmountCents: Scalars['Int'];
  eventsRequestRestaurantTransactionFeePercentage: Scalars['Float'];
  eventsRewardCents: Scalars['Int'];
  foodTypePagesEnabled: Scalars['Boolean'];
  /** Image */
  image?: InputMaybe<Scalars['Upload']>;
  imageAuthor?: InputMaybe<Scalars['String']>;
  imageAuthorUrl?: InputMaybe<Scalars['String']>;
  imageLicense?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  showMap: Scalars['Boolean'];
  state: Scalars['String'];
  topTrucksDescription?: InputMaybe<HtmlRecordInput>;
  topTrucksEnabled: Scalars['Boolean'];
  upsellTypeAdjustments?: InputMaybe<Array<MarketUpsellTypeAdjustmentInput>>;
};

export type MarketTopTruck = {
  __typename?: 'MarketTopTruck';
  description: HtmlRecord;
  featuredItems: Array<Item>;
  id: Scalars['Int'];
  market: Market;
  position: Scalars['Int'];
  truck: Truck;
};

/** Autogenerated return type of MarketUpdate. */
export type MarketUpdatePayload = {
  __typename?: 'MarketUpdatePayload';
  errors?: Maybe<Array<UserError>>;
  market?: Maybe<Market>;
};

/** Autogenerated return type of MarketUpdateTopTrucks. */
export type MarketUpdateTopTrucksPayload = {
  __typename?: 'MarketUpdateTopTrucksPayload';
  errors?: Maybe<Array<UserError>>;
  market?: Maybe<Market>;
};

export type MarketUpsellTypeAdjustmentInput = {
  adjustmentCents: Scalars['Int'];
  upsellTypeId: Scalars['Int'];
};

/** Autogenerated return type of MarketplaceClickCreate. */
export type MarketplaceClickCreatePayload = {
  __typename?: 'MarketplaceClickCreatePayload';
  errors?: Maybe<Array<UserError>>;
};

export type MarketsFilterInput = {
  /** Whether a market is active */
  active?: InputMaybe<Scalars['Boolean']>;
  /** Near my ip */
  nearMe?: InputMaybe<Scalars['Boolean']>;
};

export type MealPartsInput = {
  count: Scalars['Int'];
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type Menu = {
  __typename?: 'Menu';
  active: Scalars['Boolean'];
  bookable: Scalars['Boolean'];
  catering: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  customerMenuUrl?: Maybe<Scalars['String']>;
  foodTypes: Array<FoodType>;
  hasPrices: Scalars['Boolean'];
  id: Scalars['Int'];
  items: Array<Item>;
  manualOrder: Scalars['Boolean'];
  name: Scalars['String'];
  public: Scalars['Boolean'];
  restaurant: Restaurant;
  taxIncluded: Scalars['Boolean'];
  trucks: Array<Truck>;
};


export type MenuCustomerMenuUrlArgs = {
  truckId?: InputMaybe<Scalars['Int']>;
};


export type MenuItemsArgs = {
  filter?: InputMaybe<ItemsFilterInput>;
  page?: InputMaybe<CollectionInput>;
  sort?: InputMaybe<Array<ItemSortInput>>;
};

/** Autogenerated return type of MenuActivate. */
export type MenuActivatePayload = {
  __typename?: 'MenuActivatePayload';
  errors?: Maybe<Array<UserError>>;
  menu?: Maybe<Menu>;
};

export type MenuCollection = Collection & {
  __typename?: 'MenuCollection';
  /** Limit */
  limit?: Maybe<Scalars['Int']>;
  /** Offset */
  offset?: Maybe<Scalars['Int']>;
  /** List of records */
  records: Array<Menu>;
  /** Total */
  total: Scalars['Int'];
};


export type MenuCollectionTotalArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};

/** Autogenerated return type of MenuCopy. */
export type MenuCopyPayload = {
  __typename?: 'MenuCopyPayload';
  errors?: Maybe<Array<UserError>>;
  menu?: Maybe<Menu>;
};

/** Autogenerated return type of MenuCreate. */
export type MenuCreatePayload = {
  __typename?: 'MenuCreatePayload';
  errors?: Maybe<Array<UserError>>;
  menu?: Maybe<Menu>;
};

/** Autogenerated return type of MenuItemsCopy. */
export type MenuItemsCopyPayload = {
  __typename?: 'MenuItemsCopyPayload';
  errors?: Maybe<Array<UserError>>;
  menu?: Maybe<Menu>;
};

/** Autogenerated return type of MenuRemove. */
export type MenuRemovePayload = {
  __typename?: 'MenuRemovePayload';
  errors?: Maybe<Array<UserError>>;
  restaurant?: Maybe<Restaurant>;
};

/** Autogenerated return type of MenuUpdate. */
export type MenuUpdatePayload = {
  __typename?: 'MenuUpdatePayload';
  errors?: Maybe<Array<UserError>>;
  menu?: Maybe<Menu>;
};

/** Autogenerated return type of MenuUpdatePositions. */
export type MenuUpdatePositionsPayload = {
  __typename?: 'MenuUpdatePositionsPayload';
  errors?: Maybe<Array<UserError>>;
  menu?: Maybe<Menu>;
};

export type MenusFilterInput = {
  /** Filter by active */
  active?: InputMaybe<Scalars['Boolean']>;
  /** Filter by catering menu */
  catering?: InputMaybe<Scalars['Boolean']>;
  truckId?: InputMaybe<Scalars['Int']>;
};

/** Autogenerated return type of MetabaseMakePublicLink. */
export type MetabaseMakePublicLinkPayload = {
  __typename?: 'MetabaseMakePublicLinkPayload';
  errors?: Maybe<Array<UserError>>;
  url?: Maybe<Scalars['String']>;
};

export type MetabaseQuestion = {
  __typename?: 'MetabaseQuestion';
  id: Scalars['Int'];
  iframeUrl: Scalars['String'];
  name: Scalars['String'];
};

export type MetabaseQuestionParamsInput = {
  /** Key */
  key?: InputMaybe<Scalars['String']>;
  /** Value */
  value?: InputMaybe<Scalars['String']>;
};

export type Money = {
  __typename?: 'Money';
  cents: Scalars['Int'];
  formatted: Scalars['String'];
};

export type Note = {
  __typename?: 'Note';
  content: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['Int'];
  user: NoteCommenter;
};

/** Autogenerated return type of NoteAdd. */
export type NoteAddPayload = {
  __typename?: 'NoteAddPayload';
  errors?: Maybe<Array<UserError>>;
  note?: Maybe<Note>;
};

export type NoteCollection = Collection & {
  __typename?: 'NoteCollection';
  /** Limit */
  limit?: Maybe<Scalars['Int']>;
  /** Offset */
  offset?: Maybe<Scalars['Int']>;
  /** List of records */
  records: Array<Note>;
  /** Total */
  total: Scalars['Int'];
};


export type NoteCollectionTotalArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};

export type NoteCommenter = {
  __typename?: 'NoteCommenter';
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type NotesSortInput = {
  /** ASC / DESC */
  direction: SortDirection;
  /** Field to sort by */
  field: NotesSortInputFields;
};

export enum NotesSortInputFields {
  CreatedAt = 'created_at'
}

export type OfflineOrder = {
  __typename?: 'OfflineOrder';
  amountCustomer: Money;
  amountItems: Money;
  amountRestaurant: Money;
  amountStripe: Money;
  amountTax: Money;
  amountTip: Money;
  canRefund: Scalars['Boolean'];
  chargeType: OfflineOrderCharge;
  chargeTypeHuman: Scalars['String'];
  cookAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  customerEmail?: Maybe<Scalars['String']>;
  customerName?: Maybe<Scalars['String']>;
  customerPaymentStatus: OfflineOrderCustomerPaymentStatus;
  customerPaymentStatusHuman: Scalars['String'];
  customerPhone?: Maybe<Scalars['String']>;
  friendlyId: Scalars['String'];
  guessName?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  location: Location;
  offlineOrderItems: Array<OfflineOrderItem>;
  offlineOrderRefunds: Array<OfflineOrderRefund>;
  platform: OfflineOrderPlatform;
  profilePictureUrl: Scalars['String'];
  status: OfflineOrderStatus;
  statusHuman: Scalars['String'];
  stripeReferences?: Maybe<Array<StripeReference>>;
  truckPaymentStatus: OfflineOrderTruckPaymentStatus;
  truckPaymentStatusHuman: Scalars['String'];
};


export type OfflineOrderGuessNameArgs = {
  email?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};

export type OfflineOrderAnswer = {
  __typename?: 'OfflineOrderAnswer';
  adjustment?: Maybe<Money>;
  id: Scalars['Int'];
  text: Scalars['String'];
};

export type OfflineOrderAnswerInput = {
  answerId: Scalars['Int'];
};

/** Autogenerated return type of OfflineOrderCardConfirm. */
export type OfflineOrderCardConfirmPayload = {
  __typename?: 'OfflineOrderCardConfirmPayload';
  errors?: Maybe<Array<UserError>>;
  offlineOrder?: Maybe<OfflineOrder>;
};

/** Autogenerated return type of OfflineOrderCashConfirm. */
export type OfflineOrderCashConfirmPayload = {
  __typename?: 'OfflineOrderCashConfirmPayload';
  errors?: Maybe<Array<UserError>>;
  offlineOrder?: Maybe<OfflineOrder>;
};

export enum OfflineOrderCharge {
  PaidWithCard = 'paid_with_card',
  PaidWithCash = 'paid_with_cash'
}

export type OfflineOrderCollection = Collection & {
  __typename?: 'OfflineOrderCollection';
  /** Limit */
  limit?: Maybe<Scalars['Int']>;
  /** Offset */
  offset?: Maybe<Scalars['Int']>;
  /** List of records */
  records: Array<OfflineOrder>;
  /** Total */
  total: Scalars['Int'];
};


export type OfflineOrderCollectionTotalArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};

/** Autogenerated return type of OfflineOrderCompleted. */
export type OfflineOrderCompletedPayload = {
  __typename?: 'OfflineOrderCompletedPayload';
  errors?: Maybe<Array<UserError>>;
  offlineOrder?: Maybe<OfflineOrder>;
};

/** Autogenerated return type of OfflineOrderCreate. */
export type OfflineOrderCreatePayload = {
  __typename?: 'OfflineOrderCreatePayload';
  errors?: Maybe<Array<UserError>>;
  offlineOrder?: Maybe<OfflineOrder>;
};

export enum OfflineOrderCustomerPaymentStatus {
  CustomerAuthorized = 'customer_authorized',
  CustomerNotPaid = 'customer_not_paid',
  CustomerPaid = 'customer_paid',
  CustomerRefunded = 'customer_refunded'
}

/** Autogenerated return type of OfflineOrderDiscard. */
export type OfflineOrderDiscardPayload = {
  __typename?: 'OfflineOrderDiscardPayload';
  errors?: Maybe<Array<UserError>>;
  offlineOrder?: Maybe<OfflineOrder>;
};

export type OfflineOrderItem = {
  __typename?: 'OfflineOrderItem';
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  item?: Maybe<Item>;
  name: Scalars['String'];
  offlineOrderQuestions: Array<OfflineOrderQuestion>;
  price: Money;
  quantity: Scalars['Int'];
  specialInstructions?: Maybe<Scalars['String']>;
};

export type OfflineOrderItemInput = {
  addonToUuid?: InputMaybe<Scalars['String']>;
  custom: Scalars['Boolean'];
  itemId?: InputMaybe<Scalars['Int']>;
  itemName?: InputMaybe<Scalars['String']>;
  priceCents?: InputMaybe<Scalars['Int']>;
  quantity?: InputMaybe<Scalars['Int']>;
  questions?: InputMaybe<Array<OfflineOrderQuestionInput>>;
  specialInstructions?: InputMaybe<Scalars['String']>;
  uuid?: InputMaybe<Scalars['String']>;
};

export enum OfflineOrderPlatform {
  Android = 'android',
  Ios = 'ios'
}

export type OfflineOrderPrice = {
  __typename?: 'OfflineOrderPrice';
  amountCustomer: Money;
  amountRestaurant: Money;
  amountStripe: Money;
  amountTax: Money;
  amountTip: Money;
  items: Array<OfflineOrderPriceItem>;
};

export type OfflineOrderPriceInput = {
  amountTipCents: Scalars['Int'];
  chargeType: OfflineOrderCharge;
  items: Array<OfflineOrderItemInput>;
  locationId: Scalars['Int'];
  platform: OfflineOrderPlatform;
};

export type OfflineOrderPriceItem = {
  __typename?: 'OfflineOrderPriceItem';
  index: Scalars['Int'];
  itemId?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  quantity: Scalars['Int'];
  specialInstructions?: Maybe<Scalars['String']>;
  total: Money;
  uuid?: Maybe<Scalars['String']>;
};

export type OfflineOrderQuestion = {
  __typename?: 'OfflineOrderQuestion';
  id: Scalars['Int'];
  offlineOrderAnswers: Array<OfflineOrderAnswer>;
  text: Scalars['String'];
};

export type OfflineOrderQuestionInput = {
  answers: Array<OfflineOrderAnswerInput>;
  questionId: Scalars['Int'];
};

/** Autogenerated return type of OfflineOrderReady. */
export type OfflineOrderReadyPayload = {
  __typename?: 'OfflineOrderReadyPayload';
  errors?: Maybe<Array<UserError>>;
  offlineOrder?: Maybe<OfflineOrder>;
};

export type OfflineOrderRefund = {
  __typename?: 'OfflineOrderRefund';
  amountCustomer: Money;
  amountItems: Money;
  amountTax: Money;
  amountTip: Money;
  createdAt: Scalars['DateTime'];
  id: Scalars['Int'];
};

/** Autogenerated return type of OfflineOrderRefund. */
export type OfflineOrderRefundPayload = {
  __typename?: 'OfflineOrderRefundPayload';
  errors?: Maybe<Array<UserError>>;
  offlineOrder?: Maybe<OfflineOrder>;
};

/** Autogenerated return type of OfflineOrderSendReceipt. */
export type OfflineOrderSendReceiptPayload = {
  __typename?: 'OfflineOrderSendReceiptPayload';
  errors?: Maybe<Array<UserError>>;
  offlineOrder?: Maybe<OfflineOrder>;
};

export enum OfflineOrderStatus {
  Completed = 'completed',
  Confirmed = 'confirmed',
  Draft = 'draft',
  Ready = 'ready'
}

export enum OfflineOrderTruckPaymentStatus {
  TruckNotPaid = 'truck_not_paid',
  TruckPaid = 'truck_paid',
  TruckPaymentReversed = 'truck_payment_reversed'
}

export type OfflineOrdersFilterInput = {
  statuses?: InputMaybe<Array<OfflineOrderStatus>>;
};

export type OfflineOrdersSortInput = {
  /** ASC / DESC */
  direction: SortDirection;
  /** Field to sort by */
  field: OfflineOrdersSortInputFields;
};

export enum OfflineOrdersSortInputFields {
  CreatedAt = 'created_at'
}

export type Order = {
  __typename?: 'Order';
  assignedTo?: Maybe<Organizer>;
  canBeAbandoned?: Maybe<Scalars['Boolean']>;
  canCancel?: Maybe<Scalars['Boolean']>;
  canChangePickupTime: Scalars['Boolean'];
  cancelledAt?: Maybe<Scalars['DateTime']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  confirmedAt?: Maybe<Scalars['DateTime']>;
  cookAt: Scalars['DateTime'];
  createdAt?: Maybe<Scalars['DateTime']>;
  customer?: Maybe<Customer>;
  customerNotes?: Maybe<Scalars['String']>;
  customerPaymentStatus?: Maybe<OrderCustomerPaymentStatus>;
  delayedPickup: Scalars['Boolean'];
  delayedPickupAt?: Maybe<Scalars['DateTime']>;
  estimatedCompletionAt?: Maybe<Scalars['DateTime']>;
  friendlyId?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  location: Location;
  messagingConversations?: Maybe<Array<Conversation>>;
  orderItemPrices: Array<OrderItemPrice>;
  orderItems?: Maybe<Array<OrderItem>>;
  orderRating?: Maybe<OrderRating>;
  platform: Platform;
  preOrder?: Maybe<Scalars['Boolean']>;
  priceLinesAdmin?: Maybe<Array<OrderPriceLine>>;
  priceLinesCustomer: Array<OrderPriceLine>;
  priceLinesRestaurant: Array<OrderPriceLine>;
  prices?: Maybe<OrderPrices>;
  readyAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<OrderStatus>;
  statusHuman?: Maybe<Scalars['String']>;
  statusSetAt?: Maybe<Scalars['DateTime']>;
  stripeReferences?: Maybe<Array<StripeReference>>;
  timeline?: Maybe<OrderTimeline>;
  token: Scalars['String'];
  truck: Truck;
  truckPaymentStatus?: Maybe<OrderTruckPaymentStatus>;
};

/** Autogenerated return type of OrderAbandon. */
export type OrderAbandonPayload = {
  __typename?: 'OrderAbandonPayload';
  errors?: Maybe<Array<UserError>>;
  order?: Maybe<Order>;
};

/** Autogenerated return type of OrderAssign. */
export type OrderAssignPayload = {
  __typename?: 'OrderAssignPayload';
  errors?: Maybe<Array<UserError>>;
  order?: Maybe<Order>;
};

/** Autogenerated return type of OrderCancel. */
export type OrderCancelPayload = {
  __typename?: 'OrderCancelPayload';
  errors?: Maybe<Array<UserError>>;
  order?: Maybe<Order>;
};

/** Autogenerated return type of OrderChangePickupTime. */
export type OrderChangePickupTimePayload = {
  __typename?: 'OrderChangePickupTimePayload';
  errors?: Maybe<Array<UserError>>;
  order?: Maybe<Order>;
};

export type OrderCollection = Collection & {
  __typename?: 'OrderCollection';
  /** Limit */
  limit?: Maybe<Scalars['Int']>;
  /** Offset */
  offset?: Maybe<Scalars['Int']>;
  /** List of records */
  records: Array<Order>;
  /** Total */
  total: Scalars['Int'];
};


export type OrderCollectionTotalArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};

/** Autogenerated return type of OrderComplete. */
export type OrderCompletePayload = {
  __typename?: 'OrderCompletePayload';
  errors?: Maybe<Array<UserError>>;
  order?: Maybe<Order>;
};

/** Autogenerated return type of OrderConfirm. */
export type OrderConfirmPayload = {
  __typename?: 'OrderConfirmPayload';
  errors?: Maybe<Array<UserError>>;
  order?: Maybe<Order>;
};

export enum OrderCustomerPaymentStatus {
  CustomerAuthorized = 'customer_authorized',
  CustomerNotPaid = 'customer_not_paid',
  CustomerPaid = 'customer_paid',
  CustomerRefunded = 'customer_refunded'
}

export type OrderItem = {
  __typename?: 'OrderItem';
  active: Scalars['Boolean'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  item: Item;
  name?: Maybe<Scalars['String']>;
  orderItemQuestions: Array<OrderItemQuestion>;
  price: Money;
  quantity?: Maybe<Scalars['Int']>;
  specialInstructions?: Maybe<Scalars['String']>;
};

export type OrderItemAnswer = {
  __typename?: 'OrderItemAnswer';
  active: Scalars['Boolean'];
  adjustment?: Maybe<Money>;
  id: Scalars['Int'];
  text?: Maybe<Scalars['String']>;
};

export type OrderItemPrice = {
  __typename?: 'OrderItemPrice';
  name: Scalars['String'];
  orderItem: OrderItem;
  quantity: Scalars['Int'];
  taxIncluded: Scalars['Boolean'];
  total: Money;
};

export type OrderItemQuestion = {
  __typename?: 'OrderItemQuestion';
  id: Scalars['Int'];
  orderItemAnswers: Array<OrderItemAnswer>;
  text?: Maybe<Scalars['String']>;
};

export type OrderPartialRefund = {
  __typename?: 'OrderPartialRefund';
  amountCustomerRefund: Money;
  amountRestaurantReversal: Money;
  createdAt: Scalars['DateTime'];
  customerReason: Scalars['String'];
  customerRefundStatus: OrderPartialRefundCustomerStatus;
  customerRefundStatusHuman: Scalars['String'];
  id: Scalars['Int'];
  order: Order;
  rejectReason?: Maybe<Scalars['String']>;
  removeOrderAnswerIds: Array<Scalars['Int']>;
  removeOrderItemIds: Array<Scalars['Int']>;
  restaurantReversalStatus: OrderPartialRefundRestaurantStatus;
  restaurantReversalStatusHuman: Scalars['String'];
  status: OrderPartialRefundStatus;
  statusHuman: Scalars['String'];
  useCredits: Scalars['Boolean'];
};

/** Autogenerated return type of OrderPartialRefundApprove. */
export type OrderPartialRefundApprovePayload = {
  __typename?: 'OrderPartialRefundApprovePayload';
  errors?: Maybe<Array<UserError>>;
  orderPartialRefund?: Maybe<OrderPartialRefund>;
};

export type OrderPartialRefundCollection = Collection & {
  __typename?: 'OrderPartialRefundCollection';
  /** Limit */
  limit?: Maybe<Scalars['Int']>;
  /** Offset */
  offset?: Maybe<Scalars['Int']>;
  /** List of records */
  records: Array<OrderPartialRefund>;
  /** Total */
  total: Scalars['Int'];
};


export type OrderPartialRefundCollectionTotalArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};

/** Autogenerated return type of OrderPartialRefundCreate. */
export type OrderPartialRefundCreatePayload = {
  __typename?: 'OrderPartialRefundCreatePayload';
  errors?: Maybe<Array<UserError>>;
  order?: Maybe<Order>;
  orderPartialRefund?: Maybe<OrderPartialRefund>;
};

export enum OrderPartialRefundCustomerStatus {
  CustomerNotRefunded = 'customer_not_refunded',
  CustomerRefunded = 'customer_refunded'
}

export type OrderPartialRefundInput = {
  customerReason: Scalars['String'];
  orderItems: Array<OrderPartialRefundItem>;
  truckNotification: Scalars['Boolean'];
  useCredits: Scalars['Boolean'];
};

export type OrderPartialRefundItem = {
  orderItemId: Scalars['Int'];
  removeAnswerIds: Array<Scalars['Int']>;
  removeItem: Scalars['Boolean'];
};

/** Autogenerated return type of OrderPartialRefundReject. */
export type OrderPartialRefundRejectPayload = {
  __typename?: 'OrderPartialRefundRejectPayload';
  errors?: Maybe<Array<UserError>>;
  orderPartialRefund?: Maybe<OrderPartialRefund>;
};

export enum OrderPartialRefundRestaurantStatus {
  RestaurantTransferNotReversed = 'restaurant_transfer_not_reversed',
  RestaurantTransferReversed = 'restaurant_transfer_reversed'
}

export type OrderPartialRefundSortInput = {
  /** ASC / DESC */
  direction: SortDirection;
  /** Field to sort by */
  field: OrderPartialRefundSortInputFields;
};

export enum OrderPartialRefundSortInputFields {
  CreatedAt = 'created_at'
}

export enum OrderPartialRefundStatus {
  Approved = 'approved',
  Pending = 'pending',
  Rejected = 'rejected'
}

export type OrderPartialRefundsFilterInput = {
  restaurantId?: InputMaybe<Scalars['Int']>;
  statuses?: InputMaybe<Array<OrderPartialRefundStatus>>;
};

export type OrderPriceLine = {
  __typename?: 'OrderPriceLine';
  alwaysVisible: Scalars['Boolean'];
  amount?: Maybe<Money>;
  name: Scalars['String'];
  tags: Array<PriceLineTag>;
};

export type OrderPrices = {
  __typename?: 'OrderPrices';
  amountBft?: Maybe<Money>;
  amountBftCompensationForDiscounts?: Maybe<Money>;
  amountConvenienceFee?: Maybe<Money>;
  amountCustomer?: Maybe<Money>;
  amountCustomerBeforeTax?: Maybe<Money>;
  amountDiscount?: Maybe<Money>;
  amountRestaurant?: Maybe<Money>;
  amountRestaurantTransactionFee?: Maybe<Money>;
  amountSales?: Maybe<Money>;
  amountStripe?: Maybe<Money>;
  amountSubtotal?: Maybe<Money>;
  amountTax?: Maybe<Money>;
  amountTaxBft?: Maybe<Money>;
  amountTaxCustomer?: Maybe<Money>;
  amountTip?: Maybe<Money>;
  clientCompanyDiscount?: Maybe<Money>;
  referralBonus?: Maybe<Money>;
  referralBonusUsed?: Maybe<Money>;
};

export type OrderRating = {
  __typename?: 'OrderRating';
  id: Scalars['Int'];
  public: Scalars['Boolean'];
  ratedAt: Scalars['DateTime'];
  reason?: Maybe<Scalars['String']>;
  stars?: Maybe<Scalars['Int']>;
  viewed: Scalars['Boolean'];
};

export type OrderRatingCollection = Collection & {
  __typename?: 'OrderRatingCollection';
  /** Limit */
  limit?: Maybe<Scalars['Int']>;
  /** Offset */
  offset?: Maybe<Scalars['Int']>;
  /** List of records */
  records: Array<OrderRating>;
  /** Total */
  total: Scalars['Int'];
};


export type OrderRatingCollectionTotalArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};

/** Autogenerated return type of OrderRatingRate. */
export type OrderRatingRatePayload = {
  __typename?: 'OrderRatingRatePayload';
  errors?: Maybe<Array<UserError>>;
  order?: Maybe<Order>;
  orderRating?: Maybe<OrderRating>;
};

/** Autogenerated return type of OrderRatingViewed. */
export type OrderRatingViewedPayload = {
  __typename?: 'OrderRatingViewedPayload';
  errors?: Maybe<Array<UserError>>;
  order?: Maybe<Order>;
  orderRating?: Maybe<OrderRating>;
};

export type OrderRatingsFilterInput = {
  hasReason?: InputMaybe<Scalars['Boolean']>;
  public?: InputMaybe<Scalars['Boolean']>;
  stars?: InputMaybe<Array<Scalars['Int']>>;
};

export type OrderRatingsSortInput = {
  /** ASC / DESC */
  direction: SortDirection;
  /** Field to sort by */
  field: OrderRatingsSortInputFields;
};

export enum OrderRatingsSortInputFields {
  RatedAt = 'rated_at',
  Stars = 'stars'
}

/** Autogenerated return type of OrderReady. */
export type OrderReadyPayload = {
  __typename?: 'OrderReadyPayload';
  errors?: Maybe<Array<UserError>>;
  order?: Maybe<Order>;
};

/** Autogenerated return type of OrderRefundCustomer. */
export type OrderRefundCustomerPayload = {
  __typename?: 'OrderRefundCustomerPayload';
  errors?: Maybe<Array<UserError>>;
  order?: Maybe<Order>;
};

export type OrderRefundEstimation = {
  __typename?: 'OrderRefundEstimation';
  errors?: Maybe<Array<UserError>>;
  order?: Maybe<Order>;
  orderPartialRefund?: Maybe<OrderPartialRefund>;
};

/** Autogenerated return type of OrderReverseTruckPayment. */
export type OrderReverseTruckPaymentPayload = {
  __typename?: 'OrderReverseTruckPaymentPayload';
  errors?: Maybe<Array<UserError>>;
  order?: Maybe<Order>;
};

export enum OrderStatus {
  Abandoned = 'abandoned',
  Cancelled = 'cancelled',
  Completed = 'completed',
  InProgress = 'in_progress',
  Pending = 'pending',
  Ready = 'ready',
  Refused = 'refused'
}

export type OrderTimeline = {
  __typename?: 'OrderTimeline';
  events?: Maybe<Array<OrderTimelineEvent>>;
};

export type OrderTimelineEvent = {
  __typename?: 'OrderTimelineEvent';
  name?: Maybe<Scalars['String']>;
  time?: Maybe<Scalars['DateTime']>;
};

export enum OrderTruckPaymentStatus {
  TruckNotPaid = 'truck_not_paid',
  TruckPaid = 'truck_paid',
  TruckPaymentReversed = 'truck_payment_reversed'
}

/** Autogenerated return type of OrderUnassign. */
export type OrderUnassignPayload = {
  __typename?: 'OrderUnassignPayload';
  errors?: Maybe<Array<UserError>>;
  order?: Maybe<Order>;
};

export type OrdersFilterInput = {
  /** Orders created after this date */
  createdAtGt?: InputMaybe<Scalars['DateTime']>;
  pendingRating?: InputMaybe<Scalars['Boolean']>;
  /** Order is in one of these statuses */
  statuses?: InputMaybe<Array<OrderStatus>>;
};

export type OrdersSortInput = {
  /** ASC / DESC */
  direction: SortDirection;
  /** Field to sort by */
  field: OrdersSortInputFields;
};

export enum OrdersSortInputFields {
  CookAt = 'cook_at',
  CreatedAt = 'created_at',
  DelayedPickup = 'delayed_pickup',
  ReadyAt = 'ready_at'
}

export type Organization = {
  __typename?: 'Organization';
  amountConvenienceFeeCents: Scalars['Int'];
  bftCateringFeePercentage: Scalars['Float'];
  bftSalesPercentageCut: Scalars['Float'];
  bookingFeeCents: Scalars['Int'];
  bookingFeePercentage: Scalars['Float'];
  cateringEmailCustomer?: Maybe<Scalars['String']>;
  cateringEmailName?: Maybe<Scalars['String']>;
  cateringEmailNotifications?: Maybe<Scalars['String']>;
  cateringEmailTruck?: Maybe<Scalars['String']>;
  cateringEmailWebsite?: Maybe<Scalars['String']>;
  cateringLogo?: Maybe<ImageAttachment>;
  cateringPhone?: Maybe<Scalars['String']>;
  defaultLotSetting?: Maybe<DefaultLotSetting>;
  enableRestaurantTransactionFee: Scalars['Boolean'];
  enabledEmails: Array<Scalars['String']>;
  id: Scalars['Int'];
  lots?: Maybe<Array<Lot>>;
  municipality: Scalars['Boolean'];
  name: Scalars['String'];
  organizationBankAccounts: Array<OrganizationBankAccount>;
  organizationBookingRestriction?: Maybe<OrganizationBookingRestriction>;
  organizationDebitCards: Array<OrganizationDebitCard>;
  organizers: OrganizerCollection;
  overwriteBookingFee: Scalars['Boolean'];
  restaurantTransactionFeePercentage: Scalars['Float'];
  seoName: Scalars['String'];
  stripeAccountCreated?: Maybe<Scalars['Boolean']>;
  stripeLink?: Maybe<Scalars['String']>;
  useBookingFeePercentage: Scalars['Boolean'];
  verification?: Maybe<Verification>;
};


export type OrganizationOrganizersArgs = {
  filter?: InputMaybe<OrganizersFilterInput>;
};


export type OrganizationVerificationArgs = {
  forceSync?: InputMaybe<Scalars['Boolean']>;
};

export type OrganizationBankAccount = {
  __typename?: 'OrganizationBankAccount';
  active?: Maybe<Scalars['Boolean']>;
  bankName?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  last4?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of OrganizationBankAccountCreate. */
export type OrganizationBankAccountCreatePayload = {
  __typename?: 'OrganizationBankAccountCreatePayload';
  errors?: Maybe<Array<UserError>>;
  organization?: Maybe<Organization>;
  organizationBankAccount?: Maybe<OrganizationBankAccount>;
};

/** Autogenerated return type of OrganizationBankAccountDestroy. */
export type OrganizationBankAccountDestroyPayload = {
  __typename?: 'OrganizationBankAccountDestroyPayload';
  errors?: Maybe<Array<UserError>>;
  organization?: Maybe<Organization>;
};

/** Autogenerated return type of OrganizationBankAccountMakeCurrent. */
export type OrganizationBankAccountMakeCurrentPayload = {
  __typename?: 'OrganizationBankAccountMakeCurrentPayload';
  errors?: Maybe<Array<UserError>>;
  organization?: Maybe<Organization>;
  organizationBankAccount?: Maybe<OrganizationBankAccount>;
};

export type OrganizationBookingRestriction = {
  __typename?: 'OrganizationBookingRestriction';
  bookingDelaySeconds: Scalars['Int'];
  id: Scalars['Int'];
};

/** Autogenerated return type of OrganizationBookingRestrictionUpdate. */
export type OrganizationBookingRestrictionUpdatePayload = {
  __typename?: 'OrganizationBookingRestrictionUpdatePayload';
  errors?: Maybe<Array<UserError>>;
  organizationBookingRestriction?: Maybe<OrganizationBookingRestriction>;
};

export type OrganizationCollection = Collection & {
  __typename?: 'OrganizationCollection';
  /** Limit */
  limit?: Maybe<Scalars['Int']>;
  /** Offset */
  offset?: Maybe<Scalars['Int']>;
  /** List of records */
  records: Array<Organization>;
  /** Total */
  total: Scalars['Int'];
};


export type OrganizationCollectionTotalArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};

/** Autogenerated return type of OrganizationCreate. */
export type OrganizationCreatePayload = {
  __typename?: 'OrganizationCreatePayload';
  errors?: Maybe<Array<UserError>>;
  organization?: Maybe<Organization>;
};

export type OrganizationDebitCard = {
  __typename?: 'OrganizationDebitCard';
  active?: Maybe<Scalars['Boolean']>;
  brand?: Maybe<Scalars['String']>;
  expMonth?: Maybe<Scalars['String']>;
  expYear?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  last4?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of OrganizationDebitCardCreate. */
export type OrganizationDebitCardCreatePayload = {
  __typename?: 'OrganizationDebitCardCreatePayload';
  errors?: Maybe<Array<UserError>>;
  organization?: Maybe<Organization>;
  organizationDebitCard?: Maybe<OrganizationDebitCard>;
};

/** Autogenerated return type of OrganizationDebitCardDestroy. */
export type OrganizationDebitCardDestroyPayload = {
  __typename?: 'OrganizationDebitCardDestroyPayload';
  errors?: Maybe<Array<UserError>>;
  organization?: Maybe<Organization>;
};

/** Autogenerated return type of OrganizationDebitCardMakeCurrent. */
export type OrganizationDebitCardMakeCurrentPayload = {
  __typename?: 'OrganizationDebitCardMakeCurrentPayload';
  errors?: Maybe<Array<UserError>>;
  organization?: Maybe<Organization>;
  organizationDebitCard?: Maybe<OrganizationDebitCard>;
};

/** Autogenerated return type of OrganizationEditStripeAccount. */
export type OrganizationEditStripeAccountPayload = {
  __typename?: 'OrganizationEditStripeAccountPayload';
  errors?: Maybe<Array<UserError>>;
  stripeUrl?: Maybe<Scalars['String']>;
};

export type OrganizationInput = {
  amountConvenienceFeeCents?: InputMaybe<Scalars['Int']>;
  bftCateringFeePercentage: Scalars['Float'];
  bftSalesPercentageCut: Scalars['Float'];
  bookingFeeCents?: InputMaybe<Scalars['Int']>;
  bookingFeePercentage?: InputMaybe<Scalars['Float']>;
  cateringLogo?: InputMaybe<Scalars['Upload']>;
  enableRestaurantTransactionFee?: InputMaybe<Scalars['Boolean']>;
  municipality?: InputMaybe<Scalars['Boolean']>;
  /** Name */
  name?: InputMaybe<Scalars['String']>;
  overwriteBookingFee?: InputMaybe<Scalars['Boolean']>;
  restaurantTransactionFeePercentage?: InputMaybe<Scalars['Float']>;
  useBookingFeePercentage?: InputMaybe<Scalars['Boolean']>;
};

/** Autogenerated return type of OrganizationUpdateCatering. */
export type OrganizationUpdateCateringPayload = {
  __typename?: 'OrganizationUpdateCateringPayload';
  errors?: Maybe<Array<UserError>>;
  organization?: Maybe<Organization>;
};

/** Autogenerated return type of OrganizationUpdate. */
export type OrganizationUpdatePayload = {
  __typename?: 'OrganizationUpdatePayload';
  errors?: Maybe<Array<UserError>>;
  organization?: Maybe<Organization>;
};

export type OrganizationsFilterInput = {
  municipality?: InputMaybe<Scalars['Boolean']>;
  /** Search */
  search?: InputMaybe<Scalars['String']>;
};

export type Organizer = {
  __typename?: 'Organizer';
  active?: Maybe<Scalars['Boolean']>;
  assignedOrders: OrderCollection;
  authToken?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  lastName?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  organization: Organization;
  phone?: Maybe<Scalars['String']>;
  roles: Array<OrganizerRole>;
  spoofUrl?: Maybe<Scalars['String']>;
  subscribedToLots?: Maybe<Array<Lot>>;
};


export type OrganizerAssignedOrdersArgs = {
  filter?: InputMaybe<OrdersFilterInput>;
  page?: InputMaybe<CollectionInput>;
  sort?: InputMaybe<Array<OrdersSortInput>>;
};


export type OrganizerSpoofUrlArgs = {
  to?: InputMaybe<Scalars['String']>;
};

export type OrganizerCollection = Collection & {
  __typename?: 'OrganizerCollection';
  /** Limit */
  limit?: Maybe<Scalars['Int']>;
  /** Offset */
  offset?: Maybe<Scalars['Int']>;
  /** List of records */
  records: Array<Organizer>;
  /** Total */
  total: Scalars['Int'];
};


export type OrganizerCollectionTotalArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};

/** Autogenerated return type of OrganizerCreate. */
export type OrganizerCreatePayload = {
  __typename?: 'OrganizerCreatePayload';
  errors?: Maybe<Array<UserError>>;
  organizer?: Maybe<Organizer>;
};

/** Autogenerated return type of OrganizerForgotPassword. */
export type OrganizerForgotPasswordPayload = {
  __typename?: 'OrganizerForgotPasswordPayload';
  errors?: Maybe<Array<UserError>>;
};

/** Autogenerated return type of OrganizerLogin. */
export type OrganizerLoginPayload = {
  __typename?: 'OrganizerLoginPayload';
  errors?: Maybe<Array<UserError>>;
  organizer?: Maybe<Organizer>;
};

/** Autogenerated return type of OrganizerLotSubscriptionCreate. */
export type OrganizerLotSubscriptionCreatePayload = {
  __typename?: 'OrganizerLotSubscriptionCreatePayload';
  errors?: Maybe<Array<UserError>>;
  organizer?: Maybe<Organizer>;
};

/** Autogenerated return type of OrganizerLotSubscriptionRemove. */
export type OrganizerLotSubscriptionRemovePayload = {
  __typename?: 'OrganizerLotSubscriptionRemovePayload';
  errors?: Maybe<Array<UserError>>;
  organizer?: Maybe<Organizer>;
};

/** Autogenerated return type of OrganizerNotifyTrucks. */
export type OrganizerNotifyTrucksPayload = {
  __typename?: 'OrganizerNotifyTrucksPayload';
  errors?: Maybe<Array<UserError>>;
  success?: Maybe<Scalars['Boolean']>;
};

/** Autogenerated return type of OrganizerResetPassword. */
export type OrganizerResetPasswordPayload = {
  __typename?: 'OrganizerResetPasswordPayload';
  errors?: Maybe<Array<UserError>>;
  organizer?: Maybe<Organizer>;
};

export enum OrganizerRole {
  Catering = 'catering',
  Events = 'events',
  Full = 'full',
  OrderMonitoring = 'order_monitoring',
  Payment = 'payment',
  Reports = 'reports',
  Sales = 'sales'
}

/** Autogenerated return type of OrganizerUpdate. */
export type OrganizerUpdatePayload = {
  __typename?: 'OrganizerUpdatePayload';
  errors?: Maybe<Array<UserError>>;
  organizer?: Maybe<Organizer>;
};

export type OrganizersFilterInput = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  /** Organizer is active */
  isActive?: InputMaybe<Scalars['Boolean']>;
};

export type Partnership = {
  __typename?: 'Partnership';
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

export type PartnershipTruckData = {
  __typename?: 'PartnershipTruckData';
  data: Scalars['JSON'];
  id: Scalars['Int'];
};

export enum Platform {
  Android = 'android',
  Ios = 'ios',
  Web = 'web'
}

/** Autogenerated return type of PreferredVendorChange. */
export type PreferredVendorChangePayload = {
  __typename?: 'PreferredVendorChangePayload';
  errors?: Maybe<Array<UserError>>;
  truck?: Maybe<Truck>;
};

export type PriceLine = {
  __typename?: 'PriceLine';
  alwaysVisible: Scalars['Boolean'];
  amount?: Maybe<Money>;
  name: Scalars['String'];
  tags: Array<PriceLineTag>;
};

export enum PriceLineTag {
  Coupon = 'coupon',
  Total = 'total'
}

export type PublicRating = {
  __typename?: 'PublicRating';
  id: Scalars['String'];
  name: Scalars['String'];
  ratedAt: Scalars['DateTime'];
  stars: Scalars['Int'];
  text: Scalars['String'];
};

export type PublicRatingCollection = {
  __typename?: 'PublicRatingCollection';
  /** Average rating */
  average: Scalars['Float'];
  /** Limit */
  limit?: Maybe<Scalars['Int']>;
  /** Offset */
  offset?: Maybe<Scalars['Int']>;
  /** List of records */
  records: Array<TruckPublicGenericRating>;
  /** Total */
  total: Scalars['Int'];
};

export type Query = {
  __typename?: 'Query';
  abTest?: Maybe<Scalars['String']>;
  accountDeletionRequests: AccountDeletionRequestCollection;
  adminQuickSearch?: Maybe<Array<QuickSearchMatch>>;
  agentChat?: Maybe<AgentChat>;
  agentChats: AgentChatCollection;
  bftContactInfo: BftContactInfo;
  blogPost?: Maybe<BlogPost>;
  blogPosts: Array<BlogPost>;
  cartItemEstimation: CartItemPrice;
  cateringCategories: Array<CateringCategory>;
  cateringCategory?: Maybe<CateringCategory>;
  cateringCustomRequest?: Maybe<CateringCustomRequest>;
  cateringCustomRequests: CateringCustomRequestCollection;
  cateringRatings: TruckGenericRatingCollection;
  cateringRatingsPublic: PublicRatingCollection;
  cateringRequest?: Maybe<CateringRequest>;
  cateringRequestBudget: CateringRequestBudget;
  cateringRequestBudgetValidation?: Maybe<UserError>;
  cateringRequestPreview?: Maybe<CateringRequestPreview>;
  cateringRequestProposalsPrice: Money;
  cateringRequests: CateringRequestCollection;
  cateringTruckRequest?: Maybe<CateringTruckRequest>;
  clientCompanies: ClientCompanyCollection;
  clientCompany: ClientCompany;
  clientCompanyInvoices: ClientCompanyInvoiceCollection;
  coupon: Coupon;
  coupons: CouponCollection;
  creditsTriggersConfig: CreditsTriggersConfig;
  currentAdmin?: Maybe<Admin>;
  currentCart?: Maybe<Cart>;
  currentClientCompany?: Maybe<ClientCompany>;
  currentCorporateUser?: Maybe<CorporateUser>;
  currentCustomer?: Maybe<Customer>;
  currentEmployee?: Maybe<Employee>;
  currentOrganization?: Maybe<Organization>;
  currentOrganizer?: Maybe<Organizer>;
  currentRestaurant?: Maybe<Restaurant>;
  currentUser?: Maybe<User>;
  customer: Customer;
  customerByEmail?: Maybe<Customer>;
  customerPaths: CustomerPaths;
  customerUnifiedCateringRequests: UnifiedCateringRequestCollection;
  customers: CustomerCollection;
  dashNotifications: DashNotificationCollection;
  dashSubscribedToEntity: DashEntitySubscription;
  dashSubscriptionChannels: Array<DashSubscriptionChannel>;
  dashWatchers: Array<DashWatcher>;
  describeCancellationPolicy: Array<Scalars['String']>;
  emailThread: EmailThread;
  emailThreadWithFallback: EmailThread;
  emailThreads: EmailThreadCollection;
  emailTokenToEmail?: Maybe<Scalars['String']>;
  employee?: Maybe<Employee>;
  entityNotes: NoteCollection;
  event: Event;
  eventAvailabilityDates?: Maybe<Array<EventAvailabilityDate>>;
  events: EventCollection;
  eventsRequest: EventsRequest;
  eventsRequests: EventsRequestCollection;
  foodItemTags: Array<ItemTag>;
  foodTypeCategories: Array<FoodTypeCategory>;
  foodTypePage?: Maybe<FoodTypePage>;
  foodTypePages: Array<FoodTypePage>;
  foodTypes: Array<FoodType>;
  globalConfig: GlobalConfig;
  guessLocation: GuessLocation;
  healthPermit?: Maybe<HealthPermit>;
  healthPermits: HealthPermitCollection;
  item: Item;
  itemQuestion: ItemQuestion;
  location: Location;
  locationItem: LocationItem;
  locationItemAnswer: LocationItemAnswer;
  locationItemQuestion: LocationItemQuestion;
  locationSalesPercentageEstimate: Money;
  locations: LocationCollection;
  logEventTypes: Array<LogEventHandler>;
  logEvents: LogEventCollection;
  lot?: Maybe<Lot>;
  lotGroup?: Maybe<LotGroup>;
  lotGroups: LotGroupCollection;
  lots: LotCollection;
  mapLocationGroups: Array<MapLocationGroup>;
  mapLocationItems: Array<MapLocationGroupItem>;
  market: Market;
  marketByAddress?: Maybe<Market>;
  marketBySlug?: Maybe<Market>;
  markets: MarketCollection;
  menu: Menu;
  metabaseQuestion: MetabaseQuestion;
  offlineOrder?: Maybe<OfflineOrder>;
  offlineOrderPrice: OfflineOrderPrice;
  order?: Maybe<Order>;
  orderPartialRefund?: Maybe<OrderPartialRefund>;
  orderPartialRefunds: OrderPartialRefundCollection;
  orderRefundEstimation: OrderRefundEstimation;
  organization?: Maybe<Organization>;
  organizations: OrganizationCollection;
  organizerQuickSearch: Array<QuickSearchMatch>;
  partnerships?: Maybe<Array<Partnership>>;
  phoneTokenToPhone?: Maybe<Scalars['String']>;
  rateableEntity: RateableEntity;
  replyTemplate?: Maybe<ReplyTemplate>;
  replyTemplateSuggestions: Array<ReplyTemplate>;
  replyTemplates: Array<ReplyTemplate>;
  restaurant: Restaurant;
  restaurants: RestaurantCollection;
  salesGuaranteeInvoices: SalesGuaranteeInvoiceCollection;
  sqlInspectTables?: Maybe<Array<SqlTableDetail>>;
  sqlReportDetails?: Maybe<SqlReportDetails>;
  sqlReportsList?: Maybe<Array<SqlReportListItem>>;
  sqlSchemaDescription?: Maybe<Scalars['String']>;
  stripeManualTransferEntityPreview?: Maybe<StripeManualTransferEntityPreview>;
  stripeManualTransfers: StripeManualTransferCollection;
  structuredData: StructuredData;
  testCustomerDevices: Array<UserDevice>;
  testTruckDevices: Array<UserDevice>;
  textConversation?: Maybe<TextConversation>;
  truck: Truck;
  truckCalendar: Array<TruckCalendarDate>;
  truckChat: TruckChat;
  truckChats: TruckChatCollection;
  truckDocument?: Maybe<TruckDocument>;
  truckDocumentByToken?: Maybe<TruckDocument>;
  truckDocumentCategories: Array<TruckDocumentCategory>;
  truckDocuments: TruckDocumentCollection;
  truckFaqs: Array<TruckFaq>;
  truckGenericEventCounts: TruckGenericEventCounts;
  truckGenericEvents: TruckGenericEventCollection;
  truckGroup: TruckGroup;
  truckGroups: Array<TruckGroup>;
  truckGroupsCount: Scalars['Int'];
  truckQuickSearch: Array<TruckQuickSearchSection>;
  truckRequiredDocumentsStatus: Array<TruckRequiredDocumentsStatus>;
  truckReview?: Maybe<TruckReview>;
  truckReviews: TruckReviewCollection;
  trucks: TruckCollection;
  twoFaSession: TwoFaSession;
  upcomingSubscribedLots: UpcomingSubscribedLots;
  uploadedAssets?: Maybe<Array<UploadedAsset>>;
  upsellTypes: Array<UpsellType>;
  userNotificationGroups?: Maybe<Array<UserNotificationGroup>>;
  webPushSubscriptions: Array<WebPushSubscription>;
};


export type QueryAbTestArgs = {
  name: Scalars['String'];
};


export type QueryAccountDeletionRequestsArgs = {
  page?: InputMaybe<CollectionInput>;
};


export type QueryAdminQuickSearchArgs = {
  search: Scalars['String'];
};


export type QueryAgentChatArgs = {
  id?: InputMaybe<Scalars['Int']>;
};


export type QueryAgentChatsArgs = {
  filter?: InputMaybe<AgentChatsFilterInput>;
  page?: InputMaybe<CollectionInput>;
};


export type QueryBlogPostArgs = {
  id?: InputMaybe<Scalars['Int']>;
  seoName?: InputMaybe<Scalars['String']>;
};


export type QueryBlogPostsArgs = {
  published?: InputMaybe<Scalars['Boolean']>;
};


export type QueryCartItemEstimationArgs = {
  item: CartItemInput;
};


export type QueryCateringCategoriesArgs = {
  marketId?: InputMaybe<Scalars['Int']>;
};


export type QueryCateringCategoryArgs = {
  id?: InputMaybe<Scalars['Int']>;
  marketSeoName?: InputMaybe<Scalars['String']>;
  seoName?: InputMaybe<Scalars['String']>;
};


export type QueryCateringCustomRequestArgs = {
  code?: InputMaybe<Scalars['String']>;
};


export type QueryCateringCustomRequestsArgs = {
  direction?: InputMaybe<SortDirection>;
  filter?: InputMaybe<CateringCustomRequestsFilterInput>;
  page?: InputMaybe<CollectionInput>;
};


export type QueryCateringRatingsArgs = {
  filter?: InputMaybe<TruckGenericRatingsFilterInput>;
  page?: InputMaybe<CollectionInput>;
};


export type QueryCateringRatingsPublicArgs = {
  categorySlug?: InputMaybe<Scalars['String']>;
  foodTypeSlug?: InputMaybe<Scalars['String']>;
  marketId?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<CollectionInput>;
};


export type QueryCateringRequestArgs = {
  id: Scalars['Int'];
  token?: InputMaybe<Scalars['String']>;
};


export type QueryCateringRequestBudgetArgs = {
  address: Scalars['String'];
  attendees: Scalars['Int'];
  cateringType: Scalars['String'];
  dropOff?: InputMaybe<Scalars['Boolean']>;
  fixedLocation?: InputMaybe<Scalars['Boolean']>;
  mealParts: Array<MealPartsInput>;
};


export type QueryCateringRequestBudgetValidationArgs = {
  address: Scalars['String'];
  attendees: Scalars['Int'];
  cateringType: Scalars['String'];
  customerTotalBudgetCents: Scalars['Int'];
  dropOff: Scalars['Boolean'];
  mealParts: Array<MealPartsInput>;
};


export type QueryCateringRequestPreviewArgs = {
  id: Scalars['Int'];
  token?: InputMaybe<Scalars['String']>;
};


export type QueryCateringRequestProposalsPriceArgs = {
  cateringRequestId: Scalars['Int'];
  proposalVariantIds: Array<Scalars['Int']>;
};


export type QueryCateringRequestsArgs = {
  filter?: InputMaybe<CateringRequestsFilterInput>;
  page?: InputMaybe<CollectionInput>;
  sort?: InputMaybe<Array<CateringRequestsSortInput>>;
};


export type QueryCateringTruckRequestArgs = {
  id: Scalars['Int'];
};


export type QueryClientCompaniesArgs = {
  page?: InputMaybe<CollectionInput>;
};


export type QueryClientCompanyArgs = {
  id: Scalars['Int'];
};


export type QueryClientCompanyInvoicesArgs = {
  page?: InputMaybe<CollectionInput>;
  sort?: InputMaybe<Array<ClientCompanyInvoiceSortInput>>;
};


export type QueryCouponArgs = {
  id: Scalars['Int'];
};


export type QueryCouponsArgs = {
  filter?: InputMaybe<CouponsFilterInput>;
  page?: InputMaybe<CollectionInput>;
  sort?: InputMaybe<Array<CouponsSortInput>>;
};


export type QueryCurrentCartArgs = {
  returnUuid?: InputMaybe<Scalars['Boolean']>;
  uuid?: InputMaybe<Scalars['String']>;
};


export type QueryCustomerArgs = {
  id: Scalars['Int'];
};


export type QueryCustomerByEmailArgs = {
  email: Scalars['String'];
};


export type QueryCustomerUnifiedCateringRequestsArgs = {
  filter?: InputMaybe<UnifiedCateringRequestsFilterInput>;
  page?: InputMaybe<CollectionInput>;
};


export type QueryCustomersArgs = {
  filter?: InputMaybe<CustomersFilterInput>;
  page?: InputMaybe<CollectionInput>;
};


export type QueryDashNotificationsArgs = {
  filter?: InputMaybe<DashNotificationsFilterInput>;
  page?: InputMaybe<CollectionInput>;
};


export type QueryDashSubscribedToEntityArgs = {
  entityId: Scalars['Int'];
  entityType: SubscriptionEntity;
};


export type QueryDescribeCancellationPolicyArgs = {
  cancellationPolicyFullDays: Scalars['Int'];
  cancellationPolicyHalfDays: Scalars['Int'];
  showFee?: InputMaybe<Scalars['Boolean']>;
};


export type QueryEmailThreadArgs = {
  id?: InputMaybe<Scalars['Int']>;
};


export type QueryEmailThreadWithFallbackArgs = {
  email?: InputMaybe<Scalars['String']>;
  entityId?: InputMaybe<Scalars['Int']>;
  entityType?: InputMaybe<EmailThreadEntity>;
};


export type QueryEmailThreadsArgs = {
  filter?: InputMaybe<EmailThreadsFilterInput>;
  page?: InputMaybe<CollectionInput>;
  sort?: InputMaybe<Array<EmailThreadsSortInput>>;
};


export type QueryEmailTokenToEmailArgs = {
  emailToken: Scalars['String'];
};


export type QueryEmployeeArgs = {
  id: Scalars['Int'];
};


export type QueryEntityNotesArgs = {
  entityType: CommentableEntity;
  id: Scalars['Int'];
  page?: InputMaybe<CollectionInput>;
  sort?: InputMaybe<Array<NotesSortInput>>;
};


export type QueryEventArgs = {
  id: Scalars['Int'];
};


export type QueryEventAvailabilityDatesArgs = {
  fromDate: Scalars['DateTime'];
  lotId?: InputMaybe<Scalars['Int']>;
  marketId?: InputMaybe<Scalars['Int']>;
  toDate: Scalars['DateTime'];
  truckId: Scalars['Int'];
};


export type QueryEventsArgs = {
  filter?: InputMaybe<EventsFilterInput>;
  page?: InputMaybe<CollectionInput>;
  sort?: InputMaybe<Array<EventsSortInput>>;
};


export type QueryEventsRequestArgs = {
  id: Scalars['Int'];
};


export type QueryEventsRequestsArgs = {
  filter?: InputMaybe<EventsRequestsFilterInput>;
  page?: InputMaybe<CollectionInput>;
  sort?: InputMaybe<Array<EventsRequestsSortInput>>;
};


export type QueryFoodTypePageArgs = {
  id?: InputMaybe<Scalars['Int']>;
  marketSeoName?: InputMaybe<Scalars['String']>;
  seoName?: InputMaybe<Scalars['String']>;
};


export type QueryFoodTypePagesArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  featured?: InputMaybe<Scalars['Boolean']>;
  marketId?: InputMaybe<Scalars['Int']>;
};


export type QueryFoodTypesArgs = {
  filter?: InputMaybe<FoodTypesFilterInput>;
};


export type QueryHealthPermitArgs = {
  id: Scalars['Int'];
};


export type QueryHealthPermitsArgs = {
  filter?: InputMaybe<HealthPermitFilterInput>;
  page?: InputMaybe<CollectionInput>;
  sort?: InputMaybe<Array<HealthPermitSortInput>>;
};


export type QueryItemArgs = {
  id: Scalars['Int'];
};


export type QueryItemQuestionArgs = {
  id: Scalars['Int'];
};


export type QueryLocationArgs = {
  id: Scalars['Int'];
};


export type QueryLocationItemArgs = {
  id: Scalars['Int'];
};


export type QueryLocationItemAnswerArgs = {
  id: Scalars['Int'];
};


export type QueryLocationItemQuestionArgs = {
  id: Scalars['Int'];
};


export type QueryLocationSalesPercentageEstimateArgs = {
  locationId: Scalars['Int'];
  walkupSalesAmountCents: Scalars['Int'];
};


export type QueryLocationsArgs = {
  filter?: InputMaybe<LocationsFilterInput>;
  page?: InputMaybe<CollectionInput>;
  sort?: InputMaybe<Array<LocationsSortInput>>;
};


export type QueryLogEventsArgs = {
  filter?: InputMaybe<LogEventInput>;
  page?: InputMaybe<CollectionInput>;
  sort?: InputMaybe<Array<LogEventsSortInput>>;
};


export type QueryLotArgs = {
  id?: InputMaybe<Scalars['Int']>;
  seoName?: InputMaybe<Scalars['String']>;
};


export type QueryLotGroupArgs = {
  id?: InputMaybe<Scalars['Int']>;
  seoName?: InputMaybe<Scalars['String']>;
};


export type QueryLotGroupsArgs = {
  page?: InputMaybe<CollectionInput>;
  sort?: InputMaybe<Array<LotGroupsSortInput>>;
};


export type QueryLotsArgs = {
  filter?: InputMaybe<LotsFilterInput>;
  page?: InputMaybe<CollectionInput>;
  sort?: InputMaybe<Array<LotsSortInput>>;
};


export type QueryMapLocationGroupsArgs = {
  fromDatetime: Scalars['DateTime'];
  marketId?: InputMaybe<Scalars['Int']>;
  toDatetime: Scalars['DateTime'];
};


export type QueryMapLocationItemsArgs = {
  keys: Array<Scalars['String']>;
};


export type QueryMarketArgs = {
  id: Scalars['Int'];
};


export type QueryMarketByAddressArgs = {
  fullAddress: Scalars['String'];
};


export type QueryMarketBySlugArgs = {
  slug: Scalars['String'];
};


export type QueryMarketsArgs = {
  filter?: InputMaybe<MarketsFilterInput>;
  page?: InputMaybe<CollectionInput>;
};


export type QueryMenuArgs = {
  id: Scalars['Int'];
};


export type QueryMetabaseQuestionArgs = {
  params?: InputMaybe<Array<MetabaseQuestionParamsInput>>;
  questionName: Scalars['String'];
};


export type QueryOfflineOrderArgs = {
  id: Scalars['Int'];
};


export type QueryOfflineOrderPriceArgs = {
  order: OfflineOrderPriceInput;
};


export type QueryOrderArgs = {
  id: Scalars['Int'];
};


export type QueryOrderPartialRefundArgs = {
  id: Scalars['Int'];
};


export type QueryOrderPartialRefundsArgs = {
  filter?: InputMaybe<OrderPartialRefundsFilterInput>;
  page?: InputMaybe<CollectionInput>;
  sort?: InputMaybe<Array<OrderPartialRefundSortInput>>;
};


export type QueryOrderRefundEstimationArgs = {
  orderId: Scalars['Int'];
  refund?: InputMaybe<OrderPartialRefundInput>;
  refundId?: InputMaybe<Scalars['Int']>;
};


export type QueryOrganizationArgs = {
  id?: InputMaybe<Scalars['Int']>;
  seoName?: InputMaybe<Scalars['String']>;
};


export type QueryOrganizationsArgs = {
  filter?: InputMaybe<OrganizationsFilterInput>;
  page?: InputMaybe<CollectionInput>;
};


export type QueryOrganizerQuickSearchArgs = {
  search: Scalars['String'];
};


export type QueryPhoneTokenToPhoneArgs = {
  phoneToken: Scalars['String'];
};


export type QueryRateableEntityArgs = {
  token: Scalars['String'];
};


export type QueryReplyTemplateArgs = {
  id: Scalars['Int'];
};


export type QueryReplyTemplateSuggestionsArgs = {
  eventId?: InputMaybe<Scalars['Int']>;
  id: Scalars['Int'];
  topic?: InputMaybe<ReplyTemplateTopic>;
  truckRequestId?: InputMaybe<Scalars['Int']>;
  type: ReplyTemplateEntity;
};


export type QueryRestaurantArgs = {
  id: Scalars['Int'];
};


export type QueryRestaurantsArgs = {
  filter?: InputMaybe<RestaurantsFilterInput>;
  page?: InputMaybe<CollectionInput>;
  sort?: InputMaybe<Array<RestaurantsSortInput>>;
};


export type QuerySalesGuaranteeInvoicesArgs = {
  page?: InputMaybe<CollectionInput>;
  sort?: InputMaybe<Array<SalesGuaranteeInvoiceSortInput>>;
};


export type QuerySqlInspectTablesArgs = {
  tableNames: Array<Scalars['String']>;
};


export type QuerySqlReportDetailsArgs = {
  id: Scalars['String'];
};


export type QueryStripeManualTransferEntityPreviewArgs = {
  entityId: Scalars['Int'];
  entityType: StripeManualTransferEntity;
};


export type QueryStripeManualTransfersArgs = {
  filter?: InputMaybe<StripeManualTransfersFilterInput>;
  page?: InputMaybe<CollectionInput>;
};


export type QueryTextConversationArgs = {
  createIfNotExists?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  phone?: InputMaybe<Scalars['String']>;
};


export type QueryTruckArgs = {
  id?: InputMaybe<Scalars['Int']>;
  seoName?: InputMaybe<Scalars['String']>;
};


export type QueryTruckCalendarArgs = {
  fromDate: Scalars['DateTime'];
  lotId?: InputMaybe<Scalars['Int']>;
  marketId?: InputMaybe<Scalars['Int']>;
  toDate: Scalars['DateTime'];
  truckId: Scalars['Int'];
};


export type QueryTruckChatArgs = {
  id: Scalars['Int'];
};


export type QueryTruckChatsArgs = {
  filter?: InputMaybe<TruckChatsFilterInput>;
  page?: InputMaybe<CollectionInput>;
  sort?: InputMaybe<Array<TruckChatsSortInput>>;
};


export type QueryTruckDocumentArgs = {
  id: Scalars['Int'];
};


export type QueryTruckDocumentByTokenArgs = {
  accessToken: Scalars['String'];
};


export type QueryTruckDocumentsArgs = {
  filter?: InputMaybe<TruckDocumentFilterInput>;
  page?: InputMaybe<CollectionInput>;
  sort?: InputMaybe<Array<TruckDocumentSortInput>>;
};


export type QueryTruckGenericEventCountsArgs = {
  filter?: InputMaybe<TruckGenericEventCountsFilterInput>;
  truckId?: InputMaybe<Scalars['Int']>;
};


export type QueryTruckGenericEventsArgs = {
  filter?: InputMaybe<TruckGenericEventsFilterInput>;
  page?: InputMaybe<CollectionInput>;
  truckId?: InputMaybe<Scalars['Int']>;
};


export type QueryTruckGroupArgs = {
  id: Scalars['Int'];
};


export type QueryTruckGroupsArgs = {
  filter?: InputMaybe<TruckGroupsFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<TruckGroupsSortInput>>;
};


export type QueryTruckGroupsCountArgs = {
  filter?: InputMaybe<TruckGroupsFilterInput>;
};


export type QueryTruckQuickSearchArgs = {
  search: Scalars['String'];
  truckId?: InputMaybe<Scalars['Int']>;
};


export type QueryTruckRequiredDocumentsStatusArgs = {
  entityId: Scalars['Int'];
  entityType: TruckDocumentEntityType;
  requiredDocuments: Array<TruckDocumentCategoryId>;
  truckId: Scalars['Int'];
};


export type QueryTruckReviewArgs = {
  id: Scalars['Int'];
};


export type QueryTruckReviewsArgs = {
  filter?: InputMaybe<TruckReviewsFilterInput>;
  page?: InputMaybe<CollectionInput>;
  sort?: InputMaybe<Array<TruckReviewsSortInput>>;
};


export type QueryTrucksArgs = {
  filter?: InputMaybe<TrucksFilterInput>;
  page?: InputMaybe<CollectionInput>;
  sort?: InputMaybe<Array<TrucksSortInput>>;
};

export enum QueuePositionEnum {
  Beginning = 'beginning',
  End = 'end'
}

export type QuickSearchMatch = {
  __typename?: 'QuickSearchMatch';
  active: Scalars['Boolean'];
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  path?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type RateableEntity = {
  __typename?: 'RateableEntity';
  id: Scalars['String'];
  name: Scalars['String'];
  rateableTrucks: Array<RateableTruck>;
};

export type RateableTruck = {
  __typename?: 'RateableTruck';
  id: Scalars['Int'];
  items: Array<RateableTruckItem>;
  rating?: Maybe<TruckGenericRating>;
  truck: Truck;
};

export type RateableTruckItem = {
  __typename?: 'RateableTruckItem';
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type ReplyTemplate = {
  __typename?: 'ReplyTemplate';
  active: Scalars['Boolean'];
  channels: Array<ReplyTemplateEntity>;
  createdAt: Scalars['DateTime'];
  id: Scalars['Int'];
  name: Scalars['String'];
  receivers: Array<ReplyTemplateReceiver>;
  subject?: Maybe<Scalars['String']>;
  text: Scalars['String'];
  topics: Array<ReplyTemplateTopic>;
  updatedAt: Scalars['DateTime'];
};

/** Autogenerated return type of ReplyTemplateCreate. */
export type ReplyTemplateCreatePayload = {
  __typename?: 'ReplyTemplateCreatePayload';
  errors?: Maybe<Array<UserError>>;
  replyTemplate?: Maybe<ReplyTemplate>;
};

export enum ReplyTemplateEntity {
  Email = 'email',
  Sms = 'sms'
}

export enum ReplyTemplateReceiver {
  Customer = 'customer',
  Truck = 'truck'
}

export enum ReplyTemplateTopic {
  Catering = 'catering',
  CustomEvent = 'custom_event',
  Event = 'event',
  Generic = 'generic',
  Orders = 'orders',
  Review = 'review',
  Shift = 'shift'
}

/** Autogenerated return type of ReplyTemplateUpdate. */
export type ReplyTemplateUpdatePayload = {
  __typename?: 'ReplyTemplateUpdatePayload';
  errors?: Maybe<Array<UserError>>;
  replyTemplate?: Maybe<ReplyTemplate>;
};

export type Restaurant = {
  __typename?: 'Restaurant';
  acceptedTerms?: Maybe<Scalars['Boolean']>;
  active?: Maybe<Scalars['Boolean']>;
  allowOrders?: Maybe<Scalars['Boolean']>;
  allowToCreateContracts: Scalars['Boolean'];
  amountCredits: Money;
  banReason?: Maybe<Scalars['String']>;
  bannedAt?: Maybe<Scalars['DateTime']>;
  bannedBy?: Maybe<Admin>;
  canConfirmStripeManualTransfers: Scalars['Boolean'];
  canConvertToFull: Scalars['Boolean'];
  cateringRequestsAssigned: CateringRequestCollection;
  claimAccountUrl?: Maybe<Scalars['String']>;
  completion?: Maybe<Array<RestaurantCompletionInfo>>;
  contactName?: Maybe<Scalars['String']>;
  coupons: Array<Coupon>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  disasterRelief?: Maybe<Scalars['Boolean']>;
  email: Scalars['String'];
  emailSuppressions: Array<EmailSuppression>;
  employees?: Maybe<Array<Employee>>;
  enableTerminal: Scalars['Boolean'];
  facebook?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  image?: Maybe<RestaurantImage>;
  instagram?: Maybe<Scalars['String']>;
  installedApp?: Maybe<Scalars['Boolean']>;
  instantBook: Scalars['Boolean'];
  instantPayoutsEnabled?: Maybe<Scalars['Boolean']>;
  items?: Maybe<ItemCollection>;
  locations?: Maybe<LocationCollection>;
  logo: RestaurantLogo;
  menus: MenuCollection;
  name: Scalars['String'];
  offlineStripeFlatFee: Money;
  offlineStripePercentage: Scalars['Float'];
  paymentFilledIn?: Maybe<Scalars['Boolean']>;
  payoutFilledIn?: Maybe<Scalars['Boolean']>;
  phone?: Maybe<Scalars['Phone']>;
  restaurantBankAccounts: Array<RestaurantBankAccount>;
  restaurantCreditCards: Array<RestaurantCreditCard>;
  restaurantDebitCards: Array<RestaurantDebitCard>;
  sendWeeklySummary: Scalars['Boolean'];
  signupMenu?: Maybe<SignupMenu>;
  signupPath?: Maybe<Scalars['String']>;
  stripeAccountCreated?: Maybe<Scalars['Boolean']>;
  stripeCustomerLink?: Maybe<Scalars['String']>;
  stripeLink?: Maybe<Scalars['String']>;
  textConversation?: Maybe<TextConversation>;
  transactionFeePercentage: Scalars['Float'];
  truckPhones: Array<TruckPhone>;
  trucks?: Maybe<Array<Truck>>;
  twentyMileApparelRequest?: Maybe<ApparelPartnershipRequest>;
  twitter?: Maybe<Scalars['String']>;
  unclaimed: Scalars['Boolean'];
  userDevices?: Maybe<Array<UserDevice>>;
  verification?: Maybe<Verification>;
  website?: Maybe<Scalars['String']>;
};


export type RestaurantCateringRequestsAssignedArgs = {
  filter?: InputMaybe<CateringRequestsFilterInput>;
  page?: InputMaybe<CollectionInput>;
  sort?: InputMaybe<Array<CateringRequestsSortInput>>;
};


export type RestaurantLocationsArgs = {
  filter?: InputMaybe<LocationsFilterInput>;
  page?: InputMaybe<CollectionInput>;
  sort?: InputMaybe<Array<LocationsSortInput>>;
};


export type RestaurantMenusArgs = {
  filter?: InputMaybe<MenusFilterInput>;
  page?: InputMaybe<CollectionInput>;
};


export type RestaurantVerificationArgs = {
  forceSync?: InputMaybe<Scalars['Boolean']>;
};

/** Autogenerated return type of RestaurantAcceptTerms. */
export type RestaurantAcceptTermsPayload = {
  __typename?: 'RestaurantAcceptTermsPayload';
  errors?: Maybe<Array<UserError>>;
  restaurant?: Maybe<Restaurant>;
};

/** Autogenerated return type of RestaurantAddBankAccount. */
export type RestaurantAddBankAccountPayload = {
  __typename?: 'RestaurantAddBankAccountPayload';
  errors?: Maybe<Array<UserError>>;
  restaurant?: Maybe<Restaurant>;
};

/** Autogenerated return type of RestaurantAddPaymentCard. */
export type RestaurantAddPaymentCardPayload = {
  __typename?: 'RestaurantAddPaymentCardPayload';
  errors?: Maybe<Array<UserError>>;
  restaurant?: Maybe<Restaurant>;
};

/** Autogenerated return type of RestaurantAddPayoutCard. */
export type RestaurantAddPayoutCardPayload = {
  __typename?: 'RestaurantAddPayoutCardPayload';
  errors?: Maybe<Array<UserError>>;
  restaurant?: Maybe<Restaurant>;
};

/** Autogenerated return type of RestaurantBan. */
export type RestaurantBanPayload = {
  __typename?: 'RestaurantBanPayload';
  errors?: Maybe<Array<UserError>>;
  restaurant?: Maybe<Restaurant>;
};

export type RestaurantBankAccount = {
  __typename?: 'RestaurantBankAccount';
  active?: Maybe<Scalars['Boolean']>;
  bankName?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  last4?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of RestaurantBankAccountMakeCurrent. */
export type RestaurantBankAccountMakeCurrentPayload = {
  __typename?: 'RestaurantBankAccountMakeCurrentPayload';
  errors?: Maybe<Array<UserError>>;
  restaurant?: Maybe<Restaurant>;
};

/** Autogenerated return type of RestaurantBankAccountRemove. */
export type RestaurantBankAccountRemovePayload = {
  __typename?: 'RestaurantBankAccountRemovePayload';
  errors?: Maybe<Array<UserError>>;
  restaurant?: Maybe<Restaurant>;
};

/** Autogenerated return type of RestaurantChangeCredits. */
export type RestaurantChangeCreditsPayload = {
  __typename?: 'RestaurantChangeCreditsPayload';
  errors?: Maybe<Array<UserError>>;
  restaurant?: Maybe<Restaurant>;
};

/** Autogenerated return type of RestaurantChangeInstantPayouts. */
export type RestaurantChangeInstantPayoutsPayload = {
  __typename?: 'RestaurantChangeInstantPayoutsPayload';
  errors?: Maybe<Array<UserError>>;
  restaurant?: Maybe<Restaurant>;
};

/** Autogenerated return type of RestaurantClaim. */
export type RestaurantClaimPayload = {
  __typename?: 'RestaurantClaimPayload';
  employee?: Maybe<Employee>;
  errors?: Maybe<Array<UserError>>;
};

/** Autogenerated return type of RestaurantClaimV2. */
export type RestaurantClaimV2Payload = {
  __typename?: 'RestaurantClaimV2Payload';
  employee?: Maybe<Employee>;
  errors?: Maybe<Array<UserError>>;
};

export type RestaurantCollection = Collection & {
  __typename?: 'RestaurantCollection';
  /** Limit */
  limit?: Maybe<Scalars['Int']>;
  /** Offset */
  offset?: Maybe<Scalars['Int']>;
  /** List of records */
  records: Array<Restaurant>;
  /** Total */
  total: Scalars['Int'];
};


export type RestaurantCollectionTotalArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};

/** Autogenerated return type of RestaurantCompleteBankAccountSetup. */
export type RestaurantCompleteBankAccountSetupPayload = {
  __typename?: 'RestaurantCompleteBankAccountSetupPayload';
  errors?: Maybe<Array<UserError>>;
  restaurant?: Maybe<Restaurant>;
};

export type RestaurantCompletionInfo = {
  __typename?: 'RestaurantCompletionInfo';
  name?: Maybe<Scalars['String']>;
  required?: Maybe<Scalars['Boolean']>;
};

export type RestaurantCompletionV2 = {
  __typename?: 'RestaurantCompletionV2';
  catering: Array<RestaurantCompletionV2Step>;
  customShifts: Array<RestaurantCompletionV2Step>;
  events: Array<RestaurantCompletionV2Step>;
  profile: Array<RestaurantCompletionV2Step>;
};

export type RestaurantCompletionV2Step = {
  __typename?: 'RestaurantCompletionV2Step';
  completed: Scalars['Boolean'];
  description?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  path: Scalars['String'];
};

/** Autogenerated return type of RestaurantConvertToFull. */
export type RestaurantConvertToFullPayload = {
  __typename?: 'RestaurantConvertToFullPayload';
  employee?: Maybe<Employee>;
  errors?: Maybe<Array<UserError>>;
};

/** Autogenerated return type of RestaurantCreateBankAccountSetupIntent. */
export type RestaurantCreateBankAccountSetupIntentPayload = {
  __typename?: 'RestaurantCreateBankAccountSetupIntentPayload';
  errors?: Maybe<Array<UserError>>;
  setupIntentClientSecret?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of RestaurantCreate. */
export type RestaurantCreatePayload = {
  __typename?: 'RestaurantCreatePayload';
  errors?: Maybe<Array<UserError>>;
  restaurant?: Maybe<Restaurant>;
};

/** Autogenerated return type of RestaurantCreateStripeSession. */
export type RestaurantCreateStripeSessionPayload = {
  __typename?: 'RestaurantCreateStripeSessionPayload';
  clientSecret?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<UserError>>;
};

export type RestaurantCreditCard = {
  __typename?: 'RestaurantCreditCard';
  active?: Maybe<Scalars['Boolean']>;
  brand?: Maybe<Scalars['String']>;
  expMonth?: Maybe<Scalars['String']>;
  expYear?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  last4?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of RestaurantCreditCardMakeCurrent. */
export type RestaurantCreditCardMakeCurrentPayload = {
  __typename?: 'RestaurantCreditCardMakeCurrentPayload';
  errors?: Maybe<Array<UserError>>;
  restaurant?: Maybe<Restaurant>;
};

/** Autogenerated return type of RestaurantCreditCardRemove. */
export type RestaurantCreditCardRemovePayload = {
  __typename?: 'RestaurantCreditCardRemovePayload';
  errors?: Maybe<Array<UserError>>;
  restaurant?: Maybe<Restaurant>;
};

export type RestaurantDebitCard = {
  __typename?: 'RestaurantDebitCard';
  active?: Maybe<Scalars['Boolean']>;
  brand?: Maybe<Scalars['String']>;
  expMonth?: Maybe<Scalars['String']>;
  expYear?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  last4?: Maybe<Scalars['String']>;
  supportsInstantPayouts?: Maybe<Scalars['Boolean']>;
};

/** Autogenerated return type of RestaurantDebitCardMakeCurrent. */
export type RestaurantDebitCardMakeCurrentPayload = {
  __typename?: 'RestaurantDebitCardMakeCurrentPayload';
  errors?: Maybe<Array<UserError>>;
  restaurant?: Maybe<Restaurant>;
};

/** Autogenerated return type of RestaurantDebitCardRemove. */
export type RestaurantDebitCardRemovePayload = {
  __typename?: 'RestaurantDebitCardRemovePayload';
  errors?: Maybe<Array<UserError>>;
  restaurant?: Maybe<Restaurant>;
};

/** Autogenerated return type of RestaurantDisasterRelief. */
export type RestaurantDisasterReliefPayload = {
  __typename?: 'RestaurantDisasterReliefPayload';
  errors?: Maybe<Array<UserError>>;
  restaurant?: Maybe<Restaurant>;
};

/** Autogenerated return type of RestaurantEditStripeAccount. */
export type RestaurantEditStripeAccountPayload = {
  __typename?: 'RestaurantEditStripeAccountPayload';
  errors?: Maybe<Array<UserError>>;
  stripeUrl?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of RestaurantEnableInstantBook. */
export type RestaurantEnableInstantBookPayload = {
  __typename?: 'RestaurantEnableInstantBookPayload';
  errors?: Maybe<Array<UserError>>;
  restaurant?: Maybe<Restaurant>;
};

export type RestaurantImage = {
  __typename?: 'RestaurantImage';
  medium: Scalars['String'];
  original?: Maybe<Scalars['String']>;
  present: Scalars['Boolean'];
  small: Scalars['String'];
  thumb: Scalars['String'];
};

export type RestaurantInput = {
  /** Active */
  active: Scalars['Boolean'];
  /** Allow Orders */
  allowOrders: Scalars['Boolean'];
  /** Contact Name */
  contactName: Scalars['String'];
  /** Description */
  description?: InputMaybe<Scalars['String']>;
  /** Email */
  email: Scalars['String'];
  /** POS Enabled */
  enableTerminal?: InputMaybe<Scalars['Boolean']>;
  /** Facebook */
  facebook?: InputMaybe<Scalars['String']>;
  /** Image */
  image?: InputMaybe<Scalars['Upload']>;
  /** Instagram */
  instagram?: InputMaybe<Scalars['String']>;
  /** Instant Book Enabled */
  instantBook?: InputMaybe<Scalars['Boolean']>;
  /** Image */
  logo?: InputMaybe<Scalars['Upload']>;
  /** Name */
  name: Scalars['String'];
  offlineStripeFlatFeeCents?: InputMaybe<Scalars['Int']>;
  offlineStripePercentage?: InputMaybe<Scalars['Float']>;
  /** Phone */
  phone: Scalars['String'];
  /** Transaction fee percentage */
  transactionFeePercentage?: InputMaybe<Scalars['Float']>;
  /** Twitter */
  twitter?: InputMaybe<Scalars['String']>;
  /** Website */
  website?: InputMaybe<Scalars['String']>;
};

export type RestaurantLogo = {
  __typename?: 'RestaurantLogo';
  medium: Scalars['String'];
  original?: Maybe<Scalars['String']>;
  present: Scalars['Boolean'];
  small: Scalars['String'];
  thumb: Scalars['String'];
};

/** Autogenerated return type of RestaurantMarkUnclaimed. */
export type RestaurantMarkUnclaimedPayload = {
  __typename?: 'RestaurantMarkUnclaimedPayload';
  errors?: Maybe<Array<UserError>>;
  restaurant?: Maybe<Restaurant>;
};

/** Autogenerated return type of RestaurantReactivateEmail. */
export type RestaurantReactivateEmailPayload = {
  __typename?: 'RestaurantReactivateEmailPayload';
  errors?: Maybe<Array<UserError>>;
  restaurant?: Maybe<Restaurant>;
};

/** Autogenerated return type of RestaurantSignUp2. */
export type RestaurantSignUp2Payload = {
  __typename?: 'RestaurantSignUp2Payload';
  employee?: Maybe<Employee>;
  errors?: Maybe<Array<UserError>>;
};

/** Autogenerated return type of RestaurantSignUp. */
export type RestaurantSignUpPayload = {
  __typename?: 'RestaurantSignUpPayload';
  employee?: Maybe<Employee>;
  errors?: Maybe<Array<UserError>>;
};

/** Autogenerated return type of RestaurantSyncWithStripe. */
export type RestaurantSyncWithStripePayload = {
  __typename?: 'RestaurantSyncWithStripePayload';
  errors?: Maybe<Array<UserError>>;
  restaurant?: Maybe<Restaurant>;
};

/** Autogenerated return type of RestaurantUpdate. */
export type RestaurantUpdatePayload = {
  __typename?: 'RestaurantUpdatePayload';
  errors?: Maybe<Array<UserError>>;
  restaurant?: Maybe<Restaurant>;
};

/** Autogenerated return type of RestaurantUpdateProfile. */
export type RestaurantUpdateProfilePayload = {
  __typename?: 'RestaurantUpdateProfilePayload';
  errors?: Maybe<Array<UserError>>;
  restaurant?: Maybe<Restaurant>;
};

/** Autogenerated return type of RestaurantUpdateSignupMenu. */
export type RestaurantUpdateSignupMenuPayload = {
  __typename?: 'RestaurantUpdateSignupMenuPayload';
  errors?: Maybe<Array<UserError>>;
  restaurant?: Maybe<Restaurant>;
};

export type RestaurantsFilterInput = {
  banned?: InputMaybe<Scalars['Boolean']>;
  /** Filter by market */
  marketId?: InputMaybe<Scalars['Int']>;
  /** Filter by name */
  nameSearch?: InputMaybe<Scalars['String']>;
};

export type RestaurantsSortInput = {
  /** ASC / DESC */
  direction: SortDirection;
  /** Field to sort by */
  field: RestaurantsSortInputFields;
};

export enum RestaurantsSortInputFields {
  Active = 'active',
  Name = 'name'
}

/** Autogenerated return type of ReviewDetectTruckProblems. */
export type ReviewDetectTruckProblemsPayload = {
  __typename?: 'ReviewDetectTruckProblemsPayload';
  errors?: Maybe<Array<UserError>>;
  truckReview?: Maybe<TruckReview>;
};

/** Autogenerated return type of ReviewGenerateSuggestionForProblem. */
export type ReviewGenerateSuggestionForProblemPayload = {
  __typename?: 'ReviewGenerateSuggestionForProblemPayload';
  errors?: Maybe<Array<UserError>>;
  truck?: Maybe<Truck>;
};

/** Autogenerated return type of ReviewGenerateSuggestionForProblems. */
export type ReviewGenerateSuggestionForProblemsPayload = {
  __typename?: 'ReviewGenerateSuggestionForProblemsPayload';
  errors?: Maybe<Array<UserError>>;
  truck?: Maybe<Truck>;
};

/** Autogenerated return type of ReviewSuggestionAccept. */
export type ReviewSuggestionAcceptPayload = {
  __typename?: 'ReviewSuggestionAcceptPayload';
  errors?: Maybe<Array<UserError>>;
  suggestionRequest?: Maybe<ReviewSuggestionRequest>;
};

export enum ReviewSuggestionAction {
  ItemAddQuestions = 'item_add_questions',
  ItemGenerateDescription = 'item_generate_description',
  ItemGenerateImage = 'item_generate_image',
  ItemImageExtraction = 'item_image_extraction',
  MenuApplyFoodTypes = 'menu_apply_food_types',
  RestaurantEnableOrderAhead = 'restaurant_enable_order_ahead',
  TruckApplyServedFood = 'truck_apply_served_food',
  TruckFindSocialLinks = 'truck_find_social_links',
  TruckFixSocialLinks = 'truck_fix_social_links',
  TruckGenerateDescription = 'truck_generate_description',
  TruckGenerateImage = 'truck_generate_image'
}

/** Autogenerated return type of ReviewSuggestionNew. */
export type ReviewSuggestionNewPayload = {
  __typename?: 'ReviewSuggestionNewPayload';
  errors?: Maybe<Array<UserError>>;
  /** The request the generation started for */
  suggestionRequest?: Maybe<ReviewSuggestionRequest>;
  truck?: Maybe<Truck>;
};

/** Autogenerated return type of ReviewSuggestionReject. */
export type ReviewSuggestionRejectPayload = {
  __typename?: 'ReviewSuggestionRejectPayload';
  errors?: Maybe<Array<UserError>>;
  suggestionRequest?: Maybe<ReviewSuggestionRequest>;
};

export type ReviewSuggestionRequest = {
  __typename?: 'ReviewSuggestionRequest';
  entityId: Scalars['Int'];
  /** Name of the truck, restaurant, menu or item */
  entityName?: Maybe<Scalars['String']>;
  entityType: Scalars['String'];
  errorMessage?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  status: ReviewSuggestionRequestStatus;
  suggestionAction: ReviewSuggestionAction;
  /** Only the latest suggestion */
  suggestions: Array<ReviewTruckSuggestion>;
};

export enum ReviewSuggestionRequestStatus {
  Failed = 'failed',
  Finished = 'finished',
  InProgress = 'in_progress'
}

/** Autogenerated return type of ReviewSuggestionRevert. */
export type ReviewSuggestionRevertPayload = {
  __typename?: 'ReviewSuggestionRevertPayload';
  errors?: Maybe<Array<UserError>>;
  suggestionRequest?: Maybe<ReviewSuggestionRequest>;
};

/** Autogenerated return type of ReviewTruckInstructions. */
export type ReviewTruckInstructionsPayload = {
  __typename?: 'ReviewTruckInstructionsPayload';
  errors?: Maybe<Array<UserError>>;
  instructions?: Maybe<Scalars['String']>;
  instructionsHtml?: Maybe<Scalars['String']>;
};

export type ReviewTruckProblem = {
  __typename?: 'ReviewTruckProblem';
  acknowledgementText?: Maybe<Scalars['String']>;
  /** Only for admins */
  adminComment?: Maybe<Scalars['String']>;
  adminOnly: Scalars['Boolean'];
  category: Scalars['String'];
  createdAt: Scalars['DateTime'];
  dismissable: Scalars['Boolean'];
  dismissalComment?: Maybe<Scalars['String']>;
  dismissedAt?: Maybe<Scalars['DateTime']>;
  entityId: Scalars['Int'];
  entityType: Scalars['String'];
  id: Scalars['Int'];
  reviewComment?: Maybe<Scalars['String']>;
  severity?: Maybe<ReviewTruckProblemSeverity>;
  status: ReviewTruckProblemStatus;
  /** Suggestion that can fix the problem */
  suggestion?: Maybe<ReviewSuggestionAction>;
};

/** Autogenerated return type of ReviewTruckProblemDismiss. */
export type ReviewTruckProblemDismissPayload = {
  __typename?: 'ReviewTruckProblemDismissPayload';
  errors?: Maybe<Array<UserError>>;
  truckProblem?: Maybe<ReviewTruckProblem>;
};

export enum ReviewTruckProblemSeverity {
  Critical = 'critical',
  Error = 'error',
  Warning = 'warning'
}

export enum ReviewTruckProblemStatus {
  Dismissed = 'dismissed',
  Fixed = 'fixed',
  Passed = 'passed',
  Pending = 'pending'
}

export type ReviewTruckSuggestion = {
  __typename?: 'ReviewTruckSuggestion';
  createdAt: Scalars['DateTime'];
  /** Shape depends on the request's suggestion action */
  data: Scalars['Json'];
  id: Scalars['Int'];
  /** Images referenced by attachment id from data */
  images: Array<ImageAttachment>;
  status: ReviewTruckSuggestionStatus;
  /** Problem the suggestion fixes, null when asked for without one */
  truckProblemId?: Maybe<Scalars['Int']>;
  userPrompt?: Maybe<Scalars['String']>;
};

export enum ReviewTruckSuggestionStatus {
  Accepted = 'accepted',
  Outdated = 'outdated',
  Pending = 'pending',
  Rejected = 'rejected',
  Reverted = 'reverted'
}

export type Root = {
  __typename?: 'Root';
  accountDeletionRequestApprove?: Maybe<AccountDeletionRequestApprovePayload>;
  accountDeletionRequestReject?: Maybe<AccountDeletionRequestRejectPayload>;
  adminForgotPassword?: Maybe<AdminForgotPasswordPayload>;
  adminLogin?: Maybe<AdminLoginPayload>;
  adminResetPassword?: Maybe<AdminResetPasswordPayload>;
  agentChatCreate?: Maybe<AgentChatCreatePayload>;
  agentChatDelete?: Maybe<AgentChatDeletePayload>;
  agentChatMessageCreate?: Maybe<AgentChatMessageCreatePayload>;
  agentChatToolApproval?: Maybe<AgentChatToolApprovalPayload>;
  autoCoverRequest?: Maybe<AutoCoverRequestPayload>;
  blogPostCreate?: Maybe<BlogPostCreatePayload>;
  blogPostUpdate?: Maybe<BlogPostUpdatePayload>;
  calendarIntegrationCreate?: Maybe<CalendarIntegrationCreatePayload>;
  calendarIntegrationRemove?: Maybe<CalendarIntegrationRemovePayload>;
  calendarIntegrationUpdate?: Maybe<CalendarIntegrationUpdatePayload>;
  cartAddItem?: Maybe<CartAddItemPayload>;
  cartApplyCoupon?: Maybe<CartApplyCouponPayload>;
  cartCheckForPayment?: Maybe<CartCheckForPaymentPayload>;
  cartCheckoutSession?: Maybe<CartCheckoutSessionPayload>;
  cartCreatePaymentIntent?: Maybe<CartCreatePaymentIntentPayload>;
  cartCreateSetupIntent?: Maybe<CartCreateSetupIntentPayload>;
  cartPlaceFreeOrder?: Maybe<CartPlaceFreeOrderPayload>;
  cartRemoveCoupon?: Maybe<CartRemoveCouponPayload>;
  cartRemoveItem?: Maybe<CartRemoveItemPayload>;
  cartRemovePickupTime?: Maybe<CartRemovePickupTimePayload>;
  cartUpdateCustomerNotes?: Maybe<CartUpdateCustomerNotesPayload>;
  cartUpdateItem?: Maybe<CartUpdateItemPayload>;
  cartUpdateLotNotes?: Maybe<CartUpdateLotNotesPayload>;
  cartUpdatePickupTime?: Maybe<CartUpdatePickupTimePayload>;
  cartUpdateTip?: Maybe<CartUpdateTipPayload>;
  cartUseExistingCard?: Maybe<CartUseExistingCardPayload>;
  cartVerifyItemsAvailability?: Maybe<CartVerifyItemsAvailabilityPayload>;
  cateringAlcoholRequestCreate?: Maybe<CateringAlcoholRequestCreatePayload>;
  cateringCategoryMarketClone?: Maybe<CateringCategoryMarketClonePayload>;
  cateringCategoryUpdate?: Maybe<CateringCategoryUpdatePayload>;
  cateringConvertToDebitPayment?: Maybe<CateringConvertToDebitPaymentPayload>;
  cateringConvertToFullPayment?: Maybe<CateringConvertToFullPaymentPayload>;
  cateringCustomRequestUpdateStatus?: Maybe<CateringCustomRequestUpdateStatusPayload>;
  cateringCustomRequestUpdateTags?: Maybe<CateringCustomRequestUpdateTagsPayload>;
  cateringInvoicePay?: Maybe<CateringInvoicePayPayload>;
  cateringIssueInvoice?: Maybe<CateringIssueInvoicePayload>;
  cateringManualTruckDebitCreate?: Maybe<CateringManualTruckDebitCreatePayload>;
  cateringManualTruckDebitDelete?: Maybe<CateringManualTruckDebitDeletePayload>;
  cateringOrderCancel?: Maybe<CateringOrderCancelPayload>;
  cateringOrderCreate?: Maybe<CateringOrderCreatePayload>;
  cateringOtherCreate?: Maybe<CateringOtherCreatePayload>;
  cateringOverageRequestApprove?: Maybe<CateringOverageRequestApprovePayload>;
  cateringOverageRequestCreate?: Maybe<CateringOverageRequestCreatePayload>;
  cateringOverageRequestReject?: Maybe<CateringOverageRequestRejectPayload>;
  cateringOverageRequestRevert?: Maybe<CateringOverageRequestRevertPayload>;
  cateringOverageRequestUpdateBudget?: Maybe<CateringOverageRequestUpdateBudgetPayload>;
  cateringPayOrganizer?: Maybe<CateringPayOrganizerPayload>;
  cateringProposalAcknowledge?: Maybe<CateringProposalAcknowledgePayload>;
  cateringProposalChoose?: Maybe<CateringProposalChoosePayload>;
  cateringProposalUpdateComments?: Maybe<CateringProposalUpdateCommentsPayload>;
  cateringProposalUpdateStatus?: Maybe<CateringProposalUpdateStatusPayload>;
  cateringProposalUpdateVariantComments?: Maybe<CateringProposalUpdateVariantCommentsPayload>;
  cateringRecurringCreate?: Maybe<CateringRecurringCreatePayload>;
  cateringRequestAddTrucks?: Maybe<CateringRequestAddTrucksPayload>;
  cateringRequestAssignOrganizer?: Maybe<CateringRequestAssignOrganizerPayload>;
  cateringRequestCancel?: Maybe<CateringRequestCancelPayload>;
  cateringRequestConfirmConciergeFee?: Maybe<CateringRequestConfirmConciergeFeePayload>;
  cateringRequestCreate?: Maybe<CateringRequestCreatePayload>;
  cateringRequestCreateConciergeFeePaymentIntent?: Maybe<CateringRequestCreateConciergeFeePaymentIntentPayload>;
  cateringRequestDeleteTrucks?: Maybe<CateringRequestDeleteTrucksPayload>;
  cateringRequestFinished?: Maybe<CateringRequestFinishedPayload>;
  cateringRequestMakeTruckQueue?: Maybe<CateringRequestMakeTruckQueuePayload>;
  cateringRequestNotifyQueue?: Maybe<CateringRequestNotifyQueuePayload>;
  cateringRequestNotifyQueueTrucks?: Maybe<CateringRequestNotifyQueueTrucksPayload>;
  cateringRequestQueueRemove?: Maybe<CateringRequestQueueRemovePayload>;
  cateringRequestQueueReorder?: Maybe<CateringRequestQueueReorderPayload>;
  cateringRequestReadyForSelection?: Maybe<CateringRequestReadyForSelectionPayload>;
  cateringRequestRefundConciergeFee?: Maybe<CateringRequestRefundConciergeFeePayload>;
  cateringRequestRevert?: Maybe<CateringRequestRevertPayload>;
  cateringRequestTruckGroupsUpdate?: Maybe<CateringRequestTruckGroupsUpdatePayload>;
  cateringRequestUncancel?: Maybe<CateringRequestUncancelPayload>;
  cateringRequestUpdate?: Maybe<CateringRequestUpdatePayload>;
  cateringRequestUpdateQueueBatchSize?: Maybe<CateringRequestUpdateQueueBatchSizePayload>;
  cateringRequestUpdateTags?: Maybe<CateringRequestUpdateTagsPayload>;
  cateringTruckBudgetUpdate?: Maybe<CateringTruckBudgetUpdatePayload>;
  cateringTruckDebitCreate?: Maybe<CateringTruckDebitCreatePayload>;
  cateringTruckRequestPropose?: Maybe<CateringTruckRequestProposePayload>;
  cateringTruckRequestReject?: Maybe<CateringTruckRequestRejectPayload>;
  clientCompanyAddCard?: Maybe<ClientCompanyAddCardPayload>;
  clientCompanyAddLot?: Maybe<ClientCompanyAddLotPayload>;
  clientCompanyAddMember?: Maybe<ClientCompanyAddMemberPayload>;
  clientCompanyAddMembers?: Maybe<ClientCompanyAddMembersPayload>;
  clientCompanyCreate?: Maybe<ClientCompanyCreatePayload>;
  clientCompanyDiscountUpdate?: Maybe<ClientCompanyDiscountUpdatePayload>;
  clientCompanyMakeCardCurrent?: Maybe<ClientCompanyMakeCardCurrentPayload>;
  clientCompanyRemoveCard?: Maybe<ClientCompanyRemoveCardPayload>;
  clientCompanyRemoveLot?: Maybe<ClientCompanyRemoveLotPayload>;
  clientCompanyRemoveMember?: Maybe<ClientCompanyRemoveMemberPayload>;
  clientCompanySignupCouponUpdate?: Maybe<ClientCompanySignupCouponUpdatePayload>;
  clientCompanyUpdate?: Maybe<ClientCompanyUpdatePayload>;
  contractEnvelopeVoid?: Maybe<ContractEnvelopeVoidPayload>;
  corporateUserCreate?: Maybe<CorporateUserCreatePayload>;
  corporateUserForgotPassword?: Maybe<CorporateUserForgotPasswordPayload>;
  corporateUserLogin?: Maybe<CorporateUserLoginPayload>;
  corporateUserResetPassword?: Maybe<CorporateUserResetPasswordPayload>;
  corporateUserUpdate?: Maybe<CorporateUserUpdatePayload>;
  couponCreate?: Maybe<CouponCreatePayload>;
  couponDisable?: Maybe<CouponDisablePayload>;
  couponEnable?: Maybe<CouponEnablePayload>;
  couponUpdate?: Maybe<CouponUpdatePayload>;
  creditsTriggersConfigUpdate?: Maybe<CreditsTriggerConfigUpdatePayload>;
  customerBulkCreateByAdmin?: Maybe<CustomerBulkCreateByAdminPayload>;
  customerCardRemove?: Maybe<CustomerCardRemovePayload>;
  customerCreateByAdmin?: Maybe<CustomerCreateByAdminPayload>;
  customerCreateByOrganizer?: Maybe<CustomerCreateByOrganizerPayload>;
  customerCreditCreate?: Maybe<CustomerCreditCreatePayload>;
  customerDeviceRegister?: Maybe<CustomerDeviceRegisterPayload>;
  customerEmailCodeLogin?: Maybe<CustomerEmailCodeLoginPayload>;
  customerEmailCodeSignup?: Maybe<CustomerEmailCodeSignupPayload>;
  customerGenericSubscriptionsCreate?: Maybe<CustomerGenericSubscriptionsCreatePayload>;
  customerLogin?: Maybe<CustomerLoginPayload>;
  customerPartnerAuth?: Maybe<CustomerPartnerAuthPayload>;
  customerPhoneLogin?: Maybe<CustomerPhoneLoginPayload>;
  customerPhoneSignup?: Maybe<CustomerPhoneSignupPayload>;
  customerRemove?: Maybe<CustomerRemovePayload>;
  customerUnmarkAsFraud?: Maybe<CustomerUnmarkAsFraudPayload>;
  customerUpdate?: Maybe<CustomerUpdatePayload>;
  customerUpdateEmail?: Maybe<CustomerUpdateEmailPayload>;
  customerUpdateName?: Maybe<CustomerUpdateNamePayload>;
  customerUpdatePhone?: Maybe<CustomerUpdatePhonePayload>;
  dashNotificationsMarkRead?: Maybe<DashNotificationsMarkReadPayload>;
  dashSubscribeToEntity?: Maybe<DashSubscribeToEntityPayload>;
  dashSubscriptionChannelsUpdate?: Maybe<DashSubscriptionChannelsUpdatePayload>;
  defaultLotSettingsUpdate?: Maybe<DefaultLotSettingsUpdatePayload>;
  deleteAccountRequest?: Maybe<DeleteAccountRequestPayload>;
  emailThreadMarkAsRead?: Maybe<EmailThreadMarkAsReadPayload>;
  emailVerificationCodeSend?: Maybe<EmailVerificationCodeSendPayload>;
  emailVerificationCodeVerify?: Maybe<EmailVerificationCodeVerifyPayload>;
  employeeChangePassword?: Maybe<EmployeeChangePasswordPayload>;
  employeeChangeTruck?: Maybe<EmployeeChangeTruckPayload>;
  employeeCreate?: Maybe<EmployeeCreatePayload>;
  employeeForgotPassword?: Maybe<EmployeeForgotPasswordPayload>;
  employeeLogin?: Maybe<EmployeeLoginPayload>;
  employeeNotificationsCreate?: Maybe<EmployeeNotificationsCreatePayload>;
  employeeResetPassword?: Maybe<EmployeeResetPasswordPayload>;
  employeeUpdate?: Maybe<EmployeeUpdatePayload>;
  employeeUpdateByAdmin?: Maybe<EmployeeUpdateByAdminPayload>;
  eventAddTrucks?: Maybe<EventAddTrucksPayload>;
  eventAutoApply?: Maybe<EventAutoApplyPayload>;
  eventBook?: Maybe<EventBookPayload>;
  eventChooseTruckProposal?: Maybe<EventChooseTruckProposalPayload>;
  eventCreate?: Maybe<EventCreatePayload>;
  eventDestroy?: Maybe<EventDestroyPayload>;
  eventProposalApprove?: Maybe<EventProposalApprovePayload>;
  eventProposalReject?: Maybe<EventProposalRejectPayload>;
  eventRegisterTruck?: Maybe<EventRegisterTruckPayload>;
  eventShareWithCustomer?: Maybe<EventShareWithCustomerPayload>;
  eventTruckPropose?: Maybe<EventTruckProposePayload>;
  eventTruckRequestReject?: Maybe<EventTruckRequestRejectPayload>;
  eventUpdate?: Maybe<EventUpdatePayload>;
  eventUpdateSalesGuarantee?: Maybe<EventUpdateSalesGuaranteePayload>;
  eventsInstantBookConfigCreate?: Maybe<EventsInstantBookConfigCreatePayload>;
  eventsInstantBookFinish?: Maybe<EventsInstantBookFinishPayload>;
  eventsInstantBookUpdateGeneral?: Maybe<EventsInstantBookUpdateGeneralPayload>;
  eventsInstantBookUpdateMenu?: Maybe<EventsInstantBookUpdateMenuPayload>;
  eventsInstantBookUpdatePricing?: Maybe<EventsInstantBookUpdatePricingPayload>;
  eventsRequestAddTrucks?: Maybe<EventsRequestAddTrucksPayload>;
  eventsRequestApprove?: Maybe<EventsRequestApprovePayload>;
  eventsRequestCancel?: Maybe<EventsRequestCancelPayload>;
  eventsRequestChooseTruckProposals?: Maybe<EventsRequestChooseTruckProposalsPayload>;
  eventsRequestConfirmDeposit?: Maybe<EventsRequestConfirmDepositPayload>;
  eventsRequestCreate?: Maybe<EventsRequestCreatePayload>;
  eventsRequestCreatePaymentIntent?: Maybe<EventsRequestCreatePaymentIntentPayload>;
  eventsRequestDelete?: Maybe<EventsRequestDeletePayload>;
  eventsRequestRefundDeposit?: Maybe<EventsRequestRefundDepositPayload>;
  eventsRequestUpdateTag?: Maybe<EventsRequestUpdateTagsPayload>;
  eventsTruckProposalAcknowledge?: Maybe<EventsTruckProposalAcknowledgePayload>;
  experientialRequestCreate?: Maybe<ExperientialRequestCreatePayload>;
  experientialRequestCreateNew?: Maybe<ExperientialMarketingCreateNewPayload>;
  facebookMarketPageCreate?: Maybe<FacebookMarketPageCreatePayload>;
  facebookMarketPageDelete?: Maybe<FacebookMarketPageDeletePayload>;
  facebookMarketPageUpdate?: Maybe<FacebookMarketPageUpdatePayload>;
  facebookPagePostingCreate?: Maybe<FacebookPagePostingCreatePayload>;
  facebookPagePostingDelete?: Maybe<FacebookPagePostingDeletePayload>;
  facebookPostingIntegrationDelete?: Maybe<FacebookPostingIntegrationDeletePayload>;
  foodItemActivate?: Maybe<FoodItemActivatePayload>;
  foodItemCreate?: Maybe<FoodItemCreatePayload>;
  foodItemRemove?: Maybe<FoodItemRemovePayload>;
  foodItemUpdate?: Maybe<FoodItemUpdatePayload>;
  foodTypeCategoryCreate?: Maybe<FoodTypeCategoryCreatePayload>;
  foodTypeCategoryUpdate?: Maybe<FoodTypeCategoryUpdatePayload>;
  foodTypeCreate?: Maybe<FoodTypeCreatePayload>;
  foodTypeDestroy?: Maybe<FoodTypeDestroyPayload>;
  foodTypePageMarketClone?: Maybe<FoodTypePageMarketClonePayload>;
  foodTypePageUpdate?: Maybe<FoodTypePageUpdatePayload>;
  foodTypeUpdate?: Maybe<FoodTypeUpdatePayload>;
  globalConfigUpdate?: Maybe<GlobalConfigUpdatePayload>;
  healthPermitCreate?: Maybe<HealthPermitCreatePayload>;
  healthPermitDelete?: Maybe<HealthPermitDeletePayload>;
  healthPermitUpdate?: Maybe<HealthPermitUpdatePayload>;
  instantBookConfigCreate?: Maybe<InstantBookConfigCreatePayload>;
  instantBookFinish?: Maybe<InstantBookFinishPayload>;
  instantBookUpdateGeneral?: Maybe<InstantBookUpdateGeneralPayload>;
  instantBookUpdatePolicy?: Maybe<InstantBookUpdatePolicyPayload>;
  instantBookUpdateTiers?: Maybe<InstantBookUpdateTiersPayload>;
  itemAnswerActivate?: Maybe<ItemAnswerActivatePayload>;
  itemQuestionActivate?: Maybe<ItemQuestionActivatePayload>;
  itemQuestionCreate?: Maybe<ItemQuestionCreatePayload>;
  itemQuestionRemove?: Maybe<ItemQuestionRemovePayload>;
  itemQuestionUpdate?: Maybe<ItemQuestionUpdatePayload>;
  itemQuestionUpdatePositions?: Maybe<ItemQuestionUpdatePositionsPayload>;
  locationAddSalesGuaranteeContract?: Maybe<LocationAddSalesGuaranteeContractPayload>;
  locationCancelBooking?: Maybe<LocationCancelBookingPayload>;
  locationChangeSpot?: Maybe<LocationChangeSpotPayload>;
  locationChangeTime?: Maybe<LocationChangeTimePayload>;
  locationConfirmSales?: Maybe<LocationConfirmSalesPayload>;
  locationCreateCustom?: Maybe<LocationCreateCustomPayload>;
  locationDeferWalkupSales?: Maybe<LocationDeferWalkupSalesPayload>;
  locationEndEarlyReason?: Maybe<LocationEndEarlyReasonPayload>;
  locationEndWork?: Maybe<LocationEndWorkPayload>;
  locationItemAnswerChangeStatus?: Maybe<LocationItemAnswerChangeStatusPayload>;
  locationItemChangeMaxQuantity?: Maybe<LocationItemChangeMaxQuantityPayload>;
  locationItemChangeStatus?: Maybe<LocationItemChangeStatusPayload>;
  locationItemQuestionChangeStatus?: Maybe<LocationItemQuestionChangeStatusPayload>;
  locationMakeFeeUncollectible?: Maybe<LocationMakeFeeUncollectiblePayload>;
  locationMenuUpdate?: Maybe<LocationMenuUpdatePayload>;
  locationMinimumIsMet?: Maybe<LocationMinimumIsMetPayload>;
  locationMinimumIsNotMet?: Maybe<LocationMinimumIsNotMetPayload>;
  locationMove?: Maybe<LocationMovePayload>;
  locationPause?: Maybe<LocationPausePayload>;
  locationPaySalesPercentage?: Maybe<LocationPaySalesPercentagePayload>;
  locationProlongWork?: Maybe<LocationProlongWorkPayload>;
  locationRefundBookingFee?: Maybe<LocationRefundBookingFeePayload>;
  locationRefundCancellationFee?: Maybe<LocationRefundCancellationFeePayload>;
  locationRefundSalesPercentage?: Maybe<LocationRefundSalesPercentagePayload>;
  locationRefundTruck?: Maybe<LocationRefundTruckPayload>;
  locationRemoveTruck?: Maybe<LocationRemoveTruckPayload>;
  locationReplaceTruck?: Maybe<LocationReplaceTruckPayload>;
  locationResume?: Maybe<LocationResumePayload>;
  locationSendSalesGuaranteeContract?: Maybe<LocationSendSalesGuaranteeContractPayload>;
  locationSetCoordinates?: Maybe<LocationSetCoordinatesPayload>;
  locationStart?: Maybe<LocationStartPayload>;
  locationStartPreOrder?: Maybe<LocationStartPreOrderPayload>;
  locationSubmitWalkupSales?: Maybe<LocationSubmitWalkupSalesPayload>;
  locationTaxRateUpdate?: Maybe<LocationTaxRateUpdatePayload>;
  locationTriggerCharge?: Maybe<LocationTriggerChargePayload>;
  locationUpdateBookingFee?: Maybe<LocationUpdateBookingFeePayload>;
  locationUpdateCancellationTerms?: Maybe<LocationUpdateCancellationTermsPayload>;
  locationUpdateDelayedPickup?: Maybe<LocationUpdateDelayedPickupPayload>;
  locationUpdateOfflineOrdersSteps?: Maybe<LocationUpdateOfflineOrdersStepsPayload>;
  locationUpdateOrdersPerTimeSlot?: Maybe<LocationUpdateOrdersPerTimeSlotPayload>;
  locationUpdatePhone?: Maybe<LocationUpdatePhonePayload>;
  locationUpdatePickupTimeOptions?: Maybe<LocationUpdatePickupTimeOptionsPayload>;
  locationUpdateSalesGuarantee?: Maybe<LocationUpdateSalesGuaranteePayload>;
  locationUpdateSalesPercentage?: Maybe<LocationUpdateSalesPercentagePayload>;
  locationUpdateVisibility?: Maybe<LocationUpdateVisibilityPayload>;
  lotAssignOrganizer?: Maybe<LotAssignOrganizerPayload>;
  lotBookCustom?: Maybe<LotBookCustomPayload>;
  lotChangeOrganization?: Maybe<LotChangeOrganizationPayload>;
  lotCopySubscribers?: Maybe<LotCopySubscribersPayload>;
  lotCreate?: Maybe<LotCreatePayload>;
  lotCreateCustom?: Maybe<LotCreateCustomPayload>;
  lotGroupCreate?: Maybe<LotGroupCreatePayload>;
  lotGroupRemove?: Maybe<LotGroupRemovePayload>;
  lotGroupUpdate?: Maybe<LotGroupUpdatePayload>;
  lotGroupUpdateNotice?: Maybe<LotGroupUpdateNoticePayload>;
  lotInstantBookAdd?: Maybe<LotInstantBookAddPayload>;
  lotInstantBookRemove?: Maybe<LotInstantBookRemovePayload>;
  lotSendMenuEmail?: Maybe<LotSendMenuEmailPayload>;
  lotShareWithCustomer?: Maybe<LotShareWithCustomerPayload>;
  lotStopSharingWithCustomer?: Maybe<LotStopSharingWithCustomerPayload>;
  lotSubscribe?: Maybe<LotSubscribePayload>;
  lotUnsubscribe?: Maybe<LotUnsubscribePayload>;
  lotUpdate?: Maybe<LotUpdatePayload>;
  lotUpdateAdminSettings?: Maybe<LotUpdateAdminSettingsPayload>;
  lotUpdateDescription?: Maybe<LotUpdateDescriptionPayload>;
  lotUpdateNotice?: Maybe<LotUpdateNoticePayload>;
  marketCreate?: Maybe<MarketCreatePayload>;
  marketUpdate?: Maybe<MarketUpdatePayload>;
  marketUpdateTopTrucks?: Maybe<MarketUpdateTopTrucksPayload>;
  marketplaceClickCreate?: Maybe<MarketplaceClickCreatePayload>;
  menuActivate?: Maybe<MenuActivatePayload>;
  menuCopy?: Maybe<MenuCopyPayload>;
  menuCreate?: Maybe<MenuCreatePayload>;
  menuItemsCopy?: Maybe<MenuItemsCopyPayload>;
  menuRemove?: Maybe<MenuRemovePayload>;
  menuUpdate?: Maybe<MenuUpdatePayload>;
  menuUpdatePositions?: Maybe<MenuUpdatePositionsPayload>;
  metabaseMakePublicLink?: Maybe<MetabaseMakePublicLinkPayload>;
  noteAdd?: Maybe<NoteAddPayload>;
  offlineOrderCardConfirm?: Maybe<OfflineOrderCardConfirmPayload>;
  offlineOrderCashConfirm?: Maybe<OfflineOrderCashConfirmPayload>;
  offlineOrderCompleted?: Maybe<OfflineOrderCompletedPayload>;
  offlineOrderCreate?: Maybe<OfflineOrderCreatePayload>;
  offlineOrderDiscard?: Maybe<OfflineOrderDiscardPayload>;
  offlineOrderReady?: Maybe<OfflineOrderReadyPayload>;
  offlineOrderRefund?: Maybe<OfflineOrderRefundPayload>;
  offlineOrderSendReceipt?: Maybe<OfflineOrderSendReceiptPayload>;
  orderAbandon?: Maybe<OrderAbandonPayload>;
  orderAssign?: Maybe<OrderAssignPayload>;
  orderCancel?: Maybe<OrderCancelPayload>;
  orderChangePickupTime?: Maybe<OrderChangePickupTimePayload>;
  orderComplete?: Maybe<OrderCompletePayload>;
  orderConfirm?: Maybe<OrderConfirmPayload>;
  orderPartialRefundApprove?: Maybe<OrderPartialRefundApprovePayload>;
  orderPartialRefundCreate?: Maybe<OrderPartialRefundCreatePayload>;
  orderPartialRefundReject?: Maybe<OrderPartialRefundRejectPayload>;
  orderRatingRate?: Maybe<OrderRatingRatePayload>;
  orderRatingViewed?: Maybe<OrderRatingViewedPayload>;
  orderReady?: Maybe<OrderReadyPayload>;
  orderRefundCustomer?: Maybe<OrderRefundCustomerPayload>;
  orderReverseTruckPayment?: Maybe<OrderReverseTruckPaymentPayload>;
  orderUnassign?: Maybe<OrderUnassignPayload>;
  organizationBankAccountCreate?: Maybe<OrganizationBankAccountCreatePayload>;
  organizationBankAccountDestroy?: Maybe<OrganizationBankAccountDestroyPayload>;
  organizationBankAccountMakeCurrent?: Maybe<OrganizationBankAccountMakeCurrentPayload>;
  organizationBookingRestrictionUpdate?: Maybe<OrganizationBookingRestrictionUpdatePayload>;
  organizationCreate?: Maybe<OrganizationCreatePayload>;
  organizationDebitCardCreate?: Maybe<OrganizationDebitCardCreatePayload>;
  organizationDebitCardDestroy?: Maybe<OrganizationDebitCardDestroyPayload>;
  organizationDebitCardMakeCurrent?: Maybe<OrganizationDebitCardMakeCurrentPayload>;
  organizationEditStripeAccount?: Maybe<OrganizationEditStripeAccountPayload>;
  organizationUpdate?: Maybe<OrganizationUpdatePayload>;
  organizationUpdateCatering?: Maybe<OrganizationUpdateCateringPayload>;
  organizerCreate?: Maybe<OrganizerCreatePayload>;
  organizerForgotPassword?: Maybe<OrganizerForgotPasswordPayload>;
  organizerLogin?: Maybe<OrganizerLoginPayload>;
  organizerLotSubscriptionCreate?: Maybe<OrganizerLotSubscriptionCreatePayload>;
  organizerLotSubscriptionRemove?: Maybe<OrganizerLotSubscriptionRemovePayload>;
  organizerNotifyTrucks?: Maybe<OrganizerNotifyTrucksPayload>;
  organizerResetPassword?: Maybe<OrganizerResetPasswordPayload>;
  organizerUpdate?: Maybe<OrganizerUpdatePayload>;
  preferredVendorChange?: Maybe<PreferredVendorChangePayload>;
  replyTemplateCreate?: Maybe<ReplyTemplateCreatePayload>;
  replyTemplateUpdate?: Maybe<ReplyTemplateUpdatePayload>;
  restaurantAcceptTerms?: Maybe<RestaurantAcceptTermsPayload>;
  restaurantAddBankAccount?: Maybe<RestaurantAddBankAccountPayload>;
  restaurantAddPaymentCard?: Maybe<RestaurantAddPaymentCardPayload>;
  restaurantAddPayoutCard?: Maybe<RestaurantAddPayoutCardPayload>;
  restaurantBan?: Maybe<RestaurantBanPayload>;
  restaurantBankAccountMakeCurrent?: Maybe<RestaurantBankAccountMakeCurrentPayload>;
  restaurantBankAccountRemove?: Maybe<RestaurantBankAccountRemovePayload>;
  restaurantChangeCredits?: Maybe<RestaurantChangeCreditsPayload>;
  restaurantChangeInstantPayouts?: Maybe<RestaurantChangeInstantPayoutsPayload>;
  restaurantClaim?: Maybe<RestaurantClaimPayload>;
  restaurantClaimV2?: Maybe<RestaurantClaimV2Payload>;
  restaurantCompleteBankAccountSetup?: Maybe<RestaurantCompleteBankAccountSetupPayload>;
  restaurantConvertToFull?: Maybe<RestaurantConvertToFullPayload>;
  restaurantCreate?: Maybe<RestaurantCreatePayload>;
  restaurantCreateBankAccountSetupIntent?: Maybe<RestaurantCreateBankAccountSetupIntentPayload>;
  restaurantCreateStripeSession?: Maybe<RestaurantCreateStripeSessionPayload>;
  restaurantCreditCardMakeCurrent?: Maybe<RestaurantCreditCardMakeCurrentPayload>;
  restaurantCreditCardRemove?: Maybe<RestaurantCreditCardRemovePayload>;
  restaurantDebitCardMakeCurrent?: Maybe<RestaurantDebitCardMakeCurrentPayload>;
  restaurantDebitCardRemove?: Maybe<RestaurantDebitCardRemovePayload>;
  restaurantDisasterRelief?: Maybe<RestaurantDisasterReliefPayload>;
  restaurantEditStripeAccount?: Maybe<RestaurantEditStripeAccountPayload>;
  restaurantEnableInstantBook?: Maybe<RestaurantEnableInstantBookPayload>;
  restaurantMarkUnclaimed?: Maybe<RestaurantMarkUnclaimedPayload>;
  restaurantReactivateEmail?: Maybe<RestaurantReactivateEmailPayload>;
  restaurantSignUp?: Maybe<RestaurantSignUpPayload>;
  restaurantSignUp2?: Maybe<RestaurantSignUp2Payload>;
  restaurantSyncWithStripe?: Maybe<RestaurantSyncWithStripePayload>;
  restaurantUpdate?: Maybe<RestaurantUpdatePayload>;
  restaurantUpdateProfile?: Maybe<RestaurantUpdateProfilePayload>;
  restaurantUpdateSignupMenu?: Maybe<RestaurantUpdateSignupMenuPayload>;
  reviewDetectTruckProblems?: Maybe<ReviewDetectTruckProblemsPayload>;
  reviewGenerateSuggestionForProblem?: Maybe<ReviewGenerateSuggestionForProblemPayload>;
  reviewGenerateSuggestionForProblems?: Maybe<ReviewGenerateSuggestionForProblemsPayload>;
  reviewSuggestionAccept?: Maybe<ReviewSuggestionAcceptPayload>;
  /** Generates a new suggestion for an existing request, or for an entity and action. The user prompt is required when it replaces a pending suggestion. Suggestions that generate an image take an attached image or PDF, or an image url. */
  reviewSuggestionNew?: Maybe<ReviewSuggestionNewPayload>;
  reviewSuggestionReject?: Maybe<ReviewSuggestionRejectPayload>;
  reviewSuggestionRevert?: Maybe<ReviewSuggestionRevertPayload>;
  /** Writes an email asking the truck to fix its unresolved review problems, signed by the current admin. */
  reviewTruckInstructions?: Maybe<ReviewTruckInstructionsPayload>;
  reviewTruckProblemDismiss?: Maybe<ReviewTruckProblemDismissPayload>;
  sqlReportCreate?: Maybe<SqlReportCreatePayload>;
  stripeManualTransferCancel?: Maybe<StripeManualTransferCancelPayload>;
  stripeManualTransferConfirm?: Maybe<StripeManualTransferConfirmPayload>;
  stripeManualTransferCreate?: Maybe<StripeManualTransferCreatePayload>;
  supportEmailSend?: Maybe<SupportEmailSendPayload>;
  terminalCreateConnectionToken?: Maybe<TerminalCreateConnectionTokenPayload>;
  terminalCreateLocation?: Maybe<TerminalCreateLocationPayload>;
  testPushNotification?: Maybe<TestPushNotificationPayload>;
  textConversationMarkRead?: Maybe<TextConversationMarkReadPayload>;
  textConversationSendMessage?: Maybe<TextConversationSendMessagePayload>;
  truckCateringRatingUpdate?: Maybe<TruckCateringRatingUpdatePayload>;
  truckChatCreate?: Maybe<TruckChatCreatePayload>;
  truckChatMarkUnread?: Maybe<TruckChatMarkUnreadPayload>;
  truckChatMessageCreate?: Maybe<TruckChatMessageCreatePayload>;
  truckChatMessageUpdateFlagged?: Maybe<TruckChatMessageUpdateFlaggedPayload>;
  truckChatRead?: Maybe<TruckChatReadPayload>;
  truckCreate?: Maybe<TruckCreatePayload>;
  truckCreateUserFeedback?: Maybe<TruckCreateUserFeedbackPayload>;
  truckCreateWalkupRating?: Maybe<TruckCreateWalkupRatingPayload>;
  truckDelete?: Maybe<TruckDeletePayload>;
  truckDocumentArchive?: Maybe<TruckDocumentArchivePayload>;
  truckDocumentCreate?: Maybe<TruckDocumentCreatePayload>;
  truckDocumentDeleteAttachment?: Maybe<TruckDocumentDeleteAttachmentPayload>;
  truckDocumentReplace?: Maybe<TruckDocumentReplacePayload>;
  truckDocumentUpdate?: Maybe<TruckDocumentUpdatePayload>;
  truckDocumentUpdateVisibility?: Maybe<TruckDocumentUpdateVisibilityPayload>;
  truckDocumentsRequest?: Maybe<TruckDocumentsRequestPayload>;
  truckGroupCreate?: Maybe<TruckGroupCreatePayload>;
  truckGroupDestroy?: Maybe<TruckGroupDestroyPayload>;
  truckGroupUpdate?: Maybe<TruckGroupUpdatePayload>;
  truckPhoneVerify?: Maybe<TruckPhoneVerifyPayload>;
  truckPrinterCreate?: Maybe<TruckPrinterCreatePayload>;
  truckRateEntity?: Maybe<TruckRateEntityPayload>;
  truckReviewApprove?: Maybe<TruckReviewApprovePayload>;
  truckReviewReject?: Maybe<TruckReviewRejectPayload>;
  truckReviewRequest?: Maybe<TruckReviewRequestPayload>;
  truckSetActive?: Maybe<TruckSetActivePayload>;
  truckUpdate?: Maybe<TruckUpdatePayload>;
  truckUpdateAddress?: Maybe<TruckUpdateAddressPayload>;
  truckUpdateAutoAdvance?: Maybe<TruckUpdateAutoAdvancePayload>;
  truckUpdateAvailability?: Maybe<TruckUpdateAvailabilityPayload>;
  truckUpdateDefaultCateringMenu?: Maybe<TruckUpdateDefaultCateringMenuPayload>;
  truckUpdateDefaultEventMenu?: Maybe<TruckUpdateDefaultEventMenuPayload>;
  truckUpdateDescription?: Maybe<TruckUpdateDescriptionPayload>;
  truckUpdateEmailNotifications?: Maybe<TruckUpdateEmailNotificationsPayload>;
  truckUpdateMarket?: Maybe<TruckUpdateMarketPayload>;
  truckUpdateMenus?: Maybe<TruckUpdateMenusPayload>;
  truckUpdatePhoneNotifications?: Maybe<TruckUpdatePhoneNotificationsPayload>;
  truckUpdateTips?: Maybe<TruckUpdateTipsPayload>;
  twentyMileSignUp?: Maybe<TwentyMileSignUpPayload>;
  twitterConnectionDelete?: Maybe<TwitterConnectionDeletePayload>;
  twitterPostingIntegrationCreate?: Maybe<TwitterPostingIntegrationCreatePayload>;
  twitterPostingIntegrationDelete?: Maybe<TwitterPostingIntegrationDeletePayload>;
  twoFaEmailCodeSend?: Maybe<TwoFaEmailCodeSendPayload>;
  twoFaEmailVerifySession?: Maybe<TwoFaEmailVerifySessionPayload>;
  uploadedAssetCreate?: Maybe<UploadedAssetCreatePayload>;
  uploadedAssetRemove?: Maybe<UploadedAssetRemovePayload>;
  upsellTypeCreate?: Maybe<UpsellTypeCreatePayload>;
  upsellTypeUpdate?: Maybe<UpsellTypeUpdatePayload>;
  userChangePassword?: Maybe<UserChangePasswordPayload>;
  userLogout?: Maybe<UserLogoutPayload>;
  userNotificationsDelete?: Maybe<UserNotificationsDeletePayload>;
  userReadNotification?: Maybe<UserReadNotificationPayload>;
  verificationCodeSend?: Maybe<VerificationCodeSendPayload>;
  verificationCodeVerify?: Maybe<VerificationCodeVerifyPayload>;
  webPushSubscribe?: Maybe<WebPushSubscribePayload>;
  webPushUnsubscribe?: Maybe<WebPushUnsubscribePayload>;
};


export type RootAccountDeletionRequestApproveArgs = {
  full: Scalars['Boolean'];
  id: Scalars['Int'];
};


export type RootAccountDeletionRequestRejectArgs = {
  id: Scalars['Int'];
  reason: Scalars['String'];
};


export type RootAdminForgotPasswordArgs = {
  email: Scalars['String'];
};


export type RootAdminLoginArgs = {
  email: Scalars['String'];
  password: Scalars['String'];
};


export type RootAdminResetPasswordArgs = {
  password: Scalars['String'];
  token: Scalars['String'];
};


export type RootAgentChatDeleteArgs = {
  agentChatId: Scalars['Int'];
};


export type RootAgentChatMessageCreateArgs = {
  agentChatId?: InputMaybe<Scalars['Int']>;
  attachments?: InputMaybe<Array<Scalars['Upload']>>;
  locale?: InputMaybe<Scalars['String']>;
  pageContext?: InputMaybe<Scalars['String']>;
  text: Scalars['String'];
  truckId?: InputMaybe<Scalars['Int']>;
};


export type RootAgentChatToolApprovalArgs = {
  agentChatId: Scalars['Int'];
  agentChatMessageId: Scalars['Int'];
  approved: Scalars['Boolean'];
  reason?: InputMaybe<Scalars['String']>;
};


export type RootAutoCoverRequestArgs = {
  eventId: Scalars['Int'];
};


export type RootBlogPostCreateArgs = {
  contentSections: Array<ContentSectionInput>;
  description?: InputMaybe<Scalars['String']>;
  metaDescription: Scalars['String'];
  published: Scalars['Boolean'];
  seoName: Scalars['String'];
  title: Scalars['String'];
};


export type RootBlogPostUpdateArgs = {
  contentSections: Array<ContentSectionInput>;
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  metaDescription: Scalars['String'];
  published: Scalars['Boolean'];
  seoName: Scalars['String'];
  title: Scalars['String'];
};


export type RootCalendarIntegrationCreateArgs = {
  calendarId: Scalars['String'];
  enableExport: Scalars['Boolean'];
  enableImport: Scalars['Boolean'];
  truckId: Scalars['Int'];
};


export type RootCalendarIntegrationRemoveArgs = {
  integrationId: Scalars['Int'];
};


export type RootCalendarIntegrationUpdateArgs = {
  calendarIntegrationId: Scalars['Int'];
  enableExport?: InputMaybe<Scalars['Boolean']>;
  enableImport?: InputMaybe<Scalars['Boolean']>;
};


export type RootCartAddItemArgs = {
  cartUuid: Scalars['String'];
  item: CartItemInput;
};


export type RootCartApplyCouponArgs = {
  cartUuid: Scalars['String'];
  couponCode: Scalars['String'];
};


export type RootCartCheckForPaymentArgs = {
  cartUuid: Scalars['String'];
};


export type RootCartCheckoutSessionArgs = {
  cartUuid: Scalars['String'];
  priceCents: Scalars['Int'];
};


export type RootCartCreatePaymentIntentArgs = {
  cardId?: InputMaybe<Scalars['Int']>;
  cartUuid: Scalars['String'];
  saveCard?: InputMaybe<Scalars['Boolean']>;
};


export type RootCartCreateSetupIntentArgs = {
  cartUuid: Scalars['String'];
};


export type RootCartPlaceFreeOrderArgs = {
  cartUuid: Scalars['String'];
};


export type RootCartRemoveCouponArgs = {
  cartUuid: Scalars['String'];
};


export type RootCartRemoveItemArgs = {
  cartUuid: Scalars['String'];
  itemIndex: Scalars['Int'];
};


export type RootCartRemovePickupTimeArgs = {
  cartUuid: Scalars['String'];
};


export type RootCartUpdateCustomerNotesArgs = {
  cartUuid: Scalars['String'];
  customerNotes: Scalars['String'];
};


export type RootCartUpdateItemArgs = {
  cartUuid: Scalars['String'];
  item: CartItemInput;
  itemIndex: Scalars['Int'];
};


export type RootCartUpdateLotNotesArgs = {
  cartUuid: Scalars['String'];
  lotNotes: Scalars['String'];
};


export type RootCartUpdatePickupTimeArgs = {
  cartUuid: Scalars['String'];
  pickupTime: Scalars['DateTime'];
};


export type RootCartUpdateTipArgs = {
  amountCustomTipCents?: InputMaybe<Scalars['Int']>;
  cartUuid: Scalars['String'];
  tipPercentage?: InputMaybe<Scalars['Int']>;
};


export type RootCartUseExistingCardArgs = {
  cardId: Scalars['Int'];
  cartUuid: Scalars['String'];
};


export type RootCartVerifyItemsAvailabilityArgs = {
  cartUuid: Scalars['String'];
};


export type RootCateringAlcoholRequestCreateArgs = {
  address: Scalars['String'];
  attendees: Scalars['Int'];
  cateringRequestId?: InputMaybe<Scalars['Int']>;
  data: Scalars['Json'];
  draft: Scalars['Boolean'];
  duration: Scalars['Int'];
  email: Scalars['String'];
  fullName: Scalars['String'];
  phone: Scalars['String'];
  startAt: Scalars['DateTime'];
};


export type RootCateringCategoryMarketCloneArgs = {
  id: Scalars['Int'];
  marketId: Scalars['Int'];
};


export type RootCateringCategoryUpdateArgs = {
  active: Scalars['Boolean'];
  aiGenerated?: InputMaybe<Scalars['Boolean']>;
  contentSections: Array<ContentSectionInput>;
  enableFaq: Scalars['Boolean'];
  faqSections: Array<FaqSectionInput>;
  id: Scalars['Int'];
  image?: InputMaybe<Scalars['Upload']>;
  metaDescription: Scalars['String'];
  minBudgetCents: Scalars['Int'];
  name: Scalars['String'];
  seoName: Scalars['String'];
  subtitle: Scalars['String'];
  title: Scalars['String'];
};


export type RootCateringConvertToDebitPaymentArgs = {
  cateringRequestId: Scalars['Int'];
};


export type RootCateringConvertToFullPaymentArgs = {
  cateringRequestId: Scalars['Int'];
};


export type RootCateringCustomRequestUpdateStatusArgs = {
  recordId: Scalars['Int'];
  requestType: CateringCustomRequestType;
  status: CateringCustomRequestStatus;
};


export type RootCateringCustomRequestUpdateTagsArgs = {
  recordId: Scalars['Int'];
  requestType: CateringCustomRequestType;
  tags: Array<Scalars['String']>;
};


export type RootCateringInvoicePayArgs = {
  cateringInvoiceId: Scalars['Int'];
  paymentType: CateringInvoicePayment;
};


export type RootCateringIssueInvoiceArgs = {
  cateringRequestId: Scalars['Int'];
};


export type RootCateringManualTruckDebitCreateArgs = {
  amountCents: Scalars['Int'];
  cateringRequestId: Scalars['Int'];
  note: Scalars['String'];
  truckId: Scalars['Int'];
};


export type RootCateringManualTruckDebitDeleteArgs = {
  id: Scalars['Int'];
};


export type RootCateringOrderCancelArgs = {
  orderId: Scalars['Int'];
};


export type RootCateringOrderCreateArgs = {
  cateringRequestId: Scalars['Int'];
  cateringTruckAssignmentId: Scalars['Int'];
  customerName?: InputMaybe<Scalars['String']>;
  order: CateringOrderInput;
  orderGroupUuid?: InputMaybe<Scalars['String']>;
  token?: InputMaybe<Scalars['String']>;
};


export type RootCateringOtherCreateArgs = {
  additionalInformation?: InputMaybe<Scalars['String']>;
  address: Scalars['String'];
  attendees: Scalars['String'];
  customerName: Scalars['String'];
  email: Scalars['String'];
  endAt: Scalars['DateTime'];
  eventsStartAt: Scalars['String'];
  minimumGuarantee: Scalars['String'];
  organizationId?: InputMaybe<Scalars['Int']>;
  parking: Scalars['Boolean'];
  parkingComments?: InputMaybe<Scalars['String']>;
  phone: Scalars['String'];
  startAt: Scalars['DateTime'];
};


export type RootCateringOverageRequestApproveArgs = {
  overageRequestId: Scalars['Int'];
};


export type RootCateringOverageRequestCreateArgs = {
  cateringTruckAssignmentId: Scalars['Int'];
  mealCount: Scalars['Int'];
  overageAmountPerMealCents: Scalars['Int'];
};


export type RootCateringOverageRequestRejectArgs = {
  overageRequestId: Scalars['Int'];
  reason: Scalars['String'];
};


export type RootCateringOverageRequestRevertArgs = {
  overageRequestId: Scalars['Int'];
  reason: Scalars['String'];
};


export type RootCateringOverageRequestUpdateBudgetArgs = {
  amountCustomerCents: Scalars['Int'];
  amountTruckCents: Scalars['Int'];
  mealCount: Scalars['Int'];
  overageRequestId: Scalars['Int'];
};


export type RootCateringPayOrganizerArgs = {
  cateringRequestId: Scalars['Int'];
};


export type RootCateringProposalAcknowledgeArgs = {
  proposalId: Scalars['Int'];
};


export type RootCateringProposalChooseArgs = {
  cateringRequestId: Scalars['Int'];
  selections: Array<CateringProposalSelection>;
};


export type RootCateringProposalUpdateCommentsArgs = {
  cateringProposalId: Scalars['Int'];
  otherComments: Scalars['String'];
};


export type RootCateringProposalUpdateStatusArgs = {
  cateringProposalId: Scalars['Int'];
  status: CateringProposalStatus;
};


export type RootCateringProposalUpdateVariantCommentsArgs = {
  cateringProposalVariantId: Scalars['Int'];
  menuComments: Scalars['String'];
};


export type RootCateringRecurringCreateArgs = {
  additionalInformation?: InputMaybe<Scalars['String']>;
  address: Scalars['String'];
  attendees: Scalars['String'];
  desiredSeoName?: InputMaybe<Scalars['String']>;
  endAt: Scalars['DateTime'];
  eventsStartAt?: InputMaybe<Scalars['String']>;
  eventsStartAtTimestamp?: InputMaybe<Scalars['DateTime']>;
  minimumGuarantee: Scalars['String'];
  organizationId?: InputMaybe<Scalars['Int']>;
  parking: Scalars['Boolean'];
  parkingComments?: InputMaybe<Scalars['String']>;
  scheduleDays?: InputMaybe<Array<Scalars['String']>>;
  scheduleFrequency?: InputMaybe<Scalars['String']>;
  scheduleNotes?: InputMaybe<Scalars['String']>;
  startAt: Scalars['DateTime'];
};


export type RootCateringRequestAddTrucksArgs = {
  addToQueuePosition: QueuePositionEnum;
  cateringRequestId: Scalars['Int'];
  respectTruckCateringPreferences?: InputMaybe<Scalars['Boolean']>;
  truckGroupId: Scalars['Int'];
  truckIds: Array<Scalars['Int']>;
};


export type RootCateringRequestAssignOrganizerArgs = {
  cateringRequestId: Scalars['Int'];
  organizationId: Scalars['Int'];
};


export type RootCateringRequestCancelArgs = {
  cateringRequestId: Scalars['Int'];
  reason: Scalars['String'];
};


export type RootCateringRequestConfirmConciergeFeeArgs = {
  cateringRequestId: Scalars['Int'];
};


export type RootCateringRequestCreateArgs = {
  additionalInstructions?: InputMaybe<Scalars['String']>;
  address: Scalars['String'];
  attendees: Scalars['Int'];
  cateringType: Scalars['String'];
  copyFrom?: InputMaybe<Scalars['Int']>;
  creationNote?: InputMaybe<Scalars['String']>;
  customerEmail?: InputMaybe<Scalars['String']>;
  customerFirstName?: InputMaybe<Scalars['String']>;
  customerLastName?: InputMaybe<Scalars['String']>;
  customerPhone?: InputMaybe<Scalars['String']>;
  customerTotalBudgetCents?: InputMaybe<Scalars['Int']>;
  draft?: InputMaybe<Scalars['Boolean']>;
  dropOff?: InputMaybe<Scalars['Boolean']>;
  endAt: Scalars['DateTime'];
  fixedLocation?: InputMaybe<Scalars['Boolean']>;
  foodPreferences?: InputMaybe<Scalars['String']>;
  mealParts: Array<MealPartsInput>;
  noAutoApply?: InputMaybe<Scalars['Boolean']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  preferredContactMethod?: InputMaybe<CateringPreferredContactMethod>;
  preferredTruckId?: InputMaybe<Scalars['Int']>;
  quoteOnly?: InputMaybe<Scalars['Boolean']>;
  startAt: Scalars['DateTime'];
};


export type RootCateringRequestCreateConciergeFeePaymentIntentArgs = {
  cateringRequestId: Scalars['Int'];
};


export type RootCateringRequestDeleteTrucksArgs = {
  cateringRequestId: Scalars['ID'];
  truckRequestIds: Array<Scalars['Int']>;
};


export type RootCateringRequestFinishedArgs = {
  cateringRequestId: Scalars['Int'];
};


export type RootCateringRequestMakeTruckQueueArgs = {
  cateringRequestId: Scalars['ID'];
};


export type RootCateringRequestNotifyQueueArgs = {
  cateringRequestId: Scalars['ID'];
};


export type RootCateringRequestNotifyQueueTrucksArgs = {
  cateringRequestId: Scalars['ID'];
  truckIds: Array<Scalars['Int']>;
};


export type RootCateringRequestQueueRemoveArgs = {
  cateringRequestId: Scalars['ID'];
  truckIds: Array<Scalars['Int']>;
};


export type RootCateringRequestQueueReorderArgs = {
  cateringRequestId: Scalars['ID'];
  position: Scalars['Int'];
  truckId: Scalars['ID'];
};


export type RootCateringRequestReadyForSelectionArgs = {
  cateringRequestId: Scalars['Int'];
};


export type RootCateringRequestRefundConciergeFeeArgs = {
  cateringRequestId: Scalars['Int'];
};


export type RootCateringRequestRevertArgs = {
  cateringRequestId: Scalars['Int'];
  keepProposals?: InputMaybe<Scalars['Boolean']>;
};


export type RootCateringRequestTruckGroupsUpdateArgs = {
  cateringRequestId: Scalars['Int'];
  groups: Array<CateringRequestTruckGroupInput>;
  notesForTruck?: InputMaybe<Scalars['String']>;
  optimisticLockingToken?: InputMaybe<Scalars['String']>;
};


export type RootCateringRequestUncancelArgs = {
  cateringRequestId: Scalars['Int'];
};


export type RootCateringRequestUpdateArgs = {
  attributes: CateringRequestUpdateInput;
  cateringRequestId: Scalars['Int'];
  optimisticLockingToken?: InputMaybe<Scalars['String']>;
};


export type RootCateringRequestUpdateQueueBatchSizeArgs = {
  cateringRequestId: Scalars['Int'];
  queueBatchSize: Scalars['Int'];
};


export type RootCateringRequestUpdateTagsArgs = {
  cateringRequestId: Scalars['Int'];
  tags: Array<Scalars['String']>;
};


export type RootCateringTruckBudgetUpdateArgs = {
  amountCents: Scalars['Int'];
  cateringRequestId: Scalars['Int'];
  truckId: Scalars['Int'];
};


export type RootCateringTruckDebitCreateArgs = {
  amountCents: Scalars['Int'];
  cateringRequestId: Scalars['Int'];
  truckId: Scalars['Int'];
};


export type RootCateringTruckRequestProposeArgs = {
  cancellationPolicyFullDays?: InputMaybe<Scalars['Int']>;
  cancellationPolicyHalfDays?: InputMaybe<Scalars['Int']>;
  cateringTruckRequestId: Scalars['Int'];
  endAt?: InputMaybe<Scalars['DateTime']>;
  menuId: Scalars['Int'];
  otherComments?: InputMaybe<Scalars['String']>;
  startAt?: InputMaybe<Scalars['DateTime']>;
  variants: Array<CateringRequestProposalVariantInput>;
};


export type RootCateringTruckRequestRejectArgs = {
  cateringTruckRequestId: Scalars['Int'];
  rejectReason: Scalars['String'];
};


export type RootClientCompanyAddCardArgs = {
  clientCompanyId: Scalars['Int'];
  token: Scalars['String'];
};


export type RootClientCompanyAddLotArgs = {
  clientCompanyId: Scalars['Int'];
  lotId: Scalars['Int'];
};


export type RootClientCompanyAddMemberArgs = {
  clientCompanyId: Scalars['Int'];
  memberAttributes: ClientCompanyMemberInput;
};


export type RootClientCompanyAddMembersArgs = {
  clientCompanyId: Scalars['Int'];
  file: Scalars['String'];
};


export type RootClientCompanyCreateArgs = {
  attributes: ClientCompanyInput;
};


export type RootClientCompanyDiscountUpdateArgs = {
  dayDiscounts: Array<ClientCompanyDayDiscountInput>;
  id: Scalars['Int'];
  maxDiscountPerLocationCents?: InputMaybe<Scalars['Int']>;
  maxDiscountPerLocationEnabled?: InputMaybe<Scalars['Boolean']>;
};


export type RootClientCompanyMakeCardCurrentArgs = {
  cardId: Scalars['Int'];
  clientCompanyId: Scalars['Int'];
};


export type RootClientCompanyRemoveCardArgs = {
  cardId: Scalars['Int'];
  clientCompanyId: Scalars['Int'];
};


export type RootClientCompanyRemoveLotArgs = {
  clientCompanyId: Scalars['Int'];
  lotId: Scalars['Int'];
};


export type RootClientCompanyRemoveMemberArgs = {
  clientCompanyId: Scalars['Int'];
  memberId: Scalars['Int'];
};


export type RootClientCompanySignupCouponUpdateArgs = {
  clientCompanyId: Scalars['Int'];
  couponSignupCode: Scalars['String'];
  couponSignupEnabled: Scalars['Boolean'];
};


export type RootClientCompanyUpdateArgs = {
  attributes: ClientCompanyInput;
  id: Scalars['Int'];
};


export type RootContractEnvelopeVoidArgs = {
  envelopeId: Scalars['Int'];
  reason: Scalars['String'];
};


export type RootCorporateUserCreateArgs = {
  clientCompanyId: Scalars['Int'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
};


export type RootCorporateUserForgotPasswordArgs = {
  email: Scalars['String'];
};


export type RootCorporateUserLoginArgs = {
  email: Scalars['String'];
  password: Scalars['String'];
};


export type RootCorporateUserResetPasswordArgs = {
  password: Scalars['String'];
  token: Scalars['String'];
};


export type RootCorporateUserUpdateArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  firstName?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  lastName?: InputMaybe<Scalars['String']>;
};


export type RootCouponCreateArgs = {
  attributes: CouponInput;
};


export type RootCouponDisableArgs = {
  id: Scalars['Int'];
};


export type RootCouponEnableArgs = {
  id: Scalars['Int'];
};


export type RootCouponUpdateArgs = {
  attributes: CouponInput;
  id: Scalars['Int'];
};


export type RootCreditsTriggersConfigUpdateArgs = {
  id: Scalars['String'];
  values: Scalars['Json'];
};


export type RootCustomerBulkCreateByAdminArgs = {
  amountCreditCents?: InputMaybe<Scalars['Int']>;
  file: Scalars['Upload'];
  subscribeToLotId?: InputMaybe<Scalars['Int']>;
};


export type RootCustomerCardRemoveArgs = {
  id: Scalars['Int'];
};


export type RootCustomerCreateByAdminArgs = {
  amountCreditCents?: InputMaybe<Scalars['Int']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  subscribeToLotId?: InputMaybe<Scalars['Int']>;
};


export type RootCustomerCreateByOrganizerArgs = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  phone: Scalars['String'];
};


export type RootCustomerCreditCreateArgs = {
  amountCents: Scalars['Int'];
  customerId: Scalars['Int'];
};


export type RootCustomerDeviceRegisterArgs = {
  appVersion: Scalars['String'];
  codePushVersion: Scalars['String'];
  deviceInfo: Scalars['Json'];
  oneSignalId: Scalars['String'];
  platform: DevicePlatform;
  pushAllowed: Scalars['Boolean'];
};


export type RootCustomerEmailCodeLoginArgs = {
  emailToken: Scalars['String'];
  subscribeToLotId?: InputMaybe<Scalars['Int']>;
};


export type RootCustomerEmailCodeSignupArgs = {
  emailToken: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  phone: Scalars['String'];
  subscribeToLotId?: InputMaybe<Scalars['Int']>;
};


export type RootCustomerGenericSubscriptionsCreateArgs = {
  customerId: Scalars['Int'];
  entityIds: Array<Scalars['Int']>;
  entityType: Scalars['String'];
};


export type RootCustomerLoginArgs = {
  email: Scalars['String'];
  password: Scalars['String'];
  resetTokenAfterLogin?: InputMaybe<Scalars['Boolean']>;
};


export type RootCustomerPartnerAuthArgs = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
};


export type RootCustomerPhoneLoginArgs = {
  phoneToken: Scalars['String'];
};


export type RootCustomerPhoneSignupArgs = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  phoneToken: Scalars['String'];
  subscribeToLotId?: InputMaybe<Scalars['Int']>;
};


export type RootCustomerRemoveArgs = {
  id: Scalars['Int'];
};


export type RootCustomerUnmarkAsFraudArgs = {
  customerId: Scalars['Int'];
  reason: Scalars['String'];
};


export type RootCustomerUpdateArgs = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  id: Scalars['Int'];
  lastName: Scalars['String'];
  phone: Scalars['String'];
};


export type RootCustomerUpdateEmailArgs = {
  email: Scalars['String'];
  id: Scalars['Int'];
};


export type RootCustomerUpdateNameArgs = {
  firstName: Scalars['String'];
  id: Scalars['Int'];
  lastName: Scalars['String'];
};


export type RootCustomerUpdatePhoneArgs = {
  id: Scalars['Int'];
  phoneToken: Scalars['String'];
};


export type RootDashNotificationsMarkReadArgs = {
  all?: InputMaybe<Scalars['Boolean']>;
  ids: Array<Scalars['Int']>;
};


export type RootDashSubscribeToEntityArgs = {
  entityId: Scalars['Int'];
  entityType: SubscriptionEntity;
  subscribe: Scalars['Boolean'];
};


export type RootDashSubscriptionChannelsUpdateArgs = {
  channels: Array<Scalars['String']>;
};


export type RootDefaultLotSettingsUpdateArgs = {
  bookingCancellationFeeCents?: InputMaybe<Scalars['Int']>;
  email?: InputMaybe<Scalars['String']>;
  facebook?: InputMaybe<Scalars['String']>;
  instagram?: InputMaybe<Scalars['String']>;
  marketId?: InputMaybe<Scalars['Int']>;
  organizationId: Scalars['Int'];
  paidCancellationIntervalSeconds?: InputMaybe<Scalars['Int']>;
  phone?: InputMaybe<Scalars['String']>;
  refundIntervalSeconds?: InputMaybe<Scalars['Int']>;
  sameTruckBookingSeconds?: InputMaybe<Scalars['Int']>;
  snapchat?: InputMaybe<Scalars['String']>;
  truckGroupRules?: InputMaybe<Array<TruckGroupRuleInput>>;
  twitter?: InputMaybe<Scalars['String']>;
  website?: InputMaybe<Scalars['String']>;
  yelp?: InputMaybe<Scalars['String']>;
};


export type RootDeleteAccountRequestArgs = {
  reason?: InputMaybe<Scalars['String']>;
};


export type RootEmailThreadMarkAsReadArgs = {
  emailThreadId: Scalars['Int'];
};


export type RootEmailVerificationCodeSendArgs = {
  email: Scalars['String'];
};


export type RootEmailVerificationCodeVerifyArgs = {
  code: Scalars['String'];
  email: Scalars['String'];
};


export type RootEmployeeChangePasswordArgs = {
  employeeId: Scalars['Int'];
  password: Scalars['String'];
};


export type RootEmployeeChangeTruckArgs = {
  employeeId: Scalars['Int'];
  truckId: Scalars['Int'];
};


export type RootEmployeeCreateArgs = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  password: Scalars['String'];
  restaurantId: Scalars['Int'];
  roles: Array<EmployeeRole>;
  truckId: Scalars['Int'];
};


export type RootEmployeeForgotPasswordArgs = {
  email: Scalars['String'];
};


export type RootEmployeeLoginArgs = {
  email: Scalars['String'];
  password: Scalars['String'];
};


export type RootEmployeeNotificationsCreateArgs = {
  content: Scalars['String'];
  marketIds?: InputMaybe<Array<Scalars['Int']>>;
  title: Scalars['String'];
};


export type RootEmployeeResetPasswordArgs = {
  password: Scalars['String'];
  token: Scalars['String'];
};


export type RootEmployeeUpdateArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  firstName?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  lastName?: InputMaybe<Scalars['String']>;
  roles: Array<EmployeeRole>;
  truckId: Scalars['Int'];
};


export type RootEmployeeUpdateByAdminArgs = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  id: Scalars['Int'];
  lastName: Scalars['String'];
};


export type RootEventAddTrucksArgs = {
  eventId: Scalars['Int'];
  message?: InputMaybe<Scalars['String']>;
  truckIds: Array<Scalars['Int']>;
};


export type RootEventAutoApplyArgs = {
  eventId: Scalars['Int'];
};


export type RootEventBookArgs = {
  applyCredits?: InputMaybe<Scalars['Boolean']>;
  endAt?: InputMaybe<Scalars['DateTime']>;
  eventId: Scalars['Int'];
  menuId: Scalars['Int'];
  spot?: InputMaybe<Scalars['Int']>;
  startAt?: InputMaybe<Scalars['DateTime']>;
  truckId: Scalars['Int'];
};


export type RootEventChooseTruckProposalArgs = {
  eventId: Scalars['Int'];
  feeCents?: InputMaybe<Scalars['Int']>;
  menuId: Scalars['Int'];
  spot?: InputMaybe<Scalars['Int']>;
  truckId: Scalars['Int'];
};


export type RootEventCreateArgs = {
  allowTrucksToSpecifyTime?: InputMaybe<Scalars['Boolean']>;
  autoApplyEnabled?: InputMaybe<Scalars['Boolean']>;
  bookableAt?: InputMaybe<Scalars['String']>;
  bookingCancellationFeeCents?: InputMaybe<Scalars['Int']>;
  bookingMode?: InputMaybe<BookingMode>;
  chargeSalesPercentage?: InputMaybe<Scalars['Float']>;
  chargeSalesPercentageEnabled?: InputMaybe<Scalars['Boolean']>;
  endAt: Scalars['String'];
  feeCents?: InputMaybe<Scalars['Int']>;
  fixedSalesGuarantee?: InputMaybe<Scalars['Boolean']>;
  isRecurring?: InputMaybe<Scalars['Boolean']>;
  lotFoodRestrictions?: InputMaybe<Array<LotFoodRestrictionInput>>;
  lotId: Scalars['Int'];
  minOrdersAmountCents?: InputMaybe<Scalars['Int']>;
  numberedSpots?: InputMaybe<Scalars['Boolean']>;
  occurrenceDays?: InputMaybe<Array<Scalars['Int']>>;
  occurrenceLengthSeconds?: InputMaybe<Scalars['Int']>;
  occurrenceType?: InputMaybe<EventOccurrenceType>;
  paidCancellationIntervalSeconds?: InputMaybe<Scalars['Int']>;
  refundIntervalSeconds?: InputMaybe<Scalars['Int']>;
  requiredDocuments?: InputMaybe<Array<TruckDocumentCategoryId>>;
  requiredDocumentsNotes?: InputMaybe<Scalars['String']>;
  salesGuaranteeAmountCents?: InputMaybe<Scalars['Int']>;
  salesPercentageFrom?: InputMaybe<LocationSalesPercentageFrom>;
  salesPercentageIncludesBookingFee?: InputMaybe<Scalars['Boolean']>;
  spotDescriptions?: InputMaybe<Array<SpotDescriptionInput>>;
  spots?: InputMaybe<Scalars['Int']>;
  startAt: Scalars['String'];
  truckGroupRules?: InputMaybe<Array<TruckGroupRuleInput>>;
};


export type RootEventDestroyArgs = {
  eventId: Scalars['Int'];
  sequence?: InputMaybe<Scalars['Boolean']>;
};


export type RootEventProposalApproveArgs = {
  eventId: Scalars['Int'];
  truckId: Scalars['Int'];
};


export type RootEventProposalRejectArgs = {
  eventId: Scalars['Int'];
  reason: Scalars['String'];
  truckId: Scalars['Int'];
};


export type RootEventRegisterTruckArgs = {
  applyCredits?: InputMaybe<Scalars['Boolean']>;
  endAt?: InputMaybe<Scalars['DateTime']>;
  eventId: Scalars['Int'];
  feeCents: Scalars['Int'];
  menuId?: InputMaybe<Scalars['Int']>;
  spot?: InputMaybe<Scalars['Int']>;
  startAt?: InputMaybe<Scalars['DateTime']>;
  truckId: Scalars['Int'];
};


export type RootEventShareWithCustomerArgs = {
  customerId: Scalars['Int'];
  eventId: Scalars['Int'];
};


export type RootEventTruckProposeArgs = {
  applyCredits?: InputMaybe<Scalars['Boolean']>;
  endAt?: InputMaybe<Scalars['DateTime']>;
  eventId: Scalars['Int'];
  menuId: Scalars['Int'];
  notes?: InputMaybe<Scalars['String']>;
  salesGuaranteeAmountCents?: InputMaybe<Scalars['Int']>;
  spot?: InputMaybe<Scalars['Int']>;
  startAt?: InputMaybe<Scalars['DateTime']>;
  truckId: Scalars['Int'];
};


export type RootEventTruckRequestRejectArgs = {
  eventId: Scalars['Int'];
  truckId: Scalars['Int'];
};


export type RootEventUpdateArgs = {
  allowTrucksToSpecifyTime?: InputMaybe<Scalars['Boolean']>;
  autoApplyEnabled?: InputMaybe<Scalars['Boolean']>;
  bookableAt?: InputMaybe<Scalars['String']>;
  bookingCancellationFeeCents?: InputMaybe<Scalars['Int']>;
  bookingMode?: InputMaybe<BookingMode>;
  chargeSalesPercentage?: InputMaybe<Scalars['Float']>;
  chargeSalesPercentageEnabled?: InputMaybe<Scalars['Boolean']>;
  endAt: Scalars['String'];
  eventId: Scalars['Int'];
  feeCents?: InputMaybe<Scalars['Int']>;
  fixedSalesGuarantee?: InputMaybe<Scalars['Boolean']>;
  lotFoodRestrictions?: InputMaybe<Array<LotFoodRestrictionInput>>;
  minOrdersAmountCents?: InputMaybe<Scalars['Int']>;
  numberedSpots?: InputMaybe<Scalars['Boolean']>;
  paidCancellationIntervalSeconds?: InputMaybe<Scalars['Int']>;
  refundIntervalSeconds?: InputMaybe<Scalars['Int']>;
  requiredDocuments?: InputMaybe<Array<TruckDocumentCategoryId>>;
  requiredDocumentsNotes?: InputMaybe<Scalars['String']>;
  salesGuaranteeAmountCents?: InputMaybe<Scalars['Int']>;
  salesPercentageFrom?: InputMaybe<LocationSalesPercentageFrom>;
  salesPercentageIncludesBookingFee?: InputMaybe<Scalars['Boolean']>;
  sequence?: InputMaybe<Scalars['Boolean']>;
  spotDescriptions?: InputMaybe<Array<SpotDescriptionInput>>;
  spots?: InputMaybe<Scalars['Int']>;
  startAt: Scalars['String'];
  truckGroupRules?: InputMaybe<Array<TruckGroupRuleInput>>;
};


export type RootEventUpdateSalesGuaranteeArgs = {
  eventId: Scalars['Int'];
  salesGuarantee: Scalars['Boolean'];
};


export type RootEventsInstantBookConfigCreateArgs = {
  truckId: Scalars['Int'];
};


export type RootEventsInstantBookFinishArgs = {
  truckId: Scalars['Int'];
};


export type RootEventsInstantBookUpdateGeneralArgs = {
  customerEventsEnabled: Scalars['Boolean'];
  managedEventsEnabled: Scalars['Boolean'];
  noteForCustomer?: InputMaybe<Scalars['String']>;
  truckId: Scalars['Int'];
};


export type RootEventsInstantBookUpdateMenuArgs = {
  menuId: Scalars['Int'];
  truckId: Scalars['Int'];
};


export type RootEventsInstantBookUpdatePricingArgs = {
  baseHours: Scalars['Int'];
  baseMinimumHighSeasonPremiumDaysCents: Scalars['Int'];
  baseMinimumHighSeasonRegularDaysCents: Scalars['Int'];
  baseMinimumPremiumDaysCents: Scalars['Int'];
  baseMinimumRegularCents: Scalars['Int'];
  extraHourHighSeasonPremiumDaysCents: Scalars['Int'];
  extraHourHighSeasonRegularDaysCents: Scalars['Int'];
  extraHourPremiumDaysCents: Scalars['Int'];
  extraHourRegularCents: Scalars['Int'];
  highSeasonMonths: Array<Scalars['Int']>;
  premiumDays: Array<Scalars['Int']>;
  truckId: Scalars['Int'];
};


export type RootEventsRequestAddTrucksArgs = {
  eventsRequestId: Scalars['Int'];
  truckIds: Array<Scalars['Int']>;
};


export type RootEventsRequestApproveArgs = {
  eventsRequestId: Scalars['Int'];
};


export type RootEventsRequestCancelArgs = {
  id: Scalars['Int'];
  reason: Scalars['String'];
  refundDeposit?: InputMaybe<Scalars['Boolean']>;
};


export type RootEventsRequestChooseTruckProposalsArgs = {
  eventsRequestId: Scalars['Int'];
  truckIds: Array<Scalars['Int']>;
};


export type RootEventsRequestConfirmDepositArgs = {
  eventsRequestId: Scalars['Int'];
};


export type RootEventsRequestCreateArgs = {
  creationNote?: InputMaybe<Scalars['String']>;
  endAt: Scalars['DateTime'];
  eventType: Scalars['String'];
  foodPreferences?: InputMaybe<Scalars['String']>;
  fullAddress: Scalars['String'];
  organizationId?: InputMaybe<Scalars['Int']>;
  peopleEstimated: Scalars['Int'];
  preferredTruckId?: InputMaybe<Scalars['Int']>;
  spots: Scalars['Int'];
  startAt: Scalars['DateTime'];
  vendingInstructions?: InputMaybe<Scalars['String']>;
};


export type RootEventsRequestCreatePaymentIntentArgs = {
  eventsRequestId: Scalars['Int'];
};


export type RootEventsRequestDeleteArgs = {
  id: Scalars['Int'];
};


export type RootEventsRequestRefundDepositArgs = {
  eventsRequestId: Scalars['Int'];
};


export type RootEventsRequestUpdateTagArgs = {
  id: Scalars['Int'];
  tags: Array<Scalars['String']>;
};


export type RootEventsTruckProposalAcknowledgeArgs = {
  proposalId: Scalars['Int'];
};


export type RootExperientialRequestCreateArgs = {
  values: Scalars['Json'];
};


export type RootExperientialRequestCreateNewArgs = {
  additionalInformation?: InputMaybe<Scalars['String']>;
  companyName?: InputMaybe<Scalars['String']>;
  customerName: Scalars['String'];
  email: Scalars['String'];
  eventAt: Scalars['String'];
  markets: Scalars['String'];
  phone: Scalars['String'];
};


export type RootFacebookMarketPageCreateArgs = {
  marketId: Scalars['Int'];
  pageId: Scalars['String'];
};


export type RootFacebookMarketPageDeleteArgs = {
  facebookMarketPageId: Scalars['Int'];
};


export type RootFacebookMarketPageUpdateArgs = {
  active: Scalars['Boolean'];
  facebookMarketPageId: Scalars['Int'];
};


export type RootFacebookPagePostingCreateArgs = {
  pageId: Scalars['String'];
  truckId: Scalars['Int'];
};


export type RootFacebookPagePostingDeleteArgs = {
  pageId: Scalars['Int'];
};


export type RootFacebookPostingIntegrationDeleteArgs = {
  employeeId: Scalars['Int'];
};


export type RootFoodItemActivateArgs = {
  id: Scalars['Int'];
};


export type RootFoodItemCreateArgs = {
  description?: InputMaybe<Scalars['String']>;
  featured: Scalars['Boolean'];
  hasSpecialInstructions: Scalars['Boolean'];
  image?: InputMaybe<Scalars['Upload']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  itemQuestions?: InputMaybe<Array<ItemQuestionInput>>;
  menuId: Scalars['Int'];
  name: Scalars['String'];
  priceCents?: InputMaybe<Scalars['Int']>;
  tagIds?: InputMaybe<Array<Scalars['String']>>;
  upsellTypeId: Scalars['Int'];
};


export type RootFoodItemRemoveArgs = {
  itemId: Scalars['Int'];
};


export type RootFoodItemUpdateArgs = {
  description?: InputMaybe<Scalars['String']>;
  featured?: InputMaybe<Scalars['Boolean']>;
  hasSpecialInstructions?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['Int'];
  image?: InputMaybe<Scalars['Upload']>;
  imageDelete?: InputMaybe<Scalars['Boolean']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  priceCents?: InputMaybe<Scalars['Int']>;
  tagIds?: InputMaybe<Array<Scalars['String']>>;
  upsellTypeId?: InputMaybe<Scalars['Int']>;
};


export type RootFoodTypeCategoryCreateArgs = {
  defaultMaximumSpots?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  position: Scalars['Int'];
};


export type RootFoodTypeCategoryUpdateArgs = {
  defaultMaximumSpots?: InputMaybe<Scalars['Int']>;
  id: Scalars['Int'];
  name?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['Int']>;
};


export type RootFoodTypeCreateArgs = {
  foodTypeCategoryId: Scalars['Int'];
  name: Scalars['String'];
};


export type RootFoodTypeDestroyArgs = {
  id: Scalars['Int'];
};


export type RootFoodTypePageMarketCloneArgs = {
  id: Scalars['Int'];
  marketId: Scalars['Int'];
};


export type RootFoodTypePageUpdateArgs = {
  active: Scalars['Boolean'];
  aiGenerated?: InputMaybe<Scalars['Boolean']>;
  contentSections: Array<ContentSectionInput>;
  featured: Scalars['Boolean'];
  foodTypeIds: Array<Scalars['Int']>;
  foodTypePageItems: Array<FoodTypePageItemInput>;
  id: Scalars['Int'];
  image?: InputMaybe<Scalars['Upload']>;
  metaDescription: Scalars['String'];
  name: Scalars['String'];
  seoName: Scalars['String'];
  subtitle: Scalars['String'];
  title: Scalars['String'];
};


export type RootFoodTypeUpdateArgs = {
  id: Scalars['Int'];
  name?: InputMaybe<Scalars['String']>;
};


export type RootGlobalConfigUpdateArgs = {
  bonusForReferralCents?: InputMaybe<Scalars['Int']>;
  bookingFeeCents?: InputMaybe<Scalars['Int']>;
  bookingFeePercentage?: InputMaybe<Scalars['Float']>;
  useBookingFeePercentage?: InputMaybe<Scalars['Boolean']>;
};


export type RootHealthPermitCreateArgs = {
  municipalityId: Scalars['Int'];
  number: Scalars['String'];
  truckId: Scalars['Int'];
  truckName: Scalars['String'];
};


export type RootHealthPermitDeleteArgs = {
  id: Scalars['Int'];
};


export type RootHealthPermitUpdateArgs = {
  id: Scalars['Int'];
  municipalityId: Scalars['Int'];
  number: Scalars['String'];
  truckId: Scalars['Int'];
  truckName: Scalars['String'];
};


export type RootInstantBookConfigCreateArgs = {
  truckId: Scalars['Int'];
};


export type RootInstantBookFinishArgs = {
  truckId: Scalars['Int'];
};


export type RootInstantBookUpdateGeneralArgs = {
  cateringMinTotalCents?: InputMaybe<Scalars['Int']>;
  enabled: Scalars['Boolean'];
  maxDistanceMiles?: InputMaybe<Scalars['Float']>;
  otherComments?: InputMaybe<Scalars['String']>;
  primaryUpsellTypeIds?: InputMaybe<Array<Scalars['Int']>>;
  truckId: Scalars['Int'];
};


export type RootInstantBookUpdatePolicyArgs = {
  cancellationPolicyFullDays: Scalars['Int'];
  cancellationPolicyHalfDays: Scalars['Int'];
  truckId: Scalars['Int'];
};


export type RootInstantBookUpdateTiersArgs = {
  tiers: Array<InstantBookTierInput>;
  truckId: Scalars['Int'];
};


export type RootItemAnswerActivateArgs = {
  id: Scalars['Int'];
};


export type RootItemQuestionActivateArgs = {
  id: Scalars['Int'];
};


export type RootItemQuestionCreateArgs = {
  itemAnswers: Array<ItemAnswerInput>;
  itemId: Scalars['Int'];
  maxAnswers?: InputMaybe<Scalars['Int']>;
  questionType: ItemQuestionType;
  required: Scalars['Boolean'];
  text: Scalars['String'];
};


export type RootItemQuestionRemoveArgs = {
  itemId: Scalars['Int'];
  questionId: Scalars['Int'];
};


export type RootItemQuestionUpdateArgs = {
  id: Scalars['Int'];
  itemAnswers: Array<ItemAnswerInput>;
  maxAnswers?: InputMaybe<Scalars['Int']>;
  questionType: ItemQuestionType;
  required: Scalars['Boolean'];
  text: Scalars['String'];
};


export type RootItemQuestionUpdatePositionsArgs = {
  itemId: Scalars['Int'];
  itemQuestionIds: Array<Scalars['Int']>;
};


export type RootLocationAddSalesGuaranteeContractArgs = {
  allowCancellation: Scalars['Boolean'];
  locationId: Scalars['Int'];
  salesGuaranteeAmountCents: Scalars['Int'];
  salesGuaranteeCustomerEmail: Scalars['String'];
  salesGuaranteeCustomerName: Scalars['String'];
  salesGuaranteeWithCancellation?: InputMaybe<Scalars['Boolean']>;
};


export type RootLocationCancelBookingArgs = {
  cancelReason?: InputMaybe<Scalars['String']>;
  locationId: Scalars['Int'];
};


export type RootLocationChangeSpotArgs = {
  locationId: Scalars['Int'];
  spotNumber: Scalars['Int'];
};


export type RootLocationChangeTimeArgs = {
  endAt: Scalars['DateTime'];
  locationId: Scalars['Int'];
  startAt: Scalars['DateTime'];
};


export type RootLocationConfirmSalesArgs = {
  locationId: Scalars['Int'];
};


export type RootLocationCreateCustomArgs = {
  allowOrders: Scalars['Boolean'];
  description?: InputMaybe<Scalars['String']>;
  discoverable?: InputMaybe<Scalars['Boolean']>;
  endAt: Scalars['DateTime'];
  fullAddress?: InputMaybe<Scalars['String']>;
  isRecurring?: InputMaybe<Scalars['Boolean']>;
  lotId?: InputMaybe<Scalars['Int']>;
  lotName?: InputMaybe<Scalars['String']>;
  menuId: Scalars['Int'];
  minOrdersAmountCents?: InputMaybe<Scalars['Int']>;
  occurrenceDays?: InputMaybe<Array<Scalars['Int']>>;
  occurrenceLengthSeconds?: InputMaybe<Scalars['Int']>;
  salesGuaranteeAmountCents?: InputMaybe<Scalars['Int']>;
  salesGuaranteeCustomerEmail?: InputMaybe<Scalars['String']>;
  salesGuaranteeCustomerName?: InputMaybe<Scalars['String']>;
  salesGuaranteeWithCancellation?: InputMaybe<Scalars['Boolean']>;
  startAt: Scalars['DateTime'];
  truckId: Scalars['Int'];
};


export type RootLocationDeferWalkupSalesArgs = {
  locationId: Scalars['Int'];
  walkupSalesDeferralReason: Scalars['String'];
};


export type RootLocationEndEarlyReasonArgs = {
  locationId: Scalars['Int'];
  reason: Scalars['String'];
};


export type RootLocationEndWorkArgs = {
  locationId: Scalars['Int'];
};


export type RootLocationItemAnswerChangeStatusArgs = {
  id: Scalars['Int'];
  status: LocationItemStatus;
};


export type RootLocationItemChangeMaxQuantityArgs = {
  id: Scalars['Int'];
  maxQuantity: Scalars['Int'];
};


export type RootLocationItemChangeStatusArgs = {
  id: Scalars['Int'];
  status: LocationItemStatus;
};


export type RootLocationItemQuestionChangeStatusArgs = {
  id: Scalars['Int'];
  status: LocationItemStatus;
};


export type RootLocationMakeFeeUncollectibleArgs = {
  locationId: Scalars['Int'];
};


export type RootLocationMenuUpdateArgs = {
  locationId: Scalars['Int'];
  menuId: Scalars['Int'];
};


export type RootLocationMinimumIsMetArgs = {
  locationId: Scalars['Int'];
};


export type RootLocationMinimumIsNotMetArgs = {
  locationId: Scalars['Int'];
};


export type RootLocationMoveArgs = {
  eventId: Scalars['Int'];
  locationId: Scalars['Int'];
};


export type RootLocationPauseArgs = {
  locationId: Scalars['Int'];
};


export type RootLocationPaySalesPercentageArgs = {
  locationId: Scalars['Int'];
};


export type RootLocationProlongWorkArgs = {
  locationId: Scalars['Int'];
  minutes: Scalars['Int'];
};


export type RootLocationRefundBookingFeeArgs = {
  locationId: Scalars['Int'];
};


export type RootLocationRefundCancellationFeeArgs = {
  locationId: Scalars['Int'];
};


export type RootLocationRefundSalesPercentageArgs = {
  locationId: Scalars['Int'];
  refundReason: Scalars['String'];
};


export type RootLocationRefundTruckArgs = {
  locationId: Scalars['Int'];
};


export type RootLocationRemoveTruckArgs = {
  bookingCancellationFeeCents?: InputMaybe<Scalars['Int']>;
  cancelReason: Scalars['String'];
  findReplacement?: InputMaybe<Scalars['Boolean']>;
  locationId: Scalars['Int'];
  refundTruck?: InputMaybe<Scalars['Boolean']>;
};


export type RootLocationReplaceTruckArgs = {
  bookingCancellationFeeCents?: InputMaybe<Scalars['Int']>;
  cancelReason: Scalars['String'];
  chargeTruck?: InputMaybe<Scalars['Boolean']>;
  locationId: Scalars['Int'];
  refundTruck?: InputMaybe<Scalars['Boolean']>;
  truckId: Scalars['Int'];
};


export type RootLocationResumeArgs = {
  locationId: Scalars['Int'];
};


export type RootLocationSendSalesGuaranteeContractArgs = {
  locationId: Scalars['Int'];
};


export type RootLocationSetCoordinatesArgs = {
  latitude: Scalars['Float'];
  locationId: Scalars['Int'];
  longitude: Scalars['Float'];
};


export type RootLocationStartArgs = {
  asapOrdersEnabled?: InputMaybe<Scalars['Boolean']>;
  delayedPickupEnabled?: InputMaybe<Scalars['Boolean']>;
  locationId: Scalars['Int'];
  offlineOrdersStepsEnabled?: InputMaybe<Scalars['Boolean']>;
  ordersPerTimeSlot?: InputMaybe<Scalars['Int']>;
  taxRate?: InputMaybe<Scalars['Float']>;
};


export type RootLocationStartPreOrderArgs = {
  asapOrdersEnabled?: InputMaybe<Scalars['Boolean']>;
  delayedPickupEnabled?: InputMaybe<Scalars['Boolean']>;
  locationId: Scalars['Int'];
  offlineOrdersStepsEnabled?: InputMaybe<Scalars['Boolean']>;
  ordersPerTimeSlot?: InputMaybe<Scalars['Int']>;
  taxRate?: InputMaybe<Scalars['Float']>;
};


export type RootLocationSubmitWalkupSalesArgs = {
  locationId: Scalars['Int'];
  walkupCustomersQuantity: Scalars['Int'];
  walkupSalesAmountCents: Scalars['Int'];
};


export type RootLocationTaxRateUpdateArgs = {
  locationId: Scalars['Int'];
  taxRate: Scalars['Float'];
};


export type RootLocationTriggerChargeArgs = {
  locationId: Scalars['Int'];
};


export type RootLocationUpdateBookingFeeArgs = {
  feeCents: Scalars['Int'];
  locationId: Scalars['Int'];
};


export type RootLocationUpdateCancellationTermsArgs = {
  bookingCancellationFeeCents: Scalars['Int'];
  locationId: Scalars['Int'];
  paidCancellationIntervalSeconds: Scalars['Int'];
  refundIntervalSeconds: Scalars['Int'];
};


export type RootLocationUpdateDelayedPickupArgs = {
  delayedPickupEnabled: Scalars['Boolean'];
  locationId: Scalars['Int'];
};


export type RootLocationUpdateOfflineOrdersStepsArgs = {
  locationId: Scalars['Int'];
  offlineOrdersStepsEnabled: Scalars['Boolean'];
};


export type RootLocationUpdateOrdersPerTimeSlotArgs = {
  locationId: Scalars['Int'];
  ordersAmountPerTimeSlotCents?: InputMaybe<Scalars['Int']>;
  ordersPerTimeSlot: Scalars['Int'];
};


export type RootLocationUpdatePhoneArgs = {
  locationId: Scalars['Int'];
  phone: Scalars['String'];
};


export type RootLocationUpdatePickupTimeOptionsArgs = {
  asapOrdersEnabled: Scalars['Boolean'];
  delayedPickupEnabled: Scalars['Boolean'];
  locationId: Scalars['Int'];
};


export type RootLocationUpdateSalesGuaranteeArgs = {
  locationId: Scalars['Int'];
  salesGuarantee: Scalars['Boolean'];
  salesGuaranteeAmountCents: Scalars['Int'];
};


export type RootLocationUpdateSalesPercentageArgs = {
  chargeSalesPercentage: Scalars['Float'];
  chargeSalesPercentageEnabled: Scalars['Boolean'];
  locationId: Scalars['Int'];
  salesPercentageFrom: LocationSalesPercentageFrom;
  salesPercentageIncludesBookingFee: Scalars['Boolean'];
};


export type RootLocationUpdateVisibilityArgs = {
  locationId: Scalars['Int'];
  visible: Scalars['Boolean'];
};


export type RootLotAssignOrganizerArgs = {
  lotId: Scalars['Int'];
  organizerId?: InputMaybe<Scalars['Int']>;
};


export type RootLotBookCustomArgs = {
  allowOrders?: InputMaybe<Scalars['Boolean']>;
  discoverable?: InputMaybe<Scalars['Boolean']>;
  endTime: Scalars['DateTime'];
  lotId: Scalars['Int'];
  menuId: Scalars['Int'];
  minOrdersAmountCents?: InputMaybe<Scalars['Int']>;
  startTime: Scalars['DateTime'];
  truckId: Scalars['Int'];
};


export type RootLotChangeOrganizationArgs = {
  lotId: Scalars['Int'];
  organizationId: Scalars['Int'];
};


export type RootLotCopySubscribersArgs = {
  fromLotId: Scalars['Int'];
  toLotId: Scalars['Int'];
};


export type RootLotCreateArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  allowTrucksToSpecifyTime?: InputMaybe<Scalars['Boolean']>;
  bookingCancellationFeeCents?: InputMaybe<Scalars['Int']>;
  clientEmail?: InputMaybe<Scalars['String']>;
  clientName?: InputMaybe<Scalars['String']>;
  clientPhone?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  facebook?: InputMaybe<Scalars['String']>;
  fullAddress: Scalars['String'];
  image?: InputMaybe<Scalars['Upload']>;
  instagram?: InputMaybe<Scalars['String']>;
  locationDescription: Scalars['String'];
  lotFoodRestrictions?: InputMaybe<Array<LotFoodRestrictionInput>>;
  lotSpotLayoutImage?: InputMaybe<Scalars['Upload']>;
  marketId: Scalars['Int'];
  name: Scalars['String'];
  notificationEmail?: InputMaybe<Scalars['String']>;
  numberedSpots?: InputMaybe<Scalars['Boolean']>;
  organizerId?: InputMaybe<Scalars['Int']>;
  paidCancellationIntervalSeconds?: InputMaybe<Scalars['Int']>;
  permitNumber?: InputMaybe<Scalars['String']>;
  phone: Scalars['String'];
  refundIntervalSeconds?: InputMaybe<Scalars['Int']>;
  sameTruckBookingSeconds?: InputMaybe<Scalars['Int']>;
  sendNextWeekSchedule?: InputMaybe<Scalars['Boolean']>;
  sendOnWeekDay?: InputMaybe<Scalars['Int']>;
  seoName: Scalars['String'];
  showSalesEstimation?: InputMaybe<Scalars['Boolean']>;
  smsTruckInstructions?: InputMaybe<Scalars['String']>;
  snapchat?: InputMaybe<Scalars['String']>;
  spotDescriptions?: InputMaybe<Array<SpotDescriptionInput>>;
  spots: Scalars['Int'];
  tiktok?: InputMaybe<Scalars['String']>;
  truckGroupRules?: InputMaybe<Array<TruckGroupRuleInput>>;
  twitter?: InputMaybe<Scalars['String']>;
  vendingInstructions?: InputMaybe<Scalars['String']>;
  website?: InputMaybe<Scalars['String']>;
  yelp?: InputMaybe<Scalars['String']>;
};


export type RootLotCreateCustomArgs = {
  address: Scalars['String'];
  locationDescription?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};


export type RootLotGroupCreateArgs = {
  description?: InputMaybe<Scalars['String']>;
  flyerImage?: InputMaybe<Scalars['Upload']>;
  fullAddress: Scalars['String'];
  image?: InputMaybe<Scalars['Upload']>;
  lots: Array<LotGroupInput>;
  name: Scalars['String'];
  seoName: Scalars['String'];
};


export type RootLotGroupRemoveArgs = {
  id: Scalars['Int'];
};


export type RootLotGroupUpdateArgs = {
  description?: InputMaybe<Scalars['String']>;
  flyerImage?: InputMaybe<Scalars['Upload']>;
  fullAddress: Scalars['String'];
  id: Scalars['Int'];
  image?: InputMaybe<Scalars['Upload']>;
  lots: Array<LotGroupInput>;
  name: Scalars['String'];
  seoName: Scalars['String'];
};


export type RootLotGroupUpdateNoticeArgs = {
  content?: InputMaybe<HtmlRecordInput>;
  id: Scalars['Int'];
};


export type RootLotInstantBookAddArgs = {
  lotId: Scalars['Int'];
  truckId: Scalars['Int'];
};


export type RootLotInstantBookRemoveArgs = {
  lotId: Scalars['Int'];
  truckId: Scalars['Int'];
};


export type RootLotSendMenuEmailArgs = {
  lotId: Scalars['Int'];
};


export type RootLotShareWithCustomerArgs = {
  customerId: Scalars['Int'];
  lotId: Scalars['Int'];
  shareExistingEvents?: InputMaybe<Scalars['Boolean']>;
};


export type RootLotStopSharingWithCustomerArgs = {
  lotId: Scalars['Int'];
};


export type RootLotSubscribeArgs = {
  channel?: InputMaybe<GenericSubscriptionChannel>;
  lotId: Scalars['Int'];
};


export type RootLotUnsubscribeArgs = {
  channel?: InputMaybe<GenericSubscriptionChannel>;
  lotId: Scalars['Int'];
};


export type RootLotUpdateArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  allowTrucksToSpecifyTime?: InputMaybe<Scalars['Boolean']>;
  bookingCancellationFeeCents?: InputMaybe<Scalars['Int']>;
  clientEmail?: InputMaybe<Scalars['String']>;
  clientName?: InputMaybe<Scalars['String']>;
  clientPhone?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  facebook?: InputMaybe<Scalars['String']>;
  fullAddress: Scalars['String'];
  id: Scalars['Int'];
  image?: InputMaybe<Scalars['Upload']>;
  instagram?: InputMaybe<Scalars['String']>;
  locationDescription: Scalars['String'];
  lotFoodRestrictions?: InputMaybe<Array<LotFoodRestrictionInput>>;
  lotSpotLayoutImage?: InputMaybe<Scalars['Upload']>;
  marketId?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  notificationEmail?: InputMaybe<Scalars['String']>;
  numberedSpots?: InputMaybe<Scalars['Boolean']>;
  paidCancellationIntervalSeconds?: InputMaybe<Scalars['Int']>;
  permitNumber?: InputMaybe<Scalars['String']>;
  phone: Scalars['String'];
  refundIntervalSeconds?: InputMaybe<Scalars['Int']>;
  sameTruckBookingSeconds?: InputMaybe<Scalars['Int']>;
  sendNextWeekSchedule?: InputMaybe<Scalars['Boolean']>;
  sendOnWeekDay?: InputMaybe<Scalars['Int']>;
  seoName: Scalars['String'];
  showSalesEstimation?: InputMaybe<Scalars['Boolean']>;
  smsTruckInstructions?: InputMaybe<Scalars['String']>;
  snapchat?: InputMaybe<Scalars['String']>;
  spotDescriptions?: InputMaybe<Array<SpotDescriptionInput>>;
  spots: Scalars['Int'];
  tiktok?: InputMaybe<Scalars['String']>;
  truckGroupRules?: InputMaybe<Array<TruckGroupRuleInput>>;
  twitter?: InputMaybe<Scalars['String']>;
  vendingInstructions?: InputMaybe<Scalars['String']>;
  website?: InputMaybe<Scalars['String']>;
  yelp?: InputMaybe<Scalars['String']>;
};


export type RootLotUpdateAdminSettingsArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  allowBooking?: InputMaybe<Scalars['Boolean']>;
  allowOrders?: InputMaybe<Scalars['Boolean']>;
  amountConvenienceFeeCents?: InputMaybe<Scalars['Int']>;
  bftSalesPercentageCut?: InputMaybe<Scalars['Float']>;
  bookingFeeCents?: InputMaybe<Scalars['Int']>;
  bookingFeePercentage?: InputMaybe<Scalars['Float']>;
  chargeTruckInSeconds?: InputMaybe<Scalars['Int']>;
  collectRatings?: InputMaybe<Scalars['Boolean']>;
  creditForSubscriptionsCents?: InputMaybe<Scalars['Int']>;
  dailyMenuEmails?: InputMaybe<Scalars['Boolean']>;
  enableAutocover?: InputMaybe<Scalars['Boolean']>;
  enableRestaurantTransactionFee?: InputMaybe<Scalars['Boolean']>;
  featured?: InputMaybe<Scalars['Boolean']>;
  flyerImage?: InputMaybe<Scalars['Upload']>;
  id: Scalars['Int'];
  latitude?: InputMaybe<Scalars['Float']>;
  longitude?: InputMaybe<Scalars['Float']>;
  manuallyGeocoded?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  overwriteBookingFee?: InputMaybe<Scalars['Boolean']>;
  partnershipIds?: InputMaybe<Array<Scalars['Int']>>;
  privateProperty?: InputMaybe<Scalars['Boolean']>;
  referralEnabled?: InputMaybe<Scalars['Boolean']>;
  restaurantTransactionFeeOnOffline?: InputMaybe<Scalars['Boolean']>;
  restaurantTransactionFeePercentage?: InputMaybe<Scalars['Float']>;
  seoName?: InputMaybe<Scalars['String']>;
  shiftNotificationTimeType?: InputMaybe<ShiftNotificationTime>;
  showFullSchedule?: InputMaybe<Scalars['Boolean']>;
  showSalesEstimation?: InputMaybe<Scalars['Boolean']>;
  smsTruckInstructions?: InputMaybe<Scalars['String']>;
  taxRate?: InputMaybe<Scalars['Float']>;
  tipsEnabled?: InputMaybe<Scalars['Boolean']>;
  truckChargeDelayEnabled?: InputMaybe<Scalars['Boolean']>;
  useBookingFeePercentage?: InputMaybe<Scalars['Boolean']>;
};


export type RootLotUpdateDescriptionArgs = {
  content?: InputMaybe<HtmlRecordInput>;
  id: Scalars['Int'];
};


export type RootLotUpdateNoticeArgs = {
  content?: InputMaybe<HtmlRecordInput>;
  id: Scalars['Int'];
};


export type RootMarketCreateArgs = {
  attributes: MarketInput;
};


export type RootMarketUpdateArgs = {
  attributes: MarketInput;
  id: Scalars['Int'];
};


export type RootMarketUpdateTopTrucksArgs = {
  id: Scalars['Int'];
  trucks: Array<TopTruckInput>;
};


export type RootMarketplaceClickCreateArgs = {
  linkName: Scalars['String'];
};


export type RootMenuActivateArgs = {
  id: Scalars['Int'];
};


export type RootMenuCopyArgs = {
  fromMenuId: Scalars['Int'];
  toMenuId: Scalars['Int'];
};


export type RootMenuCreateArgs = {
  catering?: InputMaybe<Scalars['Boolean']>;
  foodTypeIds: Array<Scalars['Int']>;
  manualOrder?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  restaurantId: Scalars['Int'];
  taxIncluded?: InputMaybe<Scalars['Boolean']>;
  truckIds: Array<Scalars['Int']>;
};


export type RootMenuItemsCopyArgs = {
  itemIds: Array<Scalars['Int']>;
  menuId: Scalars['Int'];
};


export type RootMenuRemoveArgs = {
  menuId: Scalars['Int'];
};


export type RootMenuUpdateArgs = {
  foodTypeIds?: InputMaybe<Array<Scalars['Int']>>;
  id: Scalars['Int'];
  manualOrder?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  public?: InputMaybe<Scalars['Boolean']>;
  taxIncluded?: InputMaybe<Scalars['Boolean']>;
  truckIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type RootMenuUpdatePositionsArgs = {
  id: Scalars['Int'];
  itemIds: Array<Scalars['Int']>;
};


export type RootMetabaseMakePublicLinkArgs = {
  id: Scalars['Int'];
  params: Scalars['Json'];
  type: Scalars['String'];
};


export type RootNoteAddArgs = {
  content: Scalars['String'];
  entityType: CommentableEntity;
  id: Scalars['Int'];
};


export type RootOfflineOrderCardConfirmArgs = {
  amountTipCents: Scalars['Int'];
  existingPaymentIntent?: InputMaybe<Scalars['Boolean']>;
  orderId: Scalars['Int'];
  paymentIntentId?: InputMaybe<Scalars['String']>;
  signature?: InputMaybe<Scalars['Upload']>;
  signatureBase64?: InputMaybe<Scalars['String']>;
};


export type RootOfflineOrderCashConfirmArgs = {
  orderId: Scalars['Int'];
};


export type RootOfflineOrderCompletedArgs = {
  id: Scalars['Int'];
};


export type RootOfflineOrderCreateArgs = {
  order: OfflineOrderPriceInput;
};


export type RootOfflineOrderDiscardArgs = {
  orderId: Scalars['Int'];
};


export type RootOfflineOrderReadyArgs = {
  id: Scalars['Int'];
};


export type RootOfflineOrderRefundArgs = {
  amountItemsCents: Scalars['Int'];
  amountTipCents: Scalars['Int'];
  orderId: Scalars['Int'];
  reason: Scalars['String'];
};


export type RootOfflineOrderSendReceiptArgs = {
  email?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  orderId: Scalars['Int'];
  phone?: InputMaybe<Scalars['String']>;
  subscribeViaEmail?: InputMaybe<Scalars['Boolean']>;
  subscribeViaPhone?: InputMaybe<Scalars['Boolean']>;
};


export type RootOrderAbandonArgs = {
  orderId: Scalars['Int'];
};


export type RootOrderAssignArgs = {
  orderId: Scalars['Int'];
};


export type RootOrderCancelArgs = {
  orderId: Scalars['Int'];
  reason: Scalars['String'];
};


export type RootOrderChangePickupTimeArgs = {
  delayedPickupAt?: InputMaybe<Scalars['DateTime']>;
  orderId: Scalars['Int'];
};


export type RootOrderCompleteArgs = {
  orderId: Scalars['Int'];
};


export type RootOrderConfirmArgs = {
  delayedPickup?: InputMaybe<Scalars['Boolean']>;
  estimatedCompletionMinutes?: InputMaybe<Scalars['Int']>;
  orderId: Scalars['Int'];
};


export type RootOrderPartialRefundApproveArgs = {
  id: Scalars['Int'];
};


export type RootOrderPartialRefundCreateArgs = {
  orderId: Scalars['Int'];
  refund: OrderPartialRefundInput;
};


export type RootOrderPartialRefundRejectArgs = {
  id: Scalars['Int'];
  reason: Scalars['String'];
};


export type RootOrderRatingRateArgs = {
  id: Scalars['Int'];
  reason?: InputMaybe<Scalars['String']>;
  stars: Scalars['Int'];
};


export type RootOrderRatingViewedArgs = {
  id: Scalars['Int'];
};


export type RootOrderReadyArgs = {
  orderId: Scalars['Int'];
};


export type RootOrderRefundCustomerArgs = {
  orderId: Scalars['Int'];
  reason: Scalars['String'];
};


export type RootOrderReverseTruckPaymentArgs = {
  orderId: Scalars['Int'];
  reason: Scalars['String'];
};


export type RootOrderUnassignArgs = {
  orderId: Scalars['Int'];
};


export type RootOrganizationBankAccountCreateArgs = {
  token: Scalars['String'];
};


export type RootOrganizationBankAccountDestroyArgs = {
  bankAccountId: Scalars['Int'];
};


export type RootOrganizationBankAccountMakeCurrentArgs = {
  bankAccountId: Scalars['Int'];
};


export type RootOrganizationBookingRestrictionUpdateArgs = {
  bookingDelaySeconds: Scalars['Int'];
};


export type RootOrganizationCreateArgs = {
  attributes: OrganizationInput;
};


export type RootOrganizationDebitCardCreateArgs = {
  token: Scalars['String'];
};


export type RootOrganizationDebitCardDestroyArgs = {
  cardId: Scalars['Int'];
};


export type RootOrganizationDebitCardMakeCurrentArgs = {
  cardId: Scalars['Int'];
};


export type RootOrganizationEditStripeAccountArgs = {
  editMode: Scalars['Boolean'];
  failureUrl: Scalars['String'];
  organizationId: Scalars['Int'];
  successUrl: Scalars['String'];
};


export type RootOrganizationUpdateArgs = {
  attributes: OrganizationInput;
  id: Scalars['Int'];
};


export type RootOrganizationUpdateCateringArgs = {
  cateringEmailCustomer?: InputMaybe<Scalars['String']>;
  cateringEmailName: Scalars['String'];
  cateringEmailNotifications?: InputMaybe<Scalars['String']>;
  cateringEmailTruck?: InputMaybe<Scalars['String']>;
  cateringEmailWebsite?: InputMaybe<Scalars['String']>;
  cateringPhone?: InputMaybe<Scalars['String']>;
  enabledEmails?: InputMaybe<Array<Scalars['String']>>;
  id: Scalars['Int'];
};


export type RootOrganizerCreateArgs = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  organizationId: Scalars['Int'];
  password: Scalars['String'];
  phone: Scalars['String'];
  roles?: InputMaybe<Array<OrganizerRole>>;
};


export type RootOrganizerForgotPasswordArgs = {
  email: Scalars['String'];
};


export type RootOrganizerLoginArgs = {
  email: Scalars['String'];
  password: Scalars['String'];
};


export type RootOrganizerLotSubscriptionCreateArgs = {
  channel?: InputMaybe<GenericSubscriptionChannel>;
  entityId: Scalars['Int'];
  organizerId: Scalars['Int'];
};


export type RootOrganizerLotSubscriptionRemoveArgs = {
  channel?: InputMaybe<GenericSubscriptionChannel>;
  entityId: Scalars['Int'];
  organizerId: Scalars['Int'];
};


export type RootOrganizerNotifyTrucksArgs = {
  body: Scalars['String'];
  lotId: Scalars['Int'];
  subject: Scalars['String'];
  truckIds: Array<Scalars['Int']>;
};


export type RootOrganizerResetPasswordArgs = {
  password: Scalars['String'];
  token: Scalars['String'];
};


export type RootOrganizerUpdateArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  lastName?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  roles?: InputMaybe<Array<OrganizerRole>>;
};


export type RootPreferredVendorChangeArgs = {
  id: Scalars['Int'];
  preferredVendor: Scalars['Boolean'];
};


export type RootReplyTemplateCreateArgs = {
  active: Scalars['Boolean'];
  channels: Array<ReplyTemplateEntity>;
  name: Scalars['String'];
  receivers: Array<ReplyTemplateReceiver>;
  subject?: InputMaybe<Scalars['String']>;
  text: Scalars['String'];
  topics: Array<ReplyTemplateTopic>;
};


export type RootReplyTemplateUpdateArgs = {
  active: Scalars['Boolean'];
  channels: Array<ReplyTemplateEntity>;
  id: Scalars['Int'];
  name: Scalars['String'];
  receivers: Array<ReplyTemplateReceiver>;
  subject?: InputMaybe<Scalars['String']>;
  text: Scalars['String'];
  topics: Array<ReplyTemplateTopic>;
};


export type RootRestaurantAcceptTermsArgs = {
  restaurantId: Scalars['Int'];
};


export type RootRestaurantAddBankAccountArgs = {
  restaurantId: Scalars['Int'];
  token: Scalars['String'];
};


export type RootRestaurantAddPaymentCardArgs = {
  restaurantId: Scalars['Int'];
  token: Scalars['String'];
};


export type RootRestaurantAddPayoutCardArgs = {
  restaurantId: Scalars['Int'];
  token: Scalars['String'];
};


export type RootRestaurantBanArgs = {
  id: Scalars['Int'];
  reason: Scalars['String'];
};


export type RootRestaurantBankAccountMakeCurrentArgs = {
  accountId: Scalars['Int'];
};


export type RootRestaurantBankAccountRemoveArgs = {
  accountId: Scalars['Int'];
};


export type RootRestaurantChangeCreditsArgs = {
  amountCents: Scalars['Int'];
  description: Scalars['String'];
  restaurantId: Scalars['Int'];
};


export type RootRestaurantChangeInstantPayoutsArgs = {
  enable: Scalars['Boolean'];
  restaurantId: Scalars['Int'];
};


export type RootRestaurantClaimArgs = {
  code: Scalars['String'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  password: Scalars['String'];
  passwordConfirmation: Scalars['String'];
  phone: Scalars['String'];
};


export type RootRestaurantClaimV2Args = {
  code: Scalars['String'];
  emailToken: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  password: Scalars['String'];
  phoneToken: Scalars['String'];
};


export type RootRestaurantCompleteBankAccountSetupArgs = {
  restaurantId: Scalars['Int'];
  setupIntentId: Scalars['String'];
};


export type RootRestaurantConvertToFullArgs = {
  restaurantId: Scalars['Int'];
};


export type RootRestaurantCreateArgs = {
  email: Scalars['String'];
  facebook?: InputMaybe<Scalars['String']>;
  foodTypeIds: Array<Scalars['Int']>;
  fullAddress: Scalars['String'];
  image?: InputMaybe<Scalars['Upload']>;
  instagram?: InputMaybe<Scalars['String']>;
  licensePlate?: InputMaybe<Scalars['String']>;
  phone: Scalars['String'];
  truckName: Scalars['String'];
  twitter?: InputMaybe<Scalars['String']>;
  website?: InputMaybe<Scalars['String']>;
};


export type RootRestaurantCreateBankAccountSetupIntentArgs = {
  restaurantId: Scalars['Int'];
};


export type RootRestaurantCreateStripeSessionArgs = {
  restaurantId: Scalars['Int'];
};


export type RootRestaurantCreditCardMakeCurrentArgs = {
  cardId: Scalars['Int'];
};


export type RootRestaurantCreditCardRemoveArgs = {
  cardId: Scalars['Int'];
};


export type RootRestaurantDebitCardMakeCurrentArgs = {
  cardId: Scalars['Int'];
};


export type RootRestaurantDebitCardRemoveArgs = {
  cardId: Scalars['Int'];
};


export type RootRestaurantDisasterReliefArgs = {
  disasterRelief: Scalars['Boolean'];
  restaurantId: Scalars['Int'];
};


export type RootRestaurantEditStripeAccountArgs = {
  editMode?: InputMaybe<Scalars['Boolean']>;
  failureUrl: Scalars['String'];
  restaurantId: Scalars['Int'];
  successUrl: Scalars['String'];
};


export type RootRestaurantEnableInstantBookArgs = {
  id: Scalars['Int'];
};


export type RootRestaurantMarkUnclaimedArgs = {
  id: Scalars['Int'];
};


export type RootRestaurantReactivateEmailArgs = {
  email: Scalars['String'];
  restaurantId: Scalars['Int'];
};


export type RootRestaurantSignUpArgs = {
  companyLogo?: InputMaybe<Scalars['Upload']>;
  currentMenuPicture?: InputMaybe<Scalars['Upload']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  foodTypeId: Scalars['Int'];
  fullAccount?: InputMaybe<Scalars['Boolean']>;
  fullAddress?: InputMaybe<Scalars['String']>;
  lastName: Scalars['String'];
  licensePlate: Scalars['String'];
  marketId?: InputMaybe<Scalars['Int']>;
  menuChanges?: InputMaybe<Scalars['String']>;
  missingFromMenu?: InputMaybe<Scalars['String']>;
  password: Scalars['String'];
  passwordConfirmation: Scalars['String'];
  phoneToken: Scalars['String'];
  restaurantName: Scalars['String'];
  truckLogo?: InputMaybe<Scalars['Upload']>;
  truckName: Scalars['String'];
};


export type RootRestaurantSignUp2Args = {
  emailToken: Scalars['String'];
  firstName: Scalars['String'];
  foodTypeIds: Array<Scalars['Int']>;
  fullAddress: Scalars['String'];
  lastName: Scalars['String'];
  maxDistanceMiles: Scalars['Int'];
  password: Scalars['String'];
  phoneToken: Scalars['String'];
  signupPath?: InputMaybe<Scalars['String']>;
  truckName: Scalars['String'];
};


export type RootRestaurantSyncWithStripeArgs = {
  restaurantId: Scalars['Int'];
};


export type RootRestaurantUpdateArgs = {
  attributes: RestaurantInput;
  id: Scalars['Int'];
};


export type RootRestaurantUpdateProfileArgs = {
  logo?: InputMaybe<Scalars['Upload']>;
  name?: InputMaybe<Scalars['String']>;
  restaurantId: Scalars['Int'];
};


export type RootRestaurantUpdateSignupMenuArgs = {
  file: Scalars['Upload'];
  restaurantId: Scalars['Int'];
};


export type RootReviewDetectTruckProblemsArgs = {
  truckId: Scalars['Int'];
};


export type RootReviewGenerateSuggestionForProblemArgs = {
  truckId: Scalars['Int'];
  truckProblemId: Scalars['Int'];
};


export type RootReviewGenerateSuggestionForProblemsArgs = {
  truckId: Scalars['Int'];
  truckProblemIds: Array<Scalars['Int']>;
};


export type RootReviewSuggestionAcceptArgs = {
  id: Scalars['Int'];
};


export type RootReviewSuggestionNewArgs = {
  attachment?: InputMaybe<Scalars['Upload']>;
  entityId?: InputMaybe<Scalars['Int']>;
  entityType?: InputMaybe<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  suggestionAction?: InputMaybe<ReviewSuggestionAction>;
  suggestionRequestId?: InputMaybe<Scalars['Int']>;
  truckId: Scalars['Int'];
  userPrompt?: InputMaybe<Scalars['String']>;
};


export type RootReviewSuggestionRejectArgs = {
  id: Scalars['Int'];
};


export type RootReviewSuggestionRevertArgs = {
  id: Scalars['Int'];
};


export type RootReviewTruckInstructionsArgs = {
  truckId: Scalars['Int'];
};


export type RootReviewTruckProblemDismissArgs = {
  comment?: InputMaybe<Scalars['String']>;
  problemId: Scalars['Int'];
};


export type RootSqlReportCreateArgs = {
  previewRowCount?: InputMaybe<Scalars['Int']>;
  sql: Scalars['String'];
};


export type RootStripeManualTransferCancelArgs = {
  id: Scalars['Int'];
};


export type RootStripeManualTransferConfirmArgs = {
  id: Scalars['Int'];
};


export type RootStripeManualTransferCreateArgs = {
  amountCents: Scalars['Int'];
  category: Scalars['String'];
  description: Scalars['String'];
  entityId?: InputMaybe<Scalars['Int']>;
  entityType?: InputMaybe<StripeManualTransferEntity>;
  restaurantId: Scalars['Int'];
  subcategory: Scalars['String'];
};


export type RootSupportEmailSendArgs = {
  attachments?: InputMaybe<Array<Scalars['Upload']>>;
  body?: InputMaybe<Scalars['String']>;
  bodyHtml?: InputMaybe<Scalars['String']>;
  cc?: InputMaybe<Scalars['String']>;
  emailThreadId: Scalars['Int'];
  subject: Scalars['String'];
  to: Scalars['String'];
};


export type RootTerminalCreateLocationArgs = {
  locationId: Scalars['Int'];
};


export type RootTestPushNotificationArgs = {
  content?: InputMaybe<Scalars['String']>;
  data?: InputMaybe<Scalars['Json']>;
  email: Scalars['String'];
  title: Scalars['String'];
};


export type RootTextConversationMarkReadArgs = {
  cateringRequestId?: InputMaybe<Scalars['Int']>;
  customRequestCode?: InputMaybe<Scalars['String']>;
  eventId?: InputMaybe<Scalars['Int']>;
  eventsRequestId?: InputMaybe<Scalars['Int']>;
  lotId?: InputMaybe<Scalars['Int']>;
  restaurantId?: InputMaybe<Scalars['Int']>;
  textConversationId: Scalars['Int'];
  truckId?: InputMaybe<Scalars['Int']>;
};


export type RootTextConversationSendMessageArgs = {
  cateringRequestId?: InputMaybe<Scalars['Int']>;
  customRequestCode?: InputMaybe<Scalars['String']>;
  eventId?: InputMaybe<Scalars['Int']>;
  eventsRequestId?: InputMaybe<Scalars['Int']>;
  lotId?: InputMaybe<Scalars['Int']>;
  restaurantId?: InputMaybe<Scalars['Int']>;
  text: Scalars['String'];
  textConversationId: Scalars['Int'];
  truckId?: InputMaybe<Scalars['Int']>;
};


export type RootTruckCateringRatingUpdateArgs = {
  feedback: Scalars['String'];
  id: Scalars['Int'];
  published: Scalars['Boolean'];
  stars: Scalars['Int'];
};


export type RootTruckChatCreateArgs = {
  entityId: Scalars['Int'];
  entityType: TruckChatEntity;
};


export type RootTruckChatMarkUnreadArgs = {
  truckChatId: Scalars['Int'];
};


export type RootTruckChatMessageCreateArgs = {
  body: Scalars['String'];
  truckChatId: Scalars['Int'];
};


export type RootTruckChatMessageUpdateFlaggedArgs = {
  flagged: Scalars['Boolean'];
  truckChatMessageId: Scalars['Int'];
};


export type RootTruckChatReadArgs = {
  truckChatId: Scalars['Int'];
};


export type RootTruckCreateArgs = {
  cateringDropOffMinPerPersonCents?: InputMaybe<Scalars['Int']>;
  cateringDropOffMinTotalCents?: InputMaybe<Scalars['Int']>;
  cateringMinPerPersonCents?: InputMaybe<Scalars['Int']>;
  cateringMinTotalCents?: InputMaybe<Scalars['Int']>;
  defaultCateringMenuId?: InputMaybe<Scalars['Int']>;
  defaultEventMenuId?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<HtmlRecordInput>;
  dropOff?: InputMaybe<Scalars['Boolean']>;
  facebook?: InputMaybe<Scalars['String']>;
  fullAddress?: InputMaybe<Scalars['String']>;
  heightIn?: InputMaybe<Scalars['Int']>;
  image?: InputMaybe<Scalars['Upload']>;
  instagram?: InputMaybe<Scalars['String']>;
  lengthIn?: InputMaybe<Scalars['Int']>;
  licensePlate?: InputMaybe<Scalars['String']>;
  marketId?: InputMaybe<Scalars['Int']>;
  maxDistanceMiles?: InputMaybe<Scalars['Float']>;
  menuIds?: InputMaybe<Array<Scalars['Int']>>;
  name: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
  phoneToken?: InputMaybe<Scalars['String']>;
  primaryUpsellTypeIds: Array<Scalars['Int']>;
  restaurantId: Scalars['Int'];
  seoName?: InputMaybe<Scalars['String']>;
  tiktok?: InputMaybe<Scalars['String']>;
  tipsEnabled?: InputMaybe<Scalars['Boolean']>;
  twitter?: InputMaybe<Scalars['String']>;
  vehicleType?: InputMaybe<TruckVehicleType>;
  website?: InputMaybe<Scalars['String']>;
  widthIn?: InputMaybe<Scalars['Int']>;
};


export type RootTruckCreateUserFeedbackArgs = {
  lotId: Scalars['Int'];
  text: Scalars['String'];
  truckId: Scalars['Int'];
};


export type RootTruckCreateWalkupRatingArgs = {
  feedback?: InputMaybe<Scalars['String']>;
  idempotencyKey: Scalars['String'];
  locationId: Scalars['Int'];
  stars: Scalars['Int'];
};


export type RootTruckDeleteArgs = {
  truckId: Scalars['Int'];
};


export type RootTruckDocumentArchiveArgs = {
  id: Scalars['Int'];
};


export type RootTruckDocumentCreateArgs = {
  attachments?: InputMaybe<Array<Scalars['Upload']>>;
  categoryId: TruckDocumentCategoryId;
  entityId?: InputMaybe<Scalars['Int']>;
  entityType?: InputMaybe<TruckDocumentEntityType>;
  expiresAt?: InputMaybe<Scalars['DateTime']>;
  name?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<Scalars['String']>;
  truckId: Scalars['Int'];
  visibility?: InputMaybe<TruckDocumentVisibility>;
};


export type RootTruckDocumentDeleteAttachmentArgs = {
  attachmentId: Scalars['Int'];
  id: Scalars['Int'];
};


export type RootTruckDocumentReplaceArgs = {
  attachments?: InputMaybe<Array<Scalars['Upload']>>;
  entityId?: InputMaybe<Scalars['Int']>;
  entityType?: InputMaybe<TruckDocumentEntityType>;
  expiresAt?: InputMaybe<Scalars['DateTime']>;
  name?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<Scalars['String']>;
  truckDocumentId: Scalars['Int'];
  visibility?: InputMaybe<TruckDocumentVisibility>;
};


export type RootTruckDocumentUpdateArgs = {
  attachments?: InputMaybe<Array<Scalars['Upload']>>;
  expiresAt?: InputMaybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  region?: InputMaybe<Scalars['String']>;
};


export type RootTruckDocumentUpdateVisibilityArgs = {
  id: Scalars['Int'];
  visibility: TruckDocumentVisibility;
};


export type RootTruckDocumentsRequestArgs = {
  entityId?: InputMaybe<Scalars['Int']>;
  entityType?: InputMaybe<TruckDocumentEntityType>;
  requiredDocuments: Array<TruckDocumentCategoryId>;
  requiredDocumentsNotes?: InputMaybe<Scalars['String']>;
  truckId: Scalars['Int'];
};


export type RootTruckGroupCreateArgs = {
  name?: InputMaybe<Scalars['String']>;
  oneTime?: InputMaybe<Scalars['Boolean']>;
  organizationId: Scalars['Int'];
  truckIds: Array<Scalars['Int']>;
};


export type RootTruckGroupDestroyArgs = {
  truckGroupId: Scalars['Int'];
};


export type RootTruckGroupUpdateArgs = {
  name: Scalars['String'];
  truckGroupId: Scalars['Int'];
  truckIds: Array<Scalars['Int']>;
};


export type RootTruckPhoneVerifyArgs = {
  code: Scalars['String'];
  phone: Scalars['String'];
};


export type RootTruckPrinterCreateArgs = {
  emulation?: InputMaybe<Scalars['String']>;
  identifier: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  platform: Scalars['String'];
  portName?: InputMaybe<Scalars['String']>;
  printerSeries?: InputMaybe<Scalars['String']>;
  printerType: Scalars['String'];
};


export type RootTruckRateEntityArgs = {
  feedback: Scalars['String'];
  orderAgain: Scalars['Boolean'];
  stars: Scalars['Int'];
  token: Scalars['String'];
  truckId: Scalars['Int'];
};


export type RootTruckReviewApproveArgs = {
  reviewerComment?: InputMaybe<Scalars['String']>;
  truckId: Scalars['Int'];
};


export type RootTruckReviewRejectArgs = {
  reviewerComment?: InputMaybe<Scalars['String']>;
  truckId: Scalars['Int'];
};


export type RootTruckReviewRequestArgs = {
  truckId: Scalars['Int'];
};


export type RootTruckSetActiveArgs = {
  truckId: Scalars['Int'];
};


export type RootTruckUpdateArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  cateringDropOffMinPerPersonCents?: InputMaybe<Scalars['Int']>;
  cateringDropOffMinTotalCents?: InputMaybe<Scalars['Int']>;
  cateringMinPerPersonCents?: InputMaybe<Scalars['Int']>;
  cateringMinTotalCents?: InputMaybe<Scalars['Int']>;
  defaultItemImage?: InputMaybe<Scalars['Upload']>;
  defaultItemImageDelete?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<HtmlRecordInput>;
  dropOff?: InputMaybe<Scalars['Boolean']>;
  facebook?: InputMaybe<Scalars['String']>;
  fullAddress?: InputMaybe<Scalars['String']>;
  heightIn?: InputMaybe<Scalars['Int']>;
  image?: InputMaybe<Scalars['Upload']>;
  imageDelete?: InputMaybe<Scalars['Boolean']>;
  instagram?: InputMaybe<Scalars['String']>;
  lengthIn?: InputMaybe<Scalars['Int']>;
  licensePlate?: InputMaybe<Scalars['String']>;
  marketId?: InputMaybe<Scalars['Int']>;
  maxDistanceMiles?: InputMaybe<Scalars['Float']>;
  menuIds?: InputMaybe<Array<Scalars['Int']>>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  phoneToken?: InputMaybe<Scalars['String']>;
  primaryUpsellTypeIds?: InputMaybe<Array<Scalars['Int']>>;
  redirectToTruckId?: InputMaybe<Scalars['Int']>;
  seoName?: InputMaybe<Scalars['String']>;
  showAsArchived?: InputMaybe<Scalars['Boolean']>;
  tiktok?: InputMaybe<Scalars['String']>;
  tipsEnabled?: InputMaybe<Scalars['Boolean']>;
  truckId: Scalars['Int'];
  twitter?: InputMaybe<Scalars['String']>;
  vehicleType?: InputMaybe<TruckVehicleType>;
  website?: InputMaybe<Scalars['String']>;
  widthIn?: InputMaybe<Scalars['Int']>;
};


export type RootTruckUpdateAddressArgs = {
  fullAddress: Scalars['String'];
  truckId: Scalars['Int'];
};


export type RootTruckUpdateAutoAdvanceArgs = {
  autoAdvanceOrders: Scalars['Boolean'];
  truckId: Scalars['Int'];
};


export type RootTruckUpdateAvailabilityArgs = {
  availability: Array<TruckAvailabilityInput>;
  maxDistanceMiles?: InputMaybe<Scalars['Float']>;
  maxServiceHours: Scalars['Int'];
  truckId: Scalars['Int'];
};


export type RootTruckUpdateDefaultCateringMenuArgs = {
  menuId: Scalars['Int'];
  public?: InputMaybe<Scalars['Boolean']>;
  truckId: Scalars['Int'];
};


export type RootTruckUpdateDefaultEventMenuArgs = {
  menuId: Scalars['Int'];
  truckId: Scalars['Int'];
};


export type RootTruckUpdateDescriptionArgs = {
  content?: InputMaybe<HtmlRecordInput>;
  id: Scalars['Int'];
};


export type RootTruckUpdateEmailNotificationsArgs = {
  email?: InputMaybe<Scalars['String']>;
  emailToken?: InputMaybe<Scalars['String']>;
  secureToken?: InputMaybe<Scalars['String']>;
  truckId: Scalars['Int'];
  unsubscribedFromAll?: InputMaybe<Scalars['Boolean']>;
  unsubscribedTopics?: InputMaybe<Array<TruckEmailChannelTopicName>>;
};


export type RootTruckUpdateMarketArgs = {
  marketId: Scalars['Int'];
  truckId: Scalars['Int'];
};


export type RootTruckUpdateMenusArgs = {
  menuIds: Array<Scalars['Int']>;
  truckId: Scalars['Int'];
};


export type RootTruckUpdatePhoneNotificationsArgs = {
  phone?: InputMaybe<Scalars['String']>;
  phoneToken?: InputMaybe<Scalars['String']>;
  truckId: Scalars['Int'];
  unsubscribedFromAll?: InputMaybe<Scalars['Boolean']>;
  unsubscribedTopics?: InputMaybe<Array<TruckPhoneChannelTopicName>>;
};


export type RootTruckUpdateTipsArgs = {
  tipsEnabled: Scalars['Boolean'];
  truckId: Scalars['Int'];
};


export type RootTwentyMileSignUpArgs = {
  image?: InputMaybe<Scalars['Upload']>;
};


export type RootTwitterConnectionDeleteArgs = {
  employeeId: Scalars['Int'];
};


export type RootTwitterPostingIntegrationCreateArgs = {
  truckId: Scalars['Int'];
};


export type RootTwitterPostingIntegrationDeleteArgs = {
  truckId: Scalars['Int'];
};


export type RootTwoFaEmailVerifySessionArgs = {
  code: Scalars['String'];
};


export type RootUploadedAssetCreateArgs = {
  file: Scalars['Upload'];
  name: Scalars['String'];
};


export type RootUploadedAssetRemoveArgs = {
  id: Scalars['Int'];
};


export type RootUpsellTypeCreateArgs = {
  cateringName: Scalars['String'];
  minCateringBudgetCents?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  position?: InputMaybe<Scalars['Int']>;
  singlePerCart?: InputMaybe<Scalars['Boolean']>;
};


export type RootUpsellTypeUpdateArgs = {
  cateringName?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  minCateringBudgetCents?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['Int']>;
  singlePerCart?: InputMaybe<Scalars['Boolean']>;
};


export type RootUserChangePasswordArgs = {
  currentPassword: Scalars['String'];
  newPassword: Scalars['String'];
};


export type RootUserNotificationsDeleteArgs = {
  id: Scalars['Int'];
};


export type RootUserReadNotificationArgs = {
  id: Scalars['Int'];
};


export type RootVerificationCodeSendArgs = {
  phone: Scalars['String'];
  verify?: InputMaybe<Scalars['Boolean']>;
};


export type RootVerificationCodeVerifyArgs = {
  code: Scalars['String'];
  phone: Scalars['String'];
};


export type RootWebPushSubscribeArgs = {
  authKey: Scalars['String'];
  endpoint: Scalars['String'];
  p256dhKey: Scalars['String'];
};


export type RootWebPushUnsubscribeArgs = {
  subscriptionId: Scalars['Int'];
};

export enum SalesGuaranteeClientCompanyPaymentStatus {
  ClientCompanyNotPaid = 'client_company_not_paid',
  ClientCompanyPaid = 'client_company_paid',
  ClientCompanyRefunded = 'client_company_refunded'
}

export type SalesGuaranteeInvoice = {
  __typename?: 'SalesGuaranteeInvoice';
  amountClientCompany: Money;
  amountNetSales: Money;
  clientCompanyPaymentStatus: SalesGuaranteeClientCompanyPaymentStatus;
  clientCompanyPaymentStatusHuman: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['Int'];
  location?: Maybe<Location>;
  stripeInvoicePdfUrl?: Maybe<Scalars['String']>;
  stripeNumber?: Maybe<Scalars['String']>;
  stripePaymentUrl?: Maybe<Scalars['String']>;
  stripeReferences?: Maybe<Array<StripeReference>>;
};

export type SalesGuaranteeInvoiceCollection = Collection & {
  __typename?: 'SalesGuaranteeInvoiceCollection';
  /** Limit */
  limit?: Maybe<Scalars['Int']>;
  /** Offset */
  offset?: Maybe<Scalars['Int']>;
  /** List of records */
  records: Array<SalesGuaranteeInvoice>;
  /** Total */
  total: Scalars['Int'];
};


export type SalesGuaranteeInvoiceCollectionTotalArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};

export type SalesGuaranteeInvoiceSortInput = {
  /** ASC / DESC */
  direction: SortDirection;
  /** Field to sort by */
  field: SalesGuaranteeInvoiceSortInputFields;
};

export enum SalesGuaranteeInvoiceSortInputFields {
  CreatedAt = 'created_at'
}

export type SalesPrediction = {
  __typename?: 'SalesPrediction';
  description: Scalars['String'];
  /** Predicted sales rounded to the nearest $10 */
  exactPrediction: Scalars['String'];
  id: Scalars['Int'];
  show: Scalars['Boolean'];
};

export enum ShiftNotificationTime {
  ShiftNotificationTimeAllTrucks = 'shift_notification_time_all_trucks',
  ShiftNotificationTimeFirstTruck = 'shift_notification_time_first_truck',
  ShiftNotificationTimePrior = 'shift_notification_time_prior'
}

export type SignupMenu = {
  __typename?: 'SignupMenu';
  file: SignupMenuFile;
  id: Scalars['Int'];
};

export type SignupMenuFile = {
  __typename?: 'SignupMenuFile';
  original?: Maybe<Scalars['String']>;
  present: Scalars['Boolean'];
};

export enum SortDirection {
  Asc = 'asc',
  Desc = 'desc'
}

export type SpotDescription = {
  __typename?: 'SpotDescription';
  description: Scalars['String'];
};

export type SpotDescriptionInput = {
  description: Scalars['String'];
};

/** Autogenerated return type of SqlReportCreate. */
export type SqlReportCreatePayload = {
  __typename?: 'SqlReportCreatePayload';
  errors?: Maybe<Array<UserError>>;
  fullReportUrl?: Maybe<Scalars['String']>;
  /** First N rows as a JSON array of objects (N = preview_row_count, default 20, max 1000) */
  preview?: Maybe<Scalars['String']>;
  rowCount?: Maybe<Scalars['Int']>;
};

export type SqlReportDetails = {
  __typename?: 'SqlReportDetails';
  id: Scalars['String'];
  metabaseUrl?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  sql: Scalars['String'];
};

export type SqlReportListItem = {
  __typename?: 'SqlReportListItem';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type SqlTableDetail = {
  __typename?: 'SqlTableDetail';
  markdown: Scalars['String'];
  tableName: Scalars['String'];
};

export enum Status {
  AwaitingApproval = 'awaiting_approval',
  Cancelled = 'cancelled',
  Finished = 'finished',
  OrdersCreated = 'orders_created',
  RequiresInformation = 'requires_information',
  TruckAssigned = 'truck_assigned',
  TruckSearch = 'truck_search'
}

export type StripeManualTransfer = {
  __typename?: 'StripeManualTransfer';
  amount: Money;
  category: Scalars['String'];
  confirmedBy?: Maybe<Admin>;
  createdAt: Scalars['DateTime'];
  createdBy: Admin;
  description: Scalars['String'];
  entityId?: Maybe<Scalars['Int']>;
  entityLabel?: Maybe<Scalars['String']>;
  entityPath?: Maybe<Scalars['String']>;
  entityType?: Maybe<StripeManualTransferEntity>;
  errorMessage?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  restaurant: Restaurant;
  status: StripeManualTransferStatus;
  subcategory: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

/** Autogenerated return type of StripeManualTransferCancel. */
export type StripeManualTransferCancelPayload = {
  __typename?: 'StripeManualTransferCancelPayload';
  errors?: Maybe<Array<UserError>>;
  stripeManualTransfer?: Maybe<StripeManualTransfer>;
};

export type StripeManualTransferCollection = Collection & {
  __typename?: 'StripeManualTransferCollection';
  /** Limit */
  limit?: Maybe<Scalars['Int']>;
  /** Offset */
  offset?: Maybe<Scalars['Int']>;
  /** List of records */
  records: Array<StripeManualTransfer>;
  /** Total */
  total: Scalars['Int'];
};


export type StripeManualTransferCollectionTotalArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};

/** Autogenerated return type of StripeManualTransferConfirm. */
export type StripeManualTransferConfirmPayload = {
  __typename?: 'StripeManualTransferConfirmPayload';
  errors?: Maybe<Array<UserError>>;
  stripeManualTransfer?: Maybe<StripeManualTransfer>;
};

/** Autogenerated return type of StripeManualTransferCreate. */
export type StripeManualTransferCreatePayload = {
  __typename?: 'StripeManualTransferCreatePayload';
  errors?: Maybe<Array<UserError>>;
  stripeManualTransfer?: Maybe<StripeManualTransfer>;
};

export enum StripeManualTransferEntity {
  CateringRequest = 'CateringRequest',
  Event = 'Event'
}

export type StripeManualTransferEntityPreview = {
  __typename?: 'StripeManualTransferEntityPreview';
  label: Scalars['String'];
  path: Scalars['String'];
};

export enum StripeManualTransferStatus {
  Cancelled = 'cancelled',
  Confirmed = 'confirmed',
  Failed = 'failed',
  Pending = 'pending'
}

export type StripeManualTransfersFilterInput = {
  /** Filter by restaurant */
  restaurantId?: InputMaybe<Scalars['Int']>;
};

export type StripeReference = {
  __typename?: 'StripeReference';
  name?: Maybe<Scalars['String']>;
  objectType?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type StructuredData = {
  __typename?: 'StructuredData';
  cateringCategoryPage?: Maybe<Array<Scalars['String']>>;
  cateringFoodTypePage?: Maybe<Array<Scalars['String']>>;
  customerApp?: Maybe<Array<Scalars['String']>>;
  foodTrucksNearMePage?: Maybe<Array<Scalars['String']>>;
  foodTrucksSearchPage?: Maybe<Array<Scalars['String']>>;
  homePage?: Maybe<Array<Scalars['String']>>;
  lotPage?: Maybe<Array<Scalars['String']>>;
  marketCateringPage?: Maybe<Array<Scalars['String']>>;
  marketListTrucksPage?: Maybe<Array<Scalars['String']>>;
  marketPage?: Maybe<Array<Scalars['String']>>;
  marketTopTrucksPage?: Maybe<Array<Scalars['String']>>;
  marketTrucksMapPage?: Maybe<Array<Scalars['String']>>;
  shiftPage?: Maybe<Array<Scalars['String']>>;
  truckMenuPage?: Maybe<Array<Scalars['String']>>;
  truckPage?: Maybe<Array<Scalars['String']>>;
};


export type StructuredDataCateringCategoryPageArgs = {
  marketSeoName?: InputMaybe<Scalars['String']>;
  seoName: Scalars['String'];
};


export type StructuredDataCateringFoodTypePageArgs = {
  marketSeoName?: InputMaybe<Scalars['String']>;
  seoName: Scalars['String'];
};


export type StructuredDataLotPageArgs = {
  id?: InputMaybe<Scalars['Int']>;
  seoName?: InputMaybe<Scalars['String']>;
};


export type StructuredDataMarketCateringPageArgs = {
  id?: InputMaybe<Scalars['Int']>;
  seoName?: InputMaybe<Scalars['String']>;
};


export type StructuredDataMarketListTrucksPageArgs = {
  id?: InputMaybe<Scalars['Int']>;
  seoName?: InputMaybe<Scalars['String']>;
};


export type StructuredDataMarketPageArgs = {
  id?: InputMaybe<Scalars['Int']>;
  seoName?: InputMaybe<Scalars['String']>;
};


export type StructuredDataMarketTopTrucksPageArgs = {
  id?: InputMaybe<Scalars['Int']>;
  seoName?: InputMaybe<Scalars['String']>;
};


export type StructuredDataMarketTrucksMapPageArgs = {
  id?: InputMaybe<Scalars['Int']>;
  seoName?: InputMaybe<Scalars['String']>;
};


export type StructuredDataShiftPageArgs = {
  id?: InputMaybe<Scalars['Int']>;
};


export type StructuredDataTruckMenuPageArgs = {
  id?: InputMaybe<Scalars['Int']>;
  seoName?: InputMaybe<Scalars['String']>;
};


export type StructuredDataTruckPageArgs = {
  id?: InputMaybe<Scalars['Int']>;
  seoName?: InputMaybe<Scalars['String']>;
};

export type SubscribedLot = {
  __typename?: 'SubscribedLot';
  dates: Array<SubscribedLotDate>;
  id: Scalars['Int'];
  lotUrl: Scalars['String'];
  name: Scalars['String'];
};

export type SubscribedLotDate = {
  __typename?: 'SubscribedLotDate';
  date: Scalars['String'];
  id: Scalars['String'];
  locations: Array<SubscribedLotDateLocation>;
};

export type SubscribedLotDateLocation = {
  __typename?: 'SubscribedLotDateLocation';
  foodImage?: Maybe<SubscribedLotTruckFoodImage>;
  id: Scalars['Int'];
  truckName: Scalars['String'];
};

export type SubscribedLotTruckFoodImage = {
  __typename?: 'SubscribedLotTruckFoodImage';
  original?: Maybe<Scalars['String']>;
  present: Scalars['Boolean'];
};

export enum SubscriptionEntity {
  CateringRequest = 'CateringRequest',
  EmailThread = 'EmailThread',
  EventsRequest = 'EventsRequest',
  TruckChat = 'TruckChat'
}

/** Autogenerated return type of SupportEmailSend. */
export type SupportEmailSendPayload = {
  __typename?: 'SupportEmailSendPayload';
  emailThread?: Maybe<EmailThread>;
  errors?: Maybe<Array<UserError>>;
};

/** Autogenerated return type of TerminalCreateConnectionToken. */
export type TerminalCreateConnectionTokenPayload = {
  __typename?: 'TerminalCreateConnectionTokenPayload';
  errors?: Maybe<Array<UserError>>;
  secret?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of TerminalCreateLocation. */
export type TerminalCreateLocationPayload = {
  __typename?: 'TerminalCreateLocationPayload';
  errors?: Maybe<Array<UserError>>;
  id?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of TestPushNotification. */
export type TestPushNotificationPayload = {
  __typename?: 'TestPushNotificationPayload';
  customerDevices?: Maybe<Array<UserDevice>>;
  errors?: Maybe<Array<UserError>>;
  truckDevices?: Maybe<Array<UserDevice>>;
};

export type Text = {
  __typename?: 'Text';
  content?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
};

export type TextConversation = {
  __typename?: 'TextConversation';
  canMarkRead: Scalars['Boolean'];
  canSendMessage: Scalars['Boolean'];
  id: Scalars['Int'];
  phone: Scalars['String'];
  read: Scalars['Boolean'];
  sendsonarUrl?: Maybe<Scalars['String']>;
  subscribed: Scalars['Boolean'];
  textMessages: TextMessageCollection;
  textMessagesCount: Scalars['Int'];
};


export type TextConversationCanMarkReadArgs = {
  cateringRequestId?: InputMaybe<Scalars['Int']>;
  customRequestCode?: InputMaybe<Scalars['String']>;
  eventId?: InputMaybe<Scalars['Int']>;
  eventsRequestId?: InputMaybe<Scalars['Int']>;
  lotId?: InputMaybe<Scalars['Int']>;
  restaurantId?: InputMaybe<Scalars['Int']>;
  truckId?: InputMaybe<Scalars['Int']>;
};


export type TextConversationCanSendMessageArgs = {
  cateringRequestId?: InputMaybe<Scalars['Int']>;
  customRequestCode?: InputMaybe<Scalars['String']>;
  eventId?: InputMaybe<Scalars['Int']>;
  eventsRequestId?: InputMaybe<Scalars['Int']>;
  lotId?: InputMaybe<Scalars['Int']>;
  restaurantId?: InputMaybe<Scalars['Int']>;
  truckId?: InputMaybe<Scalars['Int']>;
};


export type TextConversationTextMessagesArgs = {
  page?: InputMaybe<CollectionInput>;
  sort?: InputMaybe<Array<TextMessagesSortInput>>;
};

/** Autogenerated return type of TextConversationMarkRead. */
export type TextConversationMarkReadPayload = {
  __typename?: 'TextConversationMarkReadPayload';
  errors?: Maybe<Array<UserError>>;
  textConversation?: Maybe<TextConversation>;
};

/** Autogenerated return type of TextConversationSendMessage. */
export type TextConversationSendMessagePayload = {
  __typename?: 'TextConversationSendMessagePayload';
  errors?: Maybe<Array<UserError>>;
  textConversation?: Maybe<TextConversation>;
};

export type TextMessage = {
  __typename?: 'TextMessage';
  createdAt: Scalars['DateTime'];
  direction: TextMessageDirection;
  id: Scalars['Int'];
  name: Scalars['String'];
  text: Scalars['String'];
};

export type TextMessageCollection = Collection & {
  __typename?: 'TextMessageCollection';
  /** Limit */
  limit?: Maybe<Scalars['Int']>;
  /** Offset */
  offset?: Maybe<Scalars['Int']>;
  /** List of records */
  records: Array<TextMessage>;
  /** Total */
  total: Scalars['Int'];
};


export type TextMessageCollectionTotalArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};

export enum TextMessageDirection {
  Inbound = 'inbound',
  Outbound = 'outbound'
}

export type TextMessagesSortInput = {
  /** ASC / DESC */
  direction: SortDirection;
  /** Field to sort by */
  field: TextMessagesSortInputFields;
};

export enum TextMessagesSortInputFields {
  CreatedAt = 'created_at'
}

export type TopTruckInput = {
  description: HtmlRecordInput;
  id: Scalars['Int'];
};

export type TriggerConfig = {
  __typename?: 'TriggerConfig';
  fieldsSchema: Array<TriggerFieldSchema>;
  id: Scalars['String'];
  name: Scalars['String'];
  values: Scalars['Json'];
};

export type TriggerFieldSchema = {
  __typename?: 'TriggerFieldSchema';
  dataType: Scalars['String'];
  label: Scalars['String'];
  name: Scalars['String'];
};

export type Truck = {
  __typename?: 'Truck';
  active: Scalars['Boolean'];
  address: Scalars['String'];
  autoAddress: Scalars['Boolean'];
  autoAdvanceOrders: Scalars['Boolean'];
  availability: Array<InstantBookAvailability>;
  averageRating: Scalars['Int'];
  cateringDropOffMinPerPerson: Money;
  cateringDropOffMinTotal: Money;
  cateringMinPerPerson: Money;
  cateringMinTotal: Money;
  completionV2?: Maybe<RestaurantCompletionV2>;
  creditsPrograms: Array<TruckCreditProgram>;
  currentOrNextLocation?: Maybe<Location>;
  defaultCateringMenu?: Maybe<Menu>;
  defaultEventMenu?: Maybe<Menu>;
  defaultItemImage?: Maybe<TruckDefaultItemImage>;
  description?: Maybe<HtmlRecord>;
  dropOff: Scalars['Boolean'];
  email?: Maybe<Scalars['String']>;
  emailThreads: Array<EmailThread>;
  employees: Array<Employee>;
  eventsInstantBookConfig?: Maybe<EventsInstantBookConfig>;
  eventsInstantBookEnabled: Scalars['Boolean'];
  facebook?: Maybe<Scalars['String']>;
  foodImage?: Maybe<TruckFoodImage>;
  foodTypes: Array<FoodType>;
  fullAddress: Scalars['String'];
  googleCalendarIntegration: Scalars['Boolean'];
  googleCalendarIntegrationError?: Maybe<Scalars['String']>;
  healthPermits: Array<HealthPermit>;
  /** Vehicle height in inches */
  heightIn?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  image: TruckImage;
  instagram?: Maybe<Scalars['String']>;
  instantBookConfig?: Maybe<InstantBookConfig>;
  instantBookEnabled: Scalars['Boolean'];
  instantBookLotCandidates: Array<Lot>;
  instantBookLots: Array<Lot>;
  /** Vehicle length in inches */
  lengthIn?: Maybe<Scalars['Int']>;
  licensePlate?: Maybe<Scalars['String']>;
  locations: LocationCollection;
  market: Market;
  maxDistanceMiles: Scalars['Float'];
  maxServiceHours: Scalars['Int'];
  menuPath: Scalars['String'];
  menuUrl: Scalars['String'];
  menus: Array<Menu>;
  name: Scalars['String'];
  orderRatings: OrderRatingCollection;
  partnershipData?: Maybe<PartnershipTruckData>;
  pastCustomerCaterings: Array<TruckPastCatering>;
  phone?: Maybe<Scalars['String']>;
  popularity: Scalars['Int'];
  preferredVendor: Scalars['Boolean'];
  preferredVendorBadge?: Maybe<Scalars['String']>;
  primaryUpsellTypes: Array<UpsellType>;
  ratingInfo?: Maybe<TruckRatingInfo>;
  redirectToTruck?: Maybe<Truck>;
  /** Operational reliability score, visible to organizers and admins */
  reliability?: Maybe<TruckReliability>;
  restaurant: Restaurant;
  reviewSuggestionRequests: Array<ReviewSuggestionRequest>;
  reviewTruckProblems: Array<ReviewTruckProblem>;
  salesPrediction?: Maybe<SalesPrediction>;
  schedulePath: Scalars['String'];
  scheduleUrl: Scalars['String'];
  seoName?: Maybe<Scalars['String']>;
  showAsArchived: Scalars['Boolean'];
  /** Whether to show the "hire this truck for your event" CTA */
  showHireMe: Scalars['Boolean'];
  showRatings: Scalars['Boolean'];
  slug: Scalars['String'];
  statsForOrganizer: Scalars['Json'];
  textConversation?: Maybe<TextConversation>;
  tiktok?: Maybe<Scalars['String']>;
  tipsEnabled: Scalars['Boolean'];
  truckDocuments: TruckDocumentCollection;
  truckDocumentsPublicUrl: Scalars['String'];
  truckEmailChannel: TruckEmailChannel;
  truckPhoneChannel?: Maybe<TruckPhoneChannel>;
  truckReview: TruckReview;
  truckSchedule: TruckSchedule;
  twitter?: Maybe<Scalars['String']>;
  twitterPostingIntegration?: Maybe<TwitterIntegration>;
  userDevices: Array<UserDevice>;
  vehicleType?: Maybe<TruckVehicleType>;
  website?: Maybe<Scalars['String']>;
  /** Vehicle width in inches */
  widthIn?: Maybe<Scalars['Int']>;
};


export type TruckLocationsArgs = {
  filter?: InputMaybe<LocationsFilterInput>;
  page?: InputMaybe<CollectionInput>;
  sort?: InputMaybe<Array<LocationsSortInput>>;
};


export type TruckOrderRatingsArgs = {
  filter?: InputMaybe<OrderRatingsFilterInput>;
  page?: InputMaybe<CollectionInput>;
  sort?: InputMaybe<Array<OrderRatingsSortInput>>;
};


export type TruckSalesPredictionArgs = {
  eventId: Scalars['Int'];
};


export type TruckTruckDocumentsArgs = {
  filter?: InputMaybe<TruckDocumentFilterInput>;
  page?: InputMaybe<CollectionInput>;
  sort?: InputMaybe<Array<TruckDocumentSortInput>>;
};


export type TruckTruckEmailChannelArgs = {
  secureToken?: InputMaybe<Scalars['String']>;
};


export type TruckTruckScheduleArgs = {
  page?: InputMaybe<CollectionInput>;
  startDate?: InputMaybe<Scalars['DateTime']>;
};

export type TruckAvailabilityInput = {
  /** 0-23 */
  fromHour: Scalars['Int'];
  /** 0-23 */
  toHour: Scalars['Int'];
  /** 0 is Sunday */
  wday: Scalars['Int'];
};

export type TruckCalendarDate = {
  __typename?: 'TruckCalendarDate';
  appUrl?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  endAt: Scalars['DateTime'];
  entityId: Scalars['Int'];
  id: Scalars['String'];
  name: Scalars['String'];
  raw: Scalars['Json'];
  startAt: Scalars['DateTime'];
  status: TruckCalendarDateAvailability;
  timeConflict?: Maybe<Scalars['Boolean']>;
  type: TruckCalendarDateEventType;
  webUrl?: Maybe<Scalars['String']>;
};

export enum TruckCalendarDateAvailability {
  Available = 'available',
  Booked = 'booked',
  External = 'external',
  Potential = 'potential'
}

export enum TruckCalendarDateEventType {
  CalendarExternalEvent = 'calendar_external_event',
  CateringRequest = 'catering_request',
  Event = 'event',
  Location = 'location'
}

/** Autogenerated return type of TruckCateringRatingUpdate. */
export type TruckCateringRatingUpdatePayload = {
  __typename?: 'TruckCateringRatingUpdatePayload';
  errors?: Maybe<Array<UserError>>;
  truckRating?: Maybe<TruckGenericRating>;
};

export type TruckChat = {
  __typename?: 'TruckChat';
  active: Scalars['Boolean'];
  description: Scalars['String'];
  entityPath: Scalars['String'];
  id: Scalars['Int'];
  lastMessageAt?: Maybe<Scalars['DateTime']>;
  location?: Maybe<Location>;
  read: Scalars['Boolean'];
  requestProposal?: Maybe<CateringRequestProposal>;
  truckChatMessages: TruckChatMessageCollection;
};


export type TruckChatTruckChatMessagesArgs = {
  page?: InputMaybe<CollectionInput>;
  sort?: InputMaybe<Array<TruckChatMessagesSortInput>>;
};

export type TruckChatCollection = Collection & {
  __typename?: 'TruckChatCollection';
  /** Limit */
  limit?: Maybe<Scalars['Int']>;
  /** Offset */
  offset?: Maybe<Scalars['Int']>;
  /** List of records */
  records: Array<TruckChat>;
  /** Total */
  total: Scalars['Int'];
};


export type TruckChatCollectionTotalArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};

/** Autogenerated return type of TruckChatCreate. */
export type TruckChatCreatePayload = {
  __typename?: 'TruckChatCreatePayload';
  errors?: Maybe<Array<UserError>>;
  truckChat?: Maybe<TruckChat>;
};

export enum TruckChatEntity {
  CateringRequestProposal = 'Catering_RequestProposal',
  Location = 'Location'
}

/** Autogenerated return type of TruckChatMarkUnread. */
export type TruckChatMarkUnreadPayload = {
  __typename?: 'TruckChatMarkUnreadPayload';
  errors?: Maybe<Array<UserError>>;
  truckChat?: Maybe<TruckChat>;
};

export type TruckChatMessage = {
  __typename?: 'TruckChatMessage';
  body: Scalars['String'];
  createdAt: Scalars['DateTime'];
  flagged: Scalars['Boolean'];
  id: Scalars['Int'];
  outbound: Scalars['Boolean'];
  read: Scalars['Boolean'];
  readByCustomer?: Maybe<Scalars['DateTime']>;
  readByOrganizer?: Maybe<Scalars['DateTime']>;
  readByTruck?: Maybe<Scalars['DateTime']>;
  show: Scalars['Boolean'];
  userName: Scalars['String'];
  userType: TruckChatMessageUser;
};

export type TruckChatMessageCollection = Collection & {
  __typename?: 'TruckChatMessageCollection';
  /** Limit */
  limit?: Maybe<Scalars['Int']>;
  /** Offset */
  offset?: Maybe<Scalars['Int']>;
  /** List of records */
  records: Array<TruckChatMessage>;
  /** Total */
  total: Scalars['Int'];
};


export type TruckChatMessageCollectionTotalArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};

/** Autogenerated return type of TruckChatMessageCreate. */
export type TruckChatMessageCreatePayload = {
  __typename?: 'TruckChatMessageCreatePayload';
  errors?: Maybe<Array<UserError>>;
  truckChat?: Maybe<TruckChat>;
};

/** Autogenerated return type of TruckChatMessageUpdateFlagged. */
export type TruckChatMessageUpdateFlaggedPayload = {
  __typename?: 'TruckChatMessageUpdateFlaggedPayload';
  errors?: Maybe<Array<UserError>>;
  truckChat?: Maybe<TruckChat>;
};

export enum TruckChatMessageUser {
  Admin = 'admin',
  Customer = 'customer',
  Organizer = 'organizer',
  Truck = 'truck'
}

export type TruckChatMessagesSortInput = {
  /** ASC / DESC */
  direction: SortDirection;
  /** Field to sort by */
  field: TruckChatMessagesSortInputFields;
};

export enum TruckChatMessagesSortInputFields {
  CreatedAt = 'created_at'
}

/** Autogenerated return type of TruckChatRead. */
export type TruckChatReadPayload = {
  __typename?: 'TruckChatReadPayload';
  errors?: Maybe<Array<UserError>>;
  truckChat?: Maybe<TruckChat>;
};

export type TruckChatsFilterInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  cateringRequestId?: InputMaybe<Scalars['Int']>;
  eventsRequestId?: InputMaybe<Scalars['Int']>;
  hasMessages?: InputMaybe<Scalars['Boolean']>;
  read?: InputMaybe<Scalars['Boolean']>;
};

export type TruckChatsSortInput = {
  /** ASC / DESC */
  direction: SortDirection;
  /** Field to sort by */
  field: TruckChatsSortInputFields;
};

export enum TruckChatsSortInputFields {
  CreatedAt = 'created_at',
  LastMessageAt = 'last_message_at',
  Read = 'read'
}

export type TruckCollection = Collection & {
  __typename?: 'TruckCollection';
  /** Limit */
  limit?: Maybe<Scalars['Int']>;
  /** Offset */
  offset?: Maybe<Scalars['Int']>;
  /** List of records */
  records: Array<Truck>;
  /** Total */
  total: Scalars['Int'];
};


export type TruckCollectionTotalArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};

/** Autogenerated return type of TruckCreate. */
export type TruckCreatePayload = {
  __typename?: 'TruckCreatePayload';
  errors?: Maybe<Array<UserError>>;
  truck?: Maybe<Truck>;
};

/** Autogenerated return type of TruckCreateUserFeedback. */
export type TruckCreateUserFeedbackPayload = {
  __typename?: 'TruckCreateUserFeedbackPayload';
  errors?: Maybe<Array<UserError>>;
  success?: Maybe<Scalars['Boolean']>;
};

/** Autogenerated return type of TruckCreateWalkupRating. */
export type TruckCreateWalkupRatingPayload = {
  __typename?: 'TruckCreateWalkupRatingPayload';
  errors?: Maybe<Array<UserError>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type TruckCreditProgram = {
  __typename?: 'TruckCreditProgram';
  description: Scalars['String'];
  id: Scalars['String'];
  title: Scalars['String'];
};

export type TruckDefaultItemImage = {
  __typename?: 'TruckDefaultItemImage';
  high: Scalars['String'];
  medium: Scalars['String'];
  original?: Maybe<Scalars['String']>;
  present: Scalars['Boolean'];
  resizedOriginal: Scalars['String'];
  small: Scalars['String'];
  thumb: Scalars['String'];
};

/** Autogenerated return type of TruckDelete. */
export type TruckDeletePayload = {
  __typename?: 'TruckDeletePayload';
  errors?: Maybe<Array<UserError>>;
  restaurant?: Maybe<Restaurant>;
};

export type TruckDocument = {
  __typename?: 'TruckDocument';
  archived: Scalars['Boolean'];
  attachments: Array<FileAttachment>;
  category: TruckDocumentCategory;
  categoryId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  editable: Scalars['Boolean'];
  entityDescription?: Maybe<Scalars['String']>;
  entityId?: Maybe<Scalars['Int']>;
  entityType?: Maybe<TruckDocumentEntityType>;
  expiresAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  name: Scalars['String'];
  publicUrl: Scalars['String'];
  region?: Maybe<Scalars['String']>;
  replacedBy?: Maybe<TruckDocument>;
  truck: Truck;
  validationError?: Maybe<Scalars['String']>;
  validationStatus: TruckDocumentValidationStatus;
  visibility: TruckDocumentVisibility;
};

/** Autogenerated return type of TruckDocumentArchive. */
export type TruckDocumentArchivePayload = {
  __typename?: 'TruckDocumentArchivePayload';
  errors?: Maybe<Array<UserError>>;
  truckDocument?: Maybe<TruckDocument>;
};

export type TruckDocumentCategory = {
  __typename?: 'TruckDocumentCategory';
  attachedToEntity: Scalars['Boolean'];
  description: Scalars['String'];
  expiresAtRequired: Scalars['Boolean'];
  id: Scalars['String'];
  name: Scalars['String'];
  regionRequired: Scalars['Boolean'];
};

export enum TruckDocumentCategoryId {
  /** auto_insurance */
  AutoInsurance = 'auto_insurance',
  /** business_license */
  BusinessLicense = 'business_license',
  /** custom */
  Custom = 'custom',
  /** fire_safety_certificate */
  FireSafetyCertificate = 'fire_safety_certificate',
  /** food_handler_certificate */
  FoodHandlerCertificate = 'food_handler_certificate',
  /** form_w9 */
  FormW9 = 'form_w9',
  /** general_liability_insurance */
  GeneralLiabilityInsurance = 'general_liability_insurance',
  /** general_liability_insurance_additional_insured */
  GeneralLiabilityInsuranceAdditionalInsured = 'general_liability_insurance_additional_insured',
  /** health_permit */
  HealthPermit = 'health_permit',
  /** mobile_vending_permit */
  MobileVendingPermit = 'mobile_vending_permit',
  /** sellers_permit */
  SellersPermit = 'sellers_permit',
  /** workers_compensation_insurance */
  WorkersCompensationInsurance = 'workers_compensation_insurance'
}

export type TruckDocumentCollection = Collection & {
  __typename?: 'TruckDocumentCollection';
  /** Limit */
  limit?: Maybe<Scalars['Int']>;
  /** Offset */
  offset?: Maybe<Scalars['Int']>;
  /** List of records */
  records: Array<TruckDocument>;
  /** Total */
  total: Scalars['Int'];
};


export type TruckDocumentCollectionTotalArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};

/** Autogenerated return type of TruckDocumentCreate. */
export type TruckDocumentCreatePayload = {
  __typename?: 'TruckDocumentCreatePayload';
  errors?: Maybe<Array<UserError>>;
  truckDocument?: Maybe<TruckDocument>;
};

/** Autogenerated return type of TruckDocumentDeleteAttachment. */
export type TruckDocumentDeleteAttachmentPayload = {
  __typename?: 'TruckDocumentDeleteAttachmentPayload';
  errors?: Maybe<Array<UserError>>;
  truckDocument?: Maybe<TruckDocument>;
};

export enum TruckDocumentEntityType {
  CateringRequest = 'CateringRequest',
  Lot = 'Lot'
}

export type TruckDocumentFilterInput = {
  categoryIds?: InputMaybe<Array<TruckDocumentCategoryId>>;
  entityId?: InputMaybe<Scalars['Int']>;
  entityType?: InputMaybe<TruckDocumentEntityType>;
  excludeEntitySpecific?: InputMaybe<Scalars['Boolean']>;
  expiresAfter?: InputMaybe<Scalars['DateTime']>;
  expiresBefore?: InputMaybe<Scalars['DateTime']>;
  includeArchived?: InputMaybe<Scalars['Boolean']>;
  truckId?: InputMaybe<Scalars['Int']>;
};

/** Autogenerated return type of TruckDocumentReplace. */
export type TruckDocumentReplacePayload = {
  __typename?: 'TruckDocumentReplacePayload';
  errors?: Maybe<Array<UserError>>;
  replacedTruckDocument?: Maybe<TruckDocument>;
  truckDocument?: Maybe<TruckDocument>;
};

export type TruckDocumentSortInput = {
  /** ASC / DESC */
  direction: SortDirection;
  /** Field to sort by */
  field: TruckDocumentSortInputFields;
};

export enum TruckDocumentSortInputFields {
  CategoryId = 'category_id',
  CreatedAt = 'created_at'
}

/** Autogenerated return type of TruckDocumentUpdate. */
export type TruckDocumentUpdatePayload = {
  __typename?: 'TruckDocumentUpdatePayload';
  errors?: Maybe<Array<UserError>>;
  truckDocument?: Maybe<TruckDocument>;
};

/** Autogenerated return type of TruckDocumentUpdateVisibility. */
export type TruckDocumentUpdateVisibilityPayload = {
  __typename?: 'TruckDocumentUpdateVisibilityPayload';
  errors?: Maybe<Array<UserError>>;
  truckDocument?: Maybe<TruckDocument>;
};

export enum TruckDocumentValidationStatus {
  Failed = 'failed',
  NoValidation = 'no_validation',
  Pending = 'pending',
  Verified = 'verified'
}

export enum TruckDocumentVisibility {
  /** Privately Accessible */
  PrivatelyAccessible = 'privately_accessible',
  /** Publicly Accessible */
  PubliclyAccessible = 'publicly_accessible'
}

/** Autogenerated return type of TruckDocumentsRequest. */
export type TruckDocumentsRequestPayload = {
  __typename?: 'TruckDocumentsRequestPayload';
  errors?: Maybe<Array<UserError>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type TruckEmailChannel = {
  __typename?: 'TruckEmailChannel';
  availableTopics: Array<TruckEmailChannelTopic>;
  email: Scalars['String'];
  id: Scalars['Int'];
  phone: Scalars['String'];
  unsubscribedFromAll: Scalars['Boolean'];
};

export type TruckEmailChannelTopic = {
  __typename?: 'TruckEmailChannelTopic';
  description?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  subscribed: Scalars['Boolean'];
  value: TruckEmailChannelTopicName;
};

export enum TruckEmailChannelTopicName {
  AutoCover = 'auto_cover',
  CateringUnclaimed = 'catering_unclaimed',
  EventsRequest = 'events_request',
  EventsRequestUnclaimed = 'events_request_unclaimed',
  InvitedToEvent = 'invited_to_event',
  WeeklySummary = 'weekly_summary'
}

export type TruckFaq = {
  __typename?: 'TruckFaq';
  /** Markdown */
  answer: Scalars['String'];
  category?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  title: Scalars['String'];
};

export type TruckFoodImage = {
  __typename?: 'TruckFoodImage';
  medium: Scalars['String'];
  original?: Maybe<Scalars['String']>;
  present: Scalars['Boolean'];
};

export type TruckGenericEvent = {
  __typename?: 'TruckGenericEvent';
  code: Scalars['String'];
  distance?: Maybe<Scalars['Float']>;
  endAt: Scalars['DateTime'];
  eventType: TruckGenericEventTypeEnum;
  fullAddress?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  nickname: Scalars['String'];
  potentialSalesHighlight?: Maybe<Scalars['String']>;
  proposalSubmittedAt?: Maybe<Scalars['DateTime']>;
  recordId: Scalars['Int'];
  recordType: Scalars['String'];
  shortAddress: Scalars['String'];
  startAt: Scalars['DateTime'];
  status: Scalars['String'];
  statusHuman: Scalars['String'];
  truckDashboardUrl: Scalars['String'];
};


export type TruckGenericEventDistanceArgs = {
  truckId: Scalars['Int'];
};


export type TruckGenericEventEndAtArgs = {
  truckId?: InputMaybe<Scalars['Int']>;
};


export type TruckGenericEventPotentialSalesHighlightArgs = {
  truckId: Scalars['Int'];
};


export type TruckGenericEventProposalSubmittedAtArgs = {
  truckId: Scalars['Int'];
};


export type TruckGenericEventStartAtArgs = {
  truckId?: InputMaybe<Scalars['Int']>;
};


export type TruckGenericEventStatusHumanArgs = {
  truckId: Scalars['Int'];
};


export type TruckGenericEventTruckDashboardUrlArgs = {
  truckId?: InputMaybe<Scalars['Int']>;
};

export type TruckGenericEventCollection = {
  __typename?: 'TruckGenericEventCollection';
  /** Whether more records exist after this page */
  hasMore: Scalars['Boolean'];
  /** Limit */
  limit?: Maybe<Scalars['Int']>;
  /** Offset */
  offset?: Maybe<Scalars['Int']>;
  /** List of records */
  records: Array<TruckGenericEvent>;
  /** Total */
  total: Scalars['Int'];
};

export type TruckGenericEventCounts = {
  __typename?: 'TruckGenericEventCounts';
  all: Scalars['Int'];
  awaitingCustomerResponse: Scalars['Int'];
  cancelled: Scalars['Int'];
  confirmed: Scalars['Int'];
  finished: Scalars['Int'];
  needsAcknowledgement: Scalars['Int'];
  new: Scalars['Int'];
  rejected: Scalars['Int'];
};

export type TruckGenericEventCountsFilterInput = {
  eventType?: InputMaybe<TruckGenericEventsFilterEvent>;
  marketId?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  startAtGt?: InputMaybe<Scalars['DateTime']>;
};

export enum TruckGenericEventTypeEnum {
  Catering = 'catering',
  CustomerEvent = 'customer_event',
  DropOff = 'drop_off',
  ManagedLot = 'managed_lot'
}

export enum TruckGenericEventsFilterEvent {
  Catering = 'catering',
  CustomerEvent = 'customer_event',
  DropOff = 'drop_off',
  ManagedLot = 'managed_lot'
}

export type TruckGenericEventsFilterInput = {
  eventType?: InputMaybe<TruckGenericEventsFilterEvent>;
  marketId?: InputMaybe<Scalars['Int']>;
  scope: TruckGenericEventsFilterScope;
  search?: InputMaybe<Scalars['String']>;
  sortColumn?: InputMaybe<TruckGenericEventsSortColumn>;
  sortDirection?: InputMaybe<SortDirection>;
  startAtGt?: InputMaybe<Scalars['DateTime']>;
};

export enum TruckGenericEventsFilterScope {
  All = 'all',
  AwaitingCustomerResponse = 'awaiting_customer_response',
  Cancelled = 'cancelled',
  Confirmed = 'confirmed',
  Finished = 'finished',
  NeedsAcknowledgement = 'needs_acknowledgement',
  New = 'new',
  Rejected = 'rejected'
}

export enum TruckGenericEventsSortColumn {
  CreatedAt = 'created_at',
  StartAt = 'start_at'
}

export type TruckGenericRating = {
  __typename?: 'TruckGenericRating';
  feedback?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  initialFeedback?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  orderAgain?: Maybe<Scalars['Boolean']>;
  published?: Maybe<Scalars['Boolean']>;
  reviewed?: Maybe<Scalars['Boolean']>;
  reviewedBy?: Maybe<Admin>;
  stars: Scalars['Int'];
  truck: Truck;
};

export type TruckGenericRatingCollection = Collection & {
  __typename?: 'TruckGenericRatingCollection';
  /** Limit */
  limit?: Maybe<Scalars['Int']>;
  /** Offset */
  offset?: Maybe<Scalars['Int']>;
  /** List of records */
  records: Array<TruckGenericRating>;
  /** Total */
  total: Scalars['Int'];
};


export type TruckGenericRatingCollectionTotalArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};

export type TruckGenericRatingsFilterInput = {
  published?: InputMaybe<Scalars['Boolean']>;
};

export type TruckGroup = {
  __typename?: 'TruckGroup';
  active: Scalars['Boolean'];
  defaultAllowed: Scalars['Boolean'];
  defaultBanned: Scalars['Boolean'];
  id: Scalars['Int'];
  name: Scalars['String'];
  oneTime: Scalars['Boolean'];
  trucks: Array<Truck>;
  updatedAt: Scalars['DateTime'];
  usage: Scalars['Json'];
};

/** Autogenerated return type of TruckGroupCreate. */
export type TruckGroupCreatePayload = {
  __typename?: 'TruckGroupCreatePayload';
  errors?: Maybe<Array<UserError>>;
  truckGroup?: Maybe<TruckGroup>;
};

/** Autogenerated return type of TruckGroupDestroy. */
export type TruckGroupDestroyPayload = {
  __typename?: 'TruckGroupDestroyPayload';
  errors?: Maybe<Array<UserError>>;
  success?: Maybe<Scalars['Boolean']>;
  truckGroup?: Maybe<TruckGroup>;
};

export type TruckGroupRule = {
  __typename?: 'TruckGroupRule';
  allowToBook: Scalars['Boolean'];
  chargeSalesPercentage: Scalars['Float'];
  default: Scalars['Boolean'];
  discount: Money;
  earlyAccessSeconds: Scalars['Int'];
  id: Scalars['Int'];
  maxBookingsPerSequence?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  salesPercentageOverwrite: Scalars['Boolean'];
  truckGroup: TruckGroup;
};

export type TruckGroupRuleInput = {
  allowToBook: Scalars['Boolean'];
  chargeSalesPercentage: Scalars['Float'];
  default?: InputMaybe<Scalars['Boolean']>;
  discountCents: Scalars['Int'];
  earlyAccessSeconds: Scalars['Int'];
  maxBookingsPerSequence?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  salesPercentageOverwrite: Scalars['Boolean'];
  truckGroupId: Scalars['Int'];
};

/** Autogenerated return type of TruckGroupUpdate. */
export type TruckGroupUpdatePayload = {
  __typename?: 'TruckGroupUpdatePayload';
  errors?: Maybe<Array<UserError>>;
  truckGroup?: Maybe<TruckGroup>;
};

export type TruckGroupsFilterInput = {
  /** Include archived (inactive) groups */
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
  oneTime?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
};

export type TruckGroupsSortInput = {
  /** ASC / DESC */
  direction: SortDirection;
  /** Field to sort by */
  field: TruckGroupsSortInputFields;
};

export enum TruckGroupsSortInputFields {
  Name = 'name'
}

export type TruckImage = {
  __typename?: 'TruckImage';
  high: Scalars['String'];
  horizontalStretch: Scalars['String'];
  medium: Scalars['String'];
  original?: Maybe<Scalars['String']>;
  present: Scalars['Boolean'];
  resizedOriginal: Scalars['String'];
  small: Scalars['String'];
  thumb: Scalars['String'];
};

export type TruckPastCatering = {
  __typename?: 'TruckPastCatering';
  address: Scalars['String'];
  attendees: Scalars['String'];
  date: Scalars['DateTime'];
  id: Scalars['String'];
  title: Scalars['String'];
};

export type TruckPhone = {
  __typename?: 'TruckPhone';
  id: Scalars['Int'];
  phone: Scalars['Phone'];
  verified: Scalars['Boolean'];
};

export type TruckPhoneChannel = {
  __typename?: 'TruckPhoneChannel';
  availableTopics: Array<TruckPhoneChannelTopic>;
  id: Scalars['Int'];
  phone?: Maybe<Scalars['Phone']>;
  unsubscribedFromAll: Scalars['Boolean'];
};

export type TruckPhoneChannelTopic = {
  __typename?: 'TruckPhoneChannelTopic';
  description?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  subscribed: Scalars['Boolean'];
  value: TruckPhoneChannelTopicName;
};

export enum TruckPhoneChannelTopicName {
  AutoCover = 'auto_cover',
  CateringRequest = 'catering_request',
  CateringUnclaimed = 'catering_unclaimed',
  EventsRequest = 'events_request',
  InvitedToEvent = 'invited_to_event'
}

/** Autogenerated return type of TruckPhoneVerify. */
export type TruckPhoneVerifyPayload = {
  __typename?: 'TruckPhoneVerifyPayload';
  errors?: Maybe<Array<UserError>>;
  phoneToken?: Maybe<Scalars['String']>;
  restaurant?: Maybe<Restaurant>;
};

/** Autogenerated return type of TruckPrinterCreate. */
export type TruckPrinterCreatePayload = {
  __typename?: 'TruckPrinterCreatePayload';
  errors?: Maybe<Array<UserError>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type TruckPublicGenericRating = {
  __typename?: 'TruckPublicGenericRating';
  createdAt: Scalars['DateTime'];
  feedback?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  name: Scalars['String'];
  stars: Scalars['Int'];
};

export type TruckQuickSearchMatch = {
  __typename?: 'TruckQuickSearchMatch';
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  name: Scalars['String'];
  path: Scalars['String'];
  type: Scalars['String'];
};

export type TruckQuickSearchSection = {
  __typename?: 'TruckQuickSearchSection';
  key: TruckQuickSearchSectionKey;
  matches: Array<TruckQuickSearchMatch>;
};

export enum TruckQuickSearchSectionKey {
  Caterings = 'caterings',
  Documents = 'documents',
  Events = 'events',
  Lots = 'lots',
  Menus = 'menus'
}

/** Autogenerated return type of TruckRateEntity. */
export type TruckRateEntityPayload = {
  __typename?: 'TruckRateEntityPayload';
  errors?: Maybe<Array<UserError>>;
  rateableEntity?: Maybe<RateableEntity>;
  truckRating?: Maybe<TruckGenericRating>;
};

export type TruckRatingInfo = {
  __typename?: 'TruckRatingInfo';
  averageRating: Scalars['Float'];
  ratings: Array<PublicRating>;
  ratingsCount: Scalars['Int'];
};

export type TruckReliability = {
  __typename?: 'TruckReliability';
  /** % of bookings cancelled late */
  cancelledLocations: Scalars['Float'];
  enoughData: Scalars['Boolean'];
  /** % of shifts started more than 10 minutes late */
  lateArrivals: Scalars['Float'];
  /** % of shifts ended more than 30 minutes early */
  leftEarly: Scalars['Float'];
  /** Number of completed event shifts */
  pastLocations: Scalars['Int'];
  /** Composite reliability score, 0-100; null when there isn't enough data */
  score?: Maybe<Scalars['Int']>;
};

export type TruckRequest = {
  __typename?: 'TruckRequest';
  createdAt: Scalars['DateTime'];
  emailNotificationStatus?: Maybe<TruckRequestNotificationStatus>;
  id: Scalars['Int'];
  pushNotificationStatus?: Maybe<TruckRequestNotificationStatus>;
  smsNotificationStatus?: Maybe<TruckRequestNotificationStatus>;
  status: TruckRequestStatus;
  statusHuman: Scalars['String'];
  /** Status as the truck sees it on its event page, e.g. "Organizer Review" rather than the raw request status */
  statusTruckHuman: Scalars['String'];
  truck: Truck;
  truckProposal?: Maybe<EventsTruckProposal>;
};

export enum TruckRequestNotificationStatus {
  Delivered = 'delivered',
  Opened = 'opened',
  Sent = 'sent'
}

export enum TruckRequestStatus {
  Accepted = 'accepted',
  Chosen = 'chosen',
  Outdated = 'outdated',
  PendingReview = 'pending_review',
  Rejected = 'rejected',
  Sent = 'sent'
}

export type TruckRequiredDocumentsStatus = {
  __typename?: 'TruckRequiredDocumentsStatus';
  category: TruckDocumentCategory;
  filled: Scalars['Boolean'];
  id: Scalars['String'];
  matchingDocuments: Array<TruckDocument>;
};

export type TruckReview = {
  __typename?: 'TruckReview';
  changedAfterReview: Scalars['Boolean'];
  changes: Array<TruckReviewChange>;
  emailThreads: Array<EmailThread>;
  id: Scalars['Int'];
  lastChangeAt?: Maybe<Scalars['DateTime']>;
  lastProblemCheckAt?: Maybe<Scalars['DateTime']>;
  lastReviewAt?: Maybe<Scalars['DateTime']>;
  lastTruckReviewSnapshot?: Maybe<TruckReviewSnapshot>;
  problemCheckStatus?: Maybe<TruckReviewProblemCheckStatus>;
  /** Pending problems by severity */
  problemCounts: TruckReviewProblemCounts;
  reviewRequestedAt?: Maybe<Scalars['DateTime']>;
  status: TruckReviewStatus;
  statusHuman: Scalars['String'];
  truck: Truck;
};

/** Autogenerated return type of TruckReviewApprove. */
export type TruckReviewApprovePayload = {
  __typename?: 'TruckReviewApprovePayload';
  errors?: Maybe<Array<UserError>>;
  truckReview?: Maybe<TruckReview>;
};

export type TruckReviewChange = {
  __typename?: 'TruckReviewChange';
  html: Scalars['String'];
  title: Scalars['String'];
};

export type TruckReviewCollection = Collection & {
  __typename?: 'TruckReviewCollection';
  ids: Array<Scalars['Int']>;
  /** Limit */
  limit?: Maybe<Scalars['Int']>;
  /** Offset */
  offset?: Maybe<Scalars['Int']>;
  /** List of records */
  records: Array<TruckReview>;
  /** Total */
  total: Scalars['Int'];
};


export type TruckReviewCollectionTotalArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};

export enum TruckReviewProblemCheckStatus {
  Failed = 'failed',
  Finished = 'finished',
  InProgress = 'in_progress'
}

export type TruckReviewProblemCounts = {
  __typename?: 'TruckReviewProblemCounts';
  critical: Scalars['Int'];
  error: Scalars['Int'];
  warning: Scalars['Int'];
};

/** Autogenerated return type of TruckReviewReject. */
export type TruckReviewRejectPayload = {
  __typename?: 'TruckReviewRejectPayload';
  errors?: Maybe<Array<UserError>>;
  truckReview?: Maybe<TruckReview>;
};

/** Autogenerated return type of TruckReviewRequest. */
export type TruckReviewRequestPayload = {
  __typename?: 'TruckReviewRequestPayload';
  errors?: Maybe<Array<UserError>>;
  truckReview?: Maybe<TruckReview>;
};

export type TruckReviewSnapshot = {
  __typename?: 'TruckReviewSnapshot';
  createdAt: Scalars['DateTime'];
  id: Scalars['Int'];
  name: Scalars['String'];
  reviewer: Admin;
  reviewerComment?: Maybe<Scalars['String']>;
  status: TruckReviewSnapshotStatus;
  statusHuman: Scalars['String'];
  truckReview: TruckReview;
};

export enum TruckReviewSnapshotStatus {
  Approved = 'approved',
  NotReviewed = 'not_reviewed',
  Rejected = 'rejected'
}

export enum TruckReviewStatus {
  Approved = 'approved',
  NotReviewed = 'not_reviewed',
  Rejected = 'rejected'
}

export type TruckReviewsFilterInput = {
  changedAfterReview?: InputMaybe<Scalars['Boolean']>;
  /** Only trucks with a proposal on an upcoming, active catering or event request */
  proposedToEvents?: InputMaybe<Scalars['Boolean']>;
  reviewRequested?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<TruckReviewStatus>;
  trucksFilter?: InputMaybe<TrucksFilterInput>;
};

export type TruckReviewsSortInput = {
  /** ASC / DESC */
  direction: SortDirection;
  /** Field to sort by */
  field: TruckReviewsSortInputFields;
};

export enum TruckReviewsSortInputFields {
  CreatedAt = 'created_at',
  LastChangeAt = 'last_change_at',
  LastReviewAt = 'last_review_at',
  Priority = 'priority',
  ReviewRequestedAt = 'review_requested_at',
  TimeSinceReview = 'time_since_review',
  TruckPopularity = 'truck_popularity'
}

export type TruckSchedule = {
  __typename?: 'TruckSchedule';
  /** Limit */
  limit?: Maybe<Scalars['Int']>;
  /** Offset */
  offset?: Maybe<Scalars['Int']>;
  records: Array<TruckScheduleEntry>;
  /** Total */
  total: Scalars['Int'];
};

export type TruckScheduleConflict = {
  __typename?: 'TruckScheduleConflict';
  message: Scalars['String'];
  /** error or warn */
  severity: Scalars['String'];
  /** Absolute URL to open the conflicting entity */
  truckDashboardUrl?: Maybe<Scalars['String']>;
};

export type TruckScheduleEntry = {
  __typename?: 'TruckScheduleEntry';
  address?: Maybe<Scalars['String']>;
  endAt: Scalars['DateTime'];
  entityId: Scalars['Int'];
  externalDescription?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  latitude?: Maybe<Scalars['Float']>;
  location?: Maybe<Location>;
  longitude?: Maybe<Scalars['Float']>;
  startAt: Scalars['DateTime'];
  type: TruckScheduleEntryType;
};

export enum TruckScheduleEntryType {
  ExternalEvent = 'ExternalEvent',
  Location = 'Location'
}

export enum TruckSearchStatus {
  InProgress = 'in_progress',
  Initial = 'initial',
  NoTrucks = 'no_trucks',
  NoTrucksForFoodType = 'no_trucks_for_food_type',
  TrucksNotified = 'trucks_notified'
}

/** Autogenerated return type of TruckSetActive. */
export type TruckSetActivePayload = {
  __typename?: 'TruckSetActivePayload';
  errors?: Maybe<Array<UserError>>;
  truck?: Maybe<Truck>;
};

/** Autogenerated return type of TruckUpdateAddress. */
export type TruckUpdateAddressPayload = {
  __typename?: 'TruckUpdateAddressPayload';
  errors?: Maybe<Array<UserError>>;
  truck?: Maybe<Truck>;
};

/** Autogenerated return type of TruckUpdateAutoAdvance. */
export type TruckUpdateAutoAdvancePayload = {
  __typename?: 'TruckUpdateAutoAdvancePayload';
  errors?: Maybe<Array<UserError>>;
  truck?: Maybe<Truck>;
};

/** Autogenerated return type of TruckUpdateAvailability. */
export type TruckUpdateAvailabilityPayload = {
  __typename?: 'TruckUpdateAvailabilityPayload';
  errors?: Maybe<Array<UserError>>;
  truck?: Maybe<Truck>;
};

/** Autogenerated return type of TruckUpdateDefaultCateringMenu. */
export type TruckUpdateDefaultCateringMenuPayload = {
  __typename?: 'TruckUpdateDefaultCateringMenuPayload';
  errors?: Maybe<Array<UserError>>;
  truck?: Maybe<Truck>;
};

/** Autogenerated return type of TruckUpdateDefaultEventMenu. */
export type TruckUpdateDefaultEventMenuPayload = {
  __typename?: 'TruckUpdateDefaultEventMenuPayload';
  errors?: Maybe<Array<UserError>>;
  truck?: Maybe<Truck>;
};

/** Autogenerated return type of TruckUpdateDescription. */
export type TruckUpdateDescriptionPayload = {
  __typename?: 'TruckUpdateDescriptionPayload';
  errors?: Maybe<Array<UserError>>;
  truck?: Maybe<Truck>;
};

/** Autogenerated return type of TruckUpdateEmailNotifications. */
export type TruckUpdateEmailNotificationsPayload = {
  __typename?: 'TruckUpdateEmailNotificationsPayload';
  errors?: Maybe<Array<UserError>>;
  truck?: Maybe<Truck>;
  truckEmailChannel?: Maybe<TruckEmailChannel>;
};

/** Autogenerated return type of TruckUpdateMarket. */
export type TruckUpdateMarketPayload = {
  __typename?: 'TruckUpdateMarketPayload';
  errors?: Maybe<Array<UserError>>;
  truck?: Maybe<Truck>;
};

/** Autogenerated return type of TruckUpdateMenus. */
export type TruckUpdateMenusPayload = {
  __typename?: 'TruckUpdateMenusPayload';
  errors?: Maybe<Array<UserError>>;
  truck?: Maybe<Truck>;
};

/** Autogenerated return type of TruckUpdate. */
export type TruckUpdatePayload = {
  __typename?: 'TruckUpdatePayload';
  errors?: Maybe<Array<UserError>>;
  truck?: Maybe<Truck>;
};

/** Autogenerated return type of TruckUpdatePhoneNotifications. */
export type TruckUpdatePhoneNotificationsPayload = {
  __typename?: 'TruckUpdatePhoneNotificationsPayload';
  errors?: Maybe<Array<UserError>>;
  truck?: Maybe<Truck>;
  truckPhoneChannel?: Maybe<TruckPhoneChannel>;
};

/** Autogenerated return type of TruckUpdateTips. */
export type TruckUpdateTipsPayload = {
  __typename?: 'TruckUpdateTipsPayload';
  errors?: Maybe<Array<UserError>>;
  truck?: Maybe<Truck>;
};

export enum TruckVehicleType {
  Cart = 'cart',
  Tent = 'tent',
  Trailer = 'trailer',
  Truck = 'truck'
}

export type TrucksFilterInput = {
  cateringTruckGroupIdRestrictions?: InputMaybe<Scalars['Int']>;
  excludeFoodTypeIds?: InputMaybe<Array<Scalars['Int']>>;
  foodTypeCategoryIds?: InputMaybe<Array<Scalars['Int']>>;
  foodTypeIds?: InputMaybe<Array<Scalars['Int']>>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  includeInactive?: InputMaybe<Scalars['Boolean']>;
  /** Locations are present on that day */
  locationsFilter?: InputMaybe<LocationsFilterInput>;
  marketId?: InputMaybe<Scalars['Int']>;
  marketIds?: InputMaybe<Array<Scalars['Int']>>;
  minRating?: InputMaybe<Scalars['Float']>;
  near?: InputMaybe<DistanceFilterInput>;
  nearAddress?: InputMaybe<AddressDistanceFilterInput>;
  preferredVendor?: InputMaybe<Scalars['Boolean']>;
  respectTruckCateringPreferences?: InputMaybe<Scalars['Boolean']>;
  /** Restaurant */
  restaurantId?: InputMaybe<Scalars['Int']>;
  /** Search */
  search?: InputMaybe<Scalars['String']>;
  unclaimed?: InputMaybe<Scalars['Boolean']>;
};

export type TrucksSortInput = {
  /** ASC / DESC */
  direction: SortDirection;
  /** Field to sort by */
  field: TrucksSortInputFields;
};

export enum TrucksSortInputFields {
  CreatedAt = 'created_at',
  Name = 'name',
  Popularity = 'popularity'
}

/** Autogenerated return type of TwentyMileSignUp. */
export type TwentyMileSignUpPayload = {
  __typename?: 'TwentyMileSignUpPayload';
  errors?: Maybe<Array<UserError>>;
  twentyMileApparelRequest?: Maybe<ApparelPartnershipRequest>;
};

/** Autogenerated return type of TwitterConnectionDelete. */
export type TwitterConnectionDeletePayload = {
  __typename?: 'TwitterConnectionDeletePayload';
  employee?: Maybe<Employee>;
  errors?: Maybe<Array<UserError>>;
};

export type TwitterIntegration = {
  __typename?: 'TwitterIntegration';
  id: Scalars['Int'];
  truck: Truck;
  userName: Scalars['String'];
};

/** Autogenerated return type of TwitterPostingIntegrationCreate. */
export type TwitterPostingIntegrationCreatePayload = {
  __typename?: 'TwitterPostingIntegrationCreatePayload';
  employee?: Maybe<Employee>;
  errors?: Maybe<Array<UserError>>;
};

/** Autogenerated return type of TwitterPostingIntegrationDelete. */
export type TwitterPostingIntegrationDeletePayload = {
  __typename?: 'TwitterPostingIntegrationDeletePayload';
  employee?: Maybe<Employee>;
  errors?: Maybe<Array<UserError>>;
};

/** Autogenerated return type of TwoFaEmailCodeSend. */
export type TwoFaEmailCodeSendPayload = {
  __typename?: 'TwoFaEmailCodeSendPayload';
  errors?: Maybe<Array<UserError>>;
  success?: Maybe<Scalars['Boolean']>;
};

/** Autogenerated return type of TwoFaEmailVerifySession. */
export type TwoFaEmailVerifySessionPayload = {
  __typename?: 'TwoFaEmailVerifySessionPayload';
  errors?: Maybe<Array<UserError>>;
  twoFaSession?: Maybe<TwoFaSession>;
};

export type TwoFaSession = {
  __typename?: 'TwoFaSession';
  id: Scalars['Int'];
  verified: Scalars['Boolean'];
};

export type UnifiedCateringRequest = {
  __typename?: 'UnifiedCateringRequest';
  cateringRequest?: Maybe<CateringRequest>;
  eventsRequest?: Maybe<EventsRequest>;
  id: Scalars['String'];
};

export type UnifiedCateringRequestCollection = {
  __typename?: 'UnifiedCateringRequestCollection';
  /** Limit */
  limit?: Maybe<Scalars['Int']>;
  /** Offset */
  offset?: Maybe<Scalars['Int']>;
  /** List of records */
  records: Array<UnifiedCateringRequest>;
  /** Total */
  total: Scalars['Int'];
};

export type UnifiedCateringRequestsFilterInput = {
  cateringStatuses?: InputMaybe<Array<CateringRequestStatus>>;
  eventsRequestStatuses?: InputMaybe<Array<Status>>;
  excludeCateringIds?: InputMaybe<Array<Scalars['Int']>>;
  excludeEventsRequestIds?: InputMaybe<Array<Scalars['Int']>>;
};

export type UpcomingSubscribedLots = {
  __typename?: 'UpcomingSubscribedLots';
  lots: Array<SubscribedLot>;
};

export type UploadedAsset = {
  __typename?: 'UploadedAsset';
  file: UploadedAssetFile;
  id: Scalars['Int'];
  name: Scalars['String'];
};

/** Autogenerated return type of UploadedAssetCreate. */
export type UploadedAssetCreatePayload = {
  __typename?: 'UploadedAssetCreatePayload';
  errors?: Maybe<Array<UserError>>;
  uploadedAsset?: Maybe<UploadedAsset>;
};

export type UploadedAssetFile = {
  __typename?: 'UploadedAssetFile';
  original?: Maybe<Scalars['String']>;
  present: Scalars['Boolean'];
};

/** Autogenerated return type of UploadedAssetRemove. */
export type UploadedAssetRemovePayload = {
  __typename?: 'UploadedAssetRemovePayload';
  errors?: Maybe<Array<UserError>>;
  uploadedAssets?: Maybe<Array<UploadedAsset>>;
};

export type UpsellType = {
  __typename?: 'UpsellType';
  cateringName: Scalars['String'];
  id: Scalars['Int'];
  minCateringBudget: Money;
  name: Scalars['String'];
  position: Scalars['Int'];
  showInCatering: Scalars['Boolean'];
  singlePerCart: Scalars['Boolean'];
};

/** Autogenerated return type of UpsellTypeCreate. */
export type UpsellTypeCreatePayload = {
  __typename?: 'UpsellTypeCreatePayload';
  errors?: Maybe<Array<UserError>>;
  upsellType?: Maybe<UpsellType>;
};

export type UpsellTypeMarketAdjustment = {
  __typename?: 'UpsellTypeMarketAdjustment';
  adjustment: Money;
  id: Scalars['Int'];
  market: Market;
  upsellType: UpsellType;
};

/** Autogenerated return type of UpsellTypeUpdate. */
export type UpsellTypeUpdatePayload = {
  __typename?: 'UpsellTypeUpdatePayload';
  errors?: Maybe<Array<UserError>>;
  upsellType?: Maybe<UpsellType>;
};

export type User = {
  __typename?: 'User';
  id: Scalars['Int'];
  name: Scalars['String'];
  type: Scalars['String'];
};

/** Autogenerated return type of UserChangePassword. */
export type UserChangePasswordPayload = {
  __typename?: 'UserChangePasswordPayload';
  corporateUser?: Maybe<CorporateUser>;
  employee?: Maybe<Employee>;
  errors?: Maybe<Array<UserError>>;
  organizer?: Maybe<Organizer>;
};

export type UserDevice = {
  __typename?: 'UserDevice';
  appVersion?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  oneSignalId?: Maybe<Scalars['String']>;
};

export type UserError = {
  __typename?: 'UserError';
  data?: Maybe<Scalars['Json']>;
  fullMessage?: Maybe<Scalars['String']>;
  key?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of UserLogout. */
export type UserLogoutPayload = {
  __typename?: 'UserLogoutPayload';
  errors?: Maybe<Array<UserError>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type UserNotification = {
  __typename?: 'UserNotification';
  content?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  notificationType: Scalars['String'];
  read: Scalars['Boolean'];
  title: Scalars['String'];
};

export type UserNotificationCollection = Collection & {
  __typename?: 'UserNotificationCollection';
  /** Limit */
  limit?: Maybe<Scalars['Int']>;
  /** Offset */
  offset?: Maybe<Scalars['Int']>;
  /** List of records */
  records: Array<UserNotification>;
  /** Total */
  total: Scalars['Int'];
};


export type UserNotificationCollectionTotalArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};

export type UserNotificationGroup = {
  __typename?: 'UserNotificationGroup';
  content?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['Int'];
  markets: Array<Market>;
  title: Scalars['String'];
  userNotifications: UserNotificationCollection;
};


export type UserNotificationGroupUserNotificationsArgs = {
  filter?: InputMaybe<UserNotificationsFilterInput>;
  sort?: InputMaybe<Array<UserNotificationsSortInput>>;
};

/** Autogenerated return type of UserNotificationsDelete. */
export type UserNotificationsDeletePayload = {
  __typename?: 'UserNotificationsDeletePayload';
  errors?: Maybe<Array<UserError>>;
};

export type UserNotificationsFilterInput = {
  /** Filter by read */
  unread?: InputMaybe<Scalars['Boolean']>;
};

export type UserNotificationsSortInput = {
  /** ASC / DESC */
  direction: SortDirection;
  /** Field to sort by */
  field: UserNotificationsSortInputFields;
};

export enum UserNotificationsSortInputFields {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/** Autogenerated return type of UserReadNotification. */
export type UserReadNotificationPayload = {
  __typename?: 'UserReadNotificationPayload';
  errors?: Maybe<Array<UserError>>;
  userNotification: UserNotification;
};

export type Verification = {
  __typename?: 'Verification';
  businessInfoFilled?: Maybe<Scalars['Boolean']>;
  fieldsNeeded?: Maybe<Array<Scalars['String']>>;
  id?: Maybe<Scalars['Int']>;
  legalNameFilledIn?: Maybe<Scalars['Boolean']>;
  payoutsEnabled?: Maybe<Scalars['Boolean']>;
};

/** Autogenerated return type of VerificationCodeSend. */
export type VerificationCodeSendPayload = {
  __typename?: 'VerificationCodeSendPayload';
  errors?: Maybe<Array<UserError>>;
};

/** Autogenerated return type of VerificationCodeVerify. */
export type VerificationCodeVerifyPayload = {
  __typename?: 'VerificationCodeVerifyPayload';
  errors?: Maybe<Array<UserError>>;
  phoneToken?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of WebPushSubscribe. */
export type WebPushSubscribePayload = {
  __typename?: 'WebPushSubscribePayload';
  errors?: Maybe<Array<UserError>>;
  user?: Maybe<User>;
};

export type WebPushSubscription = {
  __typename?: 'WebPushSubscription';
  createdAt: Scalars['DateTime'];
  device: Scalars['String'];
  id: Scalars['Int'];
};

/** Autogenerated return type of WebPushUnsubscribe. */
export type WebPushUnsubscribePayload = {
  __typename?: 'WebPushUnsubscribePayload';
  errors?: Maybe<Array<UserError>>;
  user?: Maybe<User>;
};
